(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var I18n, Optimize, config;

window._ = require('underscore');

window.md5 = require('../../../src/frontend/vendor/md5');

window.Cookie = require('../../../src/frontend/vendor/cookie');

window.Hogan = require('hogan.js');

require('../groupon_modules/modernizr-hacks');

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('optimize-suite');

require('../../../src/frontend/vendor/eventPause-custom');

require('jquery.finger');

window.CartWidget = require('../../../modules/cart_widget/frontend/cart_widget');

window.Fingerprint = require('fingerprintjs');

Optimize = window.Optimize;

config = Optimize.suiteData.config;

config.finch = {
  config: Optimize.finchConfig
};

Optimize.config = config;

OptimizeSuite.init(config);



},{"../../../modules/cart_widget/frontend/cart_widget":16,"../../../node_modules/grapefruit/lib/I18n":22,"../../../src/frontend/vendor/cookie":37,"../../../src/frontend/vendor/eventPause-custom":38,"../../../src/frontend/vendor/md5":39,"../groupon_modules/modernizr-hacks":9,"fingerprintjs":21,"hogan.js":24,"jquery.finger":26,"optimize-suite":28,"underscore":29}],2:[function(require,module,exports){
_.mixin(module.exports = {
  deepClone: function(object) {
    var clone;
    clone = _.clone(object);
    _.each(clone, function(value, key) {
      if (_.isObject(value)) {
        return clone[key] = _.deepClone(value);
      }
    });
    return clone;
  },
  isBlank: function(obj) {
    if (_.isString(obj)) {
      return !/\S/.test(obj);
    } else {
      return _.isEmpty(obj);
    }
  },
  escapeRegExp: function(str) {
    if (str != null) {
      return String(str).replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    } else {
      return '';
    }
  }
});



},{}],3:[function(require,module,exports){
module.exports = {
  externalObjectLoader: function(url, onloadScript, id) {
    var doc, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = 'javascript:false';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.css = 'width: 0;height: 0;border: 0';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      iframe.src = "javascript:var d=document.open();d.domain='" + document.domain + "';void 0";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (typeof dom !== "undefined" && dom !== null) {
        this.domain = dom;
      }
      scriptInit = this.createElement('script');
      scriptInit.type = 'text/javascript';
      scriptInit.innerHTML = 'Groupon=window.parent.Groupon;$=window.parent.$';
      this.body.appendChild(scriptInit);
      js = this.createElement('script');
      js.type = 'text/javascript';
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  },
  externalObjectLoaderOnready: function(fn) {
    if (typeof fn === 'function') {
      return $(document).ready(fn);
    }
  }
};



},{}],4:[function(require,module,exports){
var getConfigFromDom;

module.exports = getConfigFromDom = function(id) {
  var elt, error, text;
  if (id == null) {
    id = 'domConfig';
  }
  elt = document.getElementById(id);
  if (!elt) {
    return {};
  }
  text = elt.textContent || elt.innerText;
  try {
    return JSON.parse(text);
  } catch (error1) {
    error = error1;
    error.message += '\n     Attempted to parse: ' + text;
    throw error;
  }
};



},{}],5:[function(require,module,exports){
var base, base1, base2, detectCurrentLocation, events, extendOnDocumentReady, externalObjectLoader, externalObjectLoaderOnready, getConfigFromDom, hasTouch, loadAsyncJS, makeTag, mediaQueries, pageWidths, ref, ref1, setSiteCookies, trackEvent, unparam;

unparam = require('./unparam');

getConfigFromDom = require('./getConfigFromDom');

trackEvent = require('./trackEvent');

makeTag = require('./makeTag');

loadAsyncJS = require('./loadAsyncJS');

detectCurrentLocation = require('../../../src/frontend/helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

extendOnDocumentReady = require('./groupon_extended');

setSiteCookies = require('./setSiteCookies');

ref = require('./externalObjectLoader'), externalObjectLoader = ref.externalObjectLoader, externalObjectLoaderOnready = ref.externalObjectLoaderOnready;

if (window.Groupon == null) {
  window.Groupon = {};
}

_.extend(window.Groupon, {
  SharedJS: {},
  Widgets: {},
  PageFlags: {}
});

hasTouch = (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref1 = Modernizr.touchevents) != null ? ref1.valueOf() : void 0 : void 0) || 'ontouchstart' in window || window.navigator.maxTouchPoints || (window.DocumentTouch && document instanceof DocumentTouch);

events = hasTouch ? 'touchstart' : 'click';

pageWidths = {
  xxl: 1280,
  xl: 1080,
  slsL: 769,
  l: 720,
  m: 600,
  s: 400
};

mediaQueries = {
  xxlMin: "(min-width: " + pageWidths.xxl + "px)",
  xlMin: "(min-width: " + pageWidths.xl + "px)",
  slsLMin: "(min-width:  " + pageWidths.slsL + "px)",
  lMin: "(min-width:  " + pageWidths.l + "px)",
  mMin: "(min-width:  " + pageWidths.m + "px)",
  sMin: "(min-width:  " + pageWidths.s + "px)",
  xxlMax: "(max-width: " + (pageWidths.xxl - 1) + "px)",
  xlMax: "(max-width: " + (pageWidths.xl - 1) + "px)",
  slsLMax: "(max-width:  " + (pageWidths.slsL - 1) + "px)",
  lMax: "(max-width:  " + (pageWidths.l - 1) + "px)",
  mMax: "(max-width:  " + (pageWidths.m - 1) + "px)",
  sMax: "(max-width:  " + (pageWidths.s - 1) + "px)"
};

if ((base = window.Groupon).LS == null) {
  base.LS = {};
}

_.extend(window.Groupon.LS, {
  hasTouch: hasTouch,
  events: events,
  mediaQueries: mediaQueries,
  pageWidths: pageWidths,
  Header: {}
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon).Utils == null) {
  base2.Utils = {};
}

_.extend(Groupon.Utils, {
  unparam: unparam,
  makeTag: makeTag,
  getConfigFromDom: getConfigFromDom,
  setSiteCookies: setSiteCookies,
  externalObjectLoader: externalObjectLoader,
  externalObjectLoaderOnready: externalObjectLoaderOnready,
  trackEvent: trackEvent,
  loadAsyncJS: loadAsyncJS,
  detectCurrentLocation: detectCurrentLocation
});

extendOnDocumentReady();



},{"../../../src/frontend/helper/search/helper/m_detectCurrentLocation":33,"./externalObjectLoader":3,"./getConfigFromDom":4,"./groupon_extended":6,"./loadAsyncJS":7,"./makeTag":8,"./setSiteCookies":11,"./trackEvent":12,"./unparam":13}],6:[function(require,module,exports){
var extendFlags,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

extendFlags = function() {
  var bodyClasses, ref, ref1;
  bodyClasses = document.body.classList || $(document.body).getClasses();
  return _.extend(window.Groupon, {
    App: {
      name: $(document.head).attr('data-app')
    },
    Browsers: {
      chrome: !!window.chrome,
      ltIE10: $('html').hasClass('lt-ie10'),
      phantomJS: !!(window._phantom || window.callPhantom),
      safari: ((ref = navigator.vendor) != null ? ref.indexOf('Apple') : void 0) > -1 && !((ref1 = navigator.userAgent) != null ? ref1.match('CriOS') : void 0)
    },
    PageFlags: {
      isWeb: indexOf.call(bodyClasses, 'is-web') >= 0,
      isTouch: indexOf.call(bodyClasses, 'is-touch') >= 0,
      isLegacyResponsive: indexOf.call(bodyClasses, 'ls-resp') >= 0,
      isTouchRedesign: indexOf.call(bodyClasses, 't-redesign') >= 0,
      isTouchRequest: indexOf.call(bodyClasses, 'is-touch-request') >= 0
    }
  });
};

module.exports = function() {
  if (document.body != null) {
    return extendFlags();
  } else {
    return $(function() {
      return extendFlags();
    });
  }
};



},{}],7:[function(require,module,exports){
var loadAsyncJS;

module.exports = loadAsyncJS = function(url) {
  var p, s;
  s = document.createElement('script');
  s.async = true;
  s.src = url;
  p = document.getElementsByTagName('script')[0];
  return p.parentNode.insertBefore(s, p);
};



},{}],8:[function(require,module,exports){
var i, len, makeTag, name, ref;

makeTag = function(name, attr, content) {
  var html, key, ref, tail, val;
  if (attr == null) {
    attr = {};
  }
  if (content == null) {
    content = '';
  }
  if (typeof attr === 'string') {
    ref = [{}, attr], attr = ref[0], content = ref[1];
  }
  html = "<" + name;
  tail = "</" + name + ">";
  for (key in attr) {
    val = attr[key];
    key = _.escape(key);
    val = _.escape(String(val));
    html += ' ' + key + '="' + val + '"';
  }
  return html + '>' + content + tail;
};

ref = ['a'];
for (i = 0, len = ref.length; i < len; i++) {
  name = ref[i];
  makeTag[name] = _.partial(makeTag, name);
}

module.exports = makeTag;



},{}],9:[function(require,module,exports){
var Modernizr;

Modernizr = require('../vendor_modules/modernizr');

if (Modernizr.touchevents !== void 0) {
  Modernizr.touchevents = Modernizr.touchevents.valueOf() || !!window.navigator.maxTouchPoints;
  Modernizr.touch = Modernizr.touchevents;
  document.documentElement.className += Modernizr.touchevents ? ' touch' : ' no-touch';
}

Modernizr.addTest('csspseudoanimations', function() {
  var result, styles;
  result = false;
  if (!(Modernizr.cssanimations && window.getComputedStyle)) {
    return result;
  }
  styles = ['@', Modernizr._prefixes.join('keyframes csspseudoanimations { from { font-size: 10px; } }@').replace(/@$/, ''), '#modernizr:before { content:" "; font-size:5px;', Modernizr._prefixes.join('animation:csspseudoanimations 1ms infinite;'), '}'].join('');
  Modernizr.testStyles(styles, function(elem) {
    var style;
    style = window.getComputedStyle(elem, ':before');
    if (style !== null) {
      return result = style.getPropertyValue('font-size') === '10px';
    }
  });
  return result;
});



},{"../vendor_modules/modernizr":15}],10:[function(require,module,exports){
module.exports = function($) {
  var PlaceholderField, defaultPromptEnabled, inputEmpty, setPlaceholder;
  PlaceholderField = $.fn.PlaceholderField = function() {
    if (PlaceholderField.hasNativePlaceholderSupport()) {
      return this;
    }
    return this.each(function() {
      return PlaceholderField.initPlaceholder($(this));
    });
  };
  PlaceholderField.hasNativePlaceholderSupport = function() {
    return _.all([document.createElement('input'), document.createElement('textarea')], function(elem) {
      return elem.placeholder != null;
    });
  };
  inputEmpty = function($input) {
    return /^\s*$/.test($input.val());
  };
  PlaceholderField.initPlaceholder = function($input) {
    var focusin, focusout;
    focusin = function() {
      if (defaultPromptEnabled($input)) {
        return $input.val('').removeClass('prompting');
      }
    };
    (focusout = function() {
      if (inputEmpty($input)) {
        return setPlaceholder($input);
      }
    })();
    return $input.on({
      focusin: focusin,
      focusout: focusout
    });
  };
  setPlaceholder = function($input) {
    var ref;
    $input.addClass('prompting');
    return $input.val((ref = $input.attr('placeholder')) != null ? ref : $input.attr('title'));
  };
  defaultPromptEnabled = function($input) {
    var placeholder, sansWhitespace;
    sansWhitespace = function(val) {
      return val.replace(/\s/g, '');
    };
    placeholder = $input.attr('placeholder') || $input.attr('title') || '';
    return sansWhitespace($input.val()) === sansWhitespace(placeholder);
  };
  return PlaceholderField;
};



},{}],11:[function(require,module,exports){
var TEN_YEARS_IN_SECONDS, setSiteCookies;

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

module.exports = setSiteCookies = function(cookies, seconds) {
  var cookieDomain, key, results, val;
  if (seconds == null) {
    seconds = TEN_YEARS_IN_SECONDS;
  }
  cookieDomain = setSiteCookies.cookieDomain || (setSiteCookies.cookieDomain = $('head').data('domain'));
  results = [];
  for (key in cookies) {
    val = cookies[key];
    if (val != null) {
      results.push(Cookie.set(key, val, seconds, cookieDomain));
    } else {
      results.push(Cookie.unset(key, cookieDomain));
    }
  }
  return results;
};



},{}],12:[function(require,module,exports){
var trackEvent;

module.exports = trackEvent = function(eventName, payload) {
  var defaults, ref;
  if (payload == null) {
    payload = {};
  }
  defaults = {
    b: Cookie.get('b'),
    pageId: location.pathname
  };
  payload = _.extend({}, payload, defaults);
  if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
    if ((ref = OptimizeSuite.TrackingHub) != null) {
      ref.add("" + eventName, payload);
    }
  }
};



},{}],13:[function(require,module,exports){
var unparam;

module.exports = unparam = function(str) {
  var data, i, keyPairs, keyVal, len, tuple;
  if (str == null) {
    str = location.search;
  }
  if (typeof str !== 'string') {
    throw new TypeError("unparam needs a string, but got " + (JSON.stringify(str)));
  }
  data = {};
  keyPairs = str.replace(/\+/g, '%20').split('&');
  for (i = 0, len = keyPairs.length; i < len; i++) {
    keyVal = keyPairs[i];
    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
};



},{}],14:[function(require,module,exports){
var $, perflibLoader;

perflibLoader = require('../../src/frontend/core/perflibLoader');

perflibLoader();

$ = window.$ = window.jQuery = require('jquery');

require('../../src/frontend/core/jquery.safe-ready')($);

require('../../src/frontend/core/jquery.addons')($);

require('./groupon_modules/placeholder_field')($);

require('./common/core_libraries');



},{"../../src/frontend/core/jquery.addons":30,"../../src/frontend/core/jquery.safe-ready":31,"../../src/frontend/core/perflibLoader":32,"./common/core_libraries":1,"./groupon_modules/placeholder_field":10,"jquery":27}],15:[function(require,module,exports){



/*!
 * modernizr v3.3.1
 * Build http://modernizr.com/download?-cssanimations-cssgradients-csstransforms3d-csstransitions-flexbox-flexboxlegacy-flexboxtweener-formvalidation-hashchange-history-pointerevents-touchevents-webp-addtest-fnbind-mq-prefixed-prefixedcss-setclasses-testallprops-testprop-teststyles-dontmin
 *
 * Copyright (c)
 *  Faruk Ates
 *  Paul Irish
 *  Alex Sexton
 *  Ryan Seddon
 *  Patrick Kettner
 *  Stu Cox
 *  Richard Herrera

 * MIT License
 */

/*
 * Modernizr tests which native CSS3 and HTML5 features are available in the
 * current UA and makes the results available to you in two ways: as properties on
 * a global `Modernizr` object, and as classes on the `<html>` element. This
 * information allows you to progressively enhance your pages with a granular level
 * of control over the experience.
*/

;(function(window, document, undefined){
  var tests = [];
  

  /**
   *
   * ModernizrProto is the constructor for Modernizr
   *
   * @class
   * @access public
   */

  var ModernizrProto = {
    // The current version, dummy
    _version: '3.3.1',

    // Any settings that don't work as separate modules
    // can go in here as configuration.
    _config: {
      'classPrefix': '',
      'enableClasses': true,
      'enableJSClass': true,
      'usePrefixes': true
    },

    // Queue of tests
    _q: [],

    // Stub these for people who are listening
    on: function(test, cb) {
      // I don't really think people should do this, but we can
      // safe guard it a bit.
      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
      // This is in case people listen to synchronous tests. I would leave it out,
      // but the code to *disallow* sync tests in the real version of this
      // function is actually larger than this.
      var self = this;
      setTimeout(function() {
        cb(self[test]);
      }, 0);
    },

    addTest: function(name, fn, options) {
      tests.push({name: name, fn: fn, options: options});
    },

    addAsyncTest: function(fn) {
      tests.push({name: null, fn: fn});
    }
  };

  

  // Fake some of Object.create so we can force non test results to be non "own" properties.
  var Modernizr = function() {};
  Modernizr.prototype = ModernizrProto;

  // Leak modernizr globally when you `require` it rather than force it here.
  // Overwrite name so constructor name is nicer :D
  Modernizr = new Modernizr();

  

  var classes = [];
  

  /**
   * is returns a boolean if the typeof an obj is exactly type.
   *
   * @access private
   * @function is
   * @param {*} obj - A thing we want to check the type of
   * @param {string} type - A string to compare the typeof against
   * @returns {boolean}
   */

  function is(obj, type) {
    return typeof obj === type;
  }
  ;

  /**
   * Run through all tests and detect their support in the current UA.
   *
   * @access private
   */

  function testRunner() {
    var featureNames;
    var feature;
    var aliasIdx;
    var result;
    var nameIdx;
    var featureName;
    var featureNameSplit;

    for (var featureIdx in tests) {
      if (tests.hasOwnProperty(featureIdx)) {
        featureNames = [];
        feature = tests[featureIdx];
        // run the test, throw the return value into the Modernizr,
        // then based on that boolean, define an appropriate className
        // and push it into an array of classes we'll join later.
        //
        // If there is no name, it's an 'async' test that is run,
        // but not directly added to the object. That should
        // be done with a post-run addTest call.
        if (feature.name) {
          featureNames.push(feature.name.toLowerCase());

          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
            // Add all the aliases into the names list
            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
            }
          }
        }

        // Run the test, or use the raw value if it's not a function
        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;


        // Set each of the names on the Modernizr object
        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
          featureName = featureNames[nameIdx];
          // Support dot properties as sub tests. We don't do checking to make sure
          // that the implied parent tests have been added. You must call them in
          // order (either in the test, or make the parent test a dependency).
          //
          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
          // hashtag famous last words
          featureNameSplit = featureName.split('.');

          if (featureNameSplit.length === 1) {
            Modernizr[featureNameSplit[0]] = result;
          } else {
            // cast to a Boolean, if not one already
            /* jshint -W053 */
            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
            }

            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
          }

          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
        }
      }
    }
  }
  ;

  /**
   * docElement is a convenience wrapper to grab the root element of the document
   *
   * @access private
   * @returns {HTMLElement|SVGElement} The root element of the document
   */

  var docElement = document.documentElement;
  

  /**
   * A convenience helper to check if the document we are running in is an SVG document
   *
   * @access private
   * @returns {boolean}
   */

  var isSVG = docElement.nodeName.toLowerCase() === 'svg';
  

  /**
   * setClasses takes an array of class names and adds them to the root element
   *
   * @access private
   * @function setClasses
   * @param {string[]} classes - Array of class names
   */

  // Pass in an and array of class names, e.g.:
  //  ['no-webp', 'borderradius', ...]
  function setClasses(classes) {
    var className = docElement.className;
    var classPrefix = Modernizr._config.classPrefix || '';

    if (isSVG) {
      className = className.baseVal;
    }

    // Change `no-js` to `js` (independently of the `enableClasses` option)
    // Handle classPrefix on this too
    if (Modernizr._config.enableJSClass) {
      var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
      className = className.replace(reJS, '$1' + classPrefix + 'js$2');
    }

    if (Modernizr._config.enableClasses) {
      // Add the new classes
      className += ' ' + classPrefix + classes.join(' ' + classPrefix);
      isSVG ? docElement.className.baseVal = className : docElement.className = className;
    }

  }

  ;

  /**
   * hasOwnProp is a shim for hasOwnProperty that is needed for Safari 2.0 support
   *
   * @author kangax
   * @access private
   * @function hasOwnProp
   * @param {object} object - The object to check for a property
   * @param {string} property - The property to check for
   * @returns {boolean}
   */

  // hasOwnProperty shim by kangax needed for Safari 2.0 support
  var hasOwnProp;

  (function() {
    var _hasOwnProperty = ({}).hasOwnProperty;
    /* istanbul ignore else */
    /* we have no way of testing IE 5.5 or safari 2,
     * so just assume the else gets hit */
    if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
      hasOwnProp = function(object, property) {
        return _hasOwnProperty.call(object, property);
      };
    }
    else {
      hasOwnProp = function(object, property) { /* yes, this can give false positives/negatives, but most of the time we don't care about those */
        return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
      };
    }
  })();

  


   // _l tracks listeners for async tests, as well as tests that execute after the initial run
  ModernizrProto._l = {};

  /**
   * Modernizr.on is a way to listen for the completion of async tests. Being
   * asynchronous, they may not finish before your scripts run. As a result you
   * will get a possibly false negative `undefined` value.
   *
   * @memberof Modernizr
   * @name Modernizr.on
   * @access public
   * @function on
   * @param {string} feature - String name of the feature detect
   * @param {function} cb - Callback function returning a Boolean - true if feature is supported, false if not
   * @example
   *
   * ```js
   * Modernizr.on('flash', function( result ) {
   *   if (result) {
   *    // the browser has flash
   *   } else {
   *     // the browser does not have flash
   *   }
   * });
   * ```
   */

  ModernizrProto.on = function(feature, cb) {
    // Create the list of listeners if it doesn't exist
    if (!this._l[feature]) {
      this._l[feature] = [];
    }

    // Push this test on to the listener list
    this._l[feature].push(cb);

    // If it's already been resolved, trigger it on next tick
    if (Modernizr.hasOwnProperty(feature)) {
      // Next Tick
      setTimeout(function() {
        Modernizr._trigger(feature, Modernizr[feature]);
      }, 0);
    }
  };

  /**
   * _trigger is the private function used to signal test completion and run any
   * callbacks registered through [Modernizr.on](#modernizr-on)
   *
   * @memberof Modernizr
   * @name Modernizr._trigger
   * @access private
   * @function _trigger
   * @param {string} feature - string name of the feature detect
   * @param {function|boolean} [res] - A feature detection function, or the boolean =
   * result of a feature detection function
   */

  ModernizrProto._trigger = function(feature, res) {
    if (!this._l[feature]) {
      return;
    }

    var cbs = this._l[feature];

    // Force async
    setTimeout(function() {
      var i, cb;
      for (i = 0; i < cbs.length; i++) {
        cb = cbs[i];
        cb(res);
      }
    }, 0);

    // Don't trigger these again
    delete this._l[feature];
  };

  /**
   * addTest allows you to define your own feature detects that are not currently
   * included in Modernizr (under the covers it's the exact same code Modernizr
   * uses for its own [feature detections](https://github.com/Modernizr/Modernizr/tree/master/feature-detects)). Just like the offical detects, the result
   * will be added onto the Modernizr object, as well as an appropriate className set on
   * the html element when configured to do so
   *
   * @memberof Modernizr
   * @name Modernizr.addTest
   * @optionName Modernizr.addTest()
   * @optionProp addTest
   * @access public
   * @function addTest
   * @param {string|object} feature - The string name of the feature detect, or an
   * object of feature detect names and test
   * @param {function|boolean} test - Function returning true if feature is supported,
   * false if not. Otherwise a boolean representing the results of a feature detection
   * @example
   *
   * The most common way of creating your own feature detects is by calling
   * `Modernizr.addTest` with a string (preferably just lowercase, without any
   * punctuation), and a function you want executed that will return a boolean result
   *
   * ```js
   * Modernizr.addTest('itsTuesday', function() {
   *  var d = new Date();
   *  return d.getDay() === 2;
   * });
   * ```
   *
   * When the above is run, it will set Modernizr.itstuesday to `true` when it is tuesday,
   * and to `false` every other day of the week. One thing to notice is that the names of
   * feature detect functions are always lowercased when added to the Modernizr object. That
   * means that `Modernizr.itsTuesday` will not exist, but `Modernizr.itstuesday` will.
   *
   *
   *  Since we only look at the returned value from any feature detection function,
   *  you do not need to actually use a function. For simple detections, just passing
   *  in a statement that will return a boolean value works just fine.
   *
   * ```js
   * Modernizr.addTest('hasJquery', 'jQuery' in window);
   * ```
   *
   * Just like before, when the above runs `Modernizr.hasjquery` will be true if
   * jQuery has been included on the page. Not using a function saves a small amount
   * of overhead for the browser, as well as making your code much more readable.
   *
   * Finally, you also have the ability to pass in an object of feature names and
   * their tests. This is handy if you want to add multiple detections in one go.
   * The keys should always be a string, and the value can be either a boolean or
   * function that returns a boolean.
   *
   * ```js
   * var detects = {
   *  'hasjquery': 'jQuery' in window,
   *  'itstuesday': function() {
   *    var d = new Date();
   *    return d.getDay() === 2;
   *  }
   * }
   *
   * Modernizr.addTest(detects);
   * ```
   *
   * There is really no difference between the first methods and this one, it is
   * just a convenience to let you write more readable code.
   */

  function addTest(feature, test) {

    if (typeof feature == 'object') {
      for (var key in feature) {
        if (hasOwnProp(feature, key)) {
          addTest(key, feature[ key ]);
        }
      }
    } else {

      feature = feature.toLowerCase();
      var featureNameSplit = feature.split('.');
      var last = Modernizr[featureNameSplit[0]];

      // Again, we don't check for parent test existence. Get that right, though.
      if (featureNameSplit.length == 2) {
        last = last[featureNameSplit[1]];
      }

      if (typeof last != 'undefined') {
        // we're going to quit if you're trying to overwrite an existing test
        // if we were to allow it, we'd do this:
        //   var re = new RegExp("\\b(no-)?" + feature + "\\b");
        //   docElement.className = docElement.className.replace( re, '' );
        // but, no rly, stuff 'em.
        return Modernizr;
      }

      test = typeof test == 'function' ? test() : test;

      // Set the value (this is the magic, right here).
      if (featureNameSplit.length == 1) {
        Modernizr[featureNameSplit[0]] = test;
      } else {
        // cast to a Boolean, if not one already
        /* jshint -W053 */
        if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
          Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
        }

        Modernizr[featureNameSplit[0]][featureNameSplit[1]] = test;
      }

      // Set a single class (either `feature` or `no-feature`)
      /* jshint -W041 */
      setClasses([(!!test && test != false ? '' : 'no-') + featureNameSplit.join('-')]);
      /* jshint +W041 */

      // Trigger the event
      Modernizr._trigger(feature, test);
    }

    return Modernizr; // allow chaining.
  }

  // After all the tests are run, add self to the Modernizr prototype
  Modernizr._q.push(function() {
    ModernizrProto.addTest = addTest;
  });

  


  /**
   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
   *
   * @access private
   * @function fnBind
   * @param {function} fn - a function you want to change `this` reference to
   * @param {object} that - the `this` you want to call the function with
   * @returns {function} The wrapped version of the supplied function
   */

  function fnBind(fn, that) {
    return function() {
      return fn.apply(that, arguments);
    };
  }

  ;

  /**
   * createElement is a convenience wrapper around document.createElement. Since we
   * use createElement all over the place, this allows for (slightly) smaller code
   * as well as abstracting away issues with creating elements in contexts other than
   * HTML documents (e.g. SVG documents).
   *
   * @access private
   * @function createElement
   * @returns {HTMLElement|SVGElement} An HTML or SVG element
   */

  function createElement() {
    if (typeof document.createElement !== 'function') {
      // This is the case in IE7, where the type of createElement is "object".
      // For this reason, we cannot call apply() as Object is not a Function.
      return document.createElement(arguments[0]);
    } else if (isSVG) {
      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
    } else {
      return document.createElement.apply(document, arguments);
    }
  }

  ;

  /**
   * getBody returns the body of a document, or an element that can stand in for
   * the body if a real body does not exist
   *
   * @access private
   * @function getBody
   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
   * artificially created element that stands in for the body
   */

  function getBody() {
    // After page load injecting a fake body doesn't work so check if body exists
    var body = document.body;

    if (!body) {
      // Can't use the real body create a fake one.
      body = createElement(isSVG ? 'svg' : 'body');
      body.fake = true;
    }

    return body;
  }

  ;

  /**
   * injectElementWithStyles injects an element with style element and some CSS rules
   *
   * @access private
   * @function injectElementWithStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   */

  function injectElementWithStyles(rule, callback, nodes, testnames) {
    var mod = 'modernizr';
    var style;
    var ret;
    var node;
    var docOverflow;
    var div = createElement('div');
    var body = getBody();

    if (parseInt(nodes, 10)) {
      // In order not to give false positives we create a node for each test
      // This also allows the method to scale for unspecified uses
      while (nodes--) {
        node = createElement('div');
        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
        div.appendChild(node);
      }
    }

    style = createElement('style');
    style.type = 'text/css';
    style.id = 's' + mod;

    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
    (!body.fake ? div : body).appendChild(style);
    body.appendChild(div);

    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(document.createTextNode(rule));
    }
    div.id = mod;

    if (body.fake) {
      //avoid crashing IE8, if background image is used
      body.style.background = '';
      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
      body.style.overflow = 'hidden';
      docOverflow = docElement.style.overflow;
      docElement.style.overflow = 'hidden';
      docElement.appendChild(body);
    }

    ret = callback(div, rule);
    // If this is done after page load we don't want to remove the body so check if body exists
    if (body.fake) {
      body.parentNode.removeChild(body);
      docElement.style.overflow = docOverflow;
      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
      docElement.offsetHeight;
    } else {
      div.parentNode.removeChild(div);
    }

    return !!ret;

  }

  ;

  /**
   * Modernizr.mq tests a given media query, live against the current state of the window
   * adapted from matchMedia polyfill by Scott Jehl and Paul Irish
   * gist.github.com/786768
   *
   * @memberof Modernizr
   * @name Modernizr.mq
   * @optionName Modernizr.mq()
   * @optionProp mq
   * @access public
   * @function mq
   * @param {string} mq - String of the media query we want to test
   * @returns {boolean}
   * @example
   * Modernizr.mq allows for you to programmatically check if the current browser
   * window state matches a media query.
   *
   * ```js
   *  var query = Modernizr.mq('(min-width: 900px)');
   *
   *  if (query) {
   *    // the browser window is larger than 900px
   *  }
   * ```
   *
   * Only valid media queries are supported, therefore you must always include values
   * with your media query
   *
   * ```js
   * // good
   *  Modernizr.mq('(min-width: 900px)');
   *
   * // bad
   *  Modernizr.mq('min-width');
   * ```
   *
   * If you would just like to test that media queries are supported in general, use
   *
   * ```js
   *  Modernizr.mq('only all'); // true if MQ are supported, false if not
   * ```
   *
   *
   * Note that if the browser does not support media queries (e.g. old IE) mq will
   * always return false.
   */

  var mq = (function() {
    var matchMedia = window.matchMedia || window.msMatchMedia;
    if (matchMedia) {
      return function(mq) {
        var mql = matchMedia(mq);
        return mql && mql.matches || false;
      };
    }

    return function(mq) {
      var bool = false;

      injectElementWithStyles('@media ' + mq + ' { #modernizr { position: absolute; } }', function(node) {
        bool = (window.getComputedStyle ?
                window.getComputedStyle(node, null) :
                node.currentStyle).position == 'absolute';
      });

      return bool;
    };
  })();


  ModernizrProto.mq = mq;

  

  /**
   * If the browsers follow the spec, then they would expose vendor-specific style as:
   *   elem.style.WebkitBorderRadius
   * instead of something like the following, which would be technically incorrect:
   *   elem.style.webkitBorderRadius

   * Webkit ghosts their properties in lowercase but Opera & Moz do not.
   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
   *   erik.eae.net/archives/2008/03/10/21.48.10/

   * More here: github.com/Modernizr/Modernizr/issues/issue/21
   *
   * @access private
   * @returns {string} The string representing the vendor-specific style properties
   */

  var omPrefixes = 'Moz O ms Webkit';
  

  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
  ModernizrProto._cssomPrefixes = cssomPrefixes;
  


  /**
   * contains checks to see if a string contains another string
   *
   * @access private
   * @function contains
   * @param {string} str - The string we want to check for substrings
   * @param {string} substr - The substring we want to search the first string for
   * @returns {boolean}
   */

  function contains(str, substr) {
    return !!~('' + str).indexOf(substr);
  }

  ;

  /**
   * Create our "modernizr" element that we do most feature tests on.
   *
   * @access private
   */

  var modElem = {
    elem: createElement('modernizr')
  };

  // Clean up this element
  Modernizr._q.push(function() {
    delete modElem.elem;
  });

  

  var mStyle = {
    style: modElem.elem.style
  };

  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
  // the front of the queue.
  Modernizr._q.unshift(function() {
    delete mStyle.style;
  });

  

  /**
   * domToCSS takes a camelCase string and converts it to kebab-case
   * e.g. boxSizing -> box-sizing
   *
   * @access private
   * @function domToCSS
   * @param {string} name - String name of camelCase prop we want to convert
   * @returns {string} The kebab-case version of the supplied name
   */

  function domToCSS(name) {
    return name.replace(/([A-Z])/g, function(str, m1) {
      return '-' + m1.toLowerCase();
    }).replace(/^ms-/, '-ms-');
  }
  ;

  /**
   * nativeTestProps allows for us to use native feature detection functionality if available.
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @access private
   * @function nativeTestProps
   * @param {array} props - An array of property names
   * @param {string} value - A string representing the value we want to check via @supports
   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
   */

  // Accepts a list of property names and a single value
  // Returns `undefined` if native detection not available
  function nativeTestProps(props, value) {
    var i = props.length;
    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
    if ('CSS' in window && 'supports' in window.CSS) {
      // Try every prefixed variant of the property
      while (i--) {
        if (window.CSS.supports(domToCSS(props[i]), value)) {
          return true;
        }
      }
      return false;
    }
    // Otherwise fall back to at-rule (for Opera 12.x)
    else if ('CSSSupportsRule' in window) {
      // Build a condition string for every prefixed variant
      var conditionText = [];
      while (i--) {
        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
      }
      conditionText = conditionText.join(' or ');
      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
        return getComputedStyle(node, null).position == 'absolute';
      });
    }
    return undefined;
  }
  ;

  /**
   * cssToDOM takes a kebab-case string and converts it to camelCase
   * e.g. box-sizing -> boxSizing
   *
   * @access private
   * @function cssToDOM
   * @param {string} name - String name of kebab-case prop we want to convert
   * @returns {string} The camelCase version of the supplied name
   */

  function cssToDOM(name) {
    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
      return m1 + m2.toUpperCase();
    }).replace(/^-/, '');
  }
  ;

  // testProps is a generic CSS / DOM property test.

  // In testing support for a given CSS property, it's legit to test:
  //    `elem.style[styleName] !== undefined`
  // If the property is supported it will return an empty string,
  // if unsupported it will return undefined.

  // We'll take advantage of this quick test and skip setting a style
  // on our modernizr element, but instead just testing undefined vs
  // empty string.

  // Property names can be provided in either camelCase or kebab-case.

  function testProps(props, prefixed, value, skipValueTest) {
    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;

    // Try native detect first
    if (!is(value, 'undefined')) {
      var result = nativeTestProps(props, value);
      if (!is(result, 'undefined')) {
        return result;
      }
    }

    // Otherwise do it properly
    var afterInit, i, propsLength, prop, before;

    // If we don't have a style element, that means we're running async or after
    // the core tests, so we'll need to create our own elements to use

    // inside of an SVG element, in certain browsers, the `style` element is only
    // defined for valid tags. Therefore, if `modernizr` does not have one, we
    // fall back to a less used element and hope for the best.
    var elems = ['modernizr', 'tspan'];
    while (!mStyle.style) {
      afterInit = true;
      mStyle.modElem = createElement(elems.shift());
      mStyle.style = mStyle.modElem.style;
    }

    // Delete the objects if we created them.
    function cleanElems() {
      if (afterInit) {
        delete mStyle.style;
        delete mStyle.modElem;
      }
    }

    propsLength = props.length;
    for (i = 0; i < propsLength; i++) {
      prop = props[i];
      before = mStyle.style[prop];

      if (contains(prop, '-')) {
        prop = cssToDOM(prop);
      }

      if (mStyle.style[prop] !== undefined) {

        // If value to test has been passed in, do a set-and-check test.
        // 0 (integer) is a valid property value, so check that `value` isn't
        // undefined, rather than just checking it's truthy.
        if (!skipValueTest && !is(value, 'undefined')) {

          // Needs a try catch block because of old IE. This is slow, but will
          // be avoided in most cases because `skipValueTest` will be used.
          try {
            mStyle.style[prop] = value;
          } catch (e) {}

          // If the property value has changed, we assume the value used is
          // supported. If `value` is empty string, it'll fail here (because
          // it hasn't changed), which matches how browsers have implemented
          // CSS.supports()
          if (mStyle.style[prop] != before) {
            cleanElems();
            return prefixed == 'pfx' ? prop : true;
          }
        }
        // Otherwise just return true, or the property name if this is a
        // `prefixed()` call
        else {
          cleanElems();
          return prefixed == 'pfx' ? prop : true;
        }
      }
    }
    cleanElems();
    return false;
  }

  ;

  /**
   * List of JavaScript DOM values used for tests
   *
   * @memberof Modernizr
   * @name Modernizr._domPrefixes
   * @optionName Modernizr._domPrefixes
   * @optionProp domPrefixes
   * @access public
   * @example
   *
   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
   * than kebab-case properties, all properties are their Capitalized variant
   *
   * ```js
   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
   * ```
   */

  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
  ModernizrProto._domPrefixes = domPrefixes;
  

  /**
   * testDOMProps is a generic DOM property test; if a browser supports
   *   a certain property, it won't return undefined for it.
   *
   * @access private
   * @function testDOMProps
   * @param {array.<string>} props - An array of properties to test for
   * @param {object} obj - An object or Element you want to use to test the parameters again
   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
   */
  function testDOMProps(props, obj, elem) {
    var item;

    for (var i in props) {
      if (props[i] in obj) {

        // return the property name as a string
        if (elem === false) {
          return props[i];
        }

        item = obj[props[i]];

        // let's bind a function
        if (is(item, 'function')) {
          // bind to obj unless overriden
          return fnBind(item, elem || obj);
        }

        // return the unbound function or obj or value
        return item;
      }
    }
    return false;
  }

  ;

  /**
   * testPropsAll tests a list of DOM properties we want to check against.
   * We specify literally ALL possible (known and/or likely) properties on
   * the element including the non-vendor prefixed one, for forward-
   * compatibility.
   *
   * @access private
   * @function testPropsAll
   * @param {string} prop - A string of the property to test for
   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
   * @param {string} [value] - A string of a css value
   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
   */
  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {

    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
    props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

    // did they call .prefixed('boxSizing') or are we just testing a prop?
    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
      return testProps(props, prefixed, value, skipValueTest);

      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
    } else {
      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
      return testDOMProps(props, prefixed, elem);
    }
  }

  // Modernizr.testAllProps() investigates whether a given style property,
  // or any of its vendor-prefixed variants, is recognized
  //
  // Note that the property names must be provided in the camelCase variant.
  // Modernizr.testAllProps('boxSizing')
  ModernizrProto.testAllProps = testPropsAll;

  

  /**
   * atRule returns a given CSS property at-rule (eg @keyframes), possibly in
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @memberof Modernizr
   * @name Modernizr.atRule
   * @optionName Modernizr.atRule()
   * @optionProp atRule
   * @access public
   * @function atRule
   * @param {string} prop - String name of the @-rule to test for
   * @returns {string|boolean} The string representing the (possibly prefixed)
   * valid version of the @-rule, or `false` when it is unsupported.
   * @example
   * ```js
   *  var keyframes = Modernizr.atRule('@keyframes');
   *
   *  if (keyframes) {
   *    // keyframes are supported
   *    // could be `@-webkit-keyframes` or `@keyframes`
   *  } else {
   *    // keyframes === `false`
   *  }
   * ```
   *
   */

  var atRule = function(prop) {
    var length = prefixes.length;
    var cssrule = window.CSSRule;
    var rule;

    if (typeof cssrule === 'undefined') {
      return undefined;
    }

    if (!prop) {
      return false;
    }

    // remove literal @ from beginning of provided property
    prop = prop.replace(/^@/, '');

    // CSSRules use underscores instead of dashes
    rule = prop.replace(/-/g, '_').toUpperCase() + '_RULE';

    if (rule in cssrule) {
      return '@' + prop;
    }

    for (var i = 0; i < length; i++) {
      // prefixes gives us something like -o-, and we want O_
      var prefix = prefixes[i];
      var thisRule = prefix.toUpperCase() + '_' + rule;

      if (thisRule in cssrule) {
        return '@-' + prefix.toLowerCase() + '-' + prop;
      }
    }

    return false;
  };

  ModernizrProto.atRule = atRule;

  

  /**
   * prefixed returns the prefixed or nonprefixed property name variant of your input
   *
   * @memberof Modernizr
   * @name Modernizr.prefixed
   * @optionName Modernizr.prefixed()
   * @optionProp prefixed
   * @access public
   * @function prefixed
   * @param {string} prop - String name of the property to test for
   * @param {object} [obj] - An object to test for the prefixed properties on
   * @param {HTMLElement} [elem] - An element used to test specific properties against
   * @returns {string|false} The string representing the (possibly prefixed) valid
   * version of the property, or `false` when it is unsupported.
   * @example
   *
   * Modernizr.prefixed takes a string css value in the DOM style camelCase (as
   * opposed to the css style kebab-case) form and returns the (possibly prefixed)
   * version of that property that the browser actually supports.
   *
   * For example, in older Firefox...
   * ```js
   * prefixed('boxSizing')
   * ```
   * returns 'MozBoxSizing'
   *
   * In newer Firefox, as well as any other browser that support the unprefixed
   * version would simply return `boxSizing`. Any browser that does not support
   * the property at all, it will return `false`.
   *
   * By default, prefixed is checked against a DOM element. If you want to check
   * for a property on another object, just pass it as a second argument
   *
   * ```js
   * var rAF = prefixed('requestAnimationFrame', window);
   *
   * raf(function() {
   *  renderFunction();
   * })
   * ```
   *
   * Note that this will return _the actual function_ - not the name of the function.
   * If you need the actual name of the property, pass in `false` as a third argument
   *
   * ```js
   * var rAFProp = prefixed('requestAnimationFrame', window, false);
   *
   * rafProp === 'WebkitRequestAnimationFrame' // in older webkit
   * ```
   *
   * One common use case for prefixed is if you're trying to determine which transition
   * end event to bind to, you might do something like...
   * ```js
   * var transEndEventNames = {
   *     'WebkitTransition' : 'webkitTransitionEnd', * Saf 6, Android Browser
   *     'MozTransition'    : 'transitionend',       * only for FF < 15
   *     'transition'       : 'transitionend'        * IE10, Opera, Chrome, FF 15+, Saf 7+
   * };
   *
   * var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];
   * ```
   *
   * If you want a similar lookup, but in kebab-case, you can use [prefixedCSS](#modernizr-prefixedcss).
   */

  var prefixed = ModernizrProto.prefixed = function(prop, obj, elem) {
    if (prop.indexOf('@') === 0) {
      return atRule(prop);
    }

    if (prop.indexOf('-') != -1) {
      // Convert kebab-case to camelCase
      prop = cssToDOM(prop);
    }
    if (!obj) {
      return testPropsAll(prop, 'pfx');
    } else {
      // Testing DOM property e.g. Modernizr.prefixed('requestAnimationFrame', window) // 'mozRequestAnimationFrame'
      return testPropsAll(prop, obj, elem);
    }
  };

  

  /**
   * prefixedCSS is just like [prefixed](#modernizr-prefixed), but the returned values are in
   * kebab-case (e.g. `box-sizing`) rather than camelCase (boxSizing).
   *
   * @memberof Modernizr
   * @name Modernizr.prefixedCSS
   * @optionName Modernizr.prefixedCSS()
   * @optionProp prefixedCSS
   * @access public
   * @function prefixedCSS
   * @param {string} prop - String name of the property to test for
   * @returns {string|false} The string representing the (possibly prefixed)
   * valid version of the property, or `false` when it is unsupported.
   * @example
   *
   * `Modernizr.prefixedCSS` is like `Modernizr.prefixed`, but returns the result
   * in hyphenated form
   *
   * ```js
   * Modernizr.prefixedCSS('transition') // '-moz-transition' in old Firefox
   * ```
   *
   * Since it is only useful for CSS style properties, it can only be tested against
   * an HTMLElement.
   *
   * Properties can be passed as both the DOM style camelCase or CSS style kebab-case.
   */

  var prefixedCSS = ModernizrProto.prefixedCSS = function(prop) {
    var prefixedProp = prefixed(prop);
    return prefixedProp && domToCSS(prefixedProp);
  };
  

  /**
   * testAllProps determines whether a given CSS property is supported in the browser
   *
   * @memberof Modernizr
   * @name Modernizr.testAllProps
   * @optionName Modernizr.testAllProps()
   * @optionProp testAllProps
   * @access public
   * @function testAllProps
   * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
   * @param {string} [value] - String of the value to test
   * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
   * @example
   *
   * testAllProps determines whether a given CSS property, in some prefixed form,
   * is supported by the browser.
   *
   * ```js
   * testAllProps('boxSizing')  // true
   * ```
   *
   * It can optionally be given a CSS value in string form to test if a property
   * value is valid
   *
   * ```js
   * testAllProps('display', 'block') // true
   * testAllProps('display', 'penguin') // false
   * ```
   *
   * A boolean can be passed as a third parameter to skip the value check when
   * native detection (@supports) isn't available.
   *
   * ```js
   * testAllProps('shapeOutside', 'content-box', true);
   * ```
   */

  function testAllProps(prop, value, skipValueTest) {
    return testPropsAll(prop, undefined, undefined, value, skipValueTest);
  }
  ModernizrProto.testAllProps = testAllProps;
  

  /**
   * testProp() investigates whether a given style property is recognized
   * Property names can be provided in either camelCase or kebab-case.
   *
   * @memberof Modernizr
   * @name Modernizr.testProp
   * @access public
   * @optionName Modernizr.testProp()
   * @optionProp testProp
   * @function testProp
   * @param {string} prop - Name of the CSS property to check
   * @param {string} [value] - Name of the CSS value to check
   * @param {boolean} [useValue] - Whether or not to check the value if @supports isn't supported
   * @returns {boolean}
   * @example
   *
   * Just like [testAllProps](#modernizr-testallprops), only it does not check any vendor prefixed
   * version of the string.
   *
   * Note that the property name must be provided in camelCase (e.g. boxSizing not box-sizing)
   *
   * ```js
   * Modernizr.testProp('pointerEvents')  // true
   * ```
   *
   * You can also provide a value as an optional second argument to check if a
   * specific value is supported
   *
   * ```js
   * Modernizr.testProp('pointerEvents', 'none') // true
   * Modernizr.testProp('pointerEvents', 'penguin') // false
   * ```
   */

  var testProp = ModernizrProto.testProp = function(prop, value, useValue) {
    return testProps([prop], undefined, value, useValue);
  };
  

  /**
   * testStyles injects an element with style element and some CSS rules
   *
   * @memberof Modernizr
   * @name Modernizr.testStyles
   * @optionName Modernizr.testStyles()
   * @optionProp testStyles
   * @access public
   * @function testStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   * @example
   *
   * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
   * along with (possibly multiple) DOM elements. This lets you check for features
   * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
   *
   * ```js
   * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
   *   // elem is the first DOM node in the page (by default #modernizr)
   *   // rule is the first argument you supplied - the CSS rule in string form
   *
   *   addTest('widthworks', elem.style.width === '9px')
   * });
   * ```
   *
   * If your test requires multiple nodes, you can include a third argument
   * indicating how many additional div elements to include on the page. The
   * additional nodes are injected as children of the `elem` that is returned as
   * the first argument to the callback.
   *
   * ```js
   * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
   *   document.getElementById('modernizr').style.width === '1px'; // true
   *   document.getElementById('modernizr2').style.width === '2px'; // true
   *   elem.firstChild === document.getElementById('modernizr2'); // true
   * }, 1);
   * ```
   *
   * By default, all of the additional elements have an ID of `modernizr[n]`, where
   * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
   * the second additional is `#modernizr3`, etc.).
   * If you want to have more meaningful IDs for your function, you can provide
   * them as the fourth argument, as an array of strings
   *
   * ```js
   * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
   *   elem.firstChild === document.getElementById('foo'); // true
   *   elem.lastChild === document.getElementById('bar'); // true
   * }, 2, ['foo', 'bar']);
   * ```
   *
   */

  var testStyles = ModernizrProto.testStyles = injectElementWithStyles;
  

  /**
   * Modernizr.hasEvent() detects support for a given event
   *
   * @memberof Modernizr
   * @name Modernizr.hasEvent
   * @optionName Modernizr.hasEvent()
   * @optionProp hasEvent
   * @access public
   * @function hasEvent
   * @param  {string|*} eventName - the name of an event to test for (e.g. "resize")
   * @param  {Element|string} [element=HTMLDivElement] - is the element|document|window|tagName to test on
   * @returns {boolean}
   * @example
   *  `Modernizr.hasEvent` lets you determine if the browser supports a supplied event.
   *  By default, it does this detection on a div element
   *
   * ```js
   *  hasEvent('blur') // true;
   * ```
   *
   * However, you are able to give an object as a second argument to hasEvent to
   * detect an event on something other than a div.
   *
   * ```js
   *  hasEvent('devicelight', window) // true;
   * ```
   *
   */

  var hasEvent = (function() {

    // Detect whether event support can be detected via `in`. Test on a DOM element
    // using the "blur" event b/c it should always exist. bit.ly/event-detection
    var needsFallback = !('onblur' in document.documentElement);

    function inner(eventName, element) {

      var isSupported;
      if (!eventName) { return false; }
      if (!element || typeof element === 'string') {
        element = createElement(element || 'div');
      }

      // Testing via the `in` operator is sufficient for modern browsers and IE.
      // When using `setAttribute`, IE skips "unload", WebKit skips "unload" and
      // "resize", whereas `in` "catches" those.
      eventName = 'on' + eventName;
      isSupported = eventName in element;

      // Fallback technique for old Firefox - bit.ly/event-detection
      if (!isSupported && needsFallback) {
        if (!element.setAttribute) {
          // Switch to generic element if it lacks `setAttribute`.
          // It could be the `document`, `window`, or something else.
          element = createElement('div');
        }

        element.setAttribute(eventName, '');
        isSupported = typeof element[eventName] === 'function';

        if (element[eventName] !== undefined) {
          // If property was created, "remove it" by setting value to `undefined`.
          element[eventName] = undefined;
        }
        element.removeAttribute(eventName);
      }

      return isSupported;
    }
    return inner;
  })();


  ModernizrProto.hasEvent = hasEvent;
  
/*!
{
  "name": "Hashchange event",
  "property": "hashchange",
  "caniuse": "hashchange",
  "tags": ["history"],
  "notes": [{
    "name": "MDN documentation",
    "href": "https://developer.mozilla.org/en-US/docs/Web/API/window.onhashchange"
  }],
  "polyfills": [
    "jquery-hashchange",
    "moo-historymanager",
    "jquery-ajaxy",
    "hasher",
    "shistory"
  ]
}
!*/
/* DOC
Detects support for the `hashchange` event, fired when the current location fragment changes.
*/

  Modernizr.addTest('hashchange', function() {
    if (hasEvent('hashchange', window) === false) {
      return false;
    }

    // documentMode logic from YUI to filter out IE8 Compat Mode
    //   which false positives.
    return (document.documentMode === undefined || document.documentMode > 7);
  });

/*!
{
  "name": "History API",
  "property": "history",
  "caniuse": "history",
  "tags": ["history"],
  "authors": ["Hay Kranen", "Alexander Farkas"],
  "notes": [{
    "name": "W3C Spec",
    "href": "https://www.w3.org/TR/html51/browsers.html#the-history-interface"
  }, {
    "name": "MDN documentation",
    "href": "https://developer.mozilla.org/en-US/docs/Web/API/window.history"
  }],
  "polyfills": ["historyjs", "html5historyapi"]
}
!*/
/* DOC
Detects support for the History API for manipulating the browser session history.
*/

  Modernizr.addTest('history', function() {
    // Issue #733
    // The stock browser on Android 2.2 & 2.3, and 4.0.x returns positive on history support
    // Unfortunately support is really buggy and there is no clean way to detect
    // these bugs, so we fall back to a user agent sniff :(
    var ua = navigator.userAgent;

    // We only want Android 2 and 4.0, stock browser, and not Chrome which identifies
    // itself as 'Mobile Safari' as well, nor Windows Phone (issue #1471).
    if ((ua.indexOf('Android 2.') !== -1 ||
        (ua.indexOf('Android 4.0') !== -1)) &&
        ua.indexOf('Mobile Safari') !== -1 &&
        ua.indexOf('Chrome') === -1 &&
        ua.indexOf('Windows Phone') === -1) {
      return false;
    }

    // Return the regular check
    return (window.history && 'pushState' in window.history);
  });

/*!
{
  "name": "DOM Pointer Events API",
  "property": "pointerevents",
  "tags": ["input"],
  "authors": ["Stu Cox"],
  "notes": [
    {
      "name": "W3C spec",
      "href": "https://www.w3.org/TR/pointerevents/"
    }
  ],
  "warnings": ["This property name now refers to W3C DOM PointerEvents: https://github.com/Modernizr/Modernizr/issues/548#issuecomment-12812099"],
  "polyfills": ["handjs"]
}
!*/
/* DOC
Detects support for the DOM Pointer Events API, which provides a unified event interface for pointing input devices, as implemented in IE10+.
*/

  // **Test name hijacked!**
  // Now refers to W3C DOM PointerEvents spec rather than the CSS pointer-events property.
  Modernizr.addTest('pointerevents', function() {
    // Cannot use `.prefixed()` for events, so test each prefix
    var bool = false,
    i = domPrefixes.length;

    // Don't forget un-prefixed...
    bool = Modernizr.hasEvent('pointerdown');

    while (i-- && !bool) {
      if (hasEvent(domPrefixes[i] + 'pointerdown')) {
        bool = true;
      }
    }
    return bool;
  });


  /**
   * List of property values to set for css tests. See ticket #21
   * http://git.io/vUGl4
   *
   * @memberof Modernizr
   * @name Modernizr._prefixes
   * @optionName Modernizr._prefixes
   * @optionProp prefixes
   * @access public
   * @example
   *
   * Modernizr._prefixes is the internal list of prefixes that we test against
   * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
   * an array of kebab-case vendor prefixes you can use within your code.
   *
   * Some common use cases include
   *
   * Generating all possible prefixed version of a CSS property
   * ```js
   * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
   *
   * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
   * ```
   *
   * Generating all possible prefixed version of a CSS value
   * ```js
   * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
   *
   * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
   * ```
   */

  var prefixes = (ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : []);

  // expose these for the plugin API. Look in the source for how to join() them against your input
  ModernizrProto._prefixes = prefixes;

  
/*!
{
  "name": "Touch Events",
  "property": "touchevents",
  "caniuse" : "touch",
  "tags": ["media", "attribute"],
  "notes": [{
    "name": "Touch Events spec",
    "href": "https://www.w3.org/TR/2013/WD-touch-events-20130124/"
  }],
  "warnings": [
    "Indicates if the browser supports the Touch Events spec, and does not necessarily reflect a touchscreen device"
  ],
  "knownBugs": [
    "False-positive on some configurations of Nokia N900",
    "False-positive on some BlackBerry 6.0 builds – https://github.com/Modernizr/Modernizr/issues/372#issuecomment-3112695"
  ]
}
!*/
/* DOC
Indicates if the browser supports the W3C Touch Events API.

This *does not* necessarily reflect a touchscreen device:

* Older touchscreen devices only emulate mouse events
* Modern IE touch devices implement the Pointer Events API instead: use `Modernizr.pointerevents` to detect support for that
* Some browsers & OS setups may enable touch APIs when no touchscreen is connected
* Future browsers may implement other event models for touch interactions

See this article: [You Can't Detect A Touchscreen](http://www.stucox.com/blog/you-cant-detect-a-touchscreen/).

It's recommended to bind both mouse and touch/pointer events simultaneously – see [this HTML5 Rocks tutorial](http://www.html5rocks.com/en/mobile/touchandmouse/).

This test will also return `true` for Firefox 4 Multitouch support.
*/

  // Chrome (desktop) used to lie about its support on this, but that has since been rectified: http://crbug.com/36415
  Modernizr.addTest('touchevents', function() {
    var bool;
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      bool = true;
    } else {
      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      var query = ['@media (', prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
      testStyles(query, function(node) {
        bool = node.offsetTop === 9;
      });
    }
    return bool;
  });

/*!
{
  "name": "CSS Animations",
  "property": "cssanimations",
  "caniuse": "css-animation",
  "polyfills": ["transformie", "csssandpaper"],
  "tags": ["css"],
  "warnings": ["Android < 4 will pass this test, but can only animate a single property at a time"],
  "notes": [{
    "name" : "Article: 'Dispelling the Android CSS animation myths'",
    "href": "https://goo.gl/OGw5Gm"
  }]
}
!*/
/* DOC
Detects whether or not elements can be animated using CSS
*/

  Modernizr.addTest('cssanimations', testAllProps('animationName', 'a', true));

/*!
{
  "name": "Flexbox",
  "property": "flexbox",
  "caniuse": "flexbox",
  "tags": ["css"],
  "notes": [{
    "name": "The _new_ flexbox",
    "href": "http://dev.w3.org/csswg/css3-flexbox"
  }],
  "warnings": [
    "A `true` result for this detect does not imply that the `flex-wrap` property is supported; see the `flexwrap` detect."
  ]
}
!*/
/* DOC
Detects support for the Flexible Box Layout model, a.k.a. Flexbox, which allows easy manipulation of layout order and sizing within a container.
*/

  Modernizr.addTest('flexbox', testAllProps('flexBasis', '1px', true));

/*!
{
  "name": "Flexbox (legacy)",
  "property": "flexboxlegacy",
  "tags": ["css"],
  "polyfills": ["flexie"],
  "notes": [{
    "name": "The _old_ flexbox",
    "href": "https://www.w3.org/TR/2009/WD-css3-flexbox-20090723/"
  }]
}
!*/

  Modernizr.addTest('flexboxlegacy', testAllProps('boxDirection', 'reverse', true));

/*!
{
  "name": "Flexbox (tweener)",
  "property": "flexboxtweener",
  "tags": ["css"],
  "polyfills": ["flexie"],
  "notes": [{
    "name": "The _inbetween_ flexbox",
    "href": "https://www.w3.org/TR/2011/WD-css3-flexbox-20111129/"
  }],
  "warnings": ["This represents an old syntax, not the latest standard syntax."]
}
!*/

  Modernizr.addTest('flexboxtweener', testAllProps('flexAlign', 'end', true));

/*!
{
  "name": "CSS Gradients",
  "caniuse": "css-gradients",
  "property": "cssgradients",
  "tags": ["css"],
  "knownBugs": ["False-positives on webOS (https://github.com/Modernizr/Modernizr/issues/202)"],
  "notes": [{
    "name": "Webkit Gradient Syntax",
    "href": "https://webkit.org/blog/175/introducing-css-gradients/"
  },{
    "name": "Linear Gradient Syntax",
    "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/linear-gradient"
  },{
    "name": "W3C Gradient Spec",
    "href": "https://drafts.csswg.org/css-images-3/#gradients"
  }]
}
!*/


  Modernizr.addTest('cssgradients', function() {

    var str1 = 'background-image:';
    var str2 = 'gradient(linear,left top,right bottom,from(#9f9),to(white));';
    var css = '';
    var angle;

    for (var i = 0, len = prefixes.length - 1; i < len; i++) {
      angle = (i === 0 ? 'to ' : '');
      css += str1 + prefixes[i] + 'linear-gradient(' + angle + 'left top, #9f9, white);';
    }

    if (Modernizr._config.usePrefixes) {
    // legacy webkit syntax (FIXME: remove when syntax not in use anymore)
      css += str1 + '-webkit-' + str2;
    }

    var elem = createElement('a');
    var style = elem.style;
    style.cssText = css;

    // IE6 returns undefined so cast to string
    return ('' + style.backgroundImage).indexOf('gradient') > -1;
  });

/*!
{
  "name": "CSS Supports",
  "property": "supports",
  "caniuse": "css-featurequeries",
  "tags": ["css"],
  "builderAliases": ["css_supports"],
  "notes": [{
    "name": "W3 Spec",
    "href": "http://dev.w3.org/csswg/css3-conditional/#at-supports"
  },{
    "name": "Related Github Issue",
    "href": "github.com/Modernizr/Modernizr/issues/648"
  },{
    "name": "W3 Info",
    "href": "http://dev.w3.org/csswg/css3-conditional/#the-csssupportsrule-interface"
  }]
}
!*/

  var newSyntax = 'CSS' in window && 'supports' in window.CSS;
  var oldSyntax = 'supportsCSS' in window;
  Modernizr.addTest('supports', newSyntax || oldSyntax);

/*!
{
  "name": "CSS Transforms 3D",
  "property": "csstransforms3d",
  "caniuse": "transforms3d",
  "tags": ["css"],
  "warnings": [
    "Chrome may occassionally fail this test on some systems; more info: https://code.google.com/p/chromium/issues/detail?id=129004"
  ]
}
!*/

  Modernizr.addTest('csstransforms3d', function() {
    var ret = !!testAllProps('perspective', '1px', true);
    var usePrefix = Modernizr._config.usePrefixes;

    // Webkit's 3D transforms are passed off to the browser's own graphics renderer.
    //   It works fine in Safari on Leopard and Snow Leopard, but not in Chrome in
    //   some conditions. As a result, Webkit typically recognizes the syntax but
    //   will sometimes throw a false positive, thus we must do a more thorough check:
    if (ret && (!usePrefix || 'webkitPerspective' in docElement.style)) {
      var mq;
      var defaultStyle = '#modernizr{width:0;height:0}';
      // Use CSS Conditional Rules if available
      if (Modernizr.supports) {
        mq = '@supports (perspective: 1px)';
      } else {
        // Otherwise, Webkit allows this media query to succeed only if the feature is enabled.
        // `@media (transform-3d),(-webkit-transform-3d){ ... }`
        mq = '@media (transform-3d)';
        if (usePrefix) {
          mq += ',(-webkit-transform-3d)';
        }
      }

      mq += '{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}';

      testStyles(defaultStyle + mq, function(elem) {
        ret = elem.offsetWidth === 7 && elem.offsetHeight === 18;
      });
    }

    return ret;
  });

/*!
{
  "name": "CSS Transitions",
  "property": "csstransitions",
  "caniuse": "css-transitions",
  "tags": ["css"]
}
!*/

  Modernizr.addTest('csstransitions', testAllProps('transition', 'all', true));

/*!
{
  "name": "Form Validation",
  "property": "formvalidation",
  "tags": ["forms", "validation", "attribute"],
  "builderAliases": ["forms_validation"]
}
!*/
/* DOC
This implementation only tests support for interactive form validation.
To check validation for a specific type or a specific other constraint,
the test can be combined:

- `Modernizr.inputtypes.number && Modernizr.formvalidation` (browser supports rangeOverflow, typeMismatch etc. for type=number)
- `Modernizr.input.required && Modernizr.formvalidation` (browser supports valueMissing)
*/

  Modernizr.addTest('formvalidation', function() {
    var form = createElement('form');
    if (!('checkValidity' in form) || !('addEventListener' in form)) {
      return false;
    }
    if ('reportValidity' in form) {
      return true;
    }
    var invalidFired = false;
    var input;

    Modernizr.formvalidationapi =  true;

    // Prevent form from being submitted
    form.addEventListener('submit', function(e) {
      // Old Presto based Opera does not validate form, if submit is prevented
      // although Opera Mini servers use newer Presto.
      if (!window.opera || window.operamini) {
        e.preventDefault();
      }
      e.stopPropagation();
    }, false);

    // Calling form.submit() doesn't trigger interactive validation,
    // use a submit button instead
    //older opera browsers need a name attribute
    form.innerHTML = '<input name="modTest" required="required" /><button></button>';

    testStyles('#modernizr form{position:absolute;top:-99999em}', function(node) {
      node.appendChild(form);

      input = form.getElementsByTagName('input')[0];

      // Record whether "invalid" event is fired
      input.addEventListener('invalid', function(e) {
        invalidFired = true;
        e.preventDefault();
        e.stopPropagation();
      }, false);

      //Opera does not fully support the validationMessage property
      Modernizr.formvalidationmessage = !!input.validationMessage;

      // Submit form by clicking submit button
      form.getElementsByTagName('button')[0].click();
    });

    return invalidFired;
  });

/*!
{
  "name": "Webp",
  "async": true,
  "property": "webp",
  "tags": ["image"],
  "builderAliases": ["img_webp"],
  "authors": ["Krister Kari", "@amandeep", "Rich Bradshaw", "Ryan Seddon", "Paul Irish"],
  "notes": [{
    "name": "Webp Info",
    "href": "https://developers.google.com/speed/webp/"
  }, {
    "name": "Chormium blog - Chrome 32 Beta: Animated WebP images and faster Chrome for Android touch input",
    "href": "https://blog.chromium.org/2013/11/chrome-32-beta-animated-webp-images-and.html"
  }, {
    "name": "Webp Lossless Spec",
    "href": "https://developers.google.com/speed/webp/docs/webp_lossless_bitstream_specification"
  }, {
    "name": "Article about WebP support on Android browsers",
    "href": "http://www.wope-framework.com/en/2013/06/24/webp-support-on-android-browsers/"
  }, {
    "name": "Chormium WebP announcement",
    "href": "https://blog.chromium.org/2011/11/lossless-and-transparency-encoding-in.html?m=1"
  }]
}
!*/
/* DOC
Tests for lossy, non-alpha webp support.

Tests for all forms of webp support (lossless, lossy, alpha, and animated)..

  Modernizr.webp              // Basic support (lossy)
  Modernizr.webp.lossless     // Lossless
  Modernizr.webp.alpha        // Alpha (both lossy and lossless)
  Modernizr.webp.animation    // Animated WebP

*/


  Modernizr.addAsyncTest(function() {

    var webpTests = [{
      'uri': 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=',
      'name': 'webp'
    }, {
      'uri': 'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==',
      'name': 'webp.alpha'
    }, {
      'uri': 'data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
      'name': 'webp.animation'
    }, {
      'uri': 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=',
      'name': 'webp.lossless'
    }];

    var webp = webpTests.shift();
    function test(name, uri, cb) {

      var image = new Image();

      function addResult(event) {
        // if the event is from 'onload', check the see if the image's width is
        // 1 pixel (which indiciates support). otherwise, it fails

        var result = event && event.type === 'load' ? image.width == 1 : false;
        var baseTest = name === 'webp';

        /* jshint -W053 */
        addTest(name, baseTest ? new Boolean(result) : result);

        if (cb) {
          cb(event);
        }
      }

      image.onerror = addResult;
      image.onload = addResult;

      image.src = uri;
    }

    // test for webp support in general
    test(webp.name, webp.uri, function(e) {
      // if the webp test loaded, test everything else.
      if (e && e.type === 'load') {
        for (var i = 0; i < webpTests.length; i++) {
          test(webpTests[i].name, webpTests[i].uri);
        }
      }
    });

  });



  // Run each test
  testRunner();

  // Remove the "no-js" class if it exists
  setClasses(classes);

  delete ModernizrProto.addTest;
  delete ModernizrProto.addAsyncTest;

  // Run the things that are supposed to run after the tests
  for (var i = 0; i < Modernizr._q.length; i++) {
    Modernizr._q[i]();
  }

  // Leak Modernizr namespace
  window.Modernizr = Modernizr;


;

})(window, document);
module.exports = Modernizr;

},{}],16:[function(require,module,exports){
var CartEmpty, CartItems, CartSpinner, CartWidget, I18n, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('../../../core/frontend/groupon_modules/groupon');

ref = require('../../client_templates'), CartItems = ref.CartItems, CartEmpty = ref.CartEmpty, CartSpinner = ref.CartSpinner;

module.exports = CartWidget = (function() {
  function CartWidget(el) {
    var ref1, ref2;
    this.el = el;
    this.renderCartData = bind(this.renderCartData, this);
    this.onComplete = bind(this.onComplete, this);
    this.fetchCartData = bind(this.fetchCartData, this);
    this.$el = $(this.el);
    this.useCartSizeEndpoint = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.LS) != null ? (ref2 = ref1.flags) != null ? ref2.useCartSizeEndpoint : void 0 : void 0 : void 0;
    this.snickerdoodle = Cookie.get('snickerdoodle');
    if (this.$el.length) {
      this.fetch();
    }
  }

  CartWidget.prototype.fetch = function() {
    var complete, data, ref1, ref2, url;
    complete = this.onComplete;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    if (this.useCartSizeEndpoint) {
      url = ((ref1 = Groupon.endpoints) != null ? ref1.cartSize : void 0) || '/cart/size';
      this.$el.one('mouseover', this.fetchCartData);
    } else {
      url = ((ref2 = Groupon.endpoints) != null ? ref2.cart : void 0) || '/cart/widget';
    }
    return $.ajax({
      type: "GET",
      url: url,
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.fetchCartData = function() {
    var complete, data, ref1, translations;
    translations = Groupon.LS.translations.cart;
    this.$el.append(CartSpinner.render({
      translations: translations
    }));
    complete = this.renderCartData;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    return $.ajax({
      type: "GET",
      url: ((ref1 = Groupon.endpoints) != null ? ref1.cart : void 0) || '/cart/widget',
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.onComplete = function(data, textStatus, xhr) {
    var $cartFlyout, hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        if (hasCart) {
          this.showCart({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          });
        } else {
          if (!this.useCartSizeEndpoint) {
            this.showEmptyCart({
              translations: translations
            });
          }
        }
        if (Groupon.LS.hasTouch) {
          $cartFlyout = $('.cart-flyout');
          this.$el.find('.icon-goods').on('tap', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $cartFlyout.toggle();
            $('html').trigger('tap');
            if ($cartFlyout.is(':visible')) {
              return $('html').one('tap', function(e) {
                if ($(e.target).closest('#ls-header-cart-link').length === 0) {
                  return $cartFlyout.hide().attr('aria-hidden', 'true');
                }
              });
            }
          });
        }
      }
    }
    this.$el.addClass('cart-widget-shows');
    return delete window.CartWidget;
  };

  CartWidget.prototype.showCart = function(data) {
    this.renderCartLink(data);
    if (!this.useCartSizeEndpoint) {
      return this.$el.append(CartItems.render(data));
    }
  };

  CartWidget.prototype.renderCartLink = function(data) {
    var markup, quantity, quantity_value, ref1, translations;
    ref1 = data.response, quantity_value = ref1.quantity_value, quantity = ref1.quantity;
    translations = data.translations;
    markup = "<span class='cart-text'>" + translations.cart.desc + " (" + quantity + ")</span>\n<span class='cart-count'>" + quantity_value + "</span>";
    return this.$el.find('.icon-goods, a').html(markup);
  };

  CartWidget.prototype.renderCartData = function(data, textStatus, xhr) {
    var hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    this.$spinnerFlyout = this.$el.find('.cart-flyout.load-spinner');
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        this.$spinnerFlyout.remove();
        if (hasCart) {
          this.renderCartLink({
            response: response,
            translations: translations
          });
          return this.$el.append(CartItems.render({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          }));
        } else {
          return this.showEmptyCart({
            translations: translations
          });
        }
      } else {
        return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
      }
    } else {
      return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
    }
  };

  CartWidget.prototype.showEmptyCart = function(data) {
    this.$el.append(CartEmpty.render(data));
    if (this.useCartSizeEndpoint) {
      return this.$el.find('#ls-cart-link').html(data.translations.cart.cart);
    }
  };

  return CartWidget;

})();



},{"../../../core/frontend/groupon_modules/groupon":5,"../../../node_modules/grapefruit/lib/I18n":22,"../../client_templates":20}],17:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"ls-header-cart-body\" class=\"cart-flyout cart-empty-container\" data-bhw=\"ShoppingCart\" ");if(t.s(t.d("response.uuid",c,p,1),c,p,0,113,154,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" data-bhd='{\"uuid\":\"");t.b(t.v(t.d("response.uuid",c,p,0)));t.b("\"}' ");});c.pop();}t.b(">");t.b("\n" + i);t.b("  <div class=\"cart-empty-body\">");t.b("\n" + i);t.b("    <div class=\"cart-empty-header\">");t.b(t.v(t.d("translations.cart.empty_cart",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("    <p class=\"cart-empty-content\">");t.b(t.v(t.d("translations.cart.empty_text",c,p,0)));t.b(" <a href=\"/goods\">");t.b(t.v(t.d("translations.cart.groupon_goods",c,p,0)));t.b("</a>.</p>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"ls-header-cart-body\" class=\"cart-flyout cart-empty-container\" data-bhw=\"ShoppingCart\" {{#response.uuid}} data-bhd='{\"uuid\":\"{{response.uuid}}\"}' {{/response.uuid}}>\n  <div class=\"cart-empty-body\">\n    <div class=\"cart-empty-header\">{{translations.cart.empty_cart}}</div>\n    <p class=\"cart-empty-content\">{{translations.cart.empty_text}} <a href=\"/goods\">{{translations.cart.groupon_goods}}</a>.</p>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":24}],18:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"cart-flyout cart-container\" data-bhw=\"ShoppingCart\" ");if(t.s(t.d("response.uuid",c,p,1),c,p,0,82,123,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" data-bhd='{\"uuid\":\"");t.b(t.v(t.d("response.uuid",c,p,0)));t.b("\"}' ");});c.pop();}t.b(">");t.b("\n" + i);t.b("  <div class=\"cart-header\">");t.b("\n" + i);t.b("    <div class=\"cart-cell cart-desc\"><span class=\"cart-desc-title\">");t.b(t.v(t.d("translations.cart.desc",c,p,0)));t.b("</span><span class=\"cart-desc-qty\">(");t.b(t.v(t.d("response.quantity",c,p,0)));t.b(")</span></div>");t.b("\n" + i);t.b("    <div class=\"cart-cell cart-quantity\">");t.b(t.v(t.d("translations.cart.quantity",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("    <div class=\"cart-cell cart-price\">");t.b(t.v(t.d("translations.cart.price",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"cart-item-list\">");t.b("\n" + i);if(t.s(t.d("response.items",c,p,1),c,p,0,549,1117,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"cart-item\" data-uuid=\"");t.b(t.v(t.f("option_uuid",c,p,0)));t.b("\" data-bhc=\"deal_option:");t.b(t.v(t.f("deal_permalink",c,p,0)));t.b("+");t.b(t.v(t.f("option_uuid",c,p,0)));t.b("\" data-bhd='{\"deal_uuid\":\"");t.b(t.v(t.f("deal_uuid",c,p,0)));t.b("\", \"deal_permalink\":\"");t.b(t.v(t.f("deal_permalink",c,p,0)));t.b("\", \"option_uuid\":\"");t.b(t.v(t.f("option_uuid",c,p,0)));t.b("\", \"option_quantity\":\"");t.b(t.v(t.f("quantity",c,p,0)));t.b("\"}'>");t.b("\n" + i);t.b("        <div class=\"cart-cell cart-desc\">");t.b("\n" + i);t.b("          <div class=\"cart-img\"><img src=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\"></div>");t.b("\n" + i);t.b("          <div class=\"cart-title\">");t.b(t.v(t.f("title",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"cart-cell cart-quantity\">");t.b(t.v(t.f("quantity",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("        <div class=\"cart-cell cart-price\">");t.b(t.v(t.f("price",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"cart-footer\">");t.b("\n" + i);t.b("    <div class=\"cart-subtotal\">");t.b("\n" + i);t.b("      <div class=\"subtotal-text\">");t.b("\n" + i);t.b("        ");t.b(t.v(t.d("translations.cart.subtotal",c,p,0)));t.b(":<b>");t.b(t.v(t.d("response.subtotal",c,p,0)));t.b("</b>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"cart-links\">");t.b("\n" + i);if(t.s(t.f("showCheckout",c,p,1),c,p,0,1384,1685,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <a href=\"/cart\" class=\"btn-secondary btn-buy btn-small\" data-bhw=\"ViewCart\">");t.b("\n" + i);t.b("          ");t.b(t.v(t.d("translations.cart.view_cart",c,p,0)));t.b("\n" + i);t.b("        </a>");t.b("\n" + i);t.b("        <a href=\"/cart/checkout\" class=\"btn-buy btn-small\" data-bhw=\"ProceedToCheckout\">");t.b("\n" + i);t.b("          ");t.b(t.v(t.d("translations.cart.proceed_to_checkout",c,p,0)));t.b("\n" + i);t.b("        </a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("showCheckout",c,p,1),c,p,1,0,0,"")){t.b("        <a href=\"/cart\" class=\"btn-buy btn-small\" data-bhw=\"ViewCart\">");t.b("\n" + i);t.b("          ");t.b(t.v(t.d("translations.cart.view_cart",c,p,0)));t.b("\n" + i);t.b("        </a>");t.b("\n" + i);};t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"cart-flyout cart-container\" data-bhw=\"ShoppingCart\" {{#response.uuid}} data-bhd='{\"uuid\":\"{{response.uuid}}\"}' {{/response.uuid}}>\n  <div class=\"cart-header\">\n    <div class=\"cart-cell cart-desc\"><span class=\"cart-desc-title\">{{translations.cart.desc}}</span><span class=\"cart-desc-qty\">({{response.quantity}})</span></div>\n    <div class=\"cart-cell cart-quantity\">{{translations.cart.quantity}}</div>\n    <div class=\"cart-cell cart-price\">{{translations.cart.price}}</div>\n  </div>\n  <div class=\"cart-item-list\">\n    {{#response.items}}\n      <div class=\"cart-item\" data-uuid=\"{{option_uuid}}\" data-bhc=\"deal_option:{{deal_permalink}}+{{option_uuid}}\" data-bhd='{\"deal_uuid\":\"{{deal_uuid}}\", \"deal_permalink\":\"{{deal_permalink}}\", \"option_uuid\":\"{{option_uuid}}\", \"option_quantity\":\"{{quantity}}\"}'>\n        <div class=\"cart-cell cart-desc\">\n          <div class=\"cart-img\"><img src=\"{{url}}\"></div>\n          <div class=\"cart-title\">{{title}}</div>\n        </div>\n        <div class=\"cart-cell cart-quantity\">{{quantity}}</div>\n        <div class=\"cart-cell cart-price\">{{price}}</div>\n      </div>\n    {{/response.items}}\n  </div>\n  <div class=\"cart-footer\">\n    <div class=\"cart-subtotal\">\n      <div class=\"subtotal-text\">\n        {{translations.cart.subtotal}}:<b>{{response.subtotal}}</b>\n      </div>\n    </div>\n    <div class=\"cart-links\">\n      {{#showCheckout}}\n        <a href=\"/cart\" class=\"btn-secondary btn-buy btn-small\" data-bhw=\"ViewCart\">\n          {{translations.cart.view_cart}}\n        </a>\n        <a href=\"/cart/checkout\" class=\"btn-buy btn-small\" data-bhw=\"ProceedToCheckout\">\n          {{translations.cart.proceed_to_checkout}}\n        </a>\n      {{/showCheckout}}\n      {{^showCheckout}}\n        <a href=\"/cart\" class=\"btn-buy btn-small\" data-bhw=\"ViewCart\">\n          {{translations.cart.view_cart}}\n        </a>\n      {{/showCheckout}}\n    </div>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":24}],19:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"cart-flyout cart-container load-spinner\" data-bhw=\"ShoppingCart\" ");if(t.s(t.d("response.uuid",c,p,1),c,p,0,95,136,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" data-bhd='{\"uuid\":\"");t.b(t.v(t.d("response.uuid",c,p,0)));t.b("\"}' ");});c.pop();}t.b(">");t.b("\n" + i);t.b("  <span class=\"ls-spinner ls-spinner-green\"></span>");t.b("\n" + i);t.b("  <span class=\"ls-loading-message\">");t.b(t.v(t.d("translations.cart.loading_cart",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"cart-flyout cart-container load-spinner\" data-bhw=\"ShoppingCart\" {{#response.uuid}} data-bhd='{\"uuid\":\"{{response.uuid}}\"}' {{/response.uuid}}>\n  <span class=\"ls-spinner ls-spinner-green\"></span>\n  <span class=\"ls-loading-message\">{{translations.cart.loading_cart}}</span>\n</div>\n", Hogan);
},{"hogan.js":24}],20:[function(require,module,exports){
module.exports = {
  CartItems: require('../cart_widget/templates/cart_items.html.mustache'),
  CartEmpty: require('../cart_widget/templates/cart_empty.html.mustache'),
  CartSpinner: require('../cart_widget/templates/cart_spinner.html.mustache')
};



},{"../cart_widget/templates/cart_empty.html.mustache":17,"../cart_widget/templates/cart_items.html.mustache":18,"../cart_widget/templates/cart_spinner.html.mustache":19}],21:[function(require,module,exports){
/*
* fingerprintJS 0.5.3 - Fast browser fingerprint library
* https://github.com/Valve/fingerprintjs
* Copyright (c) 2013 Valentin Vasilyev (valentin.vasilyev@outlook.com)
* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/

;(function (name, context, definition) {
  if (typeof module !== 'undefined' && module.exports) { module.exports = definition(); }
  else if (typeof define === 'function' && define.amd) { define(definition); }
  else { context[name] = definition(); }
})('Fingerprint', this, function () {
  'use strict';
  
  var Fingerprint = function (options) {
    var nativeForEach, nativeMap;
    nativeForEach = Array.prototype.forEach;
    nativeMap = Array.prototype.map;

    this.each = function (obj, iterator, context) {
      if (obj === null) {
        return;
      }
      if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (iterator.call(context, obj[i], i, obj) === {}) return;
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (iterator.call(context, obj[key], key, obj) === {}) return;
          }
        }
      }
    };

    this.map = function(obj, iterator, context) {
      var results = [];
      // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.
      if (obj == null) return results;
      if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
      this.each(obj, function(value, index, list) {
        results[results.length] = iterator.call(context, value, index, list);
      });
      return results;
    };

    if (typeof options == 'object'){
      this.hasher = options.hasher;
      this.screen_resolution = options.screen_resolution;
      this.canvas = options.canvas;
      this.ie_activex = options.ie_activex;
    } else if(typeof options == 'function'){
      this.hasher = options;
    }
  };

  Fingerprint.prototype = {
    get: function(){
      var keys = [];
      keys.push(navigator.userAgent);
      keys.push(navigator.language);
      keys.push(screen.colorDepth);
      if (this.screen_resolution) {
        var resolution = this.getScreenResolution();
        if (typeof resolution !== 'undefined'){ // headless browsers, such as phantomjs
          keys.push(this.getScreenResolution().join('x'));
        }
      }
      keys.push(new Date().getTimezoneOffset());
      keys.push(this.hasSessionStorage());
      keys.push(this.hasLocalStorage());
      keys.push(!!window.indexedDB);
      //body might not be defined at this point or removed programmatically
      if(document.body){
        keys.push(typeof(document.body.addBehavior));
      } else {
        keys.push(typeof undefined);
      }
      keys.push(typeof(window.openDatabase));
      keys.push(navigator.cpuClass);
      keys.push(navigator.platform);
      keys.push(navigator.doNotTrack);
      keys.push(this.getPluginsString());
      if(this.canvas && this.isCanvasSupported()){
        keys.push(this.getCanvasFingerprint());
      }
      if(this.hasher){
        return this.hasher(keys.join('###'), 31);
      } else {
        return this.murmurhash3_32_gc(keys.join('###'), 31);
      }
    },

    /**
     * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
     * 
     * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
     * @see http://github.com/garycourt/murmurhash-js
     * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
     * @see http://sites.google.com/site/murmurhash/
     * 
     * @param {string} key ASCII only
     * @param {number} seed Positive integer only
     * @return {number} 32-bit positive integer hash 
     */

    murmurhash3_32_gc: function(key, seed) {
      var remainder, bytes, h1, h1b, c1, c2, k1, i;
      
      remainder = key.length & 3; // key.length % 4
      bytes = key.length - remainder;
      h1 = seed;
      c1 = 0xcc9e2d51;
      c2 = 0x1b873593;
      i = 0;
      
      while (i < bytes) {
          k1 = 
            ((key.charCodeAt(i) & 0xff)) |
            ((key.charCodeAt(++i) & 0xff) << 8) |
            ((key.charCodeAt(++i) & 0xff) << 16) |
            ((key.charCodeAt(++i) & 0xff) << 24);
        ++i;
        
        k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

        h1 ^= k1;
            h1 = (h1 << 13) | (h1 >>> 19);
        h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
        h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
      }
      
      k1 = 0;
      
      switch (remainder) {
        case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
        case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
        case 1: k1 ^= (key.charCodeAt(i) & 0xff);
        
        k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
        h1 ^= k1;
      }
      
      h1 ^= key.length;

      h1 ^= h1 >>> 16;
      h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
      h1 ^= h1 >>> 13;
      h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
      h1 ^= h1 >>> 16;

      return h1 >>> 0;
    },

    // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
    hasLocalStorage: function () {
      try{
        return !!window.localStorage;
      } catch(e) {
        return true; // SecurityError when referencing it means it exists
      }
    },
    
    hasSessionStorage: function () {
      try{
        return !!window.sessionStorage;
      } catch(e) {
        return true; // SecurityError when referencing it means it exists
      }
    },

    isCanvasSupported: function () {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    },

    isIE: function () {
      if(navigator.appName === 'Microsoft Internet Explorer') {
        return true;
      } else if(navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)){// IE 11
        return true;
      }
      return false;
    },

    getPluginsString: function () {
      if(this.isIE() && this.ie_activex){
        return this.getIEPluginsString();
      } else {
        return this.getRegularPluginsString();
      }
    },

    getRegularPluginsString: function () {
      return this.map(navigator.plugins, function (p) {
        var mimeTypes = this.map(p, function(mt){
          return [mt.type, mt.suffixes].join('~');
        }).join(',');
        return [p.name, p.description, mimeTypes].join('::');
      }, this).join(';');
    },

    getIEPluginsString: function () {
      if(window.ActiveXObject){
        var names = ['ShockwaveFlash.ShockwaveFlash',//flash plugin
          'AcroPDF.PDF', // Adobe PDF reader 7+
          'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
          'QuickTime.QuickTime', // QuickTime
          // 5 versions of real players
          'rmocx.RealPlayer G2 Control',
          'rmocx.RealPlayer G2 Control.1',
          'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
          'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
          'RealPlayer',
          'SWCtl.SWCtl', // ShockWave player
          'WMPlayer.OCX', // Windows media player
          'AgControl.AgControl', // Silverlight
          'Skype.Detection'];
          
        // starting to detect plugins in IE
        return this.map(names, function(name){
          try{
            new ActiveXObject(name);
            return name;
          } catch(e){
            return null;
          }
        }).join(';');
      } else {
        return ""; // behavior prior version 0.5.0, not breaking backwards compat.
      }
    },

    getScreenResolution: function () {
      return [screen.height, screen.width];
    },

    getCanvasFingerprint: function () {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      // https://www.browserleaks.com/canvas#how-does-it-work
      var txt = 'http://valve.github.io';
      ctx.textBaseline = "top";
      ctx.font = "14px 'Arial'";
      ctx.textBaseline = "alphabetic";
      ctx.fillStyle = "#f60";
      ctx.fillRect(125,1,62,20);
      ctx.fillStyle = "#069";
      ctx.fillText(txt, 2, 15);
      ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
      ctx.fillText(txt, 4, 17);
      return canvas.toDataURL();
    }
  };


  return Fingerprint;

});

},{}],22:[function(require,module,exports){
'use strict';
var HTML_ESCAPE, HTML_ESCAPE_REGEXP, I18n, defaultPlural,
  slice = [].slice,
  hasProp = {}.hasOwnProperty;

HTML_ESCAPE = {
  '"': '&quot;',
  '<': '&lt;',
  '>': '&gt;'
};

HTML_ESCAPE_REGEXP = new RegExp('["<>]', 'g');

defaultPlural = function(n) {
  if (n === 1) {
    return 'one';
  } else {
    return 'other';
  }
};

I18n = (function() {
  function I18n(options) {
    var ref;
    if (options == null) {
      options = {};
    }
    this.locale = 'en_US';
    this.country = 'US';
    this.translations = {};
    this.scope = [];
    this.formats = {};
    this.configure(options);
    this.keyErrors = (ref = options.keyErrors) != null ? ref : {
      count: 0
    };
  }

  I18n.prototype.isInteger = function(n) {
    return (n % 1) === 0;
  };

  I18n.prototype.configure = function(arg) {
    var country, locale, ref, scope, translations;
    ref = arg != null ? arg : {}, locale = ref.locale, country = ref.country, translations = ref.translations, scope = ref.scope;
    if (scope === '') {
      scope = [];
    }
    if ('string' === typeof scope) {
      scope = scope.split('.');
    }
    if (locale != null) {
      this.locale = locale;
    }
    if (country != null) {
      this.country = country.toUpperCase();
    }
    this.lang = this.locale.replace(/([a-z]{2,3}).*/i, '$1').toLowerCase();
    if (translations != null) {
      this.translations = translations;
    }
    if (scope != null) {
      return this.scope = scope;
    }
  };

  I18n.prototype.currentLocale = function() {
    return this.locale;
  };

  I18n.prototype.toJSON = function(scopeOnly) {
    var i, j, ref, scope, tmp, translations;
    if (scopeOnly !== false) {
      scope = this.scope.join('.');
      translations = this.lookup(scope);
      if (this.scope.length > 0) {
        for (i = j = ref = this.scope.length - 1; ref <= 0 ? j <= 0 : j >= 0; i = ref <= 0 ? ++j : --j) {
          tmp = {};
          tmp[this.scope[i]] = translations;
          translations = tmp;
        }
      }
      return {
        locale: this.locale,
        country: this.country,
        translations: translations,
        scope: scope
      };
    } else {
      return {
        locale: this.locale,
        country: this.country,
        translations: this.translations,
        scope: this.scope.join('.')
      };
    }
  };

  I18n.prototype.setPluralRule = function(lang, ruleFn) {
    return I18n.prototype.pluralRules[lang] = ruleFn;
  };

  I18n.prototype.lookup = function(scope, options) {
    var j, keyPath, len1, node, pathEl;
    if (options == null) {
      options = {};
    }
    if (options.defaultValue == null) {
      options.defaultValue = null;
    }
    keyPath = this.prepareKey(scope);
    if (options.countrySpecific) {
      keyPath.push(this.country);
    }
    if (options.scope != null) {
      keyPath = this.prepareKey(options.scope).concat(keyPath);
    }
    node = this.translations;
    for (j = 0, len1 = keyPath.length; j < len1; j++) {
      pathEl = keyPath[j];
      node = node[pathEl];
      if (node == null) {
        break;
      }
    }
    return node != null ? node : options.defaultValue;
  };

  I18n.prototype.translate = function(scope, options) {
    var error, error1, node;
    if (options == null) {
      options = {};
    }
    node = this.lookup(scope, options);
    if (node == null) {
      return this.missingTranslation(scope);
    }
    try {
      if ('object' === typeof node) {
        if ('number' === typeof options.count) {
          return this.pluralize(options.count, scope, options);
        } else {
          return node;
        }
      } else {
        return this.interpolate(node, options);
      }
    } catch (error1) {
      error = error1;
      return this.missingTranslation(scope);
    }
  };

  I18n.prototype.toCurrency = function(number, options) {
    var currencyCode, currencyOptions, format, numberOptions;
    if (typeof options === 'object') {
      currencyCode = options.currencyCode;
      numberOptions = options;
    } else {
      currencyCode = options;
      numberOptions = {
        currencyCode: currencyCode
      };
    }
    if (currencyCode == null) {
      return '[missing currency code]';
    }
    currencyOptions = this.prepareOptions(options, {
      unit: this.lookup("number.symbols.currency." + currencyCode),
      format: this.lookup('number.formats.currency')
    }, {
      unit: currencyCode === 'USD' ? '$' : currencyCode,
      format: '¤#,##0.00;(¤#,##0.00)'
    });
    format = this.parseFormat(currencyOptions.format);
    return this.formatNumber(format, number, numberOptions).replace(/¤/g, currencyOptions.unit);
  };

  I18n.prototype.toNumber = function(number, options) {
    var format, formatString, ref, ref1;
    if (options == null) {
      options = {};
    }
    formatString = (ref = (ref1 = options.format) != null ? ref1 : this.lookup('number.formats.decimal')) != null ? ref : '#,##0.###';
    format = this.prepareOptions(options, this.parseFormat(formatString));
    return this.formatNumber(format, number, options);
  };

  I18n.prototype.formatNumber = function(format, number, options) {
    var d, groupMatch, i, negative, offset, pad, ref, symbols;
    if (options == null) {
      options = {};
    }
    symbols = this.prepareOptions(this.lookup('number.symbols'), {
      decimal: '.',
      group: ','
    });
    pad = function(str, len, c) {
      if (str.length < len) {
        return (new Array(len - str.length + 1)).join(c);
      } else {
        return '';
      }
    };
    negative = number < 0;
    number = Math.abs(Number(number) * format.multiplier);
    if (format.precision >= 0) {
      number = number.toFixed(format.precision);
    }
    ref = number.toString().split('.'), i = ref[0], d = ref[1];
    if (d == null) {
      d = '';
    }
    if (format.decimalDigits < d.length) {
      d = d.replace(/[0]+$/, '');
    }
    if (options.short && /^0*$/.test(d)) {
      d = '';
    } else if (format.decimalDigits > d.length) {
      d += pad(d, format.decimalDigits, '0');
    }
    if (d.length > 0) {
      d = symbols.decimal + d;
    }
    i = pad(i, format.integerDigits, '0') + i;
    if (format.groupSize1 > 0 && i.length > format.groupSize1) {
      offset = i.length % format.groupSize1 || format.groupSize1;
      groupMatch = new RegExp("\\d{" + format.groupSize1 + "}", 'g');
      i = i.substr(0, offset) + i.substr(offset).replace(groupMatch, function(m) {
        return symbols.group + m;
      });
    }
    number = negative ? format.negativePrefix + i + d + format.negativeSuffix : format.positivePrefix + i + d + format.positiveSuffix;
    return number.replace(/%/g, symbols.percentSign).replace(/‰/g, symbols.perMille);
  };

  I18n.prototype.parseFormat = function(pattern) {
    var decPat, format, m, minusSign, p, pat, patterns, pos, pos2, pos3, ref;
    if (this.formats[pattern] != null) {
      return this.formats[pattern];
    }
    if (pattern == null) {
      pattern = '0';
    }
    format = {
      positivePrefix: '',
      positiveSuffix: '',
      negativePrefix: '',
      negativeSuffix: ''
    };
    patterns = pattern.split(';');
    minusSign = (ref = this.lookup('number.symbols.minusSign')) != null ? ref : '-';
    pat = patterns[0];
    if (m = pat.match(/^(.*?)[#,\.0]+(.*?)$/)) {
      format.positivePrefix = m[1];
      format.positiveSuffix = m[2];
    }
    if (patterns.length > 1 && (m = patterns[1].match(/^(.*?)[#,\.0]+(.*?)$/))) {
      format.negativePrefix = m[1];
      format.negativeSuffix = m[2];
    } else {
      format.negativePrefix = minusSign + format.positivePrefix;
      format.negativeSuffix = format.negativeSuffix;
    }
    format.multiplier = pat.indexOf('%') !== -1 ? 100 : pat.indexOf('‰') !== -1 ? 1000 : 1;
    if ((pos = pat.indexOf('.')) !== -1) {
      decPat = pat.substr(pos);
      decPat = decPat.replace(/\.([#]+)([0]+)/, '.$2$1');
      format.decimalDigits = (pos2 = decPat.lastIndexOf('0')) !== -1 ? pos2 : 0;
      format.precision = (pos3 = decPat.lastIndexOf('#')) >= pos2 ? pos3 : format.decimalDigits;
      pat = pat.substr(0, pos);
    } else {
      format.decimalDigits = format.precision = 0;
    }
    p = pat.replace(/,/g, '');
    format.integerDigits = (pos = p.indexOf('0')) !== -1 ? p.lastIndexOf('0') - pos + 1 : 0;
    p = pat.replace(/#/g, '0');
    if ((pos = pat.lastIndexOf(',')) !== -1) {
      format.groupSize1 = p.lastIndexOf('0') - pos;
      if ((pos2 = p.substr(0, pos).lastIndexOf(',')) !== -1) {
        format.groupSize2 = pos - pos2 - 1;
      } else {
        format.groupSize2 = 0;
      }
    } else {
      format.groupSize1 = format.groupSize2 = 0;
    }
    return this.formats[pattern] = format;
  };

  I18n.prototype.prepareKey = function(key) {
    if (key === '') {
      return [];
    }
    if (key[0] === '.') {
      return this.scope.concat(key.substr(1).split('.'));
    } else {
      return key.split('.');
    }
  };

  I18n.prototype.missingTranslation = function() {
    var base, key, scopes;
    scopes = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    key = this.prepareKey(scopes.join('.')).join('.');
    ++this.keyErrors.count;
    if ((base = this.keyErrors).first == null) {
      base.first = key;
    }
    if (typeof TrackingHub !== "undefined" && TrackingHub !== null) {
      TrackingHub.add('missing_translation', {
        key: key
      });
    }
    return "[missing " + this.locale + " '" + key + "' translation]";
  };

  I18n.prototype.interpolate = function(message, options) {
    var j, len1, matches, name, placeholder, ref, regex, value;
    if (options == null) {
      options = {};
    }
    message = message.replace(HTML_ESCAPE_REGEXP, function(htmlMatch) {
      return HTML_ESCAPE[htmlMatch];
    });
    matches = message.match(I18n.PLACEHOLDER);
    if (!matches) {
      return message;
    }
    for (j = 0, len1 = matches.length; j < len1; j++) {
      placeholder = matches[j];
      name = placeholder.replace(I18n.PLACEHOLDER, '$1');
      value = (ref = options[name]) != null ? ref : '[missing ' + placeholder + ' value]';
      regex = new RegExp(placeholder.replace(/\{/gm, '\\{').replace(/\}/gm, '\\}'));
      message = message.replace(regex, value);
    }
    return message;
  };

  I18n.prototype.copyWithScope = function(scope) {
    if (typeof scope === 'string') {
      scope = scope.split('.');
    }
    return new I18n({
      locale: this.locale,
      country: this.country,
      translations: this.translations,
      scope: scope,
      keyErrors: this.keyErrors
    });
  };

  I18n.prototype.scoped = function(scope) {
    return new I18n({
      locale: this.locale,
      country: this.country,
      translations: this.translations,
      scope: this.prepareKey("." + scope),
      keyErrors: this.keyErrors
    });
  };

  I18n.prototype.pluralize = function(count, scope, options) {
    var j, k, keys, len1, msg, node, pluralKey, pluralOpts, v;
    if (options == null) {
      options = {};
    }
    node = this.lookup(scope, options);
    if (!node) {
      return this.missingTranslation(scope);
    }
    pluralOpts = {};
    for (k in options) {
      if (!hasProp.call(options, k)) continue;
      v = options[k];
      pluralOpts[k] = v;
    }
    pluralOpts.count = count;
    msg = null;
    keys = this.pluralKeys(Number(count));
    for (j = 0, len1 = keys.length; j < len1; j++) {
      pluralKey = keys[j];
      if (node[pluralKey] != null) {
        msg = this.interpolate(node[pluralKey], pluralOpts);
        break;
      }
    }
    return msg != null ? msg : this.missingTranslation(scope, keys.pop());
  };

  I18n.prototype.pluralKeys = function(count) {
    var baseRule;
    baseRule = (this.pluralRule())(count);
    if (count === 0 && baseRule !== 'zero') {
      return ['zero', baseRule];
    } else {
      return [baseRule];
    }
  };

  I18n.prototype.prepareOptions = function() {
    var j, k, len1, opts, optsArr, res, v;
    optsArr = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    res = {};
    for (j = 0, len1 = optsArr.length; j < len1; j++) {
      opts = optsArr[j];
      if ('object' !== typeof opts) {
        continue;
      }
      for (k in opts) {
        v = opts[k];
        if (res[k] == null) {
          res[k] = v;
        }
      }
    }
    return res;
  };

  I18n.prototype.pluralRule = function() {
    var ref;
    return (ref = this.pluralRules[this.lang]) != null ? ref : defaultPlural;
  };

  I18n.prototype.pluralRules = {};

  return I18n;

})();

I18n.PLACEHOLDER = /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm;

I18n.prototype.PLACEHOLDER = I18n.PLACEHOLDER;

I18n.prototype.t = I18n.prototype.translate;

I18n.prototype.l = I18n.prototype.localize;

I18n.prototype.p = I18n.prototype.pluralize;

module.exports = I18n;

},{}],23:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],24:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":23,"./template":25}],25:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],26:[function(require,module,exports){
/*! jquery.finger - v0.1.6 - 2016-10-05
* https://github.com/ngryman/jquery.finger
* Copyright (c) 2016 Nicolas Gryman; Licensed MIT */

(function (factory) {
	if (typeof define === 'function' && define.amd)
		define(['jquery'], factory);
	else if (typeof exports === 'object')
		factory(require('jquery'));
	else
		factory(jQuery);
}(function ($) {

	var ua = navigator.userAgent,
		isChrome = /chrome/i.exec(ua),
		isAndroid = /android/i.exec(ua),
		hasTouch = 'ontouchstart' in window && !(isChrome && !isAndroid),
		startEvent = hasTouch ? 'touchstart' : 'mousedown',
		stopEvent = hasTouch ? 'touchend touchcancel' : 'mouseup mouseleave',
		moveEvent = hasTouch ? 'touchmove' : 'mousemove',

		namespace = 'finger',
		rootEl = $('html')[0],

		start = {},
		move = {},
		motion,
		safeguard,
		timeout,
		prevEl,
		prevTime,

		Finger = $.Finger = {
			pressDuration: 300,
			doubleTapInterval: 300,
			flickDuration: 150,
			motionThreshold: 5
		};

	function preventDefault(event) {
		event.preventDefault();
		$.event.remove(rootEl, 'click', preventDefault);
	}

	function page(coord, event) {
		return (hasTouch ? event.originalEvent.touches[0] : event)['page' + coord.toUpperCase()];
	}

	function trigger(event, evtName, remove) {
		var fingerEvent = $.Event(evtName, move);
		$.event.trigger(fingerEvent, { originalEvent: event }, event.target);

		if (fingerEvent.isDefaultPrevented()) {
			if (~evtName.indexOf('tap') && !hasTouch)
				$.event.add(rootEl, 'click', preventDefault);
			else
				event.preventDefault();
		}

		if (remove) {
			$.event.remove(rootEl, moveEvent + '.' + namespace, moveHandler);
			$.event.remove(rootEl, stopEvent + '.' + namespace, stopHandler);
		}
	}

	function startHandler(event) {
		if (event.which > 1)
			return;

		var timeStamp = event.timeStamp || +new Date();

		if (safeguard == timeStamp) return;
		safeguard = timeStamp;

		// initializes data
		start.x = move.x = page('x', event);
		start.y = move.y = page('y', event);
		start.time = timeStamp;
		start.target = event.target;
		move.orientation = null;
		move.end = false;
		motion = false;
		timeout = setTimeout(function() {
			trigger(event, 'press', true);
		}, Finger.pressDuration);

		$.event.add(rootEl, moveEvent + '.' + namespace, moveHandler);
		$.event.add(rootEl, stopEvent + '.' + namespace, stopHandler);

		// global prevent default
		if (Finger.preventDefault) {
			event.preventDefault();
			$.event.add(rootEl, 'click', preventDefault);
		}
	}

	function moveHandler(event) {
		// motion data
		move.x = page('x', event);
		move.y = page('y', event);
		move.dx = move.x - start.x;
		move.dy = move.y - start.y;
		move.adx = Math.abs(move.dx);
		move.ady = Math.abs(move.dy);

		// security
		motion = move.adx > Finger.motionThreshold || move.ady > Finger.motionThreshold;
		if (!motion) return;

		// moves cancel press events
		clearTimeout(timeout);

		// orientation
		if (!move.orientation) {
			if (move.adx > move.ady) {
				move.orientation = 'horizontal';
				move.direction = move.dx > 0 ? +1 : -1;
			}
			else {
				move.orientation = 'vertical';
				move.direction = move.dy > 0 ? +1 : -1;
			}
		}

		// for delegated events, the target may change over time
		// this ensures we notify the right target and simulates the mouseleave behavior
		while (event.target && event.target !== start.target)
			event.target = event.target.parentNode;
		if (event.target !== start.target) {
			event.target = start.target;
			stopHandler.call(this, $.Event(stopEvent + '.' + namespace, event));
			return;
		}

		// fire drag event
		trigger(event, 'drag');
	}

	function stopHandler(event) {
		var timeStamp = event.timeStamp || +new Date(),
			dt = timeStamp - start.time,
			evtName;

		// always clears press timeout
		clearTimeout(timeout);

		// tap-like events
		if (!motion) {
      // triggered only if targets match
      if (event.target === start.target) {
        var doubleTap = prevEl === event.target && timeStamp - prevTime < Finger.doubleTapInterval;
  			evtName = doubleTap ? 'doubletap' : 'tap';
  			prevEl = doubleTap ? null : start.target;
  			prevTime = timeStamp;
      }
		}
		// motion events
		else {
			// ensure last target is set the initial one
			event.target = start.target;
			if (dt < Finger.flickDuration) trigger(event, 'flick');
			move.end = true;
			evtName = 'drag';
		}

    if (evtName)
		  trigger(event, evtName, true);
	}

	// initial binding
	$.event.add(rootEl, startEvent + '.' + namespace, startHandler);

	// expose events as methods
	$.each('tap doubletap press drag flick'.split(' '), function(i, name) {
		$.fn[name] = function(fn) {
			return fn ? this.on(name, fn) : this.trigger(name);
		};
	});

	return Finger;

}));

},{"jquery":27}],27:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v2.1.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:01Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//

var arr = [];

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	version = "2.1.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	},

	isPlainObject: function( obj ) {
		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {
			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf("use strict") === 1 ) {
				script = document.createElement("script");
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {
			// Otherwise, avoid the DOM node creation, insertion
			// and removal by using an indirect global eval
				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];
	nodeType = context.nodeType;

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed && documentIsHTML ) {

		// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
		if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType !== 1 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;
	parent = doc.defaultView;

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Support tests
	---------------------------------------------------------------------- */
	documentIsHTML = !isXML( doc );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {
						// Inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter(function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.unique( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed, false );
	window.removeEventListener( "load", completed, false );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// We once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[0], key ) : emptyGet;
};


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( owner ) {
	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};


function Data() {
	// Support: Android<4,
	// Old WebKit does not have Object.preventExtensions/freeze method,
	// return new empty object instead with no [[set]] accessor
	Object.defineProperty( this.cache = {}, 0, {
		get: function() {
			return {};
		}
	});

	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;
Data.accepts = jQuery.acceptData;

Data.prototype = {
	key: function( owner ) {
		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return the key for a frozen object.
		if ( !Data.accepts( owner ) ) {
			return 0;
		}

		var descriptor = {},
			// Check if the owner object already has a cache key
			unlock = owner[ this.expando ];

		// If not, create one
		if ( !unlock ) {
			unlock = Data.uid++;

			// Secure it in a non-enumerable, non-writable property
			try {
				descriptor[ this.expando ] = { value: unlock };
				Object.defineProperties( owner, descriptor );

			// Support: Android<4
			// Fallback to a less secure definition
			} catch ( e ) {
				descriptor[ this.expando ] = unlock;
				jQuery.extend( owner, descriptor );
			}
		}

		// Ensure the cache object
		if ( !this.cache[ unlock ] ) {
			this.cache[ unlock ] = {};
		}

		return unlock;
	},
	set: function( owner, data, value ) {
		var prop,
			// There may be an unlock assigned to this node,
			// if there is no entry for this "owner", create one inline
			// and set the unlock as though an owner entry had always existed
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {
			// Fresh assignments by object are shallow copied
			if ( jQuery.isEmptyObject( cache ) ) {
				jQuery.extend( this.cache[ unlock ], data );
			// Otherwise, copy the properties one-by-one to the cache object
			} else {
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		// Either a valid cache is found, or will be created.
		// New caches will be created and the unlock returned,
		// allowing direct access to the newly created
		// empty data object. A valid owner object must be provided.
		var cache = this.cache[ this.key( owner ) ];

		return key === undefined ?
			cache : cache[ key ];
	},
	access: function( owner, key, value ) {
		var stored;
		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				((key && typeof key === "string") && value === undefined) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase(key) );
		}

		// [*]When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		if ( key === undefined ) {
			this.cache[ unlock ] = {};

		} else {
			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );
				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;
			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}
	},
	hasData: function( owner ) {
		return !jQuery.isEmptyObject(
			this.cache[ owner[ this.expando ] ] || {}
		);
	},
	discard: function( owner ) {
		if ( owner[ this.expando ] ) {
			delete this.cache[ owner[ this.expando ] ];
		}
	}
};
var data_priv = new Data();

var data_user = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			data_user.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend({
	hasData: function( elem ) {
		return data_user.hasData( elem ) || data_priv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return data_user.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		data_user.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to data_priv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return data_priv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		data_priv.remove( elem, name );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = data_user.get( elem );

				if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice(5) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					data_priv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				data_user.set( this, key );
			});
		}

		return access( this, function( value ) {
			var data,
				camelKey = jQuery.camelCase( key );

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {
				// Attempt to get data from the cache
				// with the key as-is
				data = data_user.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to get data from the cache
				// with the key camelized
				data = data_user.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each(function() {
				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = data_user.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				data_user.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf("-") !== -1 && data !== undefined ) {
					data_user.set( this, key, value );
				}
			});
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each(function() {
			data_user.remove( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = data_priv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = data_priv.access( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return data_priv.get( elem, key ) || data_priv.access( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				data_priv.remove( elem, [ type + "queue", key ] );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = data_priv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};

var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
})();
var strundefined = typeof undefined;



support.focusinBubbles = "onfocusin" in window;


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.hasData( elem ) && data_priv.get( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;
			data_priv.remove( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.disabled !== true || event.type !== "click" ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle, false );
	}
};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && e.stopPropagation ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// Support: Chrome 15+
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// Support: Firefox, Chrome, Safari
// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					data_priv.remove( doc, fix );

				} else {
					data_priv.access( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {

		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: 1.x compatibility
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute("type");
	}

	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		data_priv.set(
			elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
		);
	}
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( data_priv.hasData( src ) ) {
		pdataOld = data_priv.access( src );
		pdataCur = data_priv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( data_user.hasData( src ) ) {
		udataOld = data_user.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		data_user.set( dest, udataCur );
	}
}

function getAll( context, tag ) {
	var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
			context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	},

	cleanData: function( elems ) {
		var data, elem, type, key,
			special = jQuery.event.special,
			i = 0;

		for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
			if ( jQuery.acceptData( elem ) ) {
				key = elem[ data_priv.expando ];

				if ( key && (data = data_priv.cache[ key ]) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}
					if ( data_priv.cache[ key ] ) {
						// Discard any remaining `private` data
						delete data_priv.cache[ key ];
					}
				}
			}
			// Discard any remaining `user` data
			delete data_user.cache[ elem[ data_user.expando ] ];
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each(function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				});
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							// Support: QtWebKit
							// jQuery.merge because push.apply(_, arraylike) throws
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optimization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {
		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		if ( elem.ownerDocument.defaultView.opener ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		}

		return window.getComputedStyle( elem, null );
	};



function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];
	}

	if ( computed ) {

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// Support: iOS < 6
		// A tribute to the "awesome hack by Dean Edwards"
		// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
		// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?
		// Support: IE
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {
				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var pixelPositionVal, boxSizingReliableVal,
		docElem = document.documentElement,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
		"position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computePixelPositionAndBoxSizingReliable() {
		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";
		div.innerHTML = "";
		docElem.appendChild( container );

		var divStyle = window.getComputedStyle( div, null );
		pixelPositionVal = divStyle.top !== "1%";
		boxSizingReliableVal = divStyle.width === "4px";

		docElem.removeChild( container );
	}

	// Support: node.js jsdom
	// Don't assume that getComputedStyle is a property of the global object
	if ( window.getComputedStyle ) {
		jQuery.extend( support, {
			pixelPosition: function() {

				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computePixelPositionAndBoxSizingReliable();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computePixelPositionAndBoxSizingReliable();
				}
				return boxSizingReliableVal;
			},
			reliableMarginRight: function() {

				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );

				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				docElem.appendChild( container );

				ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

				docElem.removeChild( container );
				div.removeChild( marginDiv );

				return ret;
			}
		});
	}
})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
	// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = data_priv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend({

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
				style[ name ] = value;
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur(),
				// break the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = data_priv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// Ensure the complete handler is called before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always(function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		});
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = data_priv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;

			data_priv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || data_priv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = data_priv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = data_priv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
})();


var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {
			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
});




var rfocusable = /^(?:input|select|textarea|button)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each(function() {
			delete this[ jQuery.propFix[ name ] || name ];
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
					elem.tabIndex :
					-1;
			}
		}
	}
});

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = arguments.length === 0 || typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// Toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					data_priv.set( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// Handle most common string cases
					ret.replace(rreturn, "") :
					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE6-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		tmp = new DOMParser();
		xml = tmp.parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = window.location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType[0] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,
			// URL without anti-cache param
			cacheURL,
			// Response headers
			responseHeadersString,
			responseHeaders,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapAll( html.call(this, i) );
			});
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};
jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


jQuery.ajaxSettings.xhr = function() {
	try {
		return new XMLHttpRequest();
	} catch( e ) {}
};

var xhrId = 0,
	xhrCallbacks = {},
	xhrSuccessStatus = {
		// file protocol always yields status code 0, assume 200
		0: 200,
		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE9
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]();
		}
	});
}

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport(function( options ) {
	var callback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr(),
					id = ++xhrId;

				xhr.open( options.type, options.url, options.async, options.username, options.password );

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers["X-Requested-With"] ) {
					headers["X-Requested-With"] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							delete xhrCallbacks[ id ];
							callback = xhr.onload = xhr.onerror = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {
								complete(
									// file: protocol always yields status 0; see #8605, #14207
									xhr.status,
									xhr.statusText
								);
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,
									// Support: IE9
									// Accessing binary-data responseText throws an exception
									// (#11426)
									typeof xhr.responseText === "string" ? {
										text: xhr.responseText
									} : undefined,
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				xhr.onerror = callback("error");

				// Create the abort callback
				callback = xhrCallbacks[ id ] = callback("abort");

				try {
					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {
					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {
	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery("<script>").prop({
					async: true,
					charset: s.scriptCharset,
					src: s.url
				}).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};




var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// Support: BlackBerry 5, iOS 3 (original iPhone)
		// If we don't have gBCR, just use 0,0 rather than error
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : window.pageXOffset,
					top ? val : window.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Support: Safari<7+, Chrome<37+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	});
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));

},{}],28:[function(require,module,exports){
(function (global){
// OptimizeSuite v1.50.0
(function () {

    // Generated by CoffeeScript 1.4.0
    (function () {
        var Evented,
            __slice = [].slice;

        Evented = function (mod) {
            var listeners;
            listeners = {
                "*": []
            };
            mod.on = function (key, listener) {
                var _ref;
                if ((_ref = listeners[key]) == null) {
                    listeners[key] = [];
                }
                return listeners[key].push(listener);
            };
            mod.off = function (key, listenerToRemove) {
                var listener, safeListeners, _i, _len, _ref;
                safeListeners = [];
                _ref = listeners[key];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    listener = _ref[_i];
                    if (listener !== listenerToRemove) {
                        safeListeners.push(listener);
                    }
                }
                return listeners[key] = safeListeners;
            };
            mod.emit = function () {
                var args, key, listener, _i, _j, _len, _len1, _ref, _ref1, _ref2, _results;
                key = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
                if ((_ref = listeners[key]) == null) {
                    listeners[key] = [];
                }
                _ref1 = listeners[key];
                for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                    listener = _ref1[_i];
                    listener.apply(null, args);
                }
                _ref2 = listeners["*"];
                _results = [];
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                    listener = _ref2[_j];
                    _results.push(listener.apply(null, [key].concat(__slice.call(args))));
                }
                return _results;
            };
            return mod;
        };

        this.Evented = Evented;

        if (typeof module !== "undefined" && module.exports) {
            module.exports = Evented;
        }

    }).call(this);
    // Generated by CoffeeScript 1.4.0
    (function () {
        var Exception, bind, emit, exceptionKey, global, init, listeners,
            __slice = [].slice;

        global = this;

        Exception = function (name, msg, file, line, column, originalError) {
            var _ref;
            if (column == null) {
                column = 0;
            }
            this.originalError = originalError;
            this.name = name;
            this.message = msg;
            this.fileName = file;
            this.lineNumber = line;
            this.columnNumber = column;
            this.stack = ((_ref = this.originalError) != null ? _ref.stack : void 0) || "";
            this.timestamp = new Date();
            this.host = window.location.host;
            this.page_url = window.location.href;
            return this.userAgent = window.navigator.userAgent;
        };

        Exception.prototype = new Error();

        Exception.prototype.toString = function () {
            return this.stack;
        };

        listeners = {
            error: []
        };

        init = function () {
            var errorCounts, origOnError;
            errorCounts = {};
            if (window && !(typeof window.onerror === 'undefined')) {
                origOnError = window.onerror || false;
                return window.onerror = function (msg, file, line, column, errorObj) {
                    var exception, key, _ref;
                    if (msg == null) {
                        msg = arguments[0];
                    }
                    if (file == null) {
                        file = arguments[1];
                    }
                    if (line == null) {
                        line = arguments[2];
                    }
                    if (column == null) {
                        column = arguments[3];
                    }
                    if (errorObj == null) {
                        errorObj = arguments[4];
                    }
                    exception = new Exception("Uncaught Error", msg, file, line, column, errorObj);
                    key = exceptionKey(exception);
                    if ((_ref = errorCounts[key]) == null) {
                        errorCounts[key] = 0;
                    }
                    errorCounts[key] += 1;
                    if (errorCounts[key] <= 3) {
                        emit("error", exception);
                    }
                    if (typeof origOnError === "function") {
                        return origOnError(msg, file, line, column, errorObj);
                    } else {
                        return origOnError;
                    }
                };
            }
        };

        exceptionKey = function (e) {
            return "" + e.message + "_" + e.fileName + "_" + e.lineNumber + "_" + e.columnNumber;
        };

        bind = function (eventName, cb) {
            return listeners[eventName].push(cb);
        };

        emit = function () {
            var args, eventName, listener, _i, _len, _ref, _results;
            eventName = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
            _ref = listeners[eventName];
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                listener = _ref[_i];
                _results.push(listener.apply(null, args));
            }
            return _results;
        };

        global.ErrorCatcher = {
            init: init,
            on: bind
        };

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        "use strict";
        var Bloodhound, Evented,
            bind = function (fn, me) {
                return function () {
                    return fn.apply(me, arguments);
                };
            },
            slice = [].slice;

        Evented = this.Evented || noConflictRequire("evented");

        this.Bloodhound = Bloodhound = (function () {
            Evented(Bloodhound);

            Bloodhound.trigger = Bloodhound.emit;

            Bloodhound.reset = function () {};

            function Bloodhound(atts) {
                if (atts == null) {
                    atts = {};
                }
                this._onEvent = bind(this._onEvent, this);
                this.handleErrors = bind(this.handleErrors, this);
                Evented(this);
                this.bind = this.on;
                this.unbind = this.off;
                this.trigger = this.emit;
                this.errorLog = {};
                this.paused = false;
                Bloodhound.initViewportSelectors();
                this.handleErrors((function (_this) {
                    return function () {
                        var updateInterval;
                        _this.eventListeners = {};
                        _this.widgetKey = atts.widgetKey || "bhw";
                        _this.contentKey = atts.contentKey || "bhc";
                        _this.widgetContainer = atts.widgetContainer || $("body");
                        updateInterval = atts.updateInterval || 1000;
                        _this.on("error", function () {
                            var args;
                            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                            return Bloodhound.trigger.apply(Bloodhound, ["error"].concat(slice.call(args)));
                        });
                        _this._initProperties();
                        Bloodhound.Helpers.nextTick(function () {
                            _this._initEvents();
                            return _this.updateWidgets();
                        });
                        Bloodhound.Helpers.eachInterval(updateInterval, function () {
                            if (!_this.paused) {
                                return _this.updateWidgets();
                            }
                        });
                        return _this.setPauseHandlers();
                    };
                })(this));
            }

            Bloodhound.prototype.setPauseHandlers = function () {
                var keydownTimeout;
                $("body").on("focus", "select", (function (_this) {
                    return function () {
                        return _this.paused = true;
                    };
                })(this));
                $("body").on("blur", "select", (function (_this) {
                    return function () {
                        return _this.paused = false;
                    };
                })(this));
                keydownTimeout = null;
                $("body").on("focus", "input", (function (_this) {
                    return function () {
                        return $("body").on("keydown.bloodhound", function () {
                            var unPause;
                            _this.paused = true;
                            if (keydownTimeout) {
                                clearTimeout(keydownTimeout);
                            }
                            unPause = function () {
                                _this.paused = false;
                                return keydownTimeout = null;
                            };
                            return keydownTimeout = setTimeout(unPause, 1000);
                        });
                    };
                })(this));
                return $("body").on("blur", "input", (function (_this) {
                    return function () {
                        $("body").off("keydown.bloodhound");
                        if (keydownTimeout) {
                            clearTimeout(keydownTimeout);
                        }
                        keydownTimeout = null;
                        return _this.paused = false;
                    };
                })(this));
            };

            Bloodhound.prototype.reset = function () {
                this._clearPaths();
                this._initProperties();
                return this._initEvents();
            };

            Bloodhound.prototype.data = function () {
                var out, widget;
                out = {};
                out.widgets = (function () {
                    var i, len, ref, results;
                    ref = this.widgets;
                    results = [];
                    for (i = 0, len = ref.length; i < len; i++) {
                        widget = ref[i];
                        results.push(widget.data());
                    }
                    return results;
                }).call(this);
                return out;
            };

            Bloodhound.prototype.updateWidgets = function () {
                return this.handleErrors((function (_this) {
                    return function () {
                        var newWidgets;
                        newWidgets = _this.widgetFinder.findNew() || [];
                        if (newWidgets.length > 0) {
                            _this.widgets = _this.widgets.concat(newWidgets);
                            return _this.emit("impression", newWidgets);
                        }
                    };
                })(this));
            };

            Bloodhound.prototype.trackEvent = function () {
                var args, ref;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                return (ref = this.events).trackEvent.apply(ref, args);
            };

            Bloodhound.prototype.handleErrors = function (cb) {
                var e, key;
                try {
                    return cb();
                } catch (error) {
                    e = error;
                    key = "" + e.message + e.fileName;
                    if (!this.errorLog[key]) {
                        Bloodhound.Helpers.nextTick((function (_this) {
                            return function () {
                                return _this.emit("error", e);
                            };
                        })(this));
                        return this.errorLog[key] = true;
                    }
                }
            };

            Bloodhound.prototype._onEvent = function (event) {
                return this.emit("event", event);
            };

            Bloodhound.prototype._clearPaths = function () {
                $("[data-" + this.widgetKey + "-path]").removeAttr("data-" + this.widgetKey + "-path");
                return $("[data-" + this.contentKey + "-path]").removeAttr("data-" + this.contentKey + "-path");
            };

            Bloodhound.prototype._initProperties = function () {
                this.widgets = [];
                this.widgetTracker = new Bloodhound.WidgetTracker(this, this.widgetKey, this.contentKey);
                this.widgetFinder = new Bloodhound.WidgetFinder(this.widgetKey, this.contentKey, this.widgetContainer, this, this.widgetTracker);
                return this.events = new Bloodhound.Events({
                    widgetKey: this.widgetKey,
                    contentKey: this.contentKey,
                    container: this.widgetContainer,
                    widgetTracker: this.widgetTracker,
                    bloodhound: this
                });
            };

            Bloodhound.prototype._initEvents = function () {
                this.events.listenToAll();
                return this.events.bind(this._onEvent);
            };

            return Bloodhound;

        })();

    }).call(this);
    // Generated by CoffeeScript 1.11.1

    /*
     * Element finder finds HTML elements, respecting any viewport
     * settings, and returns jQuery objects to the caller.
     */

    (function () {
        var DEFAULT_VIEWPORT_BEHAVIOR,
            bind = function (fn, me) {
                return function () {
                    return fn.apply(me, arguments);
                };
            };

        DEFAULT_VIEWPORT_BEHAVIOR = true;

        Bloodhound.ElementFinder = (function () {
            function ElementFinder(container, widgetKey, contentKey) {
                this.container = container;
                this.widgetKey = widgetKey;
                this.contentKey = contentKey;
                this.ignoresViewport = bind(this.ignoresViewport, this);
            }

            ElementFinder.prototype.getNewWidgets = function () {
                var selector;
                selector = "[data-" + this.widgetKey + "]:visible:not([data-bhw-path])";
                return this.container.find(selector).filter(this.viewportFilter());
            };

            ElementFinder.prototype.getNewContents = function () {
                var selector;
                selector = "[data-" + this.widgetKey + "] [data-" + this.contentKey + "]:visible:not([data-bhc-path])";
                return this.container.find(selector).filter(this.viewportFilter());
            };

            ElementFinder.prototype.getContentsInElement = function (el) {
                return this.getAllContentsInElement(el).filter(this.viewportFilter());
            };

            ElementFinder.prototype.getAllContentsInElement = function (el) {
                var $el, selector;
                $el = $(el);
                selector = "[data-" + this.contentKey + "]:visible:not([data-" + this.widgetKey + "])";
                return $el.find(selector);
            };

            ElementFinder.prototype.isParentWidget = function (contentEl, element) {
                return this.getParentWidget(contentEl).is($(element));
            };

            ElementFinder.prototype.getParentWidget = function (contentEl) {
                return $(contentEl).parents("[data-" + this.widgetKey + "]").eq(0);
            };

            ElementFinder.prototype.viewportFilter = function () {
                var ignoresViewport;
                ignoresViewport = this.ignoresViewport;
                return function () {
                    var $el;
                    $el = $(this);
                    return $el.is(':in-viewport') || ignoresViewport($el);
                };
            };

            ElementFinder.prototype.ignoresViewport = function ($el) {
                var parents;
                if ($el.is('[data-bh-viewport=respect]')) {
                    return false;
                } else if ($el.is("[data-" + this.widgetKey + "][data-bh-viewport=ignore]")) {
                    return true;
                } else {
                    parents = $el.parents("[data-bhw]");
                    if (parents.length > 0) {
                        return this.ignoresViewport(parents.eq(0));
                    } else {
                        return DEFAULT_VIEWPORT_BEHAVIOR;
                    }
                }
            };

            return ElementFinder;

        })();

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        var bind = function (fn, me) {
            return function () {
                return fn.apply(me, arguments);
            };
        };

        Bloodhound.Events = (function () {
            function Events(arg) {
                this.widgetKey = arg.widgetKey, this.contentKey = arg.contentKey, this.container = arg.container, this.widgetTracker = arg.widgetTracker, this.bloodhound = arg.bloodhound;
                this._ensurePathsExist = bind(this._ensurePathsExist, this);
                this.handleEvent = bind(this.handleEvent, this);
                this.events = [];
                this.emitters = [];
                this.eventListeners = [];
                this._updateLength();
                this.selectors = {
                    widgets: "[data-" + this.widgetKey + "], [data-" + this.contentKey + "]",
                    forms: "form[data-" + this.widgetKey + "], form[data-" + this.contentKey + "]"
                };
                this.stopListening();
            }

            Events.prototype.listenToAll = function () {
                var doEvent, handleEvent;
                handleEvent = this.handleEvent;
                doEvent = function (e) {
                    var el;
                    el = $(this);
                    return handleEvent(e, el);
                };
                this.container.delegate(this.selectors.widgets, "click", doEvent);
                return this.container.delegate(this.selectors.forms, "change focusin focusout", doEvent);
            };

            Events.prototype.handleEvent = function (e, widgetEl) {
                var content, el, path, widget;
                el = $(widgetEl);
                this._ensurePathsExist(el);
                if (path = el.attr("data-" + this.contentKey + "-path")) {
                    if (content = this.widgetTracker.getWidgetAtPath(path)) {
                        this._onEvent(e, content);
                    }
                }
                if (path = el.attr("data-" + this.widgetKey + "-path")) {
                    if (widget = this.widgetTracker.getWidgetAtPath(path)) {
                        return this._onEvent(e, widget);
                    }
                }
            };

            Events.prototype.stopListening = function () {
                this.container.undelegate(this.selectors.widgets, "click");
                return this.container.undelegate(this.selectors.forms, "change focusin focusout");
            };

            Events.prototype.pushEvent = function (event) {
                this.events.push(event);
                this[this.length] = event;
                return this._updateLength();
            };

            Events.prototype.trigger = function (event) {
                var func, j, len, ref, results;
                ref = this.eventListeners;
                results = [];
                for (j = 0, len = ref.length; j < len; j++) {
                    func = ref[j];
                    results.push(func(event));
                }
                return results;
            };

            Events.prototype.bind = function (func) {
                return this.eventListeners.push(func);
            };

            Events.prototype.unbind = function (funcToRemove) {
                var func, j, len, newListeners, ref;
                newListeners = [];
                ref = this.eventListeners;
                for (j = 0, len = ref.length; j < len; j++) {
                    func = ref[j];
                    if (func !== funcToRemove) {
                        newListeners.push(func);
                    }
                }
                this.eventListeners = newListeners;
                return this._updateLength();
            };

            Events.prototype.trackEvent = function (e) {
                var innermostWidget, selector, target, widgets;
                target = $(e.target);
                selector = "[data-" + this.widgetKey + "],[data-" + this.contentKey + "]";
                if (target.is(selector)) {
                    return this.handleEvent(e, target);
                } else {
                    widgets = target.parents(selector);
                    innermostWidget = widgets[0];
                    if (innermostWidget) {
                        return this.handleEvent(e, innermostWidget);
                    }
                }
            };

            Events.prototype._onEvent = function (e, widget) {
                var element, event, j, len, meta, parent, ref, ref1, ref2;
                event = this._lookupEvent(e);
                if (event) {

                } else {
                    event = {
                        id: Bloodhound.Helpers.randomId(),
                        jQueryEvent: e,
                        type: e.type,
                        widgets: [widget]
                    };
                    ref = this._parentsFromPath(widget.path);
                    for (j = 0, len = ref.length; j < len; j++) {
                        parent = ref[j];
                        event.widgets.push(parent);
                    }
                    element = $(e.target);
                    meta = {};
                    if (element) {
                        meta.element_id = element.attr('id');
                        meta.element_node = element[0].nodeName.toLowerCase();
                        if (element.attr('type')) {
                            meta.element_type = element.attr('type');
                        }
                    }
                    if (((ref1 = e.type) === 'change' || ref1 === 'focusout') && element.is('input:text, textarea, input:password, select')) {
                        meta.populated = !!element.val();
                    }
                    if (e.type === 'change' && element.is('input:radio, input:checkbox')) {
                        meta.checked = element.is(':checked');
                    }
                    if (e.type === 'click') {
                        event.clickType = (ref2 = _.find(event.widgets, function (w) {
                            return w.clickType;
                        })) != null ? ref2.clickType : void 0;
                    }
                    if (!_.isEmpty(meta)) {
                        event.meta = meta;
                    }
                    this.pushEvent(event);
                    this.trigger(event);
                    return Bloodhound.Helpers.nextTick((function (_this) {
                        return function () {
                            return _this._removeEvent(event);
                        };
                    })(this));
                }
            };

            Events.prototype._lookupEvent = function (e) {
                var event, j, len, ref;
                ref = this.events;
                for (j = 0, len = ref.length; j < len; j++) {
                    event = ref[j];
                    if (event.jQueryEvent.originalEvent === e.originalEvent) {
                        return event;
                    }
                }
                return null;
            };

            Events.prototype._updateLength = function () {
                return this.length = this.events.length;
            };

            Events.prototype._removeEvent = function (event) {
                var e, i, j, len, ref;
                ref = this.events;
                for (i = j = 0, len = ref.length; j < len; i = ++j) {
                    e = ref[i];
                    if (e === event) {
                        this.events.splice(i, 1);
                        this._updateLength();
                        return;
                    }
                }
            };

            Events.prototype._parentsFromPath = function (path) {
                var delimiter, newPath, out, parts;
                out = [];
                delimiter = Bloodhound.Helpers.pathDelimiter;
                parts = path.split(delimiter);
                parts.pop();
                if (parts.length === 0) {
                    return out;
                }
                newPath = parts.join(delimiter);
                out.push(this.widgetTracker.getWidgetAtPath(newPath));
                out = out.concat(this._parentsFromPath(newPath));
                return out;
            };

            Events.prototype._ensurePathsExist = function ($el) {
                if (!($el.data(this.contentKey + "-path") || $el.data(this.widgetKey + "-path"))) {
                    return this.bloodhound.updateWidgets();
                }
            };

            return Events;

        })();

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        var S4, counter;

        counter = 0;

        Bloodhound.Helpers = {
            seed: null,
            pathDelimiter: "|",
            randomId: function () {
                var id;
                id = this.seed + "-" + (new Date().getTime()) + "-" + counter;
                counter += 1;
                return id;
            },
            nextTick: function (func) {
                return setTimeout(func);
            },
            error: function (message) {
                throw new Error("Bloodhound: " + message);
            },
            eachInterval: function (millis, func) {
                return setInterval(func, millis);
            },
            reset: function () {
                return counter = 0;
            },
            pathToElement: function (type, element, widgetKey, contentKey) {
                var $el, $p, content, i, len, names, p, parents, path, widget, widgetName;
                $el = $(element);
                parents = $el.parents("[data-" + widgetKey + "]:visible, [data-" + contentKey + "]:visible");
                names = [];
                for (i = 0, len = parents.length; i < len; i++) {
                    p = parents[i];
                    $p = $(p);
                    content = $p.attr("data-" + contentKey);
                    widget = $p.attr("data-" + widgetKey);
                    if (content) {
                        names.unshift(content);
                    }
                    if (widget) {
                        names.unshift(widget);
                    }
                }
                switch (type) {
                case "widget":
                    names.push($el.attr("data-" + widgetKey));
                    break;
                case "content":
                    widgetName = $el.attr("data-" + widgetKey);
                    if (widgetName) {
                        names.push(widgetName);
                    }
                    names.push($el.attr("data-" + contentKey));
                }
                path = names.join(Bloodhound.Helpers.pathDelimiter);
                return path;
            }
        };

        S4 = function () {
            var rand;
            return rand = (((1 + Math.random()) * 0x10000) | 0).toString(16);
        };

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        Bloodhound.initViewportSelectors = function () {

            /*
             * Viewport - jQuery selectors for finding elements in viewport
             *
             * Copyright (c) 2008-2009 Mika Tuupola
             *
             * Licensed under the MIT license:
             *   http://www.opensource.org/licenses/mit-license.php
             *
             * Project home:
             *  http://www.appelsiini.net/projects/viewport
             *
             */
            var $;
            $ = jQuery;
            if ($.inviewport) {
                return;
            }
            $.belowthefold = function (element, settings) {
                var fold;
                fold = $(window).height() + $(window).scrollTop();
                return fold <= $(element).offset().top - settings.threshold;
            };
            $.abovethetop = function (element, settings) {
                var top;
                top = $(window).scrollTop();
                return top >= $(element).offset().top + $(element).height() - settings.threshold;
            };
            $.rightofscreen = function (element, settings) {
                var fold;
                fold = $(window).width() + $(window).scrollLeft();
                return fold <= $(element).offset().left - settings.threshold;
            };
            $.leftofscreen = function (element, settings) {
                var left;
                left = $(window).scrollLeft();
                return left >= $(element).offset().left + $(element).width() - settings.threshold;
            };
            $.inviewport = function (element, settings) {
                return !$.rightofscreen(element, settings) && !$.leftofscreen(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
            };
            return $.extend($.expr[':'], {
                "below-the-fold": function (a, i, m) {
                    return $.belowthefold(a, {
                        threshold: 0
                    });
                },
                "above-the-top": function (a, i, m) {
                    return $.abovethetop(a, {
                        threshold: 0
                    });
                },
                "left-of-screen": function (a, i, m) {
                    return $.leftofscreen(a, {
                        threshold: 0
                    });
                },
                "right-of-screen": function (a, i, m) {
                    return $.rightofscreen(a, {
                        threshold: 0
                    });
                },
                "in-viewport": function (a, i, m) {
                    return $.inviewport(a, {
                        threshold: 0
                    });
                }
            });
        };

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        var slice = [].slice;

        Bloodhound.WidgetContent = (function () {
            function WidgetContent(atts) {
                var mesg, path, ref;
                ref = atts.name.split(":"), this.type = ref[0], this.name = ref[1];
                this.element = atts.element, this.position = atts.position, this.path = atts.path, this.metadata = atts.metadata;
                this.positionValue = this.getPositionValue();
                if (!(this.type && this.name)) {
                    path = this.widgetPath();
                    mesg = "Incomplete widget content '" + atts.name + "' for widget '" + path + "'";
                    Bloodhound.Helpers.error(mesg);
                }
            }

            WidgetContent.prototype.setTypePosition = function (val) {
                return this.typePosition = val;
            };

            WidgetContent.prototype.getPositionValue = function () {
                var pos;
                if (!(pos = $(this.element).offset())) {
                    return;
                }
                return 1e6 * pos.top + pos.left;
            };

            WidgetContent.prototype.widgetPath = function () {
                var content, delim, i, ref, widgetPath;
                delim = Bloodhound.Helpers.pathDelimiter;
                ref = this.path.split(delim), widgetPath = 2 <= ref.length ? slice.call(ref, 0, i = ref.length - 1) : (i = 0, []), content = ref[i++];
                return widgetPath.join(delim);
            };

            WidgetContent.prototype.data = function () {
                var out;
                out = {
                    type: this.type,
                    name: this.name,
                    position: this.position,
                    typePosition: this.typePosition,
                    height: Math.round($(this.element).height()),
                    width: Math.round($(this.element).width())
                };
                if (this.metadata) {
                    out.data = this.metadata;
                }
                return out;
            };

            return WidgetContent;

        })();

    }).call(this);
    // Generated by CoffeeScript 1.11.1

    /*
     * Widget finder's responsibility is to delegate to element finder
     * to find widget or content elements, build Widget or
     * WidgetContent objects from the untracked elements, and return them.
     */

    (function () {
        Bloodhound.WidgetFinder = (function () {
            function WidgetFinder(widgetKey, contentKey, container, bloodhound, widgetTracker) {
                this.widgetKey = widgetKey;
                this.contentKey = contentKey;
                this.bloodhound = bloodhound;
                this.widgetTracker = widgetTracker;
                this.elFinder = new Bloodhound.ElementFinder(container, this.widgetKey, this.contentKey);
                this.newWidgetContents = [];
                this.contentTypeCounts = {};
            }

            WidgetFinder.prototype.findNew = function () {
                var newWidgets;
                newWidgets = this._findNewWidgets().concat(this._findNewContentElements());
                this._setContentTypePositions();
                return newWidgets;
            };

            WidgetFinder.prototype._findNewWidgets = function () {
                var widgetElements;
                widgetElements = this.elFinder.getNewWidgets();
                return this.widgetTracker.mapUntracked(widgetElements, (function (_this) {
                    return function (i, el) {
                        return _this._widgetFromElement(el);
                    };
                })(this));
            };

            WidgetFinder.prototype._findNewContentElements = function () {
                var extraContentElements;
                extraContentElements = this.elFinder.getNewContents();
                return this.widgetTracker.mapUntracked(extraContentElements, (function (_this) {
                    return function (i, el) {
                        var $el, parentWidget;
                        $el = $(el);
                        parentWidget = $el.parents("[data-" + _this.widgetKey + "]")[0];
                        return _this._widgetFromElement(parentWidget);
                    };
                })(this));
            };

            WidgetFinder.prototype._setContentTypePositions = function () {
                var base, content, j, len, name, sorted;
                sorted = _.sortBy(this.newWidgetContents, function (wc) {
                    return wc.positionValue;
                });
                for (j = 0, len = sorted.length; j < len; j++) {
                    content = sorted[j];
                    if ((base = this.contentTypeCounts)[name = content.type] == null) {
                        base[name] = 0;
                    }
                    content.setTypePosition(this.contentTypeCounts[content.type]);
                    this.contentTypeCounts[content.type] += 1;
                }
                return this.newWidgetContents = [];
            };

            WidgetFinder.prototype._widgetFromElement = function (element) {
                var $el, allContent, content, foundContent, path, widget;
                $el = $(element);
                content = [];
                foundContent = this.elFinder.getContentsInElement(element);
                allContent = this.elFinder.getAllContentsInElement(element);
                this.widgetTracker.mapUntracked(foundContent, (function (_this) {
                    return function (i, contentEl) {
                        var position;
                        if (_this.elFinder.isParentWidget(contentEl, element)) {
                            position = _this._lookUpContentPosition(contentEl, allContent);
                            return content.push(_this._contentFromElement(contentEl, position));
                        }
                    };
                })(this));
                if ($el.is("[data-" + this.contentKey + "]")) {
                    this.bloodhound.handleErrors((function (_this) {
                        return function () {
                            return content.push(_this._contentFromElement($el, 0));
                        };
                    })(this));
                }
                path = this.widgetTracker.getWidgetPath(element);
                widget = new Bloodhound.Widget({
                    element: element,
                    name: $el.data(this.widgetKey),
                    content: content,
                    path: path,
                    metadata: $el.data("bhd"),
                    clickType: $el.data("bhclick")
                });
                this.widgetTracker.registerWidget(widget);
                return widget;
            };

            WidgetFinder.prototype._contentFromElement = function (element, position) {
                var $el, content, error, path;
                $el = $(element);
                path = this.widgetTracker.getContentPath(element);
                try {
                    content = new Bloodhound.WidgetContent({
                        element: element,
                        name: $el.data(this.contentKey),
                        position: position,
                        path: path,
                        metadata: $el.data("bhd")
                    });
                } catch (error1) {
                    error = error1;
                    this.widgetTracker.handleBadContent($el);
                    throw error;
                }
                this.widgetTracker.registerContent(content);
                this.newWidgetContents.push(content);
                return content;
            };

            WidgetFinder.prototype._lookUpContentPosition = function (contentElement, contentElements) {
                var $contentElement, el, prunedContent, type;
                $contentElement = $(contentElement);
                type = this._extractContentType($contentElement);
                prunedContent = (function () {
                    var j, len, results;
                    results = [];
                    for (j = 0, len = contentElements.length; j < len; j++) {
                        el = contentElements[j];
                        if (this._extractContentType($(el)) === type) {
                            results.push(el);
                        }
                    }
                    return results;
                }).call(this);
                return $.inArray($contentElement[0], prunedContent);
            };

            WidgetFinder.prototype._extractContentType = function ($element) {
                return $element.data('bhc').split(':')[0];
            };

            return WidgetFinder;

        })();

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        var pathToElement;

        pathToElement = Bloodhound.Helpers.pathToElement;

        Bloodhound.WidgetTracker = (function () {
            function WidgetTracker(bloodhound, widgetKey, contentKey) {
                this.bloodhound = bloodhound;
                this.widgetKey = widgetKey;
                this.contentKey = contentKey;
                this.trackedObjects = {};
            }

            WidgetTracker.prototype.mapUntracked = function (elements, func) {
                var out;
                out = [];
                this.eachUntracked(elements, function (i, el) {
                    return out.push(func(i, el));
                });
                return out;
            };

            WidgetTracker.prototype.eachUntracked = function (elements, func) {
                return elements.each((function (_this) {
                    return function (i, e) {
                        return _this.bloodhound.handleErrors(function () {
                            var $e, path;
                            $e = $(e);
                            if ($e.is("[data-" + _this.widgetKey + "]")) {
                                path = pathToElement("widget", e, _this.widgetKey, _this.contentKey);
                                if (!_this.trackedObjects[path]) {
                                    func.call(_this, i, e, path);
                                }
                            }
                            if ($e.is("[data-" + _this.contentKey + "]")) {
                                path = pathToElement("content", e, _this.widgetKey, _this.contentKey);
                                if (!_this.trackedObjects[path]) {
                                    return func.call(_this, i, e, path);
                                }
                            }
                        });
                    };
                })(this));
            };

            WidgetTracker.prototype.getWidgetPath = function (element) {
                return pathToElement('widget', element, this.widgetKey, this.contentKey);
            };

            WidgetTracker.prototype.getContentPath = function (element) {
                return pathToElement('content', element, this.widgetKey, this.contentKey);
            };

            WidgetTracker.prototype.handleBadContent = function (element) {
                var $el, badVal;
                $el = $(element);
                badVal = $el.attr("data-" + this.contentKey);
                $el.removeAttr("data-" + this.contentKey);
                return element.attr("data-" + this.contentKey + "-error", badVal);
            };

            WidgetTracker.prototype.registerWidget = function (widget) {
                return this.registerTrackingObject(widget, this.widgetKey);
            };

            WidgetTracker.prototype.registerContent = function (content) {
                return this.registerTrackingObject(content, this.contentKey);
            };

            WidgetTracker.prototype.registerTrackingObject = function (obj, key) {
                var $el, path;
                path = obj.path;
                $el = $(obj.element);
                $el.attr("data-" + key + "-path", path);
                return this.trackedObjects[path] = obj;
            };

            WidgetTracker.prototype.getWidgetAtPath = function (path) {
                return this.trackedObjects[path];
            };

            return WidgetTracker;

        })();

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        Bloodhound.Widget = (function () {
            function Widget(atts) {
                this.name = atts.name;
                this.element = atts.element;
                this.path = atts.path;
                this.content = atts.content || [];
                this.metadata = atts.metadata;
                this.clickType = atts.clickType;
                if (!this.element) {
                    Bloodhound.Helpers.error("Widget does not exist for '" + this.name + "'");
                }
                if (!this.name) {
                    Bloodhound.Helpers.error('Incomplete widget (no name)');
                }
            }

            Widget.prototype.data = function () {
                var item, out;
                out = {
                    name: this.name,
                    height: Math.round($(this.element).height()),
                    width: Math.round($(this.element).width())
                };
                if (this.metadata) {
                    out.data = this.metadata;
                }
                if (this.content.length > 0) {
                    out.content = (function () {
                        var i, len, ref, results;
                        ref = this.content;
                        results = [];
                        for (i = 0, len = ref.length; i < len; i++) {
                            item = ref[i];
                            results.push(item.data());
                        }
                        return results;
                    }).call(this);
                }
                return out;
            };

            Widget.prototype.value = function () {
                return $(this.element).val();
            };

            return Widget;

        })();

    }).call(this);
    (function (f) {
        if (typeof exports === "object" && typeof module !== "undefined") {
            module.exports = f()
        } else if (typeof define === "function" && define.amd) {
            define([], f)
        } else {
            var g;
            if (typeof window !== "undefined") {
                g = window
            } else if (typeof global !== "undefined") {
                g = global
            } else if (typeof self !== "undefined") {
                g = self
            } else {
                g = this
            }
            g.TrackingHub = f()
        }
    })(function () {
        var define, module, exports;
        return (function e(t, n, r) {
            function s(o, u) {
                if (!n[o]) {
                    if (!t[o]) {
                        var a = typeof noConflictRequire == "function" && noConflictRequire;
                        if (!u && a) return a(o, !0);
                        if (i) return i(o, !0);
                        var f = new Error("Cannot find module '" + o + "'");
                        throw f.code = "MODULE_NOT_FOUND", f
                    }
                    var l = n[o] = {
                        exports: {}
                    };
                    t[o][0].call(l.exports, function (e) {
                        var n = t[o][1][e];
                        return s(n ? n : e)
                    }, l, l.exports, e, t, n, r)
                }
                return n[o].exports
            }
            var i = typeof noConflictRequire == "function" && noConflictRequire;
            for (var o = 0; o < r.length; o++) s(r[o]);
            return s
        })({
            1: [
                function (noConflictRequire, module, exports) {
                    var Beagle, Evented, Visibility, Warehouse, isArray, isObject, jsonSafe, messagesFromJson, postParse, rejectExpired,
                        slice = [].slice;

                    Evented = this.Evented || noConflictRequire("optimize-evented");

                    Warehouse = noConflictRequire("./warehouse");

                    Visibility = noConflictRequire('./visibility');

                    Beagle = function () {
                        Evented(this);
                        this.buffer = [];
                        return this;
                    };

                    Evented(Beagle);

                    Beagle.nextTick = function (func) {
                        return setTimeout(func);
                    };

                    Beagle.setTimeout = function (func, millis) {
                        return setTimeout(func, millis);
                    };

                    Beagle.prototype.add = function (name, data) {
                        var obj;
                        if (data == null) {
                            data = {};
                        }
                        obj = {
                            name: name,
                            data: data,
                            timestamp: new Date()
                        };
                        this.buffer.push(obj);
                        return this.emit("add", obj);
                    };

                    Beagle.prototype.flush = function () {
                        var messages;
                        if (Visibility.visibilityState() === 'prerender') {
                            return [];
                        }
                        messages = this.buffer;
                        this.buffer = [];
                        if (messages.length > 0) {
                            this.emit("flush", messages);
                        }
                        return messages;
                    };

                    Beagle.prototype.log = function () {
                        var args;
                        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                        this.emit.apply(this, ["log"].concat(slice.call(args)));
                        return Beagle.emit.apply(Beagle, ["log"].concat(slice.call(args)));
                    };

                    Beagle.prototype.use = function (middleware) {
                        return middleware(this);
                    };

                    Beagle.prototype.trigger = Beagle.prototype.emit;

                    Beagle.Timer = function (millis, maxMillis) {
                        var currentMillis, middleware, onBeforeUnload, running;
                        running = true;
                        if (maxMillis == null) {
                            maxMillis = millis;
                        }
                        currentMillis = millis;
                        middleware = function (beagle) {
                            var func, schedule;
                            func = function () {
                                if (running) {
                                    beagle.flush();
                                    beagle.log("Flushed by Beagle.Timer(" + millis + ")");
                                    return schedule();
                                }
                            };
                            schedule = function () {
                                return Beagle.setTimeout(func, currentMillis);
                            };
                            Beagle.nextTick((function () {}));
                            return schedule();
                        };
                        middleware.cancel = function () {
                            return running = false;
                        };
                        middleware.resume = function () {
                            return running = true;
                        };
                        middleware.backoff = function () {
                            currentMillis *= 1.5;
                            if (currentMillis > maxMillis) {
                                return currentMillis = maxMillis;
                            }
                        };
                        middleware.success = function () {
                            return currentMillis = millis;
                        };
                        middleware;
                        if (typeof window !== "undefined") {
                            onBeforeUnload = function (e) {
                                middleware.cancel();
                                e = e || window.event;
                                if (e) {
                                    try {
                                        delete e.returnValue;
                                    } catch (_error) {
                                        e.returnValue = void 0;
                                    }
                                }
                                return void 0;
                            };
                            if (window.addEventListener) {
                                window.addEventListener("beforeunload", onBeforeUnload, false);
                            } else if (window.attachEvent) {
                                window.attachEvent("onbeforeunload", onBeforeUnload);
                            }
                        }
                        return middleware;
                    };

                    Beagle.SizeThreshold = function (threshold) {
                        return function (beagle) {
                            var dataSize;
                            dataSize = 0;
                            beagle.on("add", function (data) {
                                dataSize += JSON.stringify(data).length;
                                if (dataSize > threshold) {
                                    beagle.flush();
                                    return beagle.log("Flushed by Beagle.SizeThreshold(" + threshold + "), size is " + dataSize + ".");
                                }
                            });
                            return beagle.on("flush", function (data) {
                                return dataSize = 0;
                            });
                        };
                    };

                    Beagle.ExternalLinks = function (delay) {
                        if (delay == null) {
                            delay = 500;
                        }
                        return function (beagle) {
                            return $("body").delegate("a[href^='http']", "click", function (e) {
                                var origE, redirect, url;
                                origE = e.originalEvent;
                                if (!(e.isDefaultPrevented() || origE.defaultPrevented || origE.returnValue === false)) {
                                    e.preventDefault();
                                    url = $(e.currentTarget).attr("href");
                                    redirect = function () {
                                        return window.location.href = url;
                                    };
                                    setTimeout(redirect, delay);
                                    beagle.flush();
                                    return beagle.log("Flushed by Beagle.ExternalLinks(" + delay + "), redirecting to " + url + ".");
                                }
                            });
                        };
                    };

                    Beagle.Persistence = function (store, expiry) {
                        var MSGS_KEY, retrievePersisted;
                        MSGS_KEY = "msgs";
                        if (expiry == null) {
                            expiry = 1000 * 60 * 60 * 24 * 30;
                        }
                        if (typeof store === 'string') {
                            store = new Warehouse(store);
                        }
                        retrievePersisted = function (beagle) {
                            var json, msgs;
                            beagle.store = store;
                            if (store.getAllLocal != null) {
                                json = store.getAllLocal();
                                msgs = messagesFromJson(json, MSGS_KEY);
                                if (msgs != null) {
                                    beagle.buffer = beagle.buffer.concat(msgs);
                                }
                            }
                            return store.getAll(function (err, json) {
                                var messages;
                                if (err) {
                                    beagle.log("Storage error", err);
                                }
                                messages = messagesFromJson(json, MSGS_KEY);
                                if (messages != null) {
                                    return beagle.buffer = messages;
                                }
                            });
                        };
                        return function (beagle) {
                            beagle.on("add", function (data) {
                                data._expires = new Date().getTime() + expiry;
                                return store.appendTo(MSGS_KEY, jsonSafe(data), function (err) {
                                    delete data._expires;
                                    if (err) {
                                        beagle.flush();
                                        return beagle.log("Flushed by Beagle.Persistence due to storage error.", err);
                                    }
                                });
                            });
                            beagle.on("flush", function () {
                                return store.unset(MSGS_KEY);
                            });
                            return retrievePersisted(beagle);
                        };
                    };

                    Beagle.Console = function () {
                        return function (beagle) {
                            beagle.on("add", function (message) {
                                return console.log("Beagle::add", message);
                            });
                            beagle.on("flush", function (messages) {
                                return console.log("Beagle::flush", messages);
                            });
                            return beagle.on("log", function () {
                                var args;
                                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                                return console.log.apply(console, ["Beagle::log"].concat(slice.call(args)));
                            });
                        };
                    };

                    messagesFromJson = function (json, MSGS_KEY) {
                        if (json == null) {
                            return null;
                        }
                        json = json[MSGS_KEY];
                        if (json != null) {
                            return rejectExpired(postParse(json));
                        } else {
                            return null;
                        }
                    };

                    jsonSafe = function (val) {
                        var i, item, k, len, out, results, v;
                        if (val instanceof Error) {
                            return {
                                name: val.name,
                                stack: val.stack,
                                message: val.message
                            };
                        } else if (val instanceof Date) {
                            return "date-" + (val.getTime());
                        } else if (isObject(val)) {
                            out = {};
                            for (k in val) {
                                v = val[k];
                                out[k] = jsonSafe(v);
                            }
                            return out;
                        } else if (isArray(val)) {
                            results = [];
                            for (i = 0, len = val.length; i < len; i++) {
                                item = val[i];
                                results.push(jsonSafe(item));
                            }
                            return results;
                        } else {
                            return val;
                        }
                    };

                    rejectExpired = function (messages) {
                        var currentMessages, i, len, m, now;
                        now = new Date().getTime();
                        currentMessages = [];
                        for (i = 0, len = messages.length; i < len; i++) {
                            m = messages[i];
                            if (m._expires && m._expires > now) {
                                delete m._expires;
                                currentMessages.push(m);
                            }
                        }
                        return currentMessages;
                    };

                    isArray = function (arr) {
                        if (Array.isArray) {
                            return Array.isArray(arr);
                        } else {
                            return Object.prototype.toString.call(arr) === "[object Array]";
                        }
                    };

                    isObject = function (obj) {
                        return typeof obj === "object" && !isArray(obj) && obj !== null;
                    };

                    postParse = function (val) {
                        var date, i, item, k, len, millis, out, results, v;
                        if (typeof val === "string" && /^date-\d+$/.test(val)) {
                            millis = val.substr(5, val.length - 5);
                            date = new Date();
                            date.setTime(millis);
                            return date;
                        } else if (isObject(val)) {
                            out = {};
                            for (k in val) {
                                v = val[k];
                                out[k] = postParse(v);
                            }
                            return out;
                        } else if (isArray(val)) {
                            results = [];
                            for (i = 0, len = val.length; i < len; i++) {
                                item = val[i];
                                results.push(postParse(item));
                            }
                            return results;
                        } else {
                            return val;
                        }
                    };

                    if (typeof window !== "undefined" && window !== null) {
                        window.Beagle = Beagle;
                    }

                    if (typeof module !== "undefined" && module.exports) {
                        module.exports = Beagle;
                    }


                }, {
                    "./visibility": 11,
                    "./warehouse": 12,
                    "optimize-evented": 15
                }
            ],
            2: [
                function (noConflictRequire, module, exports) {
                    var BrowserDetect, parser;

                    parser = noConflictRequire('ua-parser-latest/js/client-parser');

                    BrowserDetect = {
                        init: function () {
                            var browserData;
                            browserData = BrowserDetect.info(window.navigator.userAgent);
                            return this.setAPI(browserData);
                        },
                        setAPI: function (browserData) {
                            this.OS = browserData.OS;
                            this.version = browserData.version;
                            this.browser = browserData.browser;
                            this.device = browserData.device;
                            this.deviceType = browserData.deviceType;
                            return browserData;
                        },
                        getOSFromFamily: function (family) {
                            if (!family) {
                                return 'Other';
                            }
                            if (family.match(/windows (?!phone)/i)) {
                                family = 'Windows';
                            } else if (family.match(/windows phone/i)) {
                                family = 'Windows Phone';
                            } else if (family.match(/mac/i)) {
                                family = 'Mac';
                            }
                            return family || 'an unknown OS';
                        },
                        getBrowserFromFamily: function (family) {
                            if (!family) {
                                return 'Other';
                            }
                            if (family.match(/silk/i)) {
                                family = 'Amazon Silk';
                            } else if (family.match(/blackberry webkit/i)) {
                                family = 'BlackBerry WebKit';
                            }
                            return family;
                        },
                        info: function (userAgent) {
                            var info;
                            if (userAgent) {
                                info = parser.parse(userAgent);
                                return {
                                    OS: this.getOSFromFamily(info.os.family),
                                    browser: this.getBrowserFromFamily(info.ua.family),
                                    version: info.ua.major ? info.ua.major + "." + info.ua.minor : 'Other',
                                    device: info.device ? info.device.family : 'Other',
                                    deviceType: info.device.type ? info.device.type : 'Other'
                                };
                            } else {
                                return {
                                    OS: 'Other',
                                    browser: 'Other',
                                    deviceType: 'Other',
                                    version: 'Other',
                                    device: 'Other'
                                };
                            }
                        }
                    };

                    if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
                        module.exports = BrowserDetect;
                    }


                }, {
                    "ua-parser-latest/js/client-parser": 21
                }
            ],
            3: [
                function (noConflictRequire, module, exports) {
                    var Warehouse, warehouses;

                    Warehouse = noConflictRequire('./warehouse');

                    warehouses = {};

                    module.exports = function (namespace) {
                        return warehouses[namespace] != null ? warehouses[namespace] : warehouses[namespace] = new Warehouse(namespace);
                    };


                }, {
                    "./warehouse": 12
                }
            ],
            4: [
                function (noConflictRequire, module, exports) {
                    (function (global) {
                        var bothArrays, bothObjects, deepMerge, isArray, isObject, mergeable, neitherArrays, ref;

                        ref = global._ || noConflictRequire('underscore'), isArray = ref.isArray, isObject = ref.isObject;

                        bothArrays = function (obj1, obj2) {
                            return isArray(obj1) && isArray(obj2);
                        };

                        neitherArrays = function (obj1, obj2) {
                            return !(isArray(obj1) || isArray(obj2));
                        };

                        bothObjects = function (obj1, obj2) {
                            return neitherArrays(obj1, obj2) && isObject(obj1) && isObject(obj2);
                        };

                        mergeable = function (obj1, obj2) {
                            return bothArrays(obj1, obj2) || bothObjects(obj1, obj2);
                        };

                        module.exports = deepMerge = function (obj1, obj2) {
                            var key, mergedObj, val;
                            if (isArray(obj1) && isArray(obj2)) {
                                return obj1.concat(obj2);
                            } else {
                                mergedObj = {};
                                for (key in obj1) {
                                    val = obj1[key];
                                    mergedObj[key] = val;
                                }
                                for (key in obj2) {
                                    val = obj2[key];
                                    if ((mergedObj[key] != null) && mergeable(mergedObj[key], val)) {
                                        mergedObj[key] = deepMerge(mergedObj[key], val);
                                    } else {
                                        mergedObj[key] = val;
                                    }
                                }
                                return mergedObj;
                            }
                        };


                    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
                }, {
                    "underscore": 13
                }
            ],
            5: [
                function (noConflictRequire, module, exports) {
                    (function (global) {
                        var BEAGLE_NAMESPACE, BUFFER_NAMESPACE, Beagle, DEFAULT_EXPIRY, DEFAULT_MAX_TIMER, DEFAULT_TIMER, InFlightMessageBuffer, Tracky, Warehouse, bufferCount, clone, extend, isArray, ref;

                        Tracky = noConflictRequire('tracky.js');

                        Warehouse = noConflictRequire('./warehouse');

                        Beagle = noConflictRequire('./beagle');

                        ref = global._ || noConflictRequire('underscore'), isArray = ref.isArray, clone = ref.clone, extend = ref.extend;

                        BUFFER_NAMESPACE = 'inFlightMessages';

                        BEAGLE_NAMESPACE = 'retryQueue';

                        bufferCount = 0;

                        DEFAULT_EXPIRY = 24 * 60 * 60 * 1000;

                        DEFAULT_TIMER = 5 * 1000;

                        DEFAULT_MAX_TIMER = 10 * 60 * 1000;

                        module.exports = InFlightMessageBuffer = (function () {
                            function InFlightMessageBuffer(config) {
                                var key, message, undeliveredMessages;
                                this.config = config;
                                this.beagle = this._initBeagle(this.config.inFlightStore);
                                this.tracky = this._initTracky();
                                this.buffered = this._initBuffer();
                                undeliveredMessages = this.buffered.getAll();
                                for (key in undeliveredMessages) {
                                    message = undeliveredMessages[key];
                                    this.track(message);
                                    this.buffered.unset(key);
                                }
                            }

                            InFlightMessageBuffer.prototype._initBeagle = function (store) {
                                var beagle, messageExpiry;
                                if (this.beagle) {
                                    return;
                                }
                                beagle = new Beagle(store);
                                messageExpiry = this.config.messageExpiry || DEFAULT_EXPIRY;
                                beagle.use(Beagle.Persistence(BEAGLE_NAMESPACE, messageExpiry));
                                this.retryTimer = Beagle.Timer(DEFAULT_TIMER, DEFAULT_MAX_TIMER);
                                beagle.use(this.retryTimer);
                                beagle.on('flush', (function (_this) {
                                    return function (messages) {
                                        var message, trackyData;
                                        trackyData = (function () {
                                            var i, len, results;
                                            results = [];
                                            for (i = 0, len = messages.length; i < len; i++) {
                                                message = messages[i];
                                                results.push(extend(clone(message.data), {
                                                    event_client_timestamp: new Date(message.timestamp.getTime()),
                                                    event_name: message.name
                                                }));
                                            }
                                            return results;
                                        })();
                                        return _this.track(trackyData);
                                    };
                                })(this));
                                return beagle;
                            };

                            InFlightMessageBuffer.prototype._initBuffer = function () {
                                return new Warehouse(BUFFER_NAMESPACE);
                            };

                            InFlightMessageBuffer.prototype._initTracky = function () {
                                Tracky.endpoint = this.config.endpoint;
                                Tracky.seed = this.config.seed;
                                return Tracky;
                            };

                            InFlightMessageBuffer.prototype._queueForRetry = function (messages) {
                                var i, len, message, results;
                                results = [];
                                for (i = 0, len = messages.length; i < len; i++) {
                                    message = messages[i];
                                    results.push(this._enqueueMessage(message.event_name, message));
                                }
                                return results;
                            };

                            InFlightMessageBuffer.prototype._nextBufferKey = function () {
                                var key;
                                key = this.config.seed + new Date().getTime() + bufferCount;
                                bufferCount += 1;
                                return key;
                            };

                            InFlightMessageBuffer.prototype._enqueueMessage = function (name, message) {
                                return this.beagle.add(name, message);
                            };

                            InFlightMessageBuffer.prototype._log = function (messages, callbacks) {
                                return this.tracky.logWithCallbacks(messages, callbacks);
                            };

                            InFlightMessageBuffer.prototype.track = function (messages) {
                                var bufferKey;
                                messages = isArray(messages) ? messages : [messages];
                                bufferKey = this._nextBufferKey();
                                this.buffered.set(bufferKey, messages);
                                return this._log(messages, {
                                    success: (function (_this) {
                                        return function () {
                                            _this.retryTimer.success();
                                            return _this.buffered.unset(bufferKey);
                                        };
                                    })(this),
                                    failure: (function (_this) {
                                        return function () {
                                            _this.retryTimer.backoff();
                                            _this._queueForRetry(messages);
                                            return _this.buffered.unset(bufferKey);
                                        };
                                    })(this)
                                });
                            };

                            return InFlightMessageBuffer;

                        })();


                    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
                }, {
                    "./beagle": 1,
                    "./warehouse": 12,
                    "tracky.js": 20,
                    "underscore": 13
                }
            ],
            6: [
                function (noConflictRequire, module, exports) {
                    var Page;

                    module.exports = Page = (function () {
                        function Page(TrackingHub, attributes) {
                            var i, key, len, ref;
                            if (attributes == null) {
                                attributes = {};
                            }
                            this.id = attributes.id || TrackingHub.randomId();
                            ref = ["id", "widgets"];
                            for (i = 0, len = ref.length; i < len; i++) {
                                key = ref[i];
                                delete attributes[key];
                            }
                            this.metadata = attributes;
                        }

                        Page.prototype.data = function () {
                            var d, key, ref, val;
                            d = {};
                            ref = this.metadata;
                            for (key in ref) {
                                val = ref[key];
                                d[key] = val;
                            }
                            d.id = this.id;
                            return d;
                        };

                        return Page;

                    })();


                }, {}
            ],
            7: [
                function (noConflictRequire, module, exports) {
                    (function (global) {
                        var Beagle, CHANNEL_NAME, CONNECTION_FAILED, CONNECTION_PENDING, CONNECTION_SUCCEEDED, Portal, SecureStorageClient, appendIframe, checkCallback, createIframe, getMethodArgs, getOrigin, getStore, merge, methodConfigs, ref, validateCall,
                            slice = [].slice;

                        Portal = noConflictRequire('optimize-portal');

                        Beagle = noConflictRequire('./beagle');

                        getStore = noConflictRequire('./data-store');

                        merge = noConflictRequire('./deep-merge');

                        ref = noConflictRequire('./secure-storage-method-config'), validateCall = ref.validateCall, getMethodArgs = ref.getMethodArgs, methodConfigs = ref.methodConfigs;

                        CHANNEL_NAME = 'secure-storage';

                        CONNECTION_FAILED = 'connectionFailed';

                        CONNECTION_SUCCEEDED = 'connectionSucceeded';

                        CONNECTION_PENDING = 'connectionPending';

                        getOrigin = function (url) {
                            var a, port;
                            a = document.createElement('a');
                            a.href = url;
                            port = a.port === '' ? '' : a.port === '443' && a.protocol === 'https:' ? '' : a.port === '80' && a.protocol === 'http:' ? '' : ":" + a.port;
                            return a.protocol + "//" + a.hostname + port;
                        };

                        createIframe = function (url) {
                            var iframe;
                            iframe = document.createElement('iframe');
                            iframe.style.display = 'none';
                            iframe.src = url;
                            return iframe;
                        };

                        appendIframe = function (iframe) {
                            var body;
                            body = document.getElementsByTagName('body')[0];
                            return body.appendChild(iframe);
                        };

                        checkCallback = function (callback) {
                            if (callback == null) {
                                throw new Error('No callback found');
                            }
                        };

                        SecureStorageClient = (function () {
                            function SecureStorageClient(namespace1, url, domready) {
                                var iframe;
                                this.namespace = namespace1;
                                if (domready == null) {
                                    domready = null;
                                }
                                if (!(this.namespace && this.namespace !== "")) {
                                    throw new Error("A valid namespace is required");
                                }
                                if (!(url && url !== "")) {
                                    throw new Error("A valid url is required");
                                }
                                this.requestCounter = 0;
                                this.connection = CONNECTION_PENDING;
                                this.requestIdSeed = "" + (new Date().getTime());
                                this.messageQueues = {};
                                this.callbacks = {};
                                this.localStore = getStore(this.namespace);
                                iframe = createIframe(url);
                                if (domready == null) {
                                    domready = SecureStorageClient.domready || noConflictRequire('domready');
                                }
                                domready((function (_this) {
                                    return function () {
                                        appendIframe(iframe);
                                        _this.portalChannel = Portal(global, iframe.contentWindow, getOrigin(url), new Beagle)(CHANNEL_NAME);
                                        return _this._listenOnChannel();
                                    };
                                })(this));
                            }

                            SecureStorageClient.prototype.get = function (key, cb) {
                                var id, message;
                                if (!this._isConnectionFailed()) {
                                    id = this._requestId('get');
                                    this._addCallback(id, cb);
                                    message = {
                                        key: key
                                    };
                                    return this._sendMessage('get', id, message);
                                } else {
                                    return this.localStore.get(key, cb);
                                }
                            };

                            SecureStorageClient.prototype.getAll = function (cb) {
                                var message;
                                if (!this._isConnectionFailed()) {
                                    message = this._getAllMessage(cb);
                                    return this._sendMessage('getAll', message.id, message);
                                } else {
                                    return this.localStore.getAll(cb);
                                }
                            };

                            SecureStorageClient.prototype.set = function (keyOrObj, value, cb) {
                                var id, message;
                                if (cb == null) {
                                    cb = null;
                                }
                                if (this._isConnected()) {
                                    if (cb === null && typeof value === 'function') {
                                        cb = value;
                                        message = {
                                            keyOrObj: keyOrObj
                                        };
                                    } else {
                                        message = {
                                            keyOrObj: keyOrObj,
                                            value: value
                                        };
                                    }
                                    if (cb == null) {
                                        cb = function () {};
                                    }
                                    id = this._requestId('set');
                                    this._addCallback(id, cb);
                                    return this._sendMessage('set', id, message);
                                } else {
                                    return this.localStore.set(keyOrObj, value, cb);
                                }
                            };

                            SecureStorageClient.prototype.setAll = function (data, cb) {
                                var id, message;
                                if (cb == null) {
                                    cb = function () {};
                                }
                                if (this._isConnected()) {
                                    id = this._requestId('setAll');
                                    this._addCallback(id, cb);
                                    message = {
                                        data: data
                                    };
                                    return this._sendMessage('setAll', id, message);
                                } else {
                                    return this.localStore.setAll(data, cb);
                                }
                            };

                            SecureStorageClient.prototype.unset = function (key, cb) {
                                var id, message;
                                if (cb == null) {
                                    cb = function () {};
                                }
                                if (this._isConnected()) {
                                    id = this._requestId('unset');
                                    this._addCallback(id, cb);
                                    message = {
                                        key: key
                                    };
                                    return this._sendMessage('unset', id, message);
                                } else {
                                    return this.localStore.unset(key, cb);
                                }
                            };

                            SecureStorageClient.prototype.unsetAll = function (cb) {
                                var id;
                                if (cb == null) {
                                    cb = function () {};
                                }
                                if (this._isConnected()) {
                                    id = this._requestId('unsetAll');
                                    this._addCallback(id, cb);
                                    return this._sendMessage('unsetAll', id);
                                } else {
                                    return this.localStore.unsetAll(cb);
                                }
                            };

                            SecureStorageClient.prototype.appendTo = function (key, data, cb) {
                                var id, message;
                                if (cb == null) {
                                    cb = function () {};
                                }
                                if (this._isConnected()) {
                                    id = this._requestId('appendTo');
                                    this._addCallback(id, cb);
                                    message = {
                                        key: key,
                                        data: data
                                    };
                                    return this._sendMessage('appendTo', id, message);
                                } else {
                                    return this.localStore.appendTo(key, data, cb);
                                }
                            };

                            SecureStorageClient.prototype.getAllLocal = function () {
                                return this.localStore.getAll();
                            };

                            SecureStorageClient.prototype._getAllMessage = function (cb) {
                                var id, namespace;
                                id = this._requestId('getAll');
                                this._addCallback(id, cb);
                                namespace = this.namespace;
                                return {
                                    id: id,
                                    namespace: namespace
                                };
                            };

                            SecureStorageClient.prototype._requestId = function (type) {
                                var id;
                                if (type == null) {
                                    type = 'generic';
                                }
                                id = type + "-" + this.requestIdSeed + "-" + (new Date().getTime()) + "-" + this.requestCounter;
                                this.requestCounter += 1;
                                return id;
                            };

                            SecureStorageClient.prototype._addCallback = function (id, callback) {
                                if (this.callbacks[id] != null) {
                                    throw new Error('Callback with that ID exists');
                                }
                                return this.callbacks[id] = callback;
                            };

                            SecureStorageClient.prototype._removeCallback = function (id) {
                                var callback;
                                if (this.callbacks[id] != null) {
                                    callback = this.callbacks[id];
                                    delete this.callbacks[id];
                                    return callback;
                                } else {
                                    return null;
                                }
                            };

                            SecureStorageClient.prototype._getValidatedCallback = function (methodConfig, message) {
                                var callback, err;
                                err = validateCall(methodConfig, message);
                                callback = this._removeCallback(message.id);
                                checkCallback(callback);
                                if (err) {
                                    callback(err);
                                    return null;
                                } else {
                                    return callback;
                                }
                            };

                            SecureStorageClient.prototype._listenOnChannel = function () {
                                var checkResponse, i, j, len, len1, message, messagesWithResults, messagesWithoutResults, onRequestComplete, onRequestCompleteWithData;
                                checkResponse = function () {
                                    var i, key, keys, len, message, results;
                                    message = arguments[0], keys = 2 <= arguments.length ? slice.call(arguments, 1) : [];
                                    if ((message != null ? message.id : void 0) == null) {
                                        throw new Error('Malformed response');
                                    }
                                    results = [];
                                    for (i = 0, len = keys.length; i < len; i++) {
                                        key = keys[i];
                                        if (message[key] == null) {
                                            throw new Error("Malformed response, missing " + key);
                                        } else {
                                            results.push(void 0);
                                        }
                                    }
                                    return results;
                                };
                                onRequestCompleteWithData = (function (_this) {
                                    return function (message) {
                                        var cb, data, error, id;
                                        checkResponse(message);
                                        id = message.id, error = message.error, data = message.data;
                                        cb = _this._removeCallback(id);
                                        checkCallback(cb);
                                        return cb(error, data);
                                    };
                                })(this);
                                onRequestComplete = (function (_this) {
                                    return function (message) {
                                        var cb, error, id;
                                        checkResponse(message);
                                        id = message.id, error = message.error;
                                        cb = _this._removeCallback(id);
                                        return typeof cb === "function" ? cb(error) : void 0;
                                    };
                                })(this);
                                messagesWithResults = ['getComplete', 'getAllComplete'];
                                messagesWithoutResults = ['setComplete', 'setAllComplete', 'unsetComplete', 'unsetAllComplete', 'appendToComplete'];
                                for (i = 0, len = messagesWithResults.length; i < len; i++) {
                                    message = messagesWithResults[i];
                                    this.portalChannel.on(message, onRequestCompleteWithData);
                                }
                                for (j = 0, len1 = messagesWithoutResults.length; j < len1; j++) {
                                    message = messagesWithoutResults[j];
                                    this.portalChannel.on(message, onRequestComplete);
                                }
                                this.portalChannel.on(CONNECTION_FAILED, (function (_this) {
                                    return function () {
                                        return _this._onConnectionFailed();
                                    };
                                })(this));
                                return this.portalChannel.on(CONNECTION_SUCCEEDED, (function (_this) {
                                    return function () {
                                        return _this._onConnectionSucceeded();
                                    };
                                })(this));
                            };

                            SecureStorageClient.prototype._isConnected = function () {
                                return this.connection === CONNECTION_SUCCEEDED;
                            };

                            SecureStorageClient.prototype._isConnectionFailed = function () {
                                return this.connection === CONNECTION_FAILED;
                            };

                            SecureStorageClient.prototype._onConnectionSucceeded = function () {
                                var message;
                                message = this._getAllMessage((function (_this) {
                                    return function (err, remoteData) {
                                        var data, localData;
                                        if (err) {
                                            return _this._onConnectionFailed();
                                        }
                                        localData = _this.localStore.getAll();
                                        data = merge(remoteData, localData);
                                        _this.connection = CONNECTION_SUCCEEDED;
                                        _this.setAll(data, function (err) {
                                            if (err) {
                                                return;
                                            }
                                            return _this.localStore.unsetAll();
                                        });
                                        return _this._processQueues(function (method, callback, methodArgs) {
                                            if (method === 'get') {
                                                return callback(null, data[methodArgs[0]]);
                                            } else if (method === 'getAll') {
                                                return callback(null, data);
                                            } else {
                                                throw 'Anything besides get* methods should not be buffered';
                                            }
                                        });
                                    };
                                })(this));
                                return this._send('getAll', message);
                            };

                            SecureStorageClient.prototype._onConnectionFailed = function () {
                                this.connection = CONNECTION_FAILED;
                                return this._processQueues((function (_this) {
                                    return function (method, callback, methodArgs) {
                                        methodArgs.push(callback);
                                        return _this[method].apply(_this, methodArgs);
                                    };
                                })(this));
                            };

                            SecureStorageClient.prototype._sendMessage = function (name, id, message) {
                                if (message == null) {
                                    message = {};
                                }
                                if (message.namespace == null) {
                                    message.namespace = this.namespace;
                                }
                                if (message.id == null) {
                                    message.id = id;
                                }
                                if (this._isConnected()) {
                                    return this._send(name, message);
                                } else {
                                    return this._addToQueue(name, message);
                                }
                            };

                            SecureStorageClient.prototype._send = function (name, message) {
                                return this.portalChannel.add(name, message);
                            };

                            SecureStorageClient.prototype._processQueues = function (cb) {
                                var callback, message, method, methodArgs, methodConfig, queue, ref1;
                                ref1 = this.messageQueues;
                                for (method in ref1) {
                                    queue = ref1[method];
                                    while (message = queue.shift()) {
                                        methodConfig = methodConfigs[method];
                                        callback = this._getValidatedCallback(methodConfig, message);
                                        if (callback == null) {
                                            return;
                                        }
                                        methodArgs = getMethodArgs(methodConfig, message);
                                        cb(method, callback, methodArgs);
                                    }
                                }
                            };

                            SecureStorageClient.prototype._addToQueue = function (name, item) {
                                var queue, queues;
                                queues = this.messageQueues;
                                if (item != null) {
                                    if (queues[name] == null) {
                                        queues[name] = [];
                                    }
                                    queue = queues[name];
                                } else {
                                    queue = queues;
                                    item = name;
                                }
                                return queue.push(item);
                            };

                            return SecureStorageClient;

                        })();

                        module.exports = SecureStorageClient;


                    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
                }, {
                    "./beagle": 1,
                    "./data-store": 3,
                    "./deep-merge": 4,
                    "./secure-storage-method-config": 8,
                    "domready": 14,
                    "optimize-portal": 16
                }
            ],
            8: [
                function (noConflictRequire, module, exports) {
                    var getAllArgNames, getMethodArgs, methodConfigs, validateCall;

                    methodConfigs = {
                        get: {
                            method: 'get',
                            args: ['key'],
                            returnData: true
                        },
                        getAll: {
                            method: 'getAll',
                            returnData: true
                        },
                        set: {
                            method: 'set',
                            args: ['keyOrObj'],
                            optArgs: ['value']
                        },
                        setAll: {
                            method: 'setAll',
                            args: ['data']
                        },
                        unset: {
                            method: 'unset',
                            args: ['key']
                        },
                        unsetAll: {
                            method: 'unsetAll'
                        },
                        appendTo: {
                            method: 'appendTo',
                            args: ['key', 'data']
                        }
                    };

                    getAllArgNames = function (methodConfig) {
                        var args, optArgs;
                        args = methodConfig.args, optArgs = methodConfig.optArgs;
                        if ((args != null) && (optArgs != null)) {
                            return args.concat(optArgs);
                        } else if (args != null) {
                            return args;
                        } else {
                            return [];
                        }
                    };

                    getMethodArgs = function (methodConfig, message) {
                        var allArgs, argNames, i, len, name;
                        argNames = getAllArgNames(methodConfig);
                        allArgs = [];
                        for (i = 0, len = argNames.length; i < len; i++) {
                            name = argNames[i];
                            allArgs.push(message[name]);
                        }
                        return allArgs;
                    };

                    validateCall = function (methodConfig, message) {
                        var argName, i, len, ref;
                        if ((message != null ? message.id : void 0) == null) {
                            throw new Error('Malformed request');
                        }
                        if (message.namespace == null) {
                            return new Error('Malformed request');
                        }
                        if (methodConfig.args != null) {
                            ref = methodConfig.args;
                            for (i = 0, len = ref.length; i < len; i++) {
                                argName = ref[i];
                                if (message[argName] == null) {
                                    return new Error("Malformed request, missing " + argName);
                                }
                            }
                        }
                    };

                    module.exports = {
                        methodConfigs: methodConfigs,
                        validateCall: validateCall,
                        getMethodArgs: getMethodArgs
                    };


                }, {}
            ],
            9: [
                function (noConflictRequire, module, exports) {
                    (function (global) {
                        var Cookie, Session, Warehouse, clone;

                        Cookie = global.Cookie || noConflictRequire('optimize-cookie');

                        clone = (global._ || noConflictRequire('underscore')).clone;

                        Warehouse = noConflictRequire('./warehouse');

                        module.exports = Session = (function () {
                            function Session(TrackingHub, config) {
                                var i, key, len, ref;
                                this.TrackingHub = TrackingHub;
                                if (config == null) {
                                    config = {};
                                }
                                config = clone(config);
                                this.expiry = config.expiry || 30 * 60;
                                this.cookieKey = config.cookieKey || "th-session-id";
                                this.cookieDomain = config.cookieDomain;
                                ref = ["expiry", "cookieKey", "cookieDomain"];
                                for (i = 0, len = ref.length; i < len; i++) {
                                    key = ref[i];
                                    delete config[key];
                                }
                                this.metadata = config;
                                this._buildId();
                                this.warehouse = new Warehouse('sessionStore');
                                this.prepareSessionStore();
                            }

                            Session.prototype.prepareSessionStore = function () {
                                if (this.id !== this.warehouse.get('sessionId')) {
                                    return this.warehouse.set({
                                        data: {},
                                        sessionId: this.id
                                    });
                                }
                            };

                            Session.prototype.data = function () {
                                var key, out, ref, val;
                                out = {};
                                ref = this.metadata;
                                for (key in ref) {
                                    val = ref[key];
                                    out[key] = val;
                                }
                                out.id = this.id;
                                return out;
                            };

                            Session.prototype.get = function (key) {
                                var sessionStore;
                                sessionStore = this.warehouse.get("data");
                                if (sessionStore) {
                                    return sessionStore[key];
                                }
                            };

                            Session.prototype.set = function (key, data) {
                                var sessionStore;
                                sessionStore = this.warehouse.get('data');
                                sessionStore[key] = data;
                                return this.warehouse.set('data', sessionStore);
                            };

                            Session.prototype.unset = function (key) {
                                var sessionStore;
                                sessionStore = this.warehouse.get('data');
                                delete sessionStore[key];
                                return this.warehouse.set('data', sessionStore);
                            };

                            Session.prototype.save = function () {
                                return Cookie.set(this.cookieKey, this.id, this.expiry, this.cookieDomain);
                            };

                            Session.prototype._buildId = function () {
                                this.id = this._idFromCookie();
                                if (this.id == null) {
                                    this.id = this.TrackingHub.randomId();
                                }
                                return this.save();
                            };

                            Session.prototype._idFromCookie = function () {
                                return Cookie.get(this.cookieKey);
                            };

                            return Session;

                        })();


                    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
                }, {
                    "./warehouse": 12,
                    "optimize-cookie": 13,
                    "underscore": 13
                }
            ],
            10: [
                function (noConflictRequire, module, exports) {
                    (function (global) {
                        var Beagle, BrowserDetect, InFlightMessageBuffer, Page, SecureStorageClient, Session, TrackingHub, Visibility, Warehouse, clone, extend, map, ref;

                        Session = noConflictRequire('./session');

                        Page = noConflictRequire('./page');

                        SecureStorageClient = noConflictRequire('./secure-storage-client');

                        Warehouse = noConflictRequire('./warehouse');

                        InFlightMessageBuffer = noConflictRequire('./in-flight-message-buffer');

                        ref = global._ || noConflictRequire('underscore'), clone = ref.clone, extend = ref.extend, map = ref.map;

                        BrowserDetect = noConflictRequire('./browser-detect');

                        Beagle = noConflictRequire('./beagle');

                        Visibility = noConflictRequire('./visibility');

                        TrackingHub = {
                            _firstInit: true,
                            Beagle: Beagle,
                            Warehouse: Warehouse,
                            BrowserDetect: BrowserDetect,
                            init: function (config) {
                                var secureStorage;
                                if (config == null) {
                                    config = {};
                                }
                                if (!config.seed) {
                                    throw "TrackingHub must be initialized with a seed value.";
                                }
                                this.counter = 0;
                                this.seed = config.seed;
                                this.session = new Session(this, config.session);
                                this.page = new Page(this, config.page);
                                this.user = config.user;
                                secureStorage = config.secureStorage || {
                                    enabled: false
                                };
                                if (this._firstInit) {
                                    if (Visibility.prerenderSupported() && Visibility.visibilityState() === 'prerender') {
                                        this._initVisibilityListener(config);
                                    } else {
                                        this._initPersistence(config);
                                    }
                                    this.inFlightBuffer = new InFlightMessageBuffer(config);
                                    this.beagle.use(Beagle.Timer(config.flushInterval || 3000));
                                    this._firstInit = false;
                                }
                                return this.add("tracking-init");
                            },
                            beagle: new Beagle(),
                            add: function (name, data) {
                                var extraData, i, key, len, reservedKeys;
                                if (data == null) {
                                    data = {};
                                }
                                reservedKeys = ['session', 'page', 'user'];
                                for (i = 0, len = reservedKeys.length; i < len; i++) {
                                    key = reservedKeys[i];
                                    if (data.hasOwnProperty(key)) {
                                        this.beagle.emit('error', new Error("Key is reserved for tracking: " + key));
                                    }
                                }
                                extraData = {
                                    session: this.session.data(),
                                    page: this.page.data(),
                                    user: this.user,
                                    event_name: name
                                };
                                extend(data, extraData);
                                return this.beagle.add.call(this.beagle, name, data);
                            },
                            track: function (messages) {
                                var trackyData;
                                trackyData = map(messages, function (message) {
                                    var data;
                                    data = clone(message.data);
                                    data.event_name = message.name;
                                    data.event_client_timestamp = new Date(message.timestamp.getTime());
                                    return data;
                                });
                                return this.inFlightBuffer.track(trackyData);
                            },
                            flush: function () {
                                return this.beagle.flush.apply(this.beagle, arguments);
                            },
                            on: function () {
                                return this.beagle.on.apply(this.beagle, arguments);
                            },
                            off: function () {
                                return this.beagle.off.apply(this.beagle, arguments);
                            },
                            use: function () {
                                return this.beagle.use.apply(this.beagle, arguments);
                            },
                            randomId: function () {
                                var id;
                                id = this.seed + "-" + (new Date().getTime()) + "-TH" + this.counter;
                                this.counter += 1;
                                return id;
                            },
                            _reset: function () {
                                return this._firstInit = true;
                            },
                            _initVisibilityListener: function (config) {
                                var onVisibilityChange;
                                onVisibilityChange = (function (_this) {
                                    return function () {
                                        _this.beagle.flush();
                                        _this._initPersistence(config);
                                        return typeof document !== "undefined" && document !== null ? document.removeEventListener(Visibility.visibilityChangeEvent(), onVisibilityChange) : void 0;
                                    };
                                })(this);
                                return typeof document !== "undefined" && document !== null ? document.addEventListener(Visibility.visibilityChangeEvent(), onVisibilityChange) : void 0;
                            },
                            _initPersistence: function (config) {
                                var client, messageExpiry, ref1;
                                messageExpiry = config.messageExpiry || 24 * 60 * 60 * 1000;
                                if ((window.postMessage != null) && (((ref1 = config.storage) != null ? ref1.type : void 0) != null) && config.storage.type === 'secure' && (config.storage.url != null)) {
                                    client = new SecureStorageClient('tracking-hub', config.storage.url);
                                    return this.beagle.use(Beagle.Persistence(client, messageExpiry));
                                } else {
                                    return this.beagle.use(Beagle.Persistence('tracking-hub', messageExpiry));
                                }
                            }
                        };

                        if (typeof window !== "undefined" && window !== null) {
                            window.TrackingHub = TrackingHub;
                        }

                        if (typeof module !== "undefined" && module.exports) {
                            module.exports = TrackingHub;
                        }


                    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
                }, {
                    "./beagle": 1,
                    "./browser-detect": 2,
                    "./in-flight-message-buffer": 5,
                    "./page": 6,
                    "./secure-storage-client": 7,
                    "./session": 9,
                    "./visibility": 11,
                    "./warehouse": 12,
                    "underscore": 13
                }
            ],
            11: [
                function (noConflictRequire, module, exports) {
                    var Visibility;

                    Visibility = {
                        prerenderSupported: function () {
                            if (this.visibilityChangeEvent()) {
                                return true;
                            } else {
                                return false;
                            }
                        },
                        visibilityChangeEvent: function () {
                            var visibilityChange;
                            if ((typeof document !== "undefined" && document !== null ? document.hidden : void 0) != null) {
                                visibilityChange = 'visibilitychange';
                            } else if ((typeof document !== "undefined" && document !== null ? document.webkitHidden : void 0) != null) {
                                visibilityChange = 'webkitvisibilitychange';
                            }
                            return visibilityChange || null;
                        },
                        visibilityState: function () {
                            return (typeof document !== "undefined" && document !== null ? document.visibilityState : void 0) || (typeof document !== "undefined" && document !== null ? document.webkitVisibilityState : void 0) || 'visible';
                        }
                    };

                    module.exports = Visibility;


                }, {}
            ],
            12: [
                function (noConflictRequire, module, exports) {
                    var LocalStorageAdapter, MemoryAdapter, Warehouse;

                    Warehouse = (function () {
                        Warehouse.store = {};

                        function Warehouse(namespace) {
                            var e, localStorageEnabled;
                            this.namespace = namespace;
                            localStorageEnabled = (function () {
                                try {
                                    localStorage.setItem("warehouse-local-storage-test", "true");
                                    localStorage.removeItem("warehouse-local-storage-test");
                                    return true;
                                } catch (_error) {
                                    e = _error;
                                    return false;
                                }
                            })();
                            this.adapter = localStorageEnabled ? LocalStorageAdapter : MemoryAdapter;
                        }

                        Warehouse.prototype.get = function (key, cb) {
                            var val;
                            if (cb == null) {
                                cb = function () {};
                            }
                            val = this.getAll()[key];
                            cb(null, val);
                            return val;
                        };

                        Warehouse.prototype.getAll = function (cb) {
                            var val;
                            if (cb == null) {
                                cb = function () {};
                            }
                            val = this.adapter.get(this.namespace) || {};
                            cb(null, val);
                            return val;
                        };

                        Warehouse.prototype.set = function (keyOrObj, val, cb) {
                            var allData, e, key, value;
                            if (cb == null) {
                                cb = null;
                            }
                            if (cb === null && typeof val === 'function') {
                                cb = val;
                                val = null;
                            }
                            if (val) {
                                key = keyOrObj;
                                allData = this.getAll();
                                allData[key] = val;
                                try {
                                    this.adapter.set(this.namespace, allData);
                                } catch (_error) {
                                    e = _error;
                                    if (cb) {
                                        return cb(e);
                                    } else {
                                        throw e;
                                    }
                                }
                                if (cb) {
                                    return cb();
                                }
                            } else {
                                for (key in keyOrObj) {
                                    value = keyOrObj[key];
                                    try {
                                        this.set(key, value);
                                    } catch (_error) {
                                        e = _error;
                                        return cb(e);
                                    }
                                }
                                if (cb) {
                                    return cb();
                                }
                            }
                        };

                        Warehouse.prototype.appendTo = function (key, data, cb) {
                            var arr, err;
                            if (cb == null) {
                                cb = null;
                            }
                            arr = this.get(key);
                            if (arr == null) {
                                arr = [];
                            }
                            if (!(((arr != null ? arr.push : void 0) != null) && typeof arr.push === 'function')) {
                                err = new Error("The item at key " + key + " must support push to use appendTo");
                                if (cb) {
                                    return cb(err);
                                } else {
                                    throw err;
                                }
                            }
                            arr.push(data);
                            return this.set(key, arr, cb);
                        };

                        Warehouse.prototype.setAll = function (data, cb) {
                            if (cb == null) {
                                cb = function () {};
                            }
                            this.adapter.set(this.namespace, data);
                            return cb();
                        };

                        Warehouse.prototype.unset = function (key, cb) {
                            var allData;
                            if (cb == null) {
                                cb = function () {};
                            }
                            allData = this.getAll();
                            delete allData[key];
                            this.adapter.set(this.namespace, allData);
                            return cb();
                        };

                        Warehouse.prototype.unsetAll = function (cb) {
                            if (cb == null) {
                                cb = function () {};
                            }
                            this.adapter.unset(this.namespace);
                            return cb();
                        };

                        return Warehouse;

                    })();

                    LocalStorageAdapter = (function () {
                        var MAX_SIZE;
                        MAX_SIZE = 1024 * 1024;
                        return {
                            get: function (key) {
                                var e, val;
                                try {
                                    val = localStorage.getItem(key);
                                    if (val) {
                                        return JSON.parse(val);
                                    }
                                } catch (_error) {
                                    e = _error;
                                    this.set(key, {});
                                    return null;
                                }
                            },
                            set: function (key, data) {
                                var jsonData;
                                jsonData = JSON.stringify(data);
                                if (jsonData.length < MAX_SIZE) {
                                    return localStorage.setItem(key, jsonData);
                                } else {
                                    return console.log("Error: Tracking Hub Warehouse too large to store in LocalStorage!");
                                }
                            },
                            unset: function (key) {
                                return localStorage.removeItem(key);
                            }
                        };
                    })();

                    MemoryAdapter = {
                        set: function (name, value) {
                            return Warehouse.store[name] = value;
                        },
                        get: function (name) {
                            return Warehouse.store[name];
                        },
                        unset: function (name) {
                            return delete Warehouse.store[name];
                        }
                    };

                    if (typeof module !== "undefined" && module.exports) {
                        module.exports = Warehouse;
                    }


                }, {}
            ],
            13: [
                function (noConflictRequire, module, exports) {

                }, {}
            ],
            14: [
                function (noConflictRequire, module, exports) {
                    /*!
                     * domready (c) Dustin Diaz 2012 - License MIT
                     */
                    ! function (name, definition) {
                        if (typeof module != 'undefined') module.exports = definition()
                        else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
                        else this[name] = definition()
                    }('domready', function (ready) {

                        var fns = [],
                            fn, f = false,
                            doc = document,
                            testEl = doc.documentElement,
                            hack = testEl.doScroll,
                            domContentLoaded = 'DOMContentLoaded',
                            addEventListener = 'addEventListener',
                            onreadystatechange = 'onreadystatechange',
                            readyState = 'readyState',
                            loadedRgx = hack ? /^loaded|^c/ : /^loaded|c/,
                            loaded = loadedRgx.test(doc[readyState])

                        function flush(f) {
                            loaded = 1
                            while (f = fns.shift()) f()
                        }

                        doc[addEventListener] && doc[addEventListener](domContentLoaded, fn = function () {
                            doc.removeEventListener(domContentLoaded, fn, f)
                            flush()
                        }, f)


                        hack && doc.attachEvent(onreadystatechange, fn = function () {
                            if (/^c/.test(doc[readyState])) {
                                doc.detachEvent(onreadystatechange, fn)
                                flush()
                            }
                        })

                        return (ready = hack ?
                            function (fn) {
                                self != top ?
                                    loaded ? fn() : fns.push(fn) :
                                    function () {
                                        try {
                                            testEl.doScroll('left')
                                        } catch (e) {
                                            return setTimeout(function () {
                                                ready(fn)
                                            }, 50)
                                        }
                                        fn()
                                }()
                            } :
                            function (fn) {
                                loaded ? fn() : fns.push(fn)
                            })
                    })

                }, {}
            ],
            15: [
                function (noConflictRequire, module, exports) {
                    // Generated by CoffeeScript 1.4.0
                    (function () {
                        var Evented,
                            __slice = [].slice;

                        Evented = function (mod) {
                            var listeners;
                            listeners = {
                                "*": []
                            };
                            mod.on = function (key, listener) {
                                var _ref;
                                if ((_ref = listeners[key]) == null) {
                                    listeners[key] = [];
                                }
                                return listeners[key].push(listener);
                            };
                            mod.off = function (key, listenerToRemove) {
                                var listener, safeListeners, _i, _len, _ref;
                                safeListeners = [];
                                _ref = listeners[key];
                                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                    listener = _ref[_i];
                                    if (listener !== listenerToRemove) {
                                        safeListeners.push(listener);
                                    }
                                }
                                return listeners[key] = safeListeners;
                            };
                            mod.emit = function () {
                                var args, key, listener, _i, _j, _len, _len1, _ref, _ref1, _ref2, _results;
                                key = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
                                if ((_ref = listeners[key]) == null) {
                                    listeners[key] = [];
                                }
                                _ref1 = listeners[key];
                                for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                    listener = _ref1[_i];
                                    listener.apply(null, args);
                                }
                                _ref2 = listeners["*"];
                                _results = [];
                                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                                    listener = _ref2[_j];
                                    _results.push(listener.apply(null, [key].concat(__slice.call(args))));
                                }
                                return _results;
                            };
                            return mod;
                        };

                        this.Evented = Evented;

                        if (typeof module !== "undefined" && module.exports) {
                            module.exports = Evented;
                        }

                    }).call(this);

                }, {}
            ],
            16: [
                function (noConflictRequire, module, exports) {
                    // Generated by CoffeeScript 1.7.1
                    (function () {
                        var CONNECTION_FAILED, CONNECTION_SUCCEEDED, MAX_ACK_ATTEMPTS, PORTAL_LISTENING, PORTAL_LISTENING_ACK, Portal;

                        PORTAL_LISTENING = 'portal.listening';

                        PORTAL_LISTENING_ACK = 'portal.listening.ack';

                        CONNECTION_FAILED = 'connectionFailed';

                        CONNECTION_SUCCEEDED = 'connectionSucceeded';

                        MAX_ACK_ATTEMPTS = 25;

                        Portal = function (source, target, targetOrigin, pluginQueue) {
                            var WaitForReady, ackTargetReady, addListener, emit, listeners, notifyListening, onPostMessage, pastEvents, portal, sendMessage, targetAckAttempts, targetAcked, targetAckedListening, targetReady;
                            if (targetOrigin == null) {
                                targetOrigin = '*';
                            }
                            if (pluginQueue == null) {
                                pluginQueue = null;
                            }
                            listeners = {};
                            pastEvents = {};
                            targetReady = false;
                            targetAcked = false;
                            targetAckAttempts = 0;
                            ackTargetReady = function () {
                                targetReady = true;
                                sendMessage(PORTAL_LISTENING_ACK);
                                return pluginQueue != null ? pluginQueue.flush() : void 0;
                            };
                            targetAckedListening = function () {
                                var channel, name, _results;
                                targetAcked = true;
                                _results = [];
                                for (channel in listeners) {
                                    name = CONNECTION_SUCCEEDED;
                                    _results.push(emit({
                                        name: name,
                                        channel: channel
                                    }));
                                }
                                return _results;
                            };
                            notifyListening = function () {
                                var channel, name, _results;
                                if (targetAcked) {
                                    return;
                                }
                                if (targetAckAttempts >= MAX_ACK_ATTEMPTS) {
                                    _results = [];
                                    for (channel in listeners) {
                                        name = CONNECTION_FAILED;
                                        _results.push(emit({
                                            name: name,
                                            channel: channel
                                        }));
                                    }
                                    return _results;
                                } else {
                                    targetAckAttempts += 1;
                                    sendMessage(PORTAL_LISTENING);
                                    return setTimeout(notifyListening, 200);
                                }
                            };
                            sendMessage = function (message) {
                                var e;
                                try {
                                    return target.postMessage(message, targetOrigin);
                                } catch (_error) {
                                    e = _error;
                                }
                            };
                            addListener = function (name, func) {
                                if (source.addEventListener != null) {
                                    return source.addEventListener(name, func);
                                } else if (source.attachEvent != null) {
                                    return source.attachEvent("on" + name, func);
                                }
                            };
                            WaitForReady = function () {
                                return function (beagle) {
                                    return beagle.on("add", function () {
                                        if (targetReady) {
                                            return beagle.flush();
                                        }
                                    });
                                };
                            };
                            if (pluginQueue == null) {
                                pluginQueue = new Beagle();
                            }
                            pluginQueue.use(WaitForReady());
                            pluginQueue.on("flush", function (msgs) {
                                var msg, _i, _len, _results;
                                _results = [];
                                for (_i = 0, _len = msgs.length; _i < _len; _i++) {
                                    msg = msgs[_i];
                                    _results.push(sendMessage(JSON.stringify(msg.data)));
                                }
                                return _results;
                            });
                            emit = function (eventData) {
                                var channel, data, eventName, func, _base, _base1, _i, _j, _len, _len1, _ref, _ref1, _results;
                                channel = eventData.channel;
                                eventName = eventData.name;
                                if (!(channel && eventName)) {
                                    return;
                                }
                                data = eventData.data;
                                if (listeners[channel] == null) {
                                    listeners[channel] = {};
                                }
                                if (pastEvents[channel] == null) {
                                    pastEvents[channel] = {};
                                }
                                if ((_base = pastEvents[channel])["*"] == null) {
                                    _base["*"] = [];
                                }
                                if ((_base1 = pastEvents[channel])[eventName] == null) {
                                    _base1[eventName] = [];
                                }
                                pastEvents[channel]["*"].push(eventData);
                                pastEvents[channel][eventName].push(eventData);
                                _ref = listeners[channel]["*"] || [];
                                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                    func = _ref[_i];
                                    func(eventName, data);
                                }
                                _ref1 = listeners[channel][eventName] || [];
                                _results = [];
                                for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
                                    func = _ref1[_j];
                                    _results.push(func(data));
                                }
                                return _results;
                            };
                            onPostMessage = function (event) {
                                var err, eventData;
                                if (!(event.source === target && (targetOrigin === '*' || targetOrigin === event.origin))) {
                                    return;
                                }
                                if (event.data === PORTAL_LISTENING) {
                                    ackTargetReady();
                                    return;
                                } else if (event.data === PORTAL_LISTENING_ACK) {
                                    targetAckedListening();
                                    return;
                                }
                                try {
                                    eventData = JSON.parse(event.data);
                                } catch (_error) {
                                    err = _error;
                                    return;
                                }
                                return emit(eventData);
                            };
                            addListener("message", onPostMessage);
                            notifyListening();
                            portal = function (channel) {
                                return {
                                    add: function (eventName, data) {
                                        if (data == null) {
                                            data = {};
                                        }
                                        return pluginQueue.add("msg", {
                                            channel: channel,
                                            name: eventName,
                                            data: data
                                        });
                                    },
                                    bind: function (eventName, func) {
                                        var _base;
                                        if (listeners[channel] == null) {
                                            listeners[channel] = {};
                                        }
                                        if ((_base = listeners[channel])[eventName] == null) {
                                            _base[eventName] = [];
                                        }
                                        return listeners[channel][eventName].push(func);
                                    },
                                    on: function (eventName, func) {
                                        return this.bind(eventName, func);
                                    },
                                    replayAndBind: function (eventName, func) {
                                        var pastEvent, _i, _len, _ref;
                                        if (pastEvents[channel] == null) {
                                            pastEvents[channel] = {};
                                        }
                                        _ref = pastEvents[channel][eventName] || [];
                                        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                            pastEvent = _ref[_i];
                                            if (eventName === "*") {
                                                func(pastEvent.name, pastEvent.data);
                                            } else {
                                                func(pastEvent.data);
                                            }
                                        }
                                        return this.bind(eventName, func);
                                    }
                                };
                            };
                            return portal;
                        };

                        if (typeof module !== "undefined" && module.exports) {
                            module.exports = Portal;
                        } else {
                            this.Portal = Portal;
                        }

                    }).call(this);

                }, {}
            ],
            17: [
                function (noConflictRequire, module, exports) {
                    /**
                     * Module dependencies.
                     */

                    var Emitter = noConflictRequire('emitter');
                    var reduce = noConflictRequire('reduce');

                    /**
                     * Root reference for iframes.
                     */

                    var root = 'undefined' == typeof window ? this : window;

                    /**
                     * Noop.
                     */

                    function noop() {};

                    /**
                     * Check if `obj` is a host object,
                     * we don't want to serialize these :)
                     *
                     * TODO: future proof, move to compoent land
                     *
                     * @param {Object} obj
                     * @return {Boolean}
                     * @api private
                     */

                    function isHost(obj) {
                        var str = {}.toString.call(obj);

                        switch (str) {
                        case '[object File]':
                        case '[object Blob]':
                        case '[object FormData]':
                            return true;
                        default:
                            return false;
                        }
                    }

                    /**
                     * Determine XHR.
                     */

                    function getXHR() {
                        if (root.XMLHttpRequest && ('file:' != root.location.protocol || !root.ActiveXObject)) {
                            return new XMLHttpRequest;
                        } else {
                            try {
                                return new ActiveXObject('Microsoft.XMLHTTP');
                            } catch (e) {}
                            try {
                                return new ActiveXObject('Msxml2.XMLHTTP.6.0');
                            } catch (e) {}
                            try {
                                return new ActiveXObject('Msxml2.XMLHTTP.3.0');
                            } catch (e) {}
                            try {
                                return new ActiveXObject('Msxml2.XMLHTTP');
                            } catch (e) {}
                        }
                        return false;
                    }

                    /**
                     * Removes leading and trailing whitespace, added to support IE.
                     *
                     * @param {String} s
                     * @return {String}
                     * @api private
                     */

                    var trim = ''.trim ? function (s) {
                        return s.trim();
                    } : function (s) {
                        return s.replace(/(^\s*|\s*$)/g, '');
                    };

                    /**
                     * Check if `obj` is an object.
                     *
                     * @param {Object} obj
                     * @return {Boolean}
                     * @api private
                     */

                    function isObject(obj) {
                        return obj === Object(obj);
                    }

                    /**
                     * Serialize the given `obj`.
                     *
                     * @param {Object} obj
                     * @return {String}
                     * @api private
                     */

                    function serialize(obj) {
                        if (!isObject(obj)) return obj;
                        var pairs = [];
                        for (var key in obj) {
                            if (null != obj[key]) {
                                pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
                            }
                        }
                        return pairs.join('&');
                    }

                    /**
                     * Expose serialization method.
                     */

                    request.serializeObject = serialize;

                    /**
                     * Parse the given x-www-form-urlencoded `str`.
                     *
                     * @param {String} str
                     * @return {Object}
                     * @api private
                     */

                    function parseString(str) {
                        var obj = {};
                        var pairs = str.split('&');
                        var parts;
                        var pair;

                        for (var i = 0, len = pairs.length; i < len; ++i) {
                            pair = pairs[i];
                            parts = pair.split('=');
                            obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                        }

                        return obj;
                    }

                    /**
                     * Expose parser.
                     */

                    request.parseString = parseString;

                    /**
                     * Default MIME type map.
                     *
                     *     superagent.types.xml = 'application/xml';
                     *
                     */

                    request.types = {
                        html: 'text/html',
                        json: 'application/json',
                        xml: 'application/xml',
                        urlencoded: 'application/x-www-form-urlencoded',
                        'form': 'application/x-www-form-urlencoded',
                        'form-data': 'application/x-www-form-urlencoded'
                    };

                    /**
                     * Default serialization map.
                     *
                     *     superagent.serialize['application/xml'] = function(obj){
                     *       return 'generated xml here';
                     *     };
                     *
                     */

                    request.serialize = {
                        'application/x-www-form-urlencoded': serialize,
                        'application/json': JSON.stringify
                    };

                    /**
                     * Default parsers.
                     *
                     *     superagent.parse['application/xml'] = function(str){
                     *       return { object parsed from str };
                     *     };
                     *
                     */

                    request.parse = {
                        'application/x-www-form-urlencoded': parseString,
                        'application/json': JSON.parse
                    };

                    /**
                     * Parse the given header `str` into
                     * an object containing the mapped fields.
                     *
                     * @param {String} str
                     * @return {Object}
                     * @api private
                     */

                    function parseHeader(str) {
                        var lines = str.split(/\r?\n/);
                        var fields = {};
                        var index;
                        var line;
                        var field;
                        var val;

                        lines.pop(); // trailing CRLF

                        for (var i = 0, len = lines.length; i < len; ++i) {
                            line = lines[i];
                            index = line.indexOf(':');
                            field = line.slice(0, index).toLowerCase();
                            val = trim(line.slice(index + 1));
                            fields[field] = val;
                        }

                        return fields;
                    }

                    /**
                     * Return the mime type for the given `str`.
                     *
                     * @param {String} str
                     * @return {String}
                     * @api private
                     */

                    function type(str) {
                        return str.split(/ *; */).shift();
                    };

                    /**
                     * Return header field parameters.
                     *
                     * @param {String} str
                     * @return {Object}
                     * @api private
                     */

                    function params(str) {
                        return reduce(str.split(/ *; */), function (obj, str) {
                            var parts = str.split(/ *= */),
                                key = parts.shift(),
                                val = parts.shift();

                            if (key && val) obj[key] = val;
                            return obj;
                        }, {});
                    };

                    /**
                     * Initialize a new `Response` with the given `xhr`.
                     *
                     *  - set flags (.ok, .error, etc)
                     *  - parse header
                     *
                     * Examples:
                     *
                     *  Aliasing `superagent` as `request` is nice:
                     *
                     *      request = superagent;
                     *
                     *  We can use the promise-like API, or pass callbacks:
                     *
                     *      request.get('/').end(function(res){});
                     *      request.get('/', function(res){});
                     *
                     *  Sending data can be chained:
                     *
                     *      request
                     *        .post('/user')
                     *        .send({ name: 'tj' })
                     *        .end(function(res){});
                     *
                     *  Or passed to `.send()`:
                     *
                     *      request
                     *        .post('/user')
                     *        .send({ name: 'tj' }, function(res){});
                     *
                     *  Or passed to `.post()`:
                     *
                     *      request
                     *        .post('/user', { name: 'tj' })
                     *        .end(function(res){});
                     *
                     * Or further reduced to a single call for simple cases:
                     *
                     *      request
                     *        .post('/user', { name: 'tj' }, function(res){});
                     *
                     * @param {XMLHTTPRequest} xhr
                     * @param {Object} options
                     * @api private
                     */

                    function Response(req, options) {
                        options = options || {};
                        this.req = req;
                        this.xhr = this.req.xhr;
                        this.text = this.req.method != 'HEAD' ? this.xhr.responseText : null;
                        this.setStatusProperties(this.xhr.status);
                        this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
                        // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
                        // getResponseHeader still works. so we get content-type even if getting
                        // other headers fails.
                        this.header['content-type'] = this.xhr.getResponseHeader('content-type');
                        this.setHeaderProperties(this.header);
                        this.body = this.req.method != 'HEAD' ? this.parseBody(this.text) : null;
                    }

                    /**
                     * Get case-insensitive `field` value.
                     *
                     * @param {String} field
                     * @return {String}
                     * @api public
                     */

                    Response.prototype.get = function (field) {
                        return this.header[field.toLowerCase()];
                    };

                    /**
                     * Set header related properties:
                     *
                     *   - `.type` the content type without params
                     *
                     * A response of "Content-Type: text/plain; charset=utf-8"
                     * will provide you with a `.type` of "text/plain".
                     *
                     * @param {Object} header
                     * @api private
                     */

                    Response.prototype.setHeaderProperties = function (header) {
                        // content-type
                        var ct = this.header['content-type'] || '';
                        this.type = type(ct);

                        // params
                        var obj = params(ct);
                        for (var key in obj) this[key] = obj[key];
                    };

                    /**
                     * Parse the given body `str`.
                     *
                     * Used for auto-parsing of bodies. Parsers
                     * are defined on the `superagent.parse` object.
                     *
                     * @param {String} str
                     * @return {Mixed}
                     * @api private
                     */

                    Response.prototype.parseBody = function (str) {
                        var parse = request.parse[this.type];
                        return parse && str && str.length ? parse(str) : null;
                    };

                    /**
                     * Set flags such as `.ok` based on `status`.
                     *
                     * For example a 2xx response will give you a `.ok` of __true__
                     * whereas 5xx will be __false__ and `.error` will be __true__. The
                     * `.clientError` and `.serverError` are also available to be more
                     * specific, and `.statusType` is the class of error ranging from 1..5
                     * sometimes useful for mapping respond colors etc.
                     *
                     * "sugar" properties are also defined for common cases. Currently providing:
                     *
                     *   - .noContent
                     *   - .badRequest
                     *   - .unauthorized
                     *   - .notAcceptable
                     *   - .notFound
                     *
                     * @param {Number} status
                     * @api private
                     */

                    Response.prototype.setStatusProperties = function (status) {
                        var type = status / 100 | 0;

                        // status / class
                        this.status = status;
                        this.statusType = type;

                        // basics
                        this.info = 1 == type;
                        this.ok = 2 == type;
                        this.clientError = 4 == type;
                        this.serverError = 5 == type;
                        this.error = (4 == type || 5 == type) ? this.toError() : false;

                        // sugar
                        this.accepted = 202 == status;
                        this.noContent = 204 == status || 1223 == status;
                        this.badRequest = 400 == status;
                        this.unauthorized = 401 == status;
                        this.notAcceptable = 406 == status;
                        this.notFound = 404 == status;
                        this.forbidden = 403 == status;
                    };

                    /**
                     * Return an `Error` representative of this response.
                     *
                     * @return {Error}
                     * @api public
                     */

                    Response.prototype.toError = function () {
                        var req = this.req;
                        var method = req.method;
                        var url = req.url;

                        var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
                        var err = new Error(msg);
                        err.status = this.status;
                        err.method = method;
                        err.url = url;

                        return err;
                    };

                    /**
                     * Expose `Response`.
                     */

                    request.Response = Response;

                    /**
                     * Initialize a new `Request` with the given `method` and `url`.
                     *
                     * @param {String} method
                     * @param {String} url
                     * @api public
                     */

                    function Request(method, url) {
                        var self = this;
                        Emitter.call(this);
                        this._query = this._query || [];
                        this.method = method;
                        this.url = url;
                        this.header = {};
                        this._header = {};
                        this.on('end', function () {
                            var err = null;
                            var res = null;

                            try {
                                res = new Response(self);
                            } catch (e) {
                                err = new Error('Parser is unable to parse the response');
                                err.parse = true;
                                err.original = e;
                            }

                            self.callback(err, res);
                        });
                    }

                    /**
                     * Mixin `Emitter`.
                     */

                    Emitter(Request.prototype);

                    /**
                     * Allow for extension
                     */

                    Request.prototype.use = function (fn) {
                        fn(this);
                        return this;
                    }

                    /**
                     * Set timeout to `ms`.
                     *
                     * @param {Number} ms
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.timeout = function (ms) {
                        this._timeout = ms;
                        return this;
                    };

                    /**
                     * Clear previous timeout.
                     *
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.clearTimeout = function () {
                        this._timeout = 0;
                        clearTimeout(this._timer);
                        return this;
                    };

                    /**
                     * Abort the request, and clear potential timeout.
                     *
                     * @return {Request}
                     * @api public
                     */

                    Request.prototype.abort = function () {
                        if (this.aborted) return;
                        this.aborted = true;
                        this.xhr.abort();
                        this.clearTimeout();
                        this.emit('abort');
                        return this;
                    };

                    /**
                     * Set header `field` to `val`, or multiple fields with one object.
                     *
                     * Examples:
                     *
                     *      req.get('/')
                     *        .set('Accept', 'application/json')
                     *        .set('X-API-Key', 'foobar')
                     *        .end(callback);
                     *
                     *      req.get('/')
                     *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
                     *        .end(callback);
                     *
                     * @param {String|Object} field
                     * @param {String} val
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.set = function (field, val) {
                        if (isObject(field)) {
                            for (var key in field) {
                                this.set(key, field[key]);
                            }
                            return this;
                        }
                        this._header[field.toLowerCase()] = val;
                        this.header[field] = val;
                        return this;
                    };

                    /**
                     * Remove header `field`.
                     *
                     * Example:
                     *
                     *      req.get('/')
                     *        .unset('User-Agent')
                     *        .end(callback);
                     *
                     * @param {String} field
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.unset = function (field) {
                        delete this._header[field.toLowerCase()];
                        delete this.header[field];
                        return this;
                    };

                    /**
                     * Get case-insensitive header `field` value.
                     *
                     * @param {String} field
                     * @return {String}
                     * @api private
                     */

                    Request.prototype.getHeader = function (field) {
                        return this._header[field.toLowerCase()];
                    };

                    /**
                     * Set Content-Type to `type`, mapping values from `request.types`.
                     *
                     * Examples:
                     *
                     *      superagent.types.xml = 'application/xml';
                     *
                     *      request.post('/')
                     *        .type('xml')
                     *        .send(xmlstring)
                     *        .end(callback);
                     *
                     *      request.post('/')
                     *        .type('application/xml')
                     *        .send(xmlstring)
                     *        .end(callback);
                     *
                     * @param {String} type
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.type = function (type) {
                        this.set('Content-Type', request.types[type] || type);
                        return this;
                    };

                    /**
                     * Set Accept to `type`, mapping values from `request.types`.
                     *
                     * Examples:
                     *
                     *      superagent.types.json = 'application/json';
                     *
                     *      request.get('/agent')
                     *        .accept('json')
                     *        .end(callback);
                     *
                     *      request.get('/agent')
                     *        .accept('application/json')
                     *        .end(callback);
                     *
                     * @param {String} accept
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.accept = function (type) {
                        this.set('Accept', request.types[type] || type);
                        return this;
                    };

                    /**
                     * Set Authorization field value with `user` and `pass`.
                     *
                     * @param {String} user
                     * @param {String} pass
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.auth = function (user, pass) {
                        var str = btoa(user + ':' + pass);
                        this.set('Authorization', 'Basic ' + str);
                        return this;
                    };

                    /**
                     * Add query-string `val`.
                     *
                     * Examples:
                     *
                     *   request.get('/shoes')
                     *     .query('size=10')
                     *     .query({ color: 'blue' })
                     *
                     * @param {Object|String} val
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.query = function (val) {
                        if ('string' != typeof val) val = serialize(val);
                        if (val) this._query.push(val);
                        return this;
                    };

                    /**
                     * Write the field `name` and `val` for "multipart/form-data"
                     * request bodies.
                     *
                     * ``` js
                     * request.post('/upload')
                     *   .field('foo', 'bar')
                     *   .end(callback);
                     * ```
                     *
                     * @param {String} name
                     * @param {String|Blob|File} val
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.field = function (name, val) {
                        if (!this._formData) this._formData = new FormData();
                        this._formData.append(name, val);
                        return this;
                    };

                    /**
                     * Queue the given `file` as an attachment to the specified `field`,
                     * with optional `filename`.
                     *
                     * ``` js
                     * request.post('/upload')
                     *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
                     *   .end(callback);
                     * ```
                     *
                     * @param {String} field
                     * @param {Blob|File} file
                     * @param {String} filename
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.attach = function (field, file, filename) {
                        if (!this._formData) this._formData = new FormData();
                        this._formData.append(field, file, filename);
                        return this;
                    };

                    /**
                     * Send `data`, defaulting the `.type()` to "json" when
                     * an object is given.
                     *
                     * Examples:
                     *
                     *       // querystring
                     *       request.get('/search')
                     *         .end(callback)
                     *
                     *       // multiple data "writes"
                     *       request.get('/search')
                     *         .send({ search: 'query' })
                     *         .send({ range: '1..5' })
                     *         .send({ order: 'desc' })
                     *         .end(callback)
                     *
                     *       // manual json
                     *       request.post('/user')
                     *         .type('json')
                     *         .send('{"name":"tj"})
                     *         .end(callback)
                     *
                     *       // auto json
                     *       request.post('/user')
                     *         .send({ name: 'tj' })
                     *         .end(callback)
                     *
                     *       // manual x-www-form-urlencoded
                     *       request.post('/user')
                     *         .type('form')
                     *         .send('name=tj')
                     *         .end(callback)
                     *
                     *       // auto x-www-form-urlencoded
                     *       request.post('/user')
                     *         .type('form')
                     *         .send({ name: 'tj' })
                     *         .end(callback)
                     *
                     *       // defaults to x-www-form-urlencoded
                     *      request.post('/user')
                     *        .send('name=tobi')
                     *        .send('species=ferret')
                     *        .end(callback)
                     *
                     * @param {String|Object} data
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.send = function (data) {
                        var obj = isObject(data);
                        var type = this.getHeader('Content-Type');

                        // merge
                        if (obj && isObject(this._data)) {
                            for (var key in data) {
                                this._data[key] = data[key];
                            }
                        } else if ('string' == typeof data) {
                            if (!type) this.type('form');
                            type = this.getHeader('Content-Type');
                            if ('application/x-www-form-urlencoded' == type) {
                                this._data = this._data ? this._data + '&' + data : data;
                            } else {
                                this._data = (this._data || '') + data;
                            }
                        } else {
                            this._data = data;
                        }

                        if (!obj) return this;
                        if (!type) this.type('json');
                        return this;
                    };

                    /**
                     * Invoke the callback with `err` and `res`
                     * and handle arity check.
                     *
                     * @param {Error} err
                     * @param {Response} res
                     * @api private
                     */

                    Request.prototype.callback = function (err, res) {
                        var fn = this._callback;
                        this.clearTimeout();
                        if (2 == fn.length) return fn(err, res);
                        if (err) return this.emit('error', err);
                        fn(res);
                    };

                    /**
                     * Invoke callback with x-domain error.
                     *
                     * @api private
                     */

                    Request.prototype.crossDomainError = function () {
                        var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
                        err.crossDomain = true;
                        this.callback(err);
                    };

                    /**
                     * Invoke callback with timeout error.
                     *
                     * @api private
                     */

                    Request.prototype.timeoutError = function () {
                        var timeout = this._timeout;
                        var err = new Error('timeout of ' + timeout + 'ms exceeded');
                        err.timeout = timeout;
                        this.callback(err);
                    };

                    /**
                     * Enable transmission of cookies with x-domain requests.
                     *
                     * Note that for this to work the origin must not be
                     * using "Access-Control-Allow-Origin" with a wildcard,
                     * and also must set "Access-Control-Allow-Credentials"
                     * to "true".
                     *
                     * @api public
                     */

                    Request.prototype.withCredentials = function () {
                        this._withCredentials = true;
                        return this;
                    };

                    /**
                     * Initiate request, invoking callback `fn(res)`
                     * with an instanceof `Response`.
                     *
                     * @param {Function} fn
                     * @return {Request} for chaining
                     * @api public
                     */

                    Request.prototype.end = function (fn) {
                        var self = this;
                        var xhr = this.xhr = getXHR();
                        var query = this._query.join('&');
                        var timeout = this._timeout;
                        var data = this._formData || this._data;

                        // store callback
                        this._callback = fn || noop;

                        // state change
                        xhr.onreadystatechange = function () {
                            if (4 != xhr.readyState) return;
                            if (0 == xhr.status) {
                                if (self.aborted) return self.timeoutError();
                                return self.crossDomainError();
                            }
                            self.emit('end');
                        };

                        // progress
                        if (xhr.upload) {
                            xhr.upload.onprogress = function (e) {
                                e.percent = e.loaded / e.total * 100;
                                self.emit('progress', e);
                            };
                        }

                        // timeout
                        if (timeout && !this._timer) {
                            this._timer = setTimeout(function () {
                                self.abort();
                            }, timeout);
                        }

                        // querystring
                        if (query) {
                            query = request.serializeObject(query);
                            this.url += ~this.url.indexOf('?') ? '&' + query : '?' + query;
                        }

                        // initiate request
                        xhr.open(this.method, this.url, true);

                        // CORS
                        if (this._withCredentials) xhr.withCredentials = true;

                        // body
                        if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
                            // serialize stuff
                            var serialize = request.serialize[this.getHeader('Content-Type')];
                            if (serialize) data = serialize(data);
                        }

                        // set header fields
                        for (var field in this.header) {
                            if (null == this.header[field]) continue;
                            xhr.setRequestHeader(field, this.header[field]);
                        }

                        // send stuff
                        this.emit('request', this);
                        xhr.send(data);
                        return this;
                    };

                    /**
                     * Expose `Request`.
                     */

                    request.Request = Request;

                    /**
                     * Issue a request:
                     *
                     * Examples:
                     *
                     *    request('GET', '/users').end(callback)
                     *    request('/users').end(callback)
                     *    request('/users', callback)
                     *
                     * @param {String} method
                     * @param {String|Function} url or callback
                     * @return {Request}
                     * @api public
                     */

                    function request(method, url) {
                        // callback
                        if ('function' == typeof url) {
                            return new Request('GET', method).end(url);
                        }

                        // url first
                        if (1 == arguments.length) {
                            return new Request('GET', method);
                        }

                        return new Request(method, url);
                    }

                    /**
                     * GET `url` with optional callback `fn(res)`.
                     *
                     * @param {String} url
                     * @param {Mixed|Function} data or fn
                     * @param {Function} fn
                     * @return {Request}
                     * @api public
                     */

                    request.get = function (url, data, fn) {
                        var req = request('GET', url);
                        if ('function' == typeof data) fn = data, data = null;
                        if (data) req.query(data);
                        if (fn) req.end(fn);
                        return req;
                    };

                    /**
                     * HEAD `url` with optional callback `fn(res)`.
                     *
                     * @param {String} url
                     * @param {Mixed|Function} data or fn
                     * @param {Function} fn
                     * @return {Request}
                     * @api public
                     */

                    request.head = function (url, data, fn) {
                        var req = request('HEAD', url);
                        if ('function' == typeof data) fn = data, data = null;
                        if (data) req.send(data);
                        if (fn) req.end(fn);
                        return req;
                    };

                    /**
                     * DELETE `url` with optional callback `fn(res)`.
                     *
                     * @param {String} url
                     * @param {Function} fn
                     * @return {Request}
                     * @api public
                     */

                    request.del = function (url, fn) {
                        var req = request('DELETE', url);
                        if (fn) req.end(fn);
                        return req;
                    };

                    /**
                     * PATCH `url` with optional `data` and callback `fn(res)`.
                     *
                     * @param {String} url
                     * @param {Mixed} data
                     * @param {Function} fn
                     * @return {Request}
                     * @api public
                     */

                    request.patch = function (url, data, fn) {
                        var req = request('PATCH', url);
                        if ('function' == typeof data) fn = data, data = null;
                        if (data) req.send(data);
                        if (fn) req.end(fn);
                        return req;
                    };

                    /**
                     * POST `url` with optional `data` and callback `fn(res)`.
                     *
                     * @param {String} url
                     * @param {Mixed} data
                     * @param {Function} fn
                     * @return {Request}
                     * @api public
                     */

                    request.post = function (url, data, fn) {
                        var req = request('POST', url);
                        if ('function' == typeof data) fn = data, data = null;
                        if (data) req.send(data);
                        if (fn) req.end(fn);
                        return req;
                    };

                    /**
                     * PUT `url` with optional `data` and callback `fn(res)`.
                     *
                     * @param {String} url
                     * @param {Mixed|Function} data or fn
                     * @param {Function} fn
                     * @return {Request}
                     * @api public
                     */

                    request.put = function (url, data, fn) {
                        var req = request('PUT', url);
                        if ('function' == typeof data) fn = data, data = null;
                        if (data) req.send(data);
                        if (fn) req.end(fn);
                        return req;
                    };

                    /**
                     * Expose `request`.
                     */

                    module.exports = request;

                }, {
                    "emitter": 18,
                    "reduce": 19
                }
            ],
            18: [
                function (noConflictRequire, module, exports) {

                    /**
                     * Expose `Emitter`.
                     */

                    module.exports = Emitter;

                    /**
                     * Initialize a new `Emitter`.
                     *
                     * @api public
                     */

                    function Emitter(obj) {
                        if (obj) return mixin(obj);
                    };

                    /**
                     * Mixin the emitter properties.
                     *
                     * @param {Object} obj
                     * @return {Object}
                     * @api private
                     */

                    function mixin(obj) {
                        for (var key in Emitter.prototype) {
                            obj[key] = Emitter.prototype[key];
                        }
                        return obj;
                    }

                    /**
                     * Listen on the given `event` with `fn`.
                     *
                     * @param {String} event
                     * @param {Function} fn
                     * @return {Emitter}
                     * @api public
                     */

                    Emitter.prototype.on =
                        Emitter.prototype.addEventListener = function (event, fn) {
                            this._callbacks = this._callbacks || {};
                            (this._callbacks[event] = this._callbacks[event] || [])
                                .push(fn);
                            return this;
                    };

                    /**
                     * Adds an `event` listener that will be invoked a single
                     * time then automatically removed.
                     *
                     * @param {String} event
                     * @param {Function} fn
                     * @return {Emitter}
                     * @api public
                     */

                    Emitter.prototype.once = function (event, fn) {
                        var self = this;
                        this._callbacks = this._callbacks || {};

                        function on() {
                            self.off(event, on);
                            fn.apply(this, arguments);
                        }

                        on.fn = fn;
                        this.on(event, on);
                        return this;
                    };

                    /**
                     * Remove the given callback for `event` or all
                     * registered callbacks.
                     *
                     * @param {String} event
                     * @param {Function} fn
                     * @return {Emitter}
                     * @api public
                     */

                    Emitter.prototype.off =
                        Emitter.prototype.removeListener =
                        Emitter.prototype.removeAllListeners =
                        Emitter.prototype.removeEventListener = function (event, fn) {
                            this._callbacks = this._callbacks || {};

                            // all
                            if (0 == arguments.length) {
                                this._callbacks = {};
                                return this;
                            }

                            // specific event
                            var callbacks = this._callbacks[event];
                            if (!callbacks) return this;

                            // remove all handlers
                            if (1 == arguments.length) {
                                delete this._callbacks[event];
                                return this;
                            }

                            // remove specific handler
                            var cb;
                            for (var i = 0; i < callbacks.length; i++) {
                                cb = callbacks[i];
                                if (cb === fn || cb.fn === fn) {
                                    callbacks.splice(i, 1);
                                    break;
                                }
                            }
                            return this;
                    };

                    /**
                     * Emit `event` with the given args.
                     *
                     * @param {String} event
                     * @param {Mixed} ...
                     * @return {Emitter}
                     */

                    Emitter.prototype.emit = function (event) {
                        this._callbacks = this._callbacks || {};
                        var args = [].slice.call(arguments, 1),
                            callbacks = this._callbacks[event];

                        if (callbacks) {
                            callbacks = callbacks.slice(0);
                            for (var i = 0, len = callbacks.length; i < len; ++i) {
                                callbacks[i].apply(this, args);
                            }
                        }

                        return this;
                    };

                    /**
                     * Return array of callbacks for `event`.
                     *
                     * @param {String} event
                     * @return {Array}
                     * @api public
                     */

                    Emitter.prototype.listeners = function (event) {
                        this._callbacks = this._callbacks || {};
                        return this._callbacks[event] || [];
                    };

                    /**
                     * Check if this emitter has `event` handlers.
                     *
                     * @param {String} event
                     * @return {Boolean}
                     * @api public
                     */

                    Emitter.prototype.hasListeners = function (event) {
                        return !!this.listeners(event).length;
                    };

                }, {}
            ],
            19: [
                function (noConflictRequire, module, exports) {

                    /**
                     * Reduce `arr` with `fn`.
                     *
                     * @param {Array} arr
                     * @param {Function} fn
                     * @param {Mixed} initial
                     *
                     * TODO: combatible error handling?
                     */

                    module.exports = function (arr, fn, initial) {
                        var idx = 0;
                        var len = arr.length;
                        var curr = arguments.length == 3 ? initial : arr[idx++];

                        while (idx < len) {
                            curr = fn.call(null, curr, arr[idx], ++idx, arr);
                        }

                        return curr;
                    };
                }, {}
            ],
            20: [
                function (noConflictRequire, module, exports) {
                    (function (global) {
                        var superagent = noConflictRequire('superagent');
                        global || (global = window)
                        var listeners = {
                            log: []
                        };

                        var Tracky = function (endpoint) {
                            this.endpoint = endpoint;
                            this.listeners = {
                                log: []
                            };
                        };

                        Tracky.superagent = superagent;

                        var S4 = function () {
                            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
                        };

                        // from https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Date/toISOString#Compatibility
                        function pad(number) {
                            var r = String(number);
                            if (r.length === 1) {
                                r = '0' + r;
                            }
                            return r;
                        }

                        function encodedSeed() {
                            if (Tracky.seed) {
                                return encodeURI(Tracky.seed);
                            }
                        }

                        function fireEvents(data, ls) {
                            for (var i = 0; i < ls.length; i++) {
                                var listener = ls[i];
                                try {
                                    listener(data);
                                } catch (e) {
                                    Tracky.whenDebugging(function () {
                                        console.log("Error running listener", listener);
                                    });
                                }
                            }
                        }

                        Tracky.on = function (name, listener) {
                            listeners[name].push(listener);
                        };

                        Tracky.prototype.on = function (name, listener) {
                            this.listeners[name].push(listener);
                        };

                        Tracky.prototype.log = function (eventName, data) {
                            var requiredData = {
                                "event_name": eventName.toString().toLowerCase(),
                                "event_client_timestamp": Tracky.currentISODateString(),
                                "event_id": Tracky.generateUUID()
                            };

                            var ajaxData = Tracky.merge({}, (data || {}), true);
                            ajaxData = Tracky.merge(ajaxData, requiredData);

                            var endpoint = this.endpoint || Tracky.endpoint;
                            if (!endpoint) {
                                Tracky.whenDebugging(function () {
                                    throw "Tracky.log error: No endpoint defined";
                                });
                                return;
                            }

                            Tracky.whenDebugging(function () {
                                console.log(endpoint + " => %s", JSON.stringify(ajaxData));
                            });
                            post(endpoint, ajaxData, false);
                            fireEvents(ajaxData, this.listeners.log.concat(listeners.log));
                        };

                        // Ensure full browser support for generating ISO Date Strings
                        Tracky.currentISODateString = function () {
                            var now = new Date();
                            return formatTimestamp(now);
                        };

                        Tracky.whenDebugging = function (callback) {
                            if (Tracky.debug) {
                                callback.call();
                            }
                        };

                        Tracky.merge = function (source, data, checkKey) {
                            var output = {},
                                key;

                            for (key in source) {
                                output[key] = source[key];
                            }

                            for (key in data) {
                                if (key.match(/^\w+$/) || !checkKey) {
                                    output[key] = data[key];
                                } else {
                                    Tracky.whenDebugging(function () {
                                        console.warn("Tracky.log - Invalid key '" + key + "' ignored");
                                    });
                                }
                            }

                            return output;
                        };

                        Tracky.generateUUID = function () {
                            var seed = encodedSeed(),
                                id = (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
                            if (seed) {
                                id = id + "-" + seed;
                            }
                            return id;
                        };

                        function ensureCallbacks(options) {
                            if (typeof options.success !== 'function') options.success = function () {}
                            if (typeof options.failure !== 'function') options.failure = function () {}
                        }

                        function postRequest(data, options) {
                            ensureCallbacks(options);

                            if (data === undefined || (data instanceof Array && data.length === 0)) {
                                Tracky.whenDebugging(function () {
                                    throw "Tracky.log error: No data to send";
                                });
                                return;
                            }

                            if (!Tracky.endpoint) {
                                Tracky.whenDebugging(function () {
                                    throw "Tracky.log error: No endpoint defined";
                                });
                                return;
                            }

                            Tracky.whenDebugging(function () {
                                console.log(Tracky.endpoint + " => %s", JSON.stringify(data));
                            });

                            post(Tracky.endpoint, data, options);
                            fireEvents(data, listeners.log);
                        }

                        function isDifferentOrigin(endpoint) {
                            var a = document.createElement('a');
                            a.href = endpoint;
                            if (a.host.length === 0) return false; // this happens with relative urls in IE
                            return window.location.protocol + window.location.host !== a.protocol + a.host;
                        }

                        function post(endpoint, data, options) {
                            if (isDifferentOrigin(endpoint)) {
                                // ensure criteria for simple XHR are met
                                if (global.XDomainRequest) {
                                    // we're not able to distinguish between sync and async here
                                    postXDomainIE(endpoint, data, options);
                                }
                                postRaw(endpoint, data, options);
                            } else {
                                if (options.synchronous) {
                                    // during the beforeunload event use sync to ensure the post succeeds
                                    postSync(endpoint, data, options);
                                } else {
                                    // basic post
                                    postAsync(endpoint, data, options);
                                }
                            }
                        }

                        function getXHR() {
                            if (global.XMLHttpRequest && ('file:' != global.location.protocol || !global.ActiveXObject)) {
                                return new XMLHttpRequest;
                            } else {
                                try {
                                    return new ActiveXObject('Microsoft.XMLHTTP');
                                } catch (e) {}
                                try {
                                    return new ActiveXObject('Msxml2.XMLHTTP.6.0');
                                } catch (e) {}
                                try {
                                    return new ActiveXObject('Msxml2.XMLHTTP.3.0');
                                } catch (e) {}
                                try {
                                    return new ActiveXObject('Msxml2.XMLHTTP');
                                } catch (e) {}
                            }
                            return false;
                        }

                        function withRetries(retriesLeft, onFail, onRetry) {
                            var doRetry = function () {
                                if (retriesLeft > 0) {
                                    retriesLeft--;
                                    onRetry(doRetry);
                                } else {
                                    onFail();
                                }
                            };
                            return onRetry(doRetry);
                        };

                        function postRaw(endpoint, data, options) {
                            withRetries(2, options.failure, function (retry) {
                                var xhr = getXHR();
                                if (!xhr) return;
                                xhr.open("POST", endpoint, !options.synchronous);
                                xhr.setRequestHeader('Content-Type', 'text/plain');
                                xhr.onreadystatechange = function () {
                                    if (xhr.readyState != 4) return;
                                    if (xhr.status != 200) {
                                        retry();
                                    } else {
                                        options.success(xhr.responseText);
                                    }
                                }
                                xhr.send(JSON.stringify(data));
                            });
                        }

                        function postXDomainIE(endpoint, data, options) {
                            withRetries(2, options.failure, function (retry) {
                                var xdr = new global.XDomainRequest();
                                xdr.onerror = function () {
                                    retry();
                                }
                                xdr.onload = function () {
                                    options.success(xdr.responseText);
                                }
                                xdr.open("post", endpoint);
                                xdr.send(JSON.stringify(data));
                            });
                        }

                        function postAsync(endpoint, data, options) {
                            withRetries(2, options.failure, function (retry) {
                                Tracky.superagent.post(endpoint)
                                    .set("X-Requested-With", null)
                                    .set("Content-Type", "text/plain")
                                    .send(JSON.stringify(data))
                                    .end(function (res) {
                                        if (res.error) retry();
                                        if (res.ok) options.success(res.text);
                                    });
                            });
                        }

                        function postSync(endpoint, data, options) {
                            withRetries(2, options.failure, function (retry) {
                                $.ajax({
                                    type: "POST",
                                    url: endpoint,
                                    contentType: 'text/plain',
                                    async: false,
                                    data: JSON.stringify(data),
                                    sucess: options.success,
                                    error: function () {
                                        retry();
                                    }
                                });
                            });
                        }

                        function ensureTrackyRulesForMessage(message) {
                            var outMessage = Tracky.merge({}, message, true);

                            outMessage.event_id = Tracky.generateUUID();

                            if (outMessage.event_name) {
                                var originalEventName = outMessage.event_name;
                                outMessage.event_name = outMessage.event_name.toString().toLowerCase();
                                if (originalEventName != outMessage.event_name) {
                                    Tracky.whenDebugging(function () {
                                        console.warn("Tracky.log: event_name being changed from %s to %s to conform with Tracky spec",
                                            originalEventName.toString(), outMessage.event_name);
                                    });
                                }
                            }

                            if (!outMessage.event_client_timestamp) {
                                outMessage.event_client_timestamp = Tracky.currentISODateString();
                            }
                            if (typeof outMessage.event_client_timestamp !== "string") {
                                outMessage.event_client_timestamp = formatTimestamp(outMessage.event_client_timestamp);
                            }

                            return outMessage;
                        }

                        function formatTimestamp(now) {
                            // Date#toISOString() seems to be unreliable cross-browser in whether it displays milliseconds,
                            // so use this implementation instead of the native function.
                            return now.getUTCFullYear() +
                                '-' + pad(now.getUTCMonth() + 1) +
                                '-' + pad(now.getUTCDate()) +
                                'T' + pad(now.getUTCHours()) +
                                ':' + pad(now.getUTCMinutes()) +
                                ':' + pad(now.getUTCSeconds()) +
                                '.' + String((now.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) +
                                'Z';
                        }

                        Tracky.logSync = function () {
                            // args can be:
                            // msgObj                    ; single message
                            // msgObj, msgObj, ...       ; bulk request
                            // [msgObj, msgObj, ... ]    ; bulk request
                            doLog(standardizeArguments(arguments), {
                                synchronous: true
                            });
                        }


                        Tracky.log = function () {
                            // args can be:
                            // msgObj                    ; single message
                            // msgObj, msgObj, ...       ; bulk request
                            // [msgObj, msgObj, ... ]    ; bulk request
                            doLog(standardizeArguments(arguments), {
                                synchronous: false
                            });
                        }

                        Tracky.logWithCallbacks = function (messages, options) {
                            // args must be:
                            // [<msgObj>], optionsObj
                            doLog(messages, options);
                        }

                        function standardizeArguments(args) {
                            var messages;
                            if (args.length === 1 && args[0] instanceof Array) {
                                messages = args[0];
                            } else {
                                messages = args;
                            }
                            return messages;
                        }

                        function doLog(args, options) {
                            var dataForRequest, trackyifiedData;

                            dataForRequest = [];

                            for (var i = 0; i < args.length; i++) {
                                trackyifiedData = ensureTrackyRulesForMessage(args[i]);

                                if (trackyifiedData.event_name) {
                                    dataForRequest.push(trackyifiedData);
                                }
                            }

                            return postRequest(dataForRequest, options);
                        };

                        module.exports = Tracky

                    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
                }, {
                    "superagent": 17
                }
            ],
            21: [
                function (noConflictRequire, module, exports) {
                    var regexes = noConflictRequire('./regexes'),
                        Results = noConflictRequire('./lib/results').BackwardsCompatResults;

                    var parsers = noConflictRequire('./make-parsers').makeParsers(regexes);

                    module.exports = parsers;
                }, {
                    "./lib/results": 25,
                    "./make-parsers": 27,
                    "./regexes": 28
                }
            ],
            22: [
                function (noConflictRequire, module, exports) {
                    exports.Device = Device

                    function Device(family, deviceType) {
                        this.family = family || 'Other';
                        this.type = deviceType || 'Other';
                    }

                    Device.prototype.toString = function () {
                        return this.family;
                    };

                    function parserForRegex(obj) {
                        var regexp = new RegExp(obj.regex),
                            deviceRep = obj.device_replacement,
                            deviceType = obj.device_type;

                        function parser(str) {
                            var m = str.match(regexp);
                            if (!m) {
                                return null;
                            }

                            var family = deviceRep ? deviceRep.replace('$1', m[1]) : m[1];
                            var type = deviceType || 'Other';
                            return new Device(family, deviceType);
                        }
                        return parser;
                    }

                    exports.makeParser = function (regexes) {
                        var parsers = [],
                            obj;

                        for (var i = 0, length = regexes.length; i < length; i++) {
                            parsers.push(parserForRegex(regexes[i]));
                        }

                        function parser(str, ua_family, os_family) {
                            var obj;

                            if (typeof str === 'string') {
                                for (var i = 0, length = parsers.length; i < length; i++) {
                                    obj = parsers[i](str, ua_family, os_family);
                                    if (obj) {
                                        return obj;
                                    }
                                }
                            }

                            return obj || new Device();
                        }

                        return parser;
                    };

                }, {}
            ],
            23: [
                function (noConflictRequire, module, exports) {
                    var DIGITS = /^\d/;

                    exports.startsWithDigit = startsWithDigit;

                    function startsWithDigit(str) {
                        return DIGITS.test(str);
                    }

                }, {}
            ],
            24: [
                function (noConflictRequire, module, exports) {
                    var startsWithDigit = noConflictRequire('./helpers').startsWithDigit;

                    exports.OS = OS

                    function OS(family, major, minor, patch, patchMinor) {
                        this.family = family || 'Other';
                        this.major = major || null;
                        this.minor = minor || null;
                        this.patch = patch || null;
                        this.patchMinor = patchMinor || null;
                    }

                    OS.prototype.toVersionString = function () {
                        var output = '';
                        if (this.major != null) {
                            output += this.major;
                            if (this.minor != null) {
                                output += '.' + this.minor;
                                if (this.patch != null) {
                                    if (startsWithDigit(this.patch)) {
                                        output += '.';
                                    }
                                    output += this.patch;
                                    if (this.patchMinor != null) {
                                        if (startsWithDigit(this.patchMinor)) {
                                            output += '.';
                                        }
                                        output += this.patchMinor;
                                    }
                                }
                            }
                        }
                        return output;
                    };

                    OS.prototype.toString = function () {
                        var suffix = this.toVersionString();
                        if (suffix) {
                            suffix = ' ' + suffix;
                        }
                        return this.family + suffix;
                    };

                    function _makeParsers(obj) {
                        var regexp = new RegExp(obj.regex),
                            famRep = obj.os_replacement,
                            majorRep = obj.os_v1_replacement,
                            minorRep = obj.os_v2_replacement,
                            patchRep = obj.os_v3_replacement,
                            patchMinorRep = obj.os_v4_replacement;

                        function parser(str) {
                            var m = str.match(regexp);
                            if (!m) {
                                return null;
                            }

                            var family = famRep ? famRep.replace('$1', m[1]) : m[1],
                                major = majorRep || m[2],
                                minor = minorRep || m[3],
                                patch = patchRep || m[4],
                                patchMinor = patchMinorRep || m[5];

                            return new OS(family, major, minor, patch, patchMinor);
                        }

                        return parser;
                    }

                    exports.makeParser = function (regexes) {
                        var parsers = [],
                            length,
                            i;
                        for (i = 0, length = regexes.length; i < length; i++) {
                            parsers.push(_makeParsers(regexes[i]));
                        }

                        function parser(str) {
                            var obj;

                            if (typeof str === 'string') {
                                for (var i = 0, length = parsers.length; i < length; i++) {
                                    obj = parsers[i](str);
                                    if (obj) {
                                        return obj;
                                    }
                                }
                            }

                            return obj || new OS();
                        }

                        return parser;
                    }

                }, {
                    "./helpers": 23
                }
            ],
            25: [
                function (noConflictRequire, module, exports) {
                    var UNDEF = void 0;

                    exports.BackwardsCompatResults = BackwardsCompatResults;

                    function BackwardsCompatResults(ua_str, ua, os, device) {
                        this.string = ua_str;
                        this.userAgent = this.ua = ua;
                        this.os = os;
                        this.device = device;

                        // Backwards compat
                        var major = ua.major,
                            minor = ua.minor,
                            patch = ua.patch;

                        this.family = ua.family;
                        this.major = major === null ? UNDEF : parseInt(major);
                        this.minor = minor === null ? UNDEF : parseInt(minor);
                        this.patch = patch === null ? UNDEF : parseInt(patch);
                    }

                    // Backwards compat
                    BackwardsCompatResults.prototype.toVersionString = function () {
                        var output = '',
                            ua = this.ua;
                        if (ua.major != null) {
                            output += ua.major;
                            if (ua.minor != null) {
                                output += '.' + ua.minor;
                                if (ua.patch != null) {
                                    output += '.' + ua.patch;
                                }
                            }
                        }
                        return output;
                    };

                    // Backwards compat
                    BackwardsCompatResults.prototype.toString = function () {
                        var suffix = this.toVersionString();
                        if (suffix) {
                            suffix = ' ' + suffix;
                        }
                        return this.ua.family + suffix;
                    };

                    // Backwards compat
                    BackwardsCompatResults.prototype.toFullString = function () {
                        return this.toString() + (this.os ? '/' + this.os : '');
                    };

                }, {}
            ],
            26: [
                function (noConflictRequire, module, exports) {
                    var startsWithDigit = noConflictRequire('./helpers').startsWithDigit,
                        OS = noConflictRequire('./os').OS;

                    exports.UA = UA

                    function UA(family, major, minor, patch) {
                        this.family = family || 'Other';
                        this.major = major || null;
                        this.minor = minor || null;
                        this.patch = patch || null;
                    }

                    UA.prototype.toString = OS.prototype.toString;
                    UA.prototype.toVersionString = OS.prototype.toVersionString;

                    function _makeParsers(obj) {
                        var regexp = new RegExp(obj.regex),
                            famRep = obj.family_replacement,
                            majorRep = obj.v1_replacement,
                            minorRep = obj.v2_replacement,
                            patchRep = obj.v3_replacement;

                        function parser(str) {
                            var m = str.match(regexp);
                            if (!m) {
                                return null;
                            }

                            var family = famRep ? famRep.replace('$1', m[1]) : m[1],
                                major = majorRep || m[2],
                                minor = minorRep || m[3],
                                patch = patchRep || m[4];

                            return new UA(family, major, minor, patch);
                        }

                        return parser;
                    }

                    exports.makeParser = function (regexes) {
                        var parsers = [],
                            length,
                            i;
                        for (i = 0, length = regexes.length; i < length; i++) {
                            parsers.push(_makeParsers(regexes[i]));
                        }

                        function parser(str) {
                            var obj;

                            if (typeof str === 'string') {
                                for (var i = 0, length = parsers.length; i < length; i++) {
                                    obj = parsers[i](str);
                                    if (obj) {
                                        return obj;
                                    }
                                }
                            }

                            return obj || new UA();
                        }

                        return parser;
                    }

                }, {
                    "./helpers": 23,
                    "./os": 24
                }
            ],
            27: [
                function (noConflictRequire, module, exports) {
                    var Results = noConflictRequire('./lib/results').BackwardsCompatResults;
                    exports.makeParsers = function (regexes) {
                        var parsers = {};
                        var parseUA = noConflictRequire('./lib/ua').makeParser(regexes.user_agent_parsers),
                            parseOS = noConflictRequire('./lib/os').makeParser(regexes.os_parsers),
                            parseDevice = noConflictRequire('./lib/device').makeParser(regexes.device_parsers);

                        parsers["parseUA"] = parseUA;
                        parsers["parseOS"] = parseOS;
                        parsers["parseDevice"] = parseDevice;

                        parsers["parse"] = function (str) {
                            var ua = parseUA(str),
                                os = parseOS(str),
                                device = parseDevice(str);
                            return new Results(str, ua, os, device);
                        }
                        return parsers;
                    }

                }, {
                    "./lib/device": 22,
                    "./lib/os": 24,
                    "./lib/results": 25,
                    "./lib/ua": 26
                }
            ],
            28: [
                function (noConflictRequire, module, exports) {
                    module.exports = {
                        "user_agent_parsers": [{
                            "regex": "(HbbTV)/(\\d+)\\.(\\d+)\\.(\\d+) \\("
                        }, {
                            "regex": "(Chimera|SeaMonkey|Camino)/(\\d+)\\.(\\d+)\\.?([ab]?\\d+[a-z]*)?"
                        }, {
                            "regex": "(Pale[Mm]oon)/(\\d+)\\.(\\d+)\\.?(\\d+)?",
                            "family_replacement": "Pale Moon (Firefox Variant)"
                        }, {
                            "regex": "(Fennec)/(\\d+)\\.(\\d+)\\.?([ab]?\\d+[a-z]*)",
                            "family_replacement": "Firefox Mobile"
                        }, {
                            "regex": "(Fennec)/(\\d+)\\.(\\d+)(pre)",
                            "family_replacement": "Firefox Mobile"
                        }, {
                            "regex": "(Fennec)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Firefox Mobile"
                        }, {
                            "regex": "Mobile.*(Firefox)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Firefox Mobile"
                        }, {
                            "regex": "(Namoroka|Shiretoko|Minefield)/(\\d+)\\.(\\d+)\\.(\\d+(?:pre)?)",
                            "family_replacement": "Firefox ($1)"
                        }, {
                            "regex": "(Firefox)/(\\d+)\\.(\\d+)(a\\d+[a-z]*)",
                            "family_replacement": "Firefox Alpha"
                        }, {
                            "regex": "(Firefox)/(\\d+)\\.(\\d+)(b\\d+[a-z]*)",
                            "family_replacement": "Firefox Beta"
                        }, {
                            "regex": "(Firefox)-(?:\\d+\\.\\d+)?/(\\d+)\\.(\\d+)(a\\d+[a-z]*)",
                            "family_replacement": "Firefox Alpha"
                        }, {
                            "regex": "(Firefox)-(?:\\d+\\.\\d+)?/(\\d+)\\.(\\d+)(b\\d+[a-z]*)",
                            "family_replacement": "Firefox Beta"
                        }, {
                            "regex": "(Namoroka|Shiretoko|Minefield)/(\\d+)\\.(\\d+)([ab]\\d+[a-z]*)?",
                            "family_replacement": "Firefox ($1)"
                        }, {
                            "regex": "(Firefox).*Tablet browser (\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "MicroB"
                        }, {
                            "regex": "(MozillaDeveloperPreview)/(\\d+)\\.(\\d+)([ab]\\d+[a-z]*)?"
                        }, {
                            "regex": "(Flock)/(\\d+)\\.(\\d+)(b\\d+?)"
                        }, {
                            "regex": "(RockMelt)/(\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Navigator)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Netscape"
                        }, {
                            "regex": "(Navigator)/(\\d+)\\.(\\d+)([ab]\\d+)",
                            "family_replacement": "Netscape"
                        }, {
                            "regex": "(Netscape6)/(\\d+)\\.(\\d+)\\.?([ab]?\\d+)?",
                            "family_replacement": "Netscape"
                        }, {
                            "regex": "(MyIBrow)/(\\d+)\\.(\\d+)",
                            "family_replacement": "My Internet Browser"
                        }, {
                            "regex": "(Opera Tablet).*Version/(\\d+)\\.(\\d+)(?:\\.(\\d+))?"
                        }, {
                            "regex": "(Opera)/.+Opera Mobi.+Version/(\\d+)\\.(\\d+)",
                            "family_replacement": "Opera Mobile"
                        }, {
                            "regex": "(Opera)/(\\d+)\\.(\\d+).+Opera Mobi",
                            "family_replacement": "Opera Mobile"
                        }, {
                            "regex": "Opera Mobi.+(Opera)[/ ](\\d+)\\.(\\d+)",
                            "family_replacement": "Opera Mobile"
                        }, {
                            "regex": "Opera Mobi",
                            "family_replacement": "Opera Mobile"
                        }, {
                            "regex": "(Opera Mini)(?:/att)?/(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Opera)/9.80.*Version/(\\d+)\\.(\\d+)(?:\\.(\\d+))?"
                        }, {
                            "regex": "(?:Mobile Safari).*(OPR)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Opera Mobile"
                        }, {
                            "regex": "(?:Chrome).*(OPR)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Opera"
                        }, {
                            "regex": "(hpw|web)OS/(\\d+)\\.(\\d+)(?:\\.(\\d+))?",
                            "family_replacement": "webOS Browser"
                        }, {
                            "regex": "(luakit)",
                            "family_replacement": "LuaKit"
                        }, {
                            "regex": "(Snowshoe)/(\\d+)\\.(\\d+).(\\d+)"
                        }, {
                            "regex": "(Lightning)/(\\d+)\\.(\\d+)\\.?((?:[ab]?\\d+[a-z]*)|(?:\\d*))"
                        }, {
                            "regex": "(Firefox)/(\\d+)\\.(\\d+)\\.(\\d+(?:pre)?) \\(Swiftfox\\)",
                            "family_replacement": "Swiftfox"
                        }, {
                            "regex": "(Firefox)/(\\d+)\\.(\\d+)([ab]\\d+[a-z]*)? \\(Swiftfox\\)",
                            "family_replacement": "Swiftfox"
                        }, {
                            "regex": "(rekonq)/(\\d+)\\.(\\d+)\\.?(\\d+)? Safari",
                            "family_replacement": "Rekonq"
                        }, {
                            "regex": "rekonq",
                            "family_replacement": "Rekonq"
                        }, {
                            "regex": "(conkeror|Conkeror)/(\\d+)\\.(\\d+)\\.?(\\d+)?",
                            "family_replacement": "Conkeror"
                        }, {
                            "regex": "(konqueror)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Konqueror"
                        }, {
                            "regex": "(WeTab)-Browser"
                        }, {
                            "regex": "(Comodo_Dragon)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Comodo Dragon"
                        }, {
                            "regex": "(YottaaMonitor|BrowserMob|HttpMonitor|YandexBot|Slurp|BingPreview|PagePeeker|ThumbShotsBot|WebThumb|URL2PNG|ZooShot|GomezA|Catchpoint bot|Willow Internet Crawler|Google SketchUp|Read%20Later)"
                        }, {
                            "regex": "(Symphony) (\\d+).(\\d+)"
                        }, {
                            "regex": "(Minimo)"
                        }, {
                            "regex": "(CrMo)/(\\d+)\\.(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Chrome Mobile"
                        }, {
                            "regex": "(CriOS)/(\\d+)\\.(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Chrome Mobile iOS"
                        }, {
                            "regex": "(Chrome)/(\\d+)\\.(\\d+)\\.(\\d+)\\.(\\d+) Mobile",
                            "family_replacement": "Chrome Mobile"
                        }, {
                            "regex": "(chromeframe)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Chrome Frame"
                        }, {
                            "regex": "(UCBrowser)[ /](\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "UC Browser"
                        }, {
                            "regex": "(UC Browser)[ /](\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(UC Browser|UCBrowser|UCWEB)(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "UC Browser"
                        }, {
                            "regex": "(SLP Browser)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Tizen Browser"
                        }, {
                            "regex": "(SE 2\\.X) MetaSr (\\d+)\\.(\\d+)",
                            "family_replacement": "Sogou Explorer"
                        }, {
                            "regex": "(baidubrowser)[/\\s](\\d+)",
                            "family_replacement": "Baidu Browser"
                        }, {
                            "regex": "(FlyFlow)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Baidu Explorer"
                        }, {
                            "regex": "(MQQBrowser/Mini)(?:(\\d+)(?:\\.(\\d+)(?:\\.(\\d+))?)?)?",
                            "family_replacement": "QQ Browser Mini"
                        }, {
                            "regex": "(MQQBrowser)(?:/(\\d+)(?:\\.(\\d+)(?:\\.(\\d+))?)?)?",
                            "family_replacement": "QQ Browser Mobile"
                        }, {
                            "regex": "(QQBrowser)(?:/(\\d+)(?:\\.(\\d+)\\.(\\d+)(?:\\.(\\d+))?)?)?",
                            "family_replacement": "QQ Browser"
                        }, {
                            "regex": "(Pingdom.com_bot_version_)(\\d+)\\.(\\d+)",
                            "family_replacement": "PingdomBot"
                        }, {
                            "regex": "(facebookexternalhit)/(\\d+)\\.(\\d+)",
                            "family_replacement": "FacebookBot"
                        }, {
                            "regex": "(LinkedInBot)/(\\d+)\\.(\\d+)",
                            "family_replacement": "LinkedInBot"
                        }, {
                            "regex": "(Twitterbot)/(\\d+)\\.(\\d+)",
                            "family_replacement": "TwitterBot"
                        }, {
                            "regex": "Google.*/\\+/web/snippet",
                            "family_replacement": "GooglePlusBot"
                        }, {
                            "regex": "(Rackspace Monitoring)/(\\d+)\\.(\\d+)",
                            "family_replacement": "RackspaceBot"
                        }, {
                            "regex": "(PyAMF)/(\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(YaBrowser)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Yandex Browser"
                        }, {
                            "regex": "(Chrome)/(\\d+)\\.(\\d+)\\.(\\d+).* MRCHROME",
                            "family_replacement": "Mail.ru Chromium Browser"
                        }, {
                            "regex": "(AOL) (\\d+)\\.(\\d+); AOLBuild (\\d+)"
                        }, {
                            "regex": "(AdobeAIR|FireWeb|Jasmine|ANTGalio|Midori|Fresco|Lobo|PaleMoon|Maxthon|Lynx|OmniWeb|Dillo|Camino|Demeter|Fluid|Fennec|Epiphany|Shiira|Sunrise|Flock|Netscape|Lunascape|WebPilot|NetFront|Netfront|Konqueror|SeaMonkey|Kazehakase|Vienna|Iceape|Iceweasel|IceWeasel|Iron|K-Meleon|Sleipnir|Galeon|GranParadiso|Opera Mini|iCab|NetNewsWire|ThunderBrowse|Iris|UP\\.Browser|Bunjalloo|Google Earth|Raven for Mac|Openwave)/(\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "MSOffice 12",
                            "family_replacement": "Outlook",
                            "v1_replacement": "2007"
                        }, {
                            "regex": "MSOffice 14",
                            "family_replacement": "Outlook",
                            "v1_replacement": "2010"
                        }, {
                            "regex": "Microsoft Outlook 15\\.\\d+\\.\\d+",
                            "family_replacement": "Outlook",
                            "v1_replacement": "2013"
                        }, {
                            "regex": "(Airmail) (\\d+)\\.(\\d+)(?:\\.(\\d+))?"
                        }, {
                            "regex": "(Thunderbird)/(\\d+)\\.(\\d+)\\.(\\d+(?:pre)?)",
                            "family_replacement": "Thunderbird"
                        }, {
                            "regex": "(Chromium|Chrome)/(\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "\\b(Dolphin)(?: |HDCN/|/INT\\-)(\\d+)\\.(\\d+)\\.?(\\d+)?"
                        }, {
                            "regex": "(bingbot|Bolt|Jasmine|IceCat|Skyfire|Midori|Maxthon|Lynx|Arora|IBrowse|Dillo|Camino|Shiira|Fennec|Phoenix|Chrome|Flock|Netscape|Lunascape|Epiphany|WebPilot|Opera Mini|Opera|NetFront|Netfront|Konqueror|Googlebot|SeaMonkey|Kazehakase|Vienna|Iceape|Iceweasel|IceWeasel|Iron|K-Meleon|Sleipnir|Galeon|GranParadiso|iCab|NetNewsWire|Space Bison|Stainless|Orca|Dolfin|BOLT|Minimo|Tizen Browser|Polaris|Abrowser|Planetweb|ICE Browser|mDolphin)/(\\d+)\\.(\\d+)\\.?(\\d+)?"
                        }, {
                            "regex": "(Chromium|Chrome)/(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(IEMobile)[ /](\\d+)\\.(\\d+)",
                            "family_replacement": "IE Mobile"
                        }, {
                            "regex": "(iRider|Crazy Browser|SkipStone|iCab|Lunascape|Sleipnir|Maemo Browser) (\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(iCab|Lunascape|Opera|Android|Jasmine|Polaris) (\\d+)\\.(\\d+)\\.?(\\d+)?"
                        }, {
                            "regex": "(Kindle)/(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Android) Donut",
                            "v1_replacement": "1",
                            "v2_replacement": "2"
                        }, {
                            "regex": "(Android) Eclair",
                            "v1_replacement": "2",
                            "v2_replacement": "1"
                        }, {
                            "regex": "(Android) Froyo",
                            "v1_replacement": "2",
                            "v2_replacement": "2"
                        }, {
                            "regex": "(Android) Gingerbread",
                            "v1_replacement": "2",
                            "v2_replacement": "3"
                        }, {
                            "regex": "(Android) Honeycomb",
                            "v1_replacement": "3"
                        }, {
                            "regex": "(MSIE) (\\d+)\\.(\\d+).*XBLWP7",
                            "family_replacement": "IE Large Screen"
                        }, {
                            "regex": "(Obigo)InternetBrowser"
                        }, {
                            "regex": "(Obigo)\\-Browser"
                        }, {
                            "regex": "(Obigo|OBIGO)[^\\d]*(\\d+)(?:.(\\d+))?",
                            "family_replacement": "Obigo"
                        }, {
                            "regex": "(MAXTHON|Maxthon) (\\d+)\\.(\\d+)",
                            "family_replacement": "Maxthon"
                        }, {
                            "regex": "(Maxthon|MyIE2|Uzbl|Shiira)",
                            "v1_replacement": "0"
                        }, {
                            "regex": "PLAYSTATION 3.+WebKit",
                            "family_replacement": "NetFront NX"
                        }, {
                            "regex": "PLAYSTATION 3",
                            "family_replacement": "NetFront"
                        }, {
                            "regex": "(PlayStation Portable)",
                            "family_replacement": "NetFront"
                        }, {
                            "regex": "(PlayStation Vita)",
                            "family_replacement": "NetFront NX"
                        }, {
                            "regex": "AppleWebKit.+ (NX)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "NetFront NX"
                        }, {
                            "regex": "(Nintendo 3DS)",
                            "family_replacement": "NetFront NX"
                        }, {
                            "regex": "(BrowseX) \\((\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(NCSA_Mosaic)/(\\d+)\\.(\\d+)",
                            "family_replacement": "NCSA Mosaic"
                        }, {
                            "regex": "(POLARIS)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Polaris"
                        }, {
                            "regex": "(Embider)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Polaris"
                        }, {
                            "regex": "(BonEcho)/(\\d+)\\.(\\d+)\\.?([ab]?\\d+)?",
                            "family_replacement": "Bon Echo"
                        }, {
                            "regex": "(CFNetwork)(?:/(\\d+)\\.(\\d+)\\.?(\\d+)?)?",
                            "family_replacement": "CFNetwork"
                        }, {
                            "regex": "(iPod).+Version/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(iPod).*Version/(\\d+)\\.(\\d+)",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(iPhone).*Version/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(iPhone).*Version/(\\d+)\\.(\\d+)",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(iPad).*Version/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(iPad).*Version/(\\d+)\\.(\\d+)",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(iPod|iPhone|iPad);.*CPU.*OS (\\d+)(?:_\\d+)?_(\\d+).*Mobile",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(iPod|iPhone|iPad)",
                            "family_replacement": "Mobile Safari"
                        }, {
                            "regex": "(AvantGo) (\\d+).(\\d+)"
                        }, {
                            "regex": "(OneBrowser)/(\\d+).(\\d+)",
                            "family_replacement": "ONE Browser"
                        }, {
                            "regex": "(Avant)",
                            "v1_replacement": "1"
                        }, {
                            "regex": "(QtCarBrowser)",
                            "v1_replacement": "1"
                        }, {
                            "regex": "^(iBrowser/Mini)(\\d+).(\\d+)",
                            "family_replacement": "iBrowser Mini"
                        }, {
                            "regex": "^(iBrowser|iRAPP)/(\\d+).(\\d+)"
                        }, {
                            "regex": "^(Nokia)",
                            "family_replacement": "Nokia Services (WAP) Browser"
                        }, {
                            "regex": "(NokiaBrowser)/(\\d+)\\.(\\d+).(\\d+)\\.(\\d+)",
                            "family_replacement": "Nokia Browser"
                        }, {
                            "regex": "(NokiaBrowser)/(\\d+)\\.(\\d+).(\\d+)",
                            "family_replacement": "Nokia Browser"
                        }, {
                            "regex": "(NokiaBrowser)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Nokia Browser"
                        }, {
                            "regex": "(BrowserNG)/(\\d+)\\.(\\d+).(\\d+)",
                            "family_replacement": "Nokia Browser"
                        }, {
                            "regex": "(Series60)/5\\.0",
                            "family_replacement": "Nokia Browser",
                            "v1_replacement": "7",
                            "v2_replacement": "0"
                        }, {
                            "regex": "(Series60)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Nokia OSS Browser"
                        }, {
                            "regex": "(S40OviBrowser)/(\\d+)\\.(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "Ovi Browser"
                        }, {
                            "regex": "(Nokia)[EN]?(\\d+)"
                        }, {
                            "regex": "(BB10);",
                            "family_replacement": "BlackBerry WebKit"
                        }, {
                            "regex": "(PlayBook).+RIM Tablet OS (\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "BlackBerry WebKit"
                        }, {
                            "regex": "(Black[bB]erry).+Version/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "BlackBerry WebKit"
                        }, {
                            "regex": "(Black[bB]erry)\\s?(\\d+)",
                            "family_replacement": "BlackBerry"
                        }, {
                            "regex": "(OmniWeb)/v(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Blazer)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Palm Blazer"
                        }, {
                            "regex": "(Pre)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Palm Pre"
                        }, {
                            "regex": "(ELinks)/(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(ELinks) \\((\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Links) \\((\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(QtWeb) Internet Browser/(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Silk)/(\\d+)\\.(\\d+)(?:\\.([0-9\\-]+))?",
                            "family_replacement": "Amazon Silk"
                        }, {
                            "regex": "(PhantomJS)/(\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(AppleWebKit)/(\\d+)\\.?(\\d+)?\\+ .* Safari",
                            "family_replacement": "WebKit Nightly"
                        }, {
                            "regex": "(Version)/(\\d+)\\.(\\d+)(?:\\.(\\d+))?.*Safari/",
                            "family_replacement": "Safari"
                        }, {
                            "regex": "(Safari)/\\d+"
                        }, {
                            "regex": "(OLPC)/Update(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(OLPC)/Update()\\.(\\d+)",
                            "v1_replacement": "0"
                        }, {
                            "regex": "(SEMC\\-Browser)/(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Teleca)",
                            "family_replacement": "Teleca Browser"
                        }, {
                            "regex": "(Phantom)/V(\\d+)\\.(\\d+)",
                            "family_replacement": "Phantom Browser"
                        }, {
                            "regex": "Trident(.*)rv.(\\d+)\\.(\\d+)",
                            "family_replacement": "IE"
                        }, {
                            "regex": "(Espial)/(\\d+)(?:\\.(\\d+))?(?:\\.(\\d+))?"
                        }, {
                            "regex": "(AppleWebKit)/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "family_replacement": "AppleMail"
                        }, {
                            "regex": "(Firefox)/(\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Firefox)/(\\d+)\\.(\\d+)(pre|[ab]\\d+[a-z]*)?"
                        }, {
                            "regex": "([MS]?IE) (\\d+)\\.(\\d+)",
                            "family_replacement": "IE"
                        }, {
                            "regex": "(python-requests)/(\\d+)\\.(\\d+)",
                            "family_replacement": "Python Requests"
                        }],
                        "os_parsers": [{
                            "regex": "HbbTV/\\d+\\.\\d+\\.\\d+ \\( ;(LG)E ;NetCast 4.0",
                            "os_v1_replacement": "2013"
                        }, {
                            "regex": "HbbTV/\\d+\\.\\d+\\.\\d+ \\( ;(LG)E ;NetCast 3.0",
                            "os_v1_replacement": "2012"
                        }, {
                            "regex": "HbbTV/1.1.1 \\(;;;;;\\) Maple_2011",
                            "os_replacement": "Samsung",
                            "os_v1_replacement": "2011"
                        }, {
                            "regex": "HbbTV/\\d+\\.\\d+\\.\\d+ \\(;(Samsung);SmartTV([0-9]{4});.*FXPDEUC",
                            "os_v2_replacement": "UE40F7000"
                        }, {
                            "regex": "HbbTV/\\d+\\.\\d+\\.\\d+ \\(;(Samsung);SmartTV([0-9]{4});.*MST12DEUC",
                            "os_v2_replacement": "UE32F4500"
                        }, {
                            "regex": "HbbTV/1.1.1 \\(; (Philips);.*NETTV/4",
                            "os_v1_replacement": "2013"
                        }, {
                            "regex": "HbbTV/1.1.1 \\(; (Philips);.*NETTV/3",
                            "os_v1_replacement": "2012"
                        }, {
                            "regex": "HbbTV/1.1.1 \\(; (Philips);.*NETTV/2",
                            "os_v1_replacement": "2011"
                        }, {
                            "regex": "HbbTV/\\d+\\.\\d+\\.\\d+.*(firetv)-firefox-plugin (\\d+).(\\d+).(\\d+)",
                            "os_replacement": "FireHbbTV"
                        }, {
                            "regex": "HbbTV/\\d+\\.\\d+\\.\\d+ \\(.*; ?([a-zA-Z]+) ?;.*(201[1-9]).*\\)"
                        }, {
                            "regex": "(Windows Phone) (?:OS[ /])?(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Android)[ \\-/](\\d+)\\.(\\d+)(?:[.\\-]([a-z0-9]+))?"
                        }, {
                            "regex": "(Android) Donut",
                            "os_v1_replacement": "1",
                            "os_v2_replacement": "2"
                        }, {
                            "regex": "(Android) Eclair",
                            "os_v1_replacement": "2",
                            "os_v2_replacement": "1"
                        }, {
                            "regex": "(Android) Froyo",
                            "os_v1_replacement": "2",
                            "os_v2_replacement": "2"
                        }, {
                            "regex": "(Android) Gingerbread",
                            "os_v1_replacement": "2",
                            "os_v2_replacement": "3"
                        }, {
                            "regex": "(Android) Honeycomb",
                            "os_v1_replacement": "3"
                        }, {
                            "regex": "^UCWEB.*; (Adr) (\\d+)\\.(\\d+)(?:[.\\-]([a-z0-9]+))?;",
                            "os_replacement": "Android"
                        }, {
                            "regex": "^UCWEB.*; (iPad OS|iPh OS) (\\d+)_(\\d+)(?:_(\\d+))?;",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "^UCWEB.*; (wds) (\\d+)\\.(\\d+)(?:\\.(\\d+))?;",
                            "os_replacement": "Windows Phone"
                        }, {
                            "regex": "^(JUC).*; ?U; ?(?:Android)?(\\d+)\\.(\\d+)(?:[\\.\\-]([a-z0-9]+))?",
                            "os_replacement": "Android"
                        }, {
                            "regex": "(Silk-Accelerated=[a-z]{4,5})",
                            "os_replacement": "Android"
                        }, {
                            "regex": "(XBLWP7)",
                            "os_replacement": "Windows Phone"
                        }, {
                            "regex": "(Windows ?Mobile)",
                            "os_replacement": "Windows Mobile"
                        }, {
                            "regex": "(Windows (?:NT 5\\.2|NT 5\\.1))",
                            "os_replacement": "Windows XP"
                        }, {
                            "regex": "(Windows NT 6\\.1)",
                            "os_replacement": "Windows 7"
                        }, {
                            "regex": "(Windows NT 6\\.0)",
                            "os_replacement": "Windows Vista"
                        }, {
                            "regex": "(Win 9x 4\\.90)",
                            "os_replacement": "Windows ME"
                        }, {
                            "regex": "(Windows 98|Windows XP|Windows ME|Windows 95|Windows CE|Windows 7|Windows NT 4\\.0|Windows Vista|Windows 2000|Windows 3.1)"
                        }, {
                            "regex": "(Windows NT 6\\.2; ARM;)",
                            "os_replacement": "Windows RT"
                        }, {
                            "regex": "(Windows NT 6\\.2)",
                            "os_replacement": "Windows 8"
                        }, {
                            "regex": "(Windows NT 6\\.3; ARM;)",
                            "os_replacement": "Windows RT 8.1"
                        }, {
                            "regex": "(Windows NT 6\\.3)",
                            "os_replacement": "Windows 8.1"
                        }, {
                            "regex": "(Windows NT 5\\.0)",
                            "os_replacement": "Windows 2000"
                        }, {
                            "regex": "(WinNT4.0)",
                            "os_replacement": "Windows NT 4.0"
                        }, {
                            "regex": "(Windows ?CE)",
                            "os_replacement": "Windows CE"
                        }, {
                            "regex": "Win ?(95|98|3.1|NT|ME|2000)",
                            "os_replacement": "Windows $1"
                        }, {
                            "regex": "Win16",
                            "os_replacement": "Windows 3.1"
                        }, {
                            "regex": "Win32",
                            "os_replacement": "Windows 95"
                        }, {
                            "regex": "(Tizen)/(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(Mac OS X) (\\d+)[_.](\\d+)(?:[_.](\\d+))?"
                        }, {
                            "regex": " (Dar)(win)/(9).(\\d+).*\\((?:i386|x86_64|Power Macintosh)\\)",
                            "os_replacement": "Mac OS X",
                            "os_v1_replacement": "10",
                            "os_v2_replacement": "5"
                        }, {
                            "regex": " (Dar)(win)/(10).(\\d+).*\\((?:i386|x86_64)\\)",
                            "os_replacement": "Mac OS X",
                            "os_v1_replacement": "10",
                            "os_v2_replacement": "6"
                        }, {
                            "regex": " (Dar)(win)/(11).(\\d+).*\\((?:i386|x86_64)\\)",
                            "os_replacement": "Mac OS X",
                            "os_v1_replacement": "10",
                            "os_v2_replacement": "7"
                        }, {
                            "regex": " (Dar)(win)/(12).(\\d+).*\\((?:i386|x86_64)\\)",
                            "os_replacement": "Mac OS X",
                            "os_v1_replacement": "10",
                            "os_v2_replacement": "8"
                        }, {
                            "regex": " (Dar)(win)/(13).(\\d+).*\\((?:i386|x86_64)\\)",
                            "os_replacement": "Mac OS X",
                            "os_v1_replacement": "10",
                            "os_v2_replacement": "9"
                        }, {
                            "regex": "Mac_PowerPC",
                            "os_replacement": "Mac OS"
                        }, {
                            "regex": "(?:PPC|Intel) (Mac OS X)"
                        }, {
                            "regex": "(CPU OS|iPhone OS|CPU iPhone) +(\\d+)[_\\.](\\d+)(?:[_\\.](\\d+))?",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(iPhone|iPad|iPod); Opera",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(iPhone|iPad|iPod).*Mac OS X.*Version/(\\d+)\\.(\\d+)",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(AppleTV)/(\\d+)\\.(\\d+)",
                            "os_replacement": "ATV OS X"
                        }, {
                            "regex": "(CFNetwork)/(5)48\\.0\\.3.* Darwin/11\\.0\\.0",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/(5)48\\.(0)\\.4.* Darwin/(1)1\\.0\\.0",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/(5)48\\.(1)\\.4",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/(4)85\\.1(3)\\.9",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/(6)09\\.(1)\\.4",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/(6)(0)9",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/6(7)2\\.(1)\\.13",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/6(7)2\\.(1)\\.(1)4",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CF)(Network)/6(7)(2)\\.1\\.15",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "7",
                            "os_v2_replacement": "1"
                        }, {
                            "regex": "(CFNetwork)/6(7)2\\.(0)\\.(?:2|8)",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CFNetwork)/709\\.1",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "8",
                            "os_v2_replacement": "0.b5"
                        }, {
                            "regex": "CFNetwork/.* Darwin/(9)\\.\\d+",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "1"
                        }, {
                            "regex": "CFNetwork/.* Darwin/(10)\\.\\d+",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "4"
                        }, {
                            "regex": "CFNetwork/.* Darwin/(11)\\.\\d+",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "5"
                        }, {
                            "regex": "CFNetwork/.* Darwin/(13)\\.\\d+",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "6"
                        }, {
                            "regex": "CFNetwork/6.* Darwin/(14)\\.\\d+",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "7"
                        }, {
                            "regex": "CFNetwork/7.* Darwin/(14)\\.\\d+",
                            "os_replacement": "iOS",
                            "os_v1_replacement": "8",
                            "os_v2_replacement": "0"
                        }, {
                            "regex": "\\b(iOS[ /]|iPhone(?:/| v|[ _]OS[/,]|; | OS : |\\d,\\d/|\\d,\\d; )|iPad/)(\\d{1,2})[_\\.](\\d{1,2})(?:[_\\.](\\d+))?",
                            "os_replacement": "iOS"
                        }, {
                            "regex": "(CrOS) [a-z0-9_]+ (\\d+)\\.(\\d+)(?:\\.(\\d+))?",
                            "os_replacement": "Chrome OS"
                        }, {
                            "regex": "([Dd]ebian)",
                            "os_replacement": "Debian"
                        }, {
                            "regex": "(Linux Mint)(?:/(\\d+))?"
                        }, {
                            "regex": "(Mandriva)(?: Linux)?/(?:[\\d.-]+m[a-z]{2}(\\d+).(\\d))?"
                        }, {
                            "regex": "(Symbian[Oo][Ss])[/ ](\\d+)\\.(\\d+)",
                            "os_replacement": "Symbian OS"
                        }, {
                            "regex": "(Symbian/3).+NokiaBrowser/7\\.3",
                            "os_replacement": "Symbian^3 Anna"
                        }, {
                            "regex": "(Symbian/3).+NokiaBrowser/7\\.4",
                            "os_replacement": "Symbian^3 Belle"
                        }, {
                            "regex": "(Symbian/3)",
                            "os_replacement": "Symbian^3"
                        }, {
                            "regex": "\\b(Series 60|SymbOS|S60Version|S60V\\d|S60\\b)",
                            "os_replacement": "Symbian OS"
                        }, {
                            "regex": "(MeeGo)"
                        }, {
                            "regex": "Symbian [Oo][Ss]",
                            "os_replacement": "Symbian OS"
                        }, {
                            "regex": "Series40;",
                            "os_replacement": "Nokia Series 40"
                        }, {
                            "regex": "Series30Plus;",
                            "os_replacement": "Nokia Series 30 Plus"
                        }, {
                            "regex": "(BB10);.+Version/(\\d+)\\.(\\d+)\\.(\\d+)",
                            "os_replacement": "BlackBerry OS"
                        }, {
                            "regex": "(Black[Bb]erry)[0-9a-z]+/(\\d+)\\.(\\d+)\\.(\\d+)(?:\\.(\\d+))?",
                            "os_replacement": "BlackBerry OS"
                        }, {
                            "regex": "(Black[Bb]erry).+Version/(\\d+)\\.(\\d+)\\.(\\d+)(?:\\.(\\d+))?",
                            "os_replacement": "BlackBerry OS"
                        }, {
                            "regex": "(RIM Tablet OS) (\\d+)\\.(\\d+)\\.(\\d+)",
                            "os_replacement": "BlackBerry Tablet OS"
                        }, {
                            "regex": "(Play[Bb]ook)",
                            "os_replacement": "BlackBerry Tablet OS"
                        }, {
                            "regex": "(Black[Bb]erry)",
                            "os_replacement": "BlackBerry OS"
                        }, {
                            "regex": "\\((?:Mobile|Tablet);.+Firefox/\\d+\\.\\d+",
                            "os_replacement": "Firefox OS"
                        }, {
                            "regex": "(BREW)[ /](\\d+)\\.(\\d+)\\.(\\d+)"
                        }, {
                            "regex": "(BREW);"
                        }, {
                            "regex": "(Brew MP|BMP)[ /](\\d+)\\.(\\d+)\\.(\\d+)",
                            "os_replacement": "Brew MP"
                        }, {
                            "regex": "BMP;",
                            "os_replacement": "Brew MP"
                        }, {
                            "regex": "(GoogleTV)(?: (\\d+)\\.(\\d+)(?:\\.(\\d+))?|/[\\da-z]+)"
                        }, {
                            "regex": "(WebTV)/(\\d+).(\\d+)"
                        }, {
                            "regex": "(hpw|web)OS/(\\d+)\\.(\\d+)(?:\\.(\\d+))?",
                            "os_replacement": "webOS"
                        }, {
                            "regex": "(VRE);"
                        }, {
                            "regex": "(Fedora|Red Hat|PCLinuxOS|Puppy|Ubuntu|Kindle|Bada|Lubuntu|BackTrack|Slackware|(?:Free|Open|Net|\\b)BSD)[/ ](\\d+)\\.(\\d+)(?:\\.(\\d+)(?:\\.(\\d+))?)?"
                        }, {
                            "regex": "(Linux)[ /](\\d+)\\.(\\d+)(?:\\.(\\d+))?.*gentoo",
                            "os_replacement": "Gentoo"
                        }, {
                            "regex": "\\((Bada);"
                        }, {
                            "regex": "(Windows|Android|WeTab|Maemo)"
                        }, {
                            "regex": "(Ubuntu|Kubuntu|Arch Linux|CentOS|Slackware|Gentoo|openSUSE|SUSE|Red Hat|Fedora|PCLinuxOS|Gentoo|Mageia|(?:Free|Open|Net|\\b)BSD)"
                        }, {
                            "regex": "(Linux)(?:[ /](\\d+)\\.(\\d+)(?:\\.(\\d+))?)?"
                        }, {
                            "regex": "SunOS",
                            "os_replacement": "Solaris"
                        }],
                        "device_parsers": [{
                            "regex": "HTC ([A-Z][a-z0-9]+) Build",
                            "device_replacement": "HTC $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "HTC ([A-Z][a-z0-9 ]+) \\d+\\.\\d+\\.\\d+\\.\\d+",
                            "device_replacement": "HTC $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "HTC_Touch_([A-Za-z0-9]+)",
                            "device_replacement": "HTC Touch ($1)",
                            "device_type": "Mobile"
                        }, {
                            "regex": "USCCHTC(\\d+)",
                            "device_replacement": "HTC $1 (US Cellular)",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Sprint APA(9292)",
                            "device_replacement": "HTC $1 (Sprint)",
                            "device_type": "Mobile"
                        }, {
                            "regex": "HTC ([A-Za-z0-9]+ [A-Z])",
                            "device_replacement": "HTC $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "HTC[-_/\\s]([A-Za-z0-9]+)",
                            "device_replacement": "HTC $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(ADR[A-Za-z0-9]+)",
                            "device_replacement": "HTC $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(HTC)",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(QtCarBrowser)",
                            "device_replacement": "Tesla Model S",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(SamsungSGHi560)",
                            "device_replacement": "Samsung SGHi560",
                            "device_type": "Mobile"
                        }, {
                            "regex": "SonyEricsson([A-Za-z0-9]+)/",
                            "device_replacement": "Ericsson $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "PLAYSTATION 3",
                            "device_replacement": "PlayStation 3"
                        }, {
                            "regex": "(PlayStation (:?Portable|Vita))",
                            "device_type": "Other"
                        }, {
                            "regex": "(PlayStation (:?\\d+))",
                            "device_type": "Other"
                        }, {
                            "regex": "(KFOT Build)",
                            "device_replacement": "Kindle Fire",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFTT Build)",
                            "device_replacement": "Kindle Fire HD",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFJWI Build)",
                            "device_replacement": "Kindle Fire HD 8.9\" WiFi",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFJWA Build)",
                            "device_replacement": "Kindle Fire HD 8.9\" 4G",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFSOWI Build)",
                            "device_replacement": "Kindle Fire HD 7\" WiFi",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFTHWI Build)",
                            "device_replacement": "Kindle Fire HDX 7\" WiFi",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFTHWA Build)",
                            "device_replacement": "Kindle Fire HDX 7\" 4G",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFAPWI Build)",
                            "device_replacement": "Kindle Fire HDX 8.9\" WiFi",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(KFAPWA Build)",
                            "device_replacement": "Kindle Fire HDX 8.9\" 4G",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(Kindle Fire)",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(Kindle)",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(Silk)/(\\d+)\\.(\\d+)(?:\\.([0-9\\-]+))?",
                            "device_replacement": "Kindle Fire",
                            "device_type": "Tablet"
                        }, {
                            "regex": "Android[\\- ][\\d]+\\.[\\d]+; [A-Za-z]{2}\\-[A-Za-z]{0,2}; WOWMobile (.+) Build",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Android[\\- ][\\d]+\\.[\\d]+\\-update1; [A-Za-z]{2}\\-[A-Za-z]{0,2}; (.+) Build",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Android[\\- ][\\d]+\\.[\\d]+\\.[\\d]+; [A-Za-z]{2}\\-[A-Za-z]{0,2}; (.+) Build",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Android[\\- ][\\d]+\\.[\\d]+\\.[\\d]+;[A-Za-z]{2}\\-[A-Za-z]{0,2};(.+) Build",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Android[\\- ][\\d]+\\.[\\d]+; [A-Za-z]{2}\\-[A-Za-z]{0,2}; (.+) Build",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Android[\\- ][\\d]+\\.[\\d]+\\.[\\d]+; (.+) Build",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Android[\\- ][\\d]+\\.[\\d]+; (.+) Build",
                            "device_type": "Mobile"
                        }, {
                            "regex": "NokiaN([0-9]+)",
                            "device_replacement": "Nokia N$1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "NOKIA([A-Za-z0-9\\v-]+)",
                            "device_replacement": "Nokia $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Nokia([A-Za-z0-9\\v-]+)",
                            "device_replacement": "Nokia $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "NOKIA ([A-Za-z0-9\\-]+)",
                            "device_replacement": "Nokia $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Nokia ([A-Za-z0-9\\-]+)",
                            "device_replacement": "Nokia $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Lumia ([A-Za-z0-9\\-]+)",
                            "device_replacement": "Lumia $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Symbian",
                            "device_replacement": "Nokia",
                            "device_type": "Mobile"
                        }, {
                            "regex": "BB10; ([A-Za-z0-9\\- ]+)\\)",
                            "device_replacement": "BlackBerry $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(PlayBook).+RIM Tablet OS",
                            "device_replacement": "BlackBerry Playbook",
                            "device_type": "Tablet"
                        }, {
                            "regex": "Black[Bb]erry ([0-9]+);",
                            "device_replacement": "BlackBerry $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Black[Bb]erry([0-9]+)",
                            "device_replacement": "BlackBerry $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Black[Bb]erry;",
                            "device_replacement": "BlackBerry",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Pre)/(\\d+)\\.(\\d+)",
                            "device_replacement": "Palm Pre",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Pixi)/(\\d+)\\.(\\d+)",
                            "device_replacement": "Palm Pixi",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Touch[Pp]ad)/(\\d+)\\.(\\d+)",
                            "device_replacement": "HP TouchPad",
                            "device_type": "Tablet"
                        }, {
                            "regex": "HPiPAQ([A-Za-z0-9]+)/(\\d+).(\\d+)",
                            "device_replacement": "HP iPAQ $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Palm([A-Za-z0-9]+)",
                            "device_replacement": "Palm $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Treo([A-Za-z0-9]+)",
                            "device_replacement": "Palm Treo $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "webOS.*(P160UNA)/(\\d+).(\\d+)",
                            "device_replacement": "HP Veer",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(AppleTV)",
                            "device_replacement": "AppleTV",
                            "device_type": "Other"
                        }, {
                            "regex": "AdsBot-Google-Mobile",
                            "device_replacement": "Spider",
                            "device_type": "Spider"
                        }, {
                            "regex": "Googlebot-Mobile/(\\d+).(\\d+)",
                            "device_replacement": "Spider",
                            "device_type": "Spider"
                        }, {
                            "regex": "Googlebot/\\d+.\\d+",
                            "device_replacement": "Spider",
                            "device_type": "Spider"
                        }, {
                            "regex": "NING/(\\d+).(\\d+)",
                            "device_replacement": "Spider"
                        }, {
                            "regex": "MsnBot-Media /(\\d+).(\\d+)",
                            "device_replacement": "Spider"
                        }, {
                            "regex": "(iPad) Simulator;",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(iPad);",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(iPod) touch;",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(iPod);",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(iPhone) Simulator;",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(iPhone);",
                            "device_type": "Mobile"
                        }, {
                            "regex": "acer_([A-Za-z0-9]+)_",
                            "device_replacement": "Acer $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "acer_([A-Za-z0-9]+)_",
                            "device_replacement": "Acer $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "ALCATEL-([A-Za-z0-9]+)",
                            "device_replacement": "Alcatel $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Alcatel-([A-Za-z0-9]+)",
                            "device_replacement": "Alcatel $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Amoi\\-([A-Za-z0-9]+)",
                            "device_replacement": "Amoi $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "AMOI\\-([A-Za-z0-9]+)",
                            "device_replacement": "Amoi $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Asus\\-([A-Za-z0-9]+)",
                            "device_replacement": "Asus $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "ASUS\\-([A-Za-z0-9]+)",
                            "device_replacement": "Asus $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "BIRD\\-([A-Za-z0-9]+)",
                            "device_replacement": "Bird $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "BIRD\\.([A-Za-z0-9]+)",
                            "device_replacement": "Bird $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "BIRD ([A-Za-z0-9]+)",
                            "device_replacement": "Bird $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Dell ([A-Za-z0-9]+)",
                            "device_replacement": "Dell $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "DoCoMo/2\\.0 ([A-Za-z0-9]+)",
                            "device_replacement": "DoCoMo $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "([A-Za-z0-9]+)_W\\;FOMA",
                            "device_replacement": "DoCoMo $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "([A-Za-z0-9]+)\\;FOMA",
                            "device_replacement": "DoCoMo $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Huawei([A-Za-z0-9]+)",
                            "device_replacement": "Huawei $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "HUAWEI-([A-Za-z0-9]+)",
                            "device_replacement": "Huawei $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "vodafone([A-Za-z0-9]+)",
                            "device_replacement": "Huawei Vodafone $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "i\\-mate ([A-Za-z0-9]+)",
                            "device_replacement": "i-mate $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Kyocera\\-([A-Za-z0-9]+)",
                            "device_replacement": "Kyocera $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "KWC\\-([A-Za-z0-9]+)",
                            "device_replacement": "Kyocera $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Lenovo\\-([A-Za-z0-9]+)",
                            "device_replacement": "Lenovo $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "Lenovo_([A-Za-z0-9]+)",
                            "device_replacement": "Lenovo $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "(HbbTV)/[0-9]+\\.[0-9]+\\.[0-9]+",
                            "device_type": "Other"
                        }, {
                            "regex": "LG/([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LG-LG([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LGE-LG([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LGE VX([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LG ([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LGE LG\\-AX([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LG\\-([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LGE\\-([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "LG([A-Za-z0-9]+)",
                            "device_replacement": "LG $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(KIN)\\.One (\\d+)\\.(\\d+)",
                            "device_replacement": "Microsoft $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(KIN)\\.Two (\\d+)\\.(\\d+)",
                            "device_replacement": "Microsoft $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Motorola)\\-([A-Za-z0-9]+)",
                            "device_type": "Mobile"
                        }, {
                            "regex": "MOTO\\-([A-Za-z0-9]+)",
                            "device_replacement": "Motorola $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "MOT\\-([A-Za-z0-9]+)",
                            "device_replacement": "Motorola $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Nintendo WiiU)",
                            "device_replacement": "Nintendo Wii U",
                            "device_type": "Other"
                        }, {
                            "regex": "Nintendo (DS|3DS|DSi|Wii);",
                            "device_replacement": "Nintendo $1",
                            "device_type": "Other"
                        }, {
                            "regex": "Pantech([A-Za-z0-9]+)",
                            "device_replacement": "Pantech $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Philips([A-Za-z0-9]+)",
                            "device_replacement": "Philips $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "Philips ([A-Za-z0-9]+)",
                            "device_replacement": "Philips $1",
                            "device_type": "Desktop"
                        }, {
                            "regex": "SAMSUNG-([A-Za-z0-9\\-]+)",
                            "device_replacement": "Samsung $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "SAMSUNG\\; ([A-Za-z0-9\\-]+)",
                            "device_replacement": "Samsung $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Dreamcast",
                            "device_replacement": "Sega Dreamcast",
                            "device_type": "Other"
                        }, {
                            "regex": "Softbank/1\\.0/([A-Za-z0-9]+)",
                            "device_replacement": "Softbank $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "Softbank/2\\.0/([A-Za-z0-9]+)",
                            "device_replacement": "Softbank $1",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(WebTV)/(\\d+).(\\d+)",
                            "device_type": "Other"
                        }, {
                            "regex": "(bingbot|bot|borg|google(^tv)|yahoo|slurp|msnbot|msrbot|openbot|archiver|netresearch|lycos|scooter|altavista|teoma|gigabot|baiduspider|blitzbot|oegp|charlotte|furlbot|http%20client|polybot|htdig|ichiro|mogimogi|larbin|pompos|scrubby|searchsight|seekbot|semanticdiscovery|silk|snappy|speedy|spider|voila|vortex|voyager|zao|zeal|fast\\-webcrawler|converacrawler|dataparksearch|findlinks|crawler|Netvibes|Sogou Pic Spider|ICC\\-Crawler|Innovazion Crawler|Daumoa|EtaoSpider|A6\\-Indexer|YisouSpider)",
                            "device_replacement": "Spider",
                            "device_type": "Spider"
                        }, {
                            "regex": "(XBLWP7)",
                            "device_replacement": "Other",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Windows|Win|Win16|Win32|WinNT4.0)",
                            "device_replacement": "Other",
                            "device_type": "Desktop"
                        }, {
                            "regex": "(Mac|Mac OS X|Darwin|Mac_PowerPC|Macintosh)",
                            "device_replacement": "Other",
                            "device_type": "Desktop"
                        }, {
                            "regex": "(Opera Tablet)",
                            "device_replacement": "Other",
                            "device_type": "Tablet"
                        }, {
                            "regex": "(Opera Mobi|Opera Mobile)",
                            "device_replacement": "Other",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Opera)",
                            "device_replacement": "Other",
                            "device_type": "Desktop"
                        }, {
                            "regex": "(hiptop|avantgo|plucker|xiino|blazer|elaine|up.browser|up.link|mmp|smartphone|midp|wap|vodafone|o2|pocket|mobile|pda)",
                            "device_replacement": "Generic Smartphone",
                            "device_type": "Mobile"
                        }, {
                            "regex": "^(1207|3gso|4thp|501i|502i|503i|504i|505i|506i|6310|6590|770s|802s|a wa|acer|acs\\-|airn|alav|asus|attw|au\\-m|aur |aus |abac|acoo|aiko|alco|alca|amoi|anex|anny|anyw|aptu|arch|argo|bell|bird|bw\\-n|bw\\-u|beck|benq|bilb|blac|c55/|cdm\\-|chtm|capi|comp|cond|craw|dall|dbte|dc\\-s|dica|ds\\-d|ds12|dait|devi|dmob|doco|dopo|el49|erk0|esl8|ez40|ez60|ez70|ezos|ezze|elai|emul|eric|ezwa|fake|fly\\-|fly_|g\\-mo|g1 u|g560|gf\\-5|grun|gene|go.w|good|grad|hcit|hd\\-m|hd\\-p|hd\\-t|hei\\-|hp i|hpip|hs\\-c|htc |htc\\-|htca|htcg)",
                            "device_replacement": "Generic Feature Phone",
                            "device_type": "Mobile"
                        }, {
                            "regex": "^(htcp|htcs|htct|htc_|haie|hita|huaw|hutc|i\\-20|i\\-go|i\\-ma|i230|iac|iac\\-|iac/|ig01|im1k|inno|iris|jata|java|kddi|kgt|kgt/|kpt |kwc\\-|klon|lexi|lg g|lg\\-a|lg\\-b|lg\\-c|lg\\-d|lg\\-f|lg\\-g|lg\\-k|lg\\-l|lg\\-m|lg\\-o|lg\\-p|lg\\-s|lg\\-t|lg\\-u|lg\\-w|lg/k|lg/l|lg/u|lg50|lg54|lge\\-|lge/|lynx|leno|m1\\-w|m3ga|m50/|maui|mc01|mc21|mcca|medi|meri|mio8|mioa|mo01|mo02|mode|modo|mot |mot\\-|mt50|mtp1|mtv |mate|maxo|merc|mits|mobi|motv|mozz|n100|n101|n102|n202|n203|n300|n302|n500|n502|n505|n700|n701|n710|nec\\-|nem\\-|newg|neon)",
                            "device_replacement": "Generic Feature Phone",
                            "device_type": "Mobile"
                        }, {
                            "regex": "^(netf|noki|nzph|o2 x|o2\\-x|opwv|owg1|opti|oran|ot\\-s|p800|pand|pg\\-1|pg\\-2|pg\\-3|pg\\-6|pg\\-8|pg\\-c|pg13|phil|pn\\-2|pt\\-g|palm|pana|pire|pock|pose|psio|qa\\-a|qc\\-2|qc\\-3|qc\\-5|qc\\-7|qc07|qc12|qc21|qc32|qc60|qci\\-|qwap|qtek|r380|r600|raks|rim9|rove|s55/|sage|sams|sc01|sch\\-|scp\\-|sdk/|se47|sec\\-|sec0|sec1|semc|sgh\\-|shar|sie\\-|sk\\-0|sl45|slid|smb3|smt5|sp01|sph\\-|spv |spv\\-|sy01|samm|sany|sava|scoo|send|siem|smar|smit|soft|sony|t\\-mo|t218|t250|t600|t610|t618|tcl\\-|tdg\\-|telm|tim\\-|ts70|tsm\\-|tsm3|tsm5|tx\\-9|tagt)",
                            "device_replacement": "Generic Feature Phone",
                            "device_type": "Mobile"
                        }, {
                            "regex": "^(talk|teli|topl|tosh|up.b|upg1|utst|v400|v750|veri|vk\\-v|vk40|vk50|vk52|vk53|vm40|vx98|virg|vite|voda|vulc|w3c |w3c\\-|wapj|wapp|wapu|wapm|wig |wapi|wapr|wapv|wapy|wapa|waps|wapt|winc|winw|wonu|x700|xda2|xdag|yas\\-|your|zte\\-|zeto|aste|audi|avan|blaz|brew|brvw|bumb|ccwa|cell|cldc|cmd\\-|dang|eml2|fetc|hipt|http|ibro|idea|ikom|ipaq|jbro|jemu|jigs|keji|kyoc|kyok|libw|m\\-cr|midp|mmef|moto|mwbp|mywa|newt|nok6|o2im|pant|pdxg|play|pluc|port|prox|rozo|sama|seri|smal|symb|treo|upsi|vx52|vx53|vx60|vx61|vx70|vx80|vx81|vx83|vx85|wap\\-|webc|whit|wmlb|xda\\-|xda_)",
                            "device_replacement": "Generic Feature Phone",
                            "device_type": "Mobile"
                        }, {
                            "regex": "(Mobile)",
                            "device_replacement": "Other",
                            "device_type": "Mobile"
                        }]
                    }
                }, {}
            ]
        }, {}, [10])(10)
    });
    (function () {
        var Evented, Finch, debug, func, _, _fn, _fn1, _i, _len, _name, _ref, _ref1,
            __hasProp = {}.hasOwnProperty,
            __slice = [].slice,
            __bind = function (fn, me) {
                return function () {
                    return fn.apply(me, arguments);
                };
            },
            __extends = function (child, parent) {
                for (var key in parent) {
                    if (__hasProp.call(parent, key)) child[key] = parent[key];
                }

                function ctor() {
                    this.constructor = child;
                }
                ctor.prototype = parent.prototype;
                child.prototype = new ctor();
                child.__super__ = parent.prototype;
                return child;
            },
            __indexOf = [].indexOf || function (item) {
                for (var i = 0, l = this.length; i < l; i++) {
                    if (i in this && this[i] === item) return i;
                }
                return -1;
            };

        _ = this._ ? this._ : typeof noConflictRequire === "function" ? noConflictRequire("underscore") : (console.warn("finch.js requires global underscore.js >= 1.6"), void 0);

        Evented = this.Evented || noConflictRequire("optimize-evented");

        Finch = Finch = (function () {
            function Finch(adapterOrWindow, config) {
                Evented(this);
                this.trigger = this.emit;
                this.withEventCapturing(this, function () {
                    var e, errorMessage, layerConfig, layerName;

                    if (config) {
                        if (!this.isValidConfig(config)) {
                            errorMessage = new Error("Finch: bad configuration");
                            this.emit("error", errorMessage, new Finch.ExperimentAttributes);
                        }
                    }
                    if (Finch.Utility.isBrowserWindow(adapterOrWindow)) {
                        this.adapter = new Finch.Adapters.Browser(adapterOrWindow);
                    } else {
                        this.adapter = adapterOrWindow;
                    }
                    this.reset();
                    this.forcedExperiments = {};
                    this.layers = [];
                    for (layerName in config) {
                        if (!__hasProp.call(config, layerName)) continue;
                        layerConfig = config[layerName];
                        try {
                            this.layers.push(new Finch.Layer(layerName, layerConfig, this));
                        } catch (_error) {
                            e = _error;
                            errorMessage = new Error("" + layerName + " layer: bad configuration");
                            this.emit("error", errorMessage, new Finch.ExperimentAttributes({
                                layerName: layerName
                            }));
                        }
                    }
                    debug('initialized');
                    this.config = config;
                    return this;
                });
            }

            Finch.prototype.withEventCapturing = function (thisArg, cb) {
                var capturedEvents, result, _emit, _on;

                capturedEvents = [];
                _emit = this.emit;
                this.emit = function () {
                    var eventArgs;

                    eventArgs = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                    return capturedEvents.push(eventArgs);
                };
                _on = this.on;
                this.on = function (name, cb) {
                    var eventArgs, _i, _len;

                    for (_i = 0, _len = capturedEvents.length; _i < _len; _i++) {
                        eventArgs = capturedEvents[_i];
                        if (name === eventArgs[0]) {
                            cb.apply(null, eventArgs.slice(1));
                        }
                        if (name === "*") {
                            cb.apply(null, eventArgs);
                        }
                    }
                    return _on(name, cb);
                };
                result = cb.call(thisArg);
                this.emit = _emit;
                return result;
            };

            Finch.prototype.isValidConfig = function (config) {
                return Finch.Utility.isMap(config);
            };

            Finch.prototype.run = function () {
                var layer, _i, _len, _ref;

                if (this.layers == null) {
                    return;
                }
                _ref = this.layers;
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    layer = _ref[_i];
                    layer.run();
                }
                return Finch.Tracking.deliver();
            };

            Finch.prototype.reset = function () {
                this.layers = [];
                this.settingKeyMap = null;
                return this.guards = new Finch.Guards(this);
            };

            Finch.prototype.inTreatment = function (options) {
                var experimentName, layer, variantName;

                experimentName = options.experimentName, variantName = options.variantName;
                if (this.forcedExperiments[experimentName]) {
                    if (!variantName) {
                        return true;
                    }
                    if (this.forcedExperiments[experimentName] === variantName) {
                        return true;
                    }
                }
                layer = this.runningLayerFromExperimentName(experimentName);
                if (layer == null) {
                    return false;
                }
                if (variantName == null) {
                    return true;
                }
                return layer.experiment().variantName() === variantName;
            };

            Finch.prototype.runPreferredExperiments = function () {
                var layer, _i, _len, _ref, _results;

                _ref = this.layers;
                _results = [];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    layer = _ref[_i];
                    _results.push(layer.preferredRun());
                }
                return _results;
            };

            Finch.prototype.experiment = function (name, variants) {
                var e, experiment, variantFunc, variantName;

                if (this.forcedExperiments[name]) {
                    return this._runForcedExperiment(name, variants);
                }
                if (!this.inTreatment({
                    experimentName: name
                })) {
                    return;
                }
                experiment = this.runningExperimentFromExperimentName(name);
                for (variantName in variants) {
                    variantFunc = variants[variantName];
                    if (this.inTreatment({
                        experimentName: name,
                        variantName: variantName
                    })) {
                        try {
                            variantFunc();
                        } catch (_error) {
                            e = _error;
                            Finch.Tracking.trackExperimentError(experiment, e);
                            this.emit("error", e, experiment.experimentAttributes());
                            return;
                        }
                    }
                }
                Finch.Tracking.trackExperiment(experiment);
                return this.emit("run", experiment);
            };

            Finch.prototype.getSetting = function (settingKey, defaultValue) {
                var experiment, setting;

                experiment = this._experimentForSettingKey(settingKey);
                if (experiment == null) {
                    return defaultValue;
                }
                setting = experiment.getSetting(settingKey, defaultValue);
                Finch.Tracking.trackExperiment(experiment);
                this.emit("run", experiment);
                return setting;
            };

            Finch.prototype.buildSettingKeyMap = function () {
                var experimentName, layer, ret, settingKey, _i, _len, _ref, _ref1;

                ret = {};
                _ref = this.layers;
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    layer = _ref[_i];
                    _ref1 = layer.settingKeyMap();
                    for (settingKey in _ref1) {
                        experimentName = _ref1[settingKey];
                        ret[settingKey] = experimentName;
                    }
                }
                return ret;
            };

            Finch.prototype._experimentForSettingKey = function (settingKey) {
                var experimentName;

                experimentName = this._experimentNameForSettingKey(settingKey);
                if (experimentName != null) {
                    return this.runningExperimentFromExperimentName(experimentName);
                }
            };

            Finch.prototype._experimentNameForSettingKey = function (settingKey) {
                var _ref;

                if ((_ref = this.settingKeyMap) == null) {
                    this.settingKeyMap = this.buildSettingKeyMap();
                }
                return this.settingKeyMap[settingKey];
            };

            Finch.prototype._runForcedExperiment = function (name, variants) {
                var e, error, errorMessage, experimentAttributes, experimentForTracking, layerForTracking, variantFunc, variantName;

                variantName = this.forcedExperiments[name];
                variantFunc = variants[variantName];
                if (!variantFunc) {
                    return;
                }
                layerForTracking = new Finch.Layer("ForcedLayer", {}, this);
                experimentAttributes = new Finch.ExperimentAttributes({
                    id: name,
                    name: name,
                    layerName: layerForTracking.name,
                    buckets: "0..999",
                    variants: [variantName],
                    variant: variantName
                });
                try {
                    experimentForTracking = new Finch.Experiment(name, layerForTracking, experimentAttributes, this);
                } catch (_error) {
                    error = _error;
                    errorMessage = new Error("" + name + " Experiment: Bad configuration");
                    this.emit("error", errorMessage, experimentAttributes);
                }
                try {
                    variantFunc();
                } catch (_error) {
                    e = _error;
                    Finch.Tracking.trackExperimentError(experimentForTracking, e);
                    this.emit("error", e, experimentAttributes);
                    return;
                }
                Finch.Tracking.trackExperiment(experimentForTracking);
                return this.emit("run", experimentForTracking);
            };

            Finch.prototype.runningLayerFromExperimentName = function (experimentName) {
                return _.find(this.layers, function (layer) {
                    return layer.isCurrentExperiment(experimentName) && layer.experiment().testMatches();
                });
            };

            Finch.prototype.runningExperimentFromExperimentName = function (experimentName) {
                var _ref;

                return (_ref = this.runningLayerFromExperimentName(experimentName)) != null ? _ref.experiment() : void 0;
            };

            Finch.prototype.forceExperiment = function (experimentName, variantName) {
                return this.forcedExperiments[experimentName] = variantName;
            };

            Finch.prototype.addGuard = function (guardName, guard, context) {
                if (context == null) {
                    context = null;
                }
                return this.guards.add(guardName, guard, context);
            };

            Finch.prototype.getGuard = function (guardName) {
                return this.guards.get(guardName);
            };

            Finch.prototype.urlPath = function () {
                return this.adapter.urlPath();
            };

            Finch.prototype.urlSearch = function () {
                return this.adapter.urlSearch();
            };

            Finch.prototype.getCookie = function () {
                var args, _ref;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return (_ref = this.adapter).getCookie.apply(_ref, args);
            };

            Finch.prototype.md5 = function () {
                var args, _ref;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return (_ref = this.adapter).md5.apply(_ref, args);
            };

            Finch.prototype.browser = function () {
                var args, _ref;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return (_ref = this.adapter).browser.apply(_ref, args);
            };

            Finch.prototype.pageChannel = function () {
                var args, _ref;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return (_ref = this.adapter).pageChannel.apply(_ref, args);
            };

            Finch.prototype.country = function () {
                var args, _ref;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return (_ref = this.adapter).country.apply(_ref, args);
            };

            Finch.prototype.division = function () {
                var args, _ref;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return (_ref = this.adapter).division.apply(_ref, args);
            };

            Finch.prototype.forcedExperimentSets = function () {
                return this.adapter.forcedExperimentSets();
            };

            return Finch;

        })();

        Finch._singleton = null;

        Finch.initialize = function () {
            var args;

            args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
            Finch._singleton = (function (func, args, ctor) {
                ctor.prototype = func.prototype;
                var child = new ctor,
                    result = func.apply(child, args);
                return Object(result) === result ? result : child;
            })(Finch, args, function () {});
            return Finch.layers = Finch._singleton.layers;
        };

        _ref = Finch.prototype;
        _fn = function () {
            var name;

            name = _name;
            return Finch[name] = function () {
                var args;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return Finch._singleton[name].apply(Finch._singleton, args);
            };
        };
        for (_name in _ref) {
            if (!__hasProp.call(_ref, _name)) continue;
            func = _ref[_name];
            _fn();
        }

        _ref1 = ["on", "off", "emit", "trigger"];
        _fn1 = function () {
            var name;

            name = _name;
            return Finch[name] = function () {
                var args;

                args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                return Finch._singleton[name].apply(Finch._singleton, args);
            };
        };
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            _name = _ref1[_i];
            _fn1();
        }

        Finch.Experiments = {};

        Finch.Experiments.Global = {};

        Finch.Diversions = {};

        Finch.Trackers = [];

        Finch.Adapters = {};

        Finch.NUMBER_OF_BUCKETS_PER_LAYER = 1000;

        Finch.VERSION = '1.11.0';

        debug = function (message) {
            if (Finch.debug && ((typeof console !== "undefined" && console !== null ? console.log : void 0) != null)) {
                return console.log("::: finch.js : " + message);
            }
        };

        if (typeof window !== "undefined" && window !== null) {
            window.Finch = Finch;
        }

        if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
            module.exports.Finch = Finch;
        }

        Finch.Adapters.Browser = (function () {
            function Browser(window) {
                this.window = window;
            }

            Browser.prototype.urlPath = function () {
                return this.window.location.pathname;
            };

            Browser.prototype.urlSearch = function () {
                return this.window.location.search;
            };

            Browser.prototype.getCookie = function (key) {
                return Cookie.get(key);
            };

            Browser.prototype.md5 = function (string) {
                return md5(string);
            };

            Browser.prototype.browser = function () {
                var user, _ref2, _ref3;

                user = (_ref2 = this.window.OptimizeSuite) != null ? (_ref3 = _ref2.TrackingHub) != null ? _ref3.user : void 0 : void 0;
                if (!user) {
                    return {
                        name: "UnknownBrowser",
                        version: "0"
                    };
                }
                return {
                    name: user.browser,
                    version: user.browserVersion
                };
            };

            Browser.prototype.pageChannel = function () {
                var _ref2, _ref3, _ref4, _ref5;

                return ((_ref2 = this.window.OptimizeSuite) != null ? (_ref3 = _ref2.TrackingHub) != null ? (_ref4 = _ref3.page) != null ? (_ref5 = _ref4.metadata) != null ? _ref5.channel : void 0 : void 0 : void 0 : void 0) || null;
            };

            Browser.prototype.country = function () {
                var _ref2, _ref3, _ref4, _ref5;

                return ((_ref2 = this.window.OptimizeSuite) != null ? (_ref3 = _ref2.TrackingHub) != null ? (_ref4 = _ref3.page) != null ? (_ref5 = _ref4.metadata) != null ? _ref5.country : void 0 : void 0 : void 0 : void 0) || null;
            };

            Browser.prototype.division = function () {
                var _ref2, _ref3, _ref4, _ref5;

                return ((_ref2 = this.window.OptimizeSuite) != null ? (_ref3 = _ref2.TrackingHub) != null ? (_ref4 = _ref3.page) != null ? (_ref5 = _ref4.metadata) != null ? _ref5.division : void 0 : void 0 : void 0 : void 0) || null;
            };

            Browser.prototype.forcedExperimentSets = function () {
                var fromQuerystring, matchedSet, out;

                if (this._forcedExperimentSets != null) {
                    return this._forcedExperimentSets;
                }
                out = this._forcedExperimentSetsFromCookies();
                if (fromQuerystring = this._forcedExperimentSetFromQuerystring()) {
                    matchedSet = _(out).find(function (set) {
                        return set.layer === fromQuerystring.layer && set.experiment === fromQuerystring.experiment;
                    });
                    if (matchedSet) {
                        matchedSet.variant = fromQuerystring.variant;
                    } else {
                        out.unshift(fromQuerystring);
                    }
                }
                this._forcedExperimentSets = out;
                return this._forcedExperimentSets;
            };

            Browser.prototype._cookies = function () {
                return this.window.document.cookie;
            };

            Browser.prototype._forcedExperimentSetFromQuerystring = function () {
                var experimentName, layerName, params, variantName;

                params = Finch.Utility.parseQueryString(this.urlSearch());
                layerName = params.finch_layer;
                experimentName = params.finch_experiment;
                variantName = params.finch_variant;
                if (layerName && experimentName && variantName) {
                    return {
                        layer: layerName,
                        experiment: experimentName,
                        variant: variantName
                    };
                }
            };

            Browser.prototype._forcedExperimentSetsFromCookies = function () {
                var cookie, experiment, key, layer, out, splitCookies, variant;

                splitCookies = this._cookies().split(/\s*;\s*/);
                out = (function () {
                    var _j, _len1, _ref2, _ref3, _results;

                    _results = [];
                    for (_j = 0, _len1 = splitCookies.length; _j < _len1; _j++) {
                        cookie = splitCookies[_j];
                        _ref2 = cookie.split('='), key = _ref2[0], variant = _ref2[1];
                        if (key.match(/^.+:.+:Variant$/)) {
                            _ref3 = key.split(':'), layer = _ref3[0], experiment = _ref3[1];
                            _results.push({
                                layer: layer,
                                experiment: experiment,
                                variant: variant
                            });
                        } else {
                            _results.push(void 0);
                        }
                    }
                    return _results;
                })();
                return _(out).compact();
            };

            return Browser;

        })();

        Finch.BuiltInGuards = (function () {
            function BuiltInGuards(finch) {
                this.finch = finch;
                this.excludeLoggedOutUsers = __bind(this.excludeLoggedOutUsers, this);
                this.excludeDivision = __bind(this.excludeDivision, this);
                this.inDivision = __bind(this.inDivision, this);
                this.inCountry = __bind(this.inCountry, this);
                this.onlyIncludeChannels = __bind(this.onlyIncludeChannels, this);
                this.excludeChannels = __bind(this.excludeChannels, this);
                this.onlyIncludeBrowsers = __bind(this.onlyIncludeBrowsers, this);
                this.excludeBrowsers = __bind(this.excludeBrowsers, this);
            }

            BuiltInGuards.prototype.excludeBrowsers = function (params) {
                var name, version, _ref2, _ref3;

                if (params == null) {
                    params = {};
                }
                if (!((_ref2 = params.browsers) != null ? _ref2.length : void 0)) {
                    return true;
                }
                _ref3 = this.finch.browser(), name = _ref3.name, version = _ref3.version;
                return _(params.browsers).all(function (browser) {
                    if (browser.name.toLowerCase() !== name.toLowerCase()) {
                        return true;
                    }
                    switch (browser.comparator) {
                    case "equals":
                        return !(parseInt(version, 10) === parseInt(browser.version, 10));
                    case "lte":
                        return !(parseInt(version, 10) <= parseInt(browser.version, 10));
                    case "gte":
                        return !(parseInt(version, 10) >= parseInt(browser.version, 10));
                    default:
                        throw "excludeBrowsers can only handle comparators 'equals', 'gte', 'lte'";
                    }
                });
            };

            BuiltInGuards.prototype.onlyIncludeBrowsers = function (params) {
                var name, version, _ref2, _ref3;

                if (params == null) {
                    params = {};
                }
                if (!((_ref2 = params.browsers) != null ? _ref2.length : void 0)) {
                    return false;
                }
                _ref3 = this.finch.browser(), name = _ref3.name, version = _ref3.version;
                if (!_(params.browsers).find(function (browser) {
                    return browser.name.toLowerCase() === name.toLowerCase();
                })) {
                    return false;
                }
                return _(params.browsers).all(function (browser) {
                    if (browser.name.toLowerCase() !== name.toLowerCase()) {
                        return true;
                    }
                    switch (browser.comparator) {
                    case "equals":
                        return parseInt(version, 10) === parseInt(browser.version, 10);
                    case "lte":
                        return parseInt(version, 10) <= parseInt(browser.version, 10);
                    case "gte":
                        return parseInt(version, 10) >= parseInt(browser.version, 10);
                    default:
                        throw "excludeBrowsers can only handle comparators 'equals', 'gte', 'lte'";
                    }
                });
            };

            BuiltInGuards.prototype.excludeChannels = function (params) {
                var channel, _ref2;

                if (params == null) {
                    params = {};
                }
                if (!((_ref2 = params.channels) != null ? _ref2.length : void 0)) {
                    return true;
                }
                channel = this.finch.pageChannel();
                if (!channel) {
                    return true;
                }
                return _(params.channels).all(function (channelName) {
                    return channelName.toLowerCase() !== channel.toLowerCase();
                });
            };

            BuiltInGuards.prototype.onlyIncludeChannels = function (params) {
                var channel, _ref2;

                if (params == null) {
                    params = {};
                }
                if (!((_ref2 = params.channels) != null ? _ref2.length : void 0)) {
                    return false;
                }
                channel = this.finch.pageChannel();
                if (!channel) {
                    return false;
                }
                return _(params.channels).any(function (channelName) {
                    return channelName.toLowerCase() === channel.toLowerCase();
                });
            };

            BuiltInGuards.prototype.inCountry = function (params) {
                var countries, country, _ref2;

                if (params == null) {
                    params = {};
                }
                if (!((_ref2 = params.countries) != null ? _ref2.length : void 0)) {
                    return true;
                }
                countries = (function () {
                    var _j, _len1, _ref3, _results;

                    _ref3 = params.countries;
                    _results = [];
                    for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
                        country = _ref3[_j];
                        _results.push(country.toLowerCase());
                    }
                    return _results;
                })();
                country = this.finch.country();
                if (!country) {
                    return false;
                }
                return _(countries).indexOf(country.toLowerCase()) !== -1;
            };

            BuiltInGuards.prototype.inDivision = function (params) {
                var division, divisions, _ref2;

                if (params == null) {
                    params = {};
                }
                if (!((_ref2 = params.divisions) != null ? _ref2.length : void 0)) {
                    return true;
                }
                divisions = (function () {
                    var _j, _len1, _ref3, _results;

                    _ref3 = params.divisions;
                    _results = [];
                    for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
                        division = _ref3[_j];
                        _results.push(division.toLowerCase());
                    }
                    return _results;
                })();
                division = this.finch.division();
                if (!division) {
                    return false;
                }
                return _(divisions).indexOf(division.toLowerCase()) !== -1;
            };

            BuiltInGuards.prototype.excludeDivision = function (params) {
                var division, divisions, _ref2;

                if (params == null) {
                    params = {};
                }
                if (!((_ref2 = params.divisions) != null ? _ref2.length : void 0)) {
                    return true;
                }
                divisions = (function () {
                    var _j, _len1, _ref3, _results;

                    _ref3 = params.divisions;
                    _results = [];
                    for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
                        division = _ref3[_j];
                        _results.push(division.toLowerCase());
                    }
                    return _results;
                })();
                division = this.finch.division();
                if (!division) {
                    return true;
                }
                return _(divisions).indexOf(division.toLowerCase()) === -1;
            };

            BuiltInGuards.prototype.excludeLoggedOutUsers = function (params) {
                if (params == null) {
                    params = {};
                }
                return !!this.finch.getCookie("snickerdoodle");
            };

            return BuiltInGuards;

        })();

        Finch.Diversion = (function () {
            function Diversion(diversionCallback) {
                this.diversionCallback = diversionCallback;
            }

            Diversion.prototype.bucket = function (layer) {
                var bucket;

                if (layer == null) {
                    throw 'layer is not defined';
                }
                if (this.diversionCallback == null) {
                    throw 'no bucketing function defined';
                }
                bucket = this.diversionCallback(layer);
                if (bucket == null) {
                    return null;
                }
                if (!this._validBucket(bucket)) {
                    throw "bucket " + bucket + " out of range";
                }
                debug("diversion bucket " + bucket + " for " + (layer != null ? layer.name : void 0));
                return bucket;
            };

            Diversion.prototype._validBucket = function (bucket) {
                return (0 <= bucket && bucket <= Finch.NUMBER_OF_BUCKETS_PER_LAYER);
            };

            return Diversion;

        })();

        Finch.HashCookieDiversion = (function (_super) {
            __extends(HashCookieDiversion, _super);

            function HashCookieDiversion() {
                var cookies;

                cookies = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
                this.cookies = cookies;
                HashCookieDiversion.__super__.constructor.call(this, function (layer) {
                    var cookie, cookieName, cookieValue, _j, _len1, _ref2, _ref3, _ref4;

                    if (this.cookies instanceof Array) {
                        _ref2 = this.cookies;
                        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                            cookie = _ref2[_j];
                            if (typeof cookieValue === "undefined" || cookieValue === null) {
                                _ref3 = [cookie, layer.finch.getCookie(cookie)], cookieName = _ref3[0], cookieValue = _ref3[1];
                            }
                        }
                    } else {
                        _ref4 = [this.cookies, layer.finch.getCookie(this.cookies)], cookieName = _ref4[0], cookieValue = _ref4[1];
                    }
                    if (cookieValue == null) {
                        debug("no valid cookies");
                        return null;
                    }
                    debug("bucketing with cookie: " + cookieName + "=" + cookieValue);
                    return this._hash(layer, "" + cookieValue + "," + layer.bucketingSalt);
                });
            }

            HashCookieDiversion.prototype._hash = function (layer, input) {
                var md5;

                md5 = layer.finch.md5(input);
                debug(md5);
                return parseInt(md5.slice(24, 32), 16) % Finch.NUMBER_OF_BUCKETS_PER_LAYER;
            };

            return HashCookieDiversion;

        })(Finch.Diversion);

        Finch.Diversions.RandomDiversion = new Finch.Diversion(function (layer) {
            return Math.floor(Math.random() * Finch.NUMBER_OF_BUCKETS_PER_LAYER);
        });

        Finch.Diversions.CookieDiversion = new Finch.HashCookieDiversion('b');

        Finch.Diversions.ConsumerIdDiversion = new Finch.HashCookieDiversion('c');

        Finch.Experiment = (function () {
            function Experiment(id, layer, config, finch) {
                var _ref2, _ref3, _ref4;

                this.id = id;
                this.layer = layer != null ? layer : {};
                if (config == null) {
                    config = {};
                }
                this.finch = finch != null ? finch : Finch;
                if (!this.isValidConfig(config)) {
                    throw new Error("bad experiment config");
                }
                this.config = config;
                this.name = (_ref2 = config.name) != null ? _ref2 : '';
                this.controlName = config.control;
                this.variants = config.variants;
                this.allVariantSettings = config.variant_settings;
                this.guards = (_ref3 = config.guards) != null ? _ref3 : [];
                this.params = (_ref4 = config.params) != null ? _ref4 : {};
                this.buckets = this._parseBucketRange(config.buckets);
                this.pathPatterns = this._parsePathPatterns(config.path_patterns);
                debug("loading experiment " + this.name);
            }

            Experiment.prototype.isValidConfig = function (config) {
                return config && config.variants && config.buckets && typeof config.buckets === "string" && config.buckets !== "" && config.variants.length > 0 && _.isArray(config.variants);
            };

            Experiment.prototype.experimentAttributes = function () {
                var _ref2;

                if (this._attrs) {
                    return this._attrs;
                }
                return this._attrs = new Finch.ExperimentAttributes(_.extend(_.clone(this.config), {
                    id: this.id,
                    layerName: (_ref2 = this.layer) != null ? _ref2.name : void 0
                }));
            };

            Experiment.prototype.getSetting = function (settingKey, defaultValue) {
                if (this.variantName() === this.controlName) {
                    return defaultValue;
                }
                return this._variantSettings()[settingKey] || defaultValue;
            };

            Experiment.prototype.run = function () {
                var _ref2;

                if (this.isDeferred()) {
                    debug("matching experiment " + this.id + " deferred with variant " + (this.variantName()));
                    return (_ref2 = this._deferCallback()) != null ? _ref2.call(this) : void 0;
                } else {
                    if (this.variant() != null) {
                        if (this.testMatches()) {
                            return this._execute();
                        } else {
                            return debug("GuardFailed on experiment " + this.id);
                        }
                    }
                }
            };

            Experiment.prototype.deferredRun = function () {
                var variantName;

                variantName = this.variantName();
                debug("running deferred experiment " + this.id + " with bucket " + variantName);
                if (this.testMatches()) {
                    this._execute();
                } else {
                    debug("GuardFailed on experiment " + this.id);
                }
                return Finch.Tracking.deliver();
            };

            Experiment.prototype.isPreferred = function () {
                return !!this.experimentDefinition().runOnInit;
            };

            Experiment.prototype.needsPreferredTracking = function () {
                return !!this.experimentDefinition().trackOnInit;
            };

            Experiment.prototype.isDeferred = function () {
                return !!this.experimentDefinition().defer;
            };

            Experiment.prototype.testMatches = function () {
                return this.pathMatches(this.finch.urlPath()) && this.paramsMatches(this.finch.urlSearch()) && this.guardMatches();
            };

            Experiment.prototype.pathMatches = function (path) {
                if ((path != null) && this.pathPatterns.length === 0) {
                    return true;
                }
                return _.any(this.pathPatterns, function (pattern) {
                    return pattern.test(path);
                });
            };

            Experiment.prototype.paramsMatches = function (querystring) {
                var queryParams;

                queryParams = Finch.Utility.parseQueryString(querystring);
                if (_.isEmpty(this.params)) {
                    return true;
                }
                return _.all(this.params, function (paramValues, paramName) {
                    if (queryParams[paramName] == null) {
                        return false;
                    }
                    return _.any(paramValues, function (value) {
                        return queryParams[paramName] === value;
                    });
                });
            };

            Experiment.prototype.guardMatches = function () {
                var _this = this;

                if (this.guards.length === 0) {
                    return true;
                }
                return _.all(this.guards, function (guard) {
                    var e, errorMessage, guardFunc, name, parameters, result, _ref2, _ref3;

                    name = guard.name || guard;
                    guardFunc = ((_ref2 = _this.experimentDefinition().guards) != null ? _ref2[name] : void 0) || _this.finch.getGuard(name) || ((_ref3 = Finch.Experiments.Global.guards) != null ? _ref3[name] : void 0);
                    if (guardFunc == null) {
                        errorMessage = new Error("" + _this.id + " Experiment: " + name + " Guard not defined");
                        _this.finch.emit("error", errorMessage, _this.experimentAttributes());
                        return false;
                    }
                    try {
                        parameters = guard.parameters || {};
                        result = guardFunc(parameters);
                        if (!result) {
                            _this.finch.emit("guarded", _this, name);
                        }
                        return result;
                    } catch (_error) {
                        e = _error;
                        _this.finch.emit("error", e, _this.experimentAttributes());
                        return false;
                    }
                });
            };

            Experiment.prototype.currentVariant = function (bucket) {
                return this.experimentDefinition().variants[this.variantNameForBucket(bucket)];
            };

            Experiment.prototype.randomVariant = function () {
                var variantName;

                variantName = this.variants[Math.floor(Math.random() * this.variants.length)];
                return this.experimentDefinition().variants[variantName];
            };

            Experiment.prototype.variant = function () {
                var _ref2;

                return (_ref2 = this.variantCache) != null ? _ref2 : this.variantCache = this.experimentDefinition().variants[this.variantName()];
            };

            Experiment.prototype.variantName = function () {
                var _ref2;

                return (_ref2 = this.variantNameCache) != null ? _ref2 : this.variantNameCache = this.variantNameForBucket(this.bucket());
            };

            Experiment.prototype._variantSettings = function () {
                var _ref2;

                return (_ref2 = this.variantSettingsCache) != null ? _ref2 : this.variantSettingsCache = this.allVariantSettings[this.variantName()] || {};
            };

            Experiment.prototype.variantNameForBucket = function (bucket) {
                return this._forcedVariantName() || this._variantNameByRoundRobin(bucket);
            };

            Experiment.prototype._forcedVariantName = function () {
                var forcedSets, set,
                    _this = this;

                forcedSets = this.finch.forcedExperimentSets();
                set = _(forcedSets).find(function (set) {
                    return set.layer === _this.layer.name && set.experiment === _this.name;
                });
                if (set) {
                    return set.variant;
                }
            };

            Experiment.prototype._variantNameByRoundRobin = function (bucket) {
                var variantIndex;

                if (!((this.buckets.min <= bucket && bucket <= this.buckets.max))) {
                    return null;
                }
                variantIndex = (bucket - this.buckets.min) % this.variants.length;
                return this.variants[variantIndex];
            };

            Experiment.prototype.bucket = function () {
                return this.layer.bucket();
            };

            Experiment.prototype.experimentDefinition = function () {
                var _base, _name1, _ref2;

                return (_ref2 = (_base = Finch.Experiments)[_name1 = this.id]) != null ? _ref2 : _base[_name1] = {
                    variants: {}
                };
            };

            Experiment.prototype._execute = function () {
                var e, variant, variantName;

                try {
                    variant = this.variant();
                    variantName = this.variantName();
                    if (variant != null) {
                        debug("rendering variant " + variantName);
                        debug(variant);
                        if (this.isPreferred() && this.needsPreferredTracking()) {
                            Finch.Tracking.trackExperiment(this);
                            Finch.Tracking.deliver();
                        }
                        variant();
                    }
                    if (!(this.isPreferred() && this.needsPreferredTracking())) {
                        Finch.Tracking.trackExperiment(this);
                    }
                    return this.finch.emit("run", this);
                } catch (_error) {
                    e = _error;
                    Finch.Tracking.trackExperimentError(this, e);
                    return this.finch.emit("error", e, this.experimentAttributes().extend({
                        variant: variantName
                    }));
                }
            };

            Experiment.prototype._deferCallback = function () {
                debug("initializing deferred experiment " + this.name);
                return this.experimentDefinition().defer;
            };

            Experiment.prototype._parseBucketRange = function (range) {
                var buckets;

                if (range == null) {
                    range = '0..999';
                }
                buckets = range.split('..');
                return {
                    min: parseInt(buckets[0], 10),
                    max: parseInt(buckets[1], 10)
                };
            };

            Experiment.prototype._parsePathPatterns = function (patterns) {
                var patternSource, _j, _len1, _results;

                if (!((patterns != null) && patterns.length > 0)) {
                    return [];
                }
                _results = [];
                for (_j = 0, _len1 = patterns.length; _j < _len1; _j++) {
                    patternSource = patterns[_j];
                    _results.push(new RegExp("^" + patternSource + "$"));
                }
                return _results;
            };

            return Experiment;

        })();

        Finch.ExperimentAttributes = (function () {
            function ExperimentAttributes(attrs) {
                var _ref10, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;

                if (attrs == null) {
                    attrs = {};
                }
                this._attrs = _.clone(attrs);
                this.layerName = (_ref2 = attrs.layerName) != null ? _ref2 : '';
                this.id = (_ref3 = attrs.id) != null ? _ref3 : '';
                this.name = (_ref4 = attrs.name) != null ? _ref4 : '';
                this.variants = (_ref5 = attrs.variants) != null ? _ref5 : [];
                this.variant = (_ref6 = attrs.variant) != null ? _ref6 : '';
                this.guards = (_ref7 = attrs.guards) != null ? _ref7 : [];
                this.params = (_ref8 = attrs.params) != null ? _ref8 : {};
                this.buckets = (_ref9 = attrs.buckets) != null ? _ref9 : '';
                this.path_patterns = (_ref10 = attrs.path_patterns) != null ? _ref10 : [];
                this.layer = {
                    name: this.layerName
                };
                this.variantName = function () {
                    return this.variant;
                };
            }

            ExperimentAttributes.prototype.clone = function () {
                return new Finch.ExperimentAttributes(this._attrs);
            };

            ExperimentAttributes.prototype.extend = function (attrs) {
                var newAttrs;

                newAttrs = _.clone(this._attrs);
                return new Finch.ExperimentAttributes(_.extend(newAttrs, attrs != null ? attrs : {}));
            };

            ExperimentAttributes.prototype.equals = function (first, second) {
                var attr, firstValue, ignoredAttributes, result, _ref2;

                if (first instanceof Finch.ExperimentAttributes && second instanceof Finch.ExperimentAttributes) {
                    ignoredAttributes = ['_attrs'];
                    result = first.layer.name === second.layer.name && first.variantName() === second.variantName();
                    for (attr in first) {
                        if (!__hasProp.call(first, attr)) continue;
                        firstValue = first[attr];
                        if ((_ref2 = !attr, __indexOf.call(ignoredAttributes, _ref2) >= 0) && !_.isFunction(firstValue) && !_.isEqual(second[attr], firstValue)) {
                            result = false;
                        }
                    }
                    return result;
                }
            };

            return ExperimentAttributes;

        })();

        Finch.Guards = (function () {
            function Guards(finch) {
                this.customGuards = {};
                this.builtInGuards = new Finch.BuiltInGuards(finch);
            }

            Guards.prototype.add = function (guardName, guard, context) {
                var guardFunc;

                if (context == null) {
                    context = null;
                }
                if (context) {
                    guardFunc = function () {
                        return guard.apply(context, arguments);
                    };
                } else {
                    guardFunc = guard;
                }
                return this.customGuards[guardName] = guardFunc;
            };

            Guards.prototype.get = function (name) {
                return this.customGuards[name] || this.builtInGuards[name];
            };

            return Guards;

        })();

        Finch.Layer = (function () {
            Layer.all = function () {
                return Finch.layers || [];
            };

            function Layer(name, config, finch) {
                var error, error_message, exp, experimentConfig, experimentIdentifier, _ref2, _ref3, _ref4;

                this.name = name;
                this.finch = finch != null ? finch : Finch;
                this.settingKeyMap = __bind(this.settingKeyMap, this);
                this.preferredRun = __bind(this.preferredRun, this);
                this.run = __bind(this.run, this);
                this.bucket = __bind(this.bucket, this);
                if (config) {
                    if (!this.isValidConfig(config)) {
                        throw new Error("bad layer config");
                    }
                    debug("loading layer " + this.name);
                    this.experiments = [];
                    _ref2 = config.experiments;
                    for (experimentIdentifier in _ref2) {
                        if (!__hasProp.call(_ref2, experimentIdentifier)) continue;
                        experimentConfig = _ref2[experimentIdentifier];
                        try {
                            exp = new Finch.Experiment(experimentIdentifier, this, experimentConfig, this.finch);
                            this.experiments.push(exp);
                        } catch (_error) {
                            error = _error;
                            error_message = new Error("" + experimentIdentifier + " Experiment: bad configuration");
                            this.finch.emit("error", error_message, new Finch.ExperimentAttributes({
                                layerName: this.name,
                                name: experimentConfig.name
                            }));
                        }
                    }
                    if (config.diversion_type != null) {
                        this.diversion = Finch.Diversions[config.diversion_type];
                    }
                    this.bucketingSalt = (_ref3 = config.bucketing_salt) != null ? _ref3 : this.name;
                }
                if ((_ref4 = this.diversion) == null) {
                    this.diversion = Finch.Diversions.RandomDiversion;
                }
            }

            Layer.prototype.isValidConfig = function (config) {
                return Finch.Utility.isMap(config);
            };

            Layer.prototype.findExperiments = function (selector) {
                var experiment, _j, _len1, _ref2, _results;

                if (selector == null) {
                    return [];
                }
                _ref2 = this.experiments;
                _results = [];
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                    experiment = _ref2[_j];
                    if (selector(experiment)) {
                        _results.push(experiment);
                    }
                }
                return _results;
            };

            Layer.prototype.experimentsForBucket = function (bucket) {
                return this.findExperiments(function (exp) {
                    return (exp.buckets.min <= bucket && bucket <= exp.buckets.max);
                });
            };

            Layer.prototype.experiment = function () {
                return this._getForcedExperiment() || this._getSingleMatchingExperiment();
            };

            Layer.prototype.isCurrentExperiment = function (experimentName) {
                var _ref2;

                return ((_ref2 = this.experiment()) != null ? _ref2.name : void 0) === experimentName;
            };

            Layer.prototype.bucket = function () {
                var _ref2;

                return (_ref2 = this.bucketCache) != null ? _ref2 : this.bucketCache = this.diversion.bucket(this);
            };

            Layer.prototype.run = function () {
                var experiment;

                experiment = this.experiment();
                if (experiment && !experiment.isPreferred()) {
                    return experiment.run();
                }
            };

            Layer.prototype.preferredRun = function () {
                var experiment;

                experiment = this.experiment();
                if (experiment && experiment.isPreferred()) {
                    return experiment.run();
                }
            };

            Layer.prototype.settingKeyMap = function () {
                var experiment, ret, settingKey, settingValue, settings, variantName, _j, _len1, _ref2, _ref3;

                ret = {};
                _ref2 = this.experiments;
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                    experiment = _ref2[_j];
                    _ref3 = experiment.allVariantSettings;
                    for (variantName in _ref3) {
                        settings = _ref3[variantName];
                        for (settingKey in settings) {
                            settingValue = settings[settingKey];
                            ret[settingKey] = experiment.name;
                        }
                    }
                }
                return ret;
            };

            Layer.prototype._getForcedExperiment = function () {
                var forcedSets, set,
                    _this = this;

                forcedSets = this.finch.forcedExperimentSets();
                set = _(forcedSets).find(function (set) {
                    return set.layer === _this.name;
                });
                if (set) {
                    return _(this.experiments).find(function (exp) {
                        return exp.name === set.experiment;
                    });
                }
            };

            Layer.prototype._getSingleMatchingExperiment = function () {
                var results,
                    _this = this;

                if (this.bucket() == null) {
                    return null;
                }
                results = this.findExperiments(function (exp) {
                    var _ref2;

                    return (exp.buckets.min <= (_ref2 = _this.bucket()) && _ref2 <= exp.buckets.max);
                });
                if (results.length === 1) {
                    return results[0];
                } else {
                    return null;
                }
            };

            return Layer;

        })();

        Finch.ConsoleLoggingTracker = {
            track: function (expSets) {
                return _(expSets).each(function (expSet) {
                    var _ref2, _ref3;

                    console.log("*****************************");
                    console.log("*** ConsoleLoggingTracker ***");
                    console.log("*****************************");
                    console.log("*** layer: " + ((_ref2 = expSet.layer) != null ? _ref2.name : void 0));
                    console.log("*** experiment: " + ((_ref3 = expSet.experiment) != null ? _ref3.name : void 0));
                    console.log("*** variant: " + expSet.variant);
                    if (expSet.error != null) {
                        console.log("*** error: " + expSet.error);
                    }
                    return console.log("*****************************");
                });
            }
        };

        Finch.PixelTracker = {
            track: function (expSets) {
                var e, experimentSets, trackerData;

                if (Finch.alwaysFirePixel || !_.isEmpty(expSets)) {
                    experimentSets = _.map(expSets, function (expSet) {
                        return {
                            layer: expSet.layer.name,
                            experiment: expSet.experiment.id,
                            variant: expSet.variant,
                            error: expSet.error
                        };
                    });
                    trackerData = Finch.externalData ? {
                        experiments: experimentSets,
                        externalData: Finch.externalData
                    } : experimentSets;
                    e = encodeURIComponent(JSON.stringify(trackerData));
                    return this.sendData(e);
                }
            },
            sendData: function (e) {
                var cacheBuster, trackerPath;

                cacheBuster = (new Date).getTime();
                trackerPath = "/analytic/experiment.gif?e=" + e + "&src=img&_=" + cacheBuster;
                return $("<img />", {
                    "class": 'finch-tracking',
                    src: trackerPath,
                    height: 1,
                    width: 1
                }).appendTo($('body'));
            }
        };

        Finch.AjaxPixelTracker = {
            track: Finch.PixelTracker.track,
            sendData: function (e) {
                var trackerPath;

                trackerPath = "/analytic/experiment.gif?e=" + e + "&src=ajax";
                return $.ajax(trackerPath, {
                    cache: false
                });
            }
        };

        Finch.Tracking = {
            deliver: function () {
                var e, tracker, _j, _len1, _ref2;

                _ref2 = Finch.Trackers;
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                    tracker = _ref2[_j];
                    try {
                        tracker.track(this._translatedExperiments());
                    } catch (_error) {
                        e = _error;
                    }
                }
                return this.flush();
            },
            trackExperiment: function (experiment) {
                var _this = this;

                return this._oncePerExperiment(experiment, function () {
                    return _this.experiments.push(experiment);
                });
            },
            trackExperimentError: function (experiment, error) {
                this.trackExperiment(experiment);
                return this.experimentErrors[experiment.id] = error;
            },
            flush: function () {
                this.experiments = [];
                return this.experimentErrors = {};
            },
            reset: function () {
                this.flush();
                return this.trackedExperimentNames = [];
            },
            _oncePerExperiment: function (experiment, cb) {
                if (!this.trackedExperimentNames[experiment.id]) {
                    cb();
                    return this.trackedExperimentNames[experiment.id] = true;
                }
            },
            _translatedExperiments: function () {
                var data, error, experiment, _j, _len1, _ref2, _results;

                _ref2 = this.experiments;
                _results = [];
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                    experiment = _ref2[_j];
                    data = {
                        layer: experiment.layer,
                        experiment: experiment,
                        variant: experiment.variantName()
                    };
                    error = this.experimentErrors[experiment.id];
                    if (error) {
                        data.error = error;
                    }
                    _results.push(data);
                }
                return _results;
            }
        };

        Finch.Tracking.reset();

        Finch.Utility = {
            parseQueryString: function (queryString) {
                var keyPairs, keyVal, params, tuple, _j, _len1, _ref2;

                params = {};
                _ref2 = keyPairs = queryString.replace(/\+/g, '%20').split('&');
                for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                    keyVal = _ref2[_j];
                    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
                        continue;
                    }
                    try {
                        params[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
                    } catch (_error) {}
                }
                return params;
            },
            isBrowserWindow: function (obj) {
                return (obj.location != null) && (obj.document != null);
            },
            isMap: function (obj) {
                return _.isObject(obj) && !_.isFunction(obj) && !_.isArray(obj);
            }
        };

    }).call(this);
    // Generated by CoffeeScript 1.6.3
    (function () {
        var SanityCheck,
            __slice = [].slice;

        this.SanityCheck = SanityCheck = (function () {
            SanityCheck.listeners = {
                success: [],
                failure: [],
                error: []
            };

            SanityCheck.checks = [];

            SanityCheck.defaultInterval = 1000;

            SanityCheck.add = function (name, func) {
                var sc,
                    _this = this;
                sc = new SanityCheck({
                    name: name,
                    func: func
                });
                sc.on("success", function (data) {
                    return _this.trigger("success", sc, data);
                });
                sc.on("failure", function (data) {
                    return _this.trigger("failure", sc, data);
                });
                sc.on("error", function (data) {
                    return _this.trigger("error", sc, data);
                });
                this.checks.push(sc);
                return sc;
            };

            SanityCheck.on = function (name, func) {
                return this.listeners[name].push(func);
            };

            SanityCheck.trigger = function () {
                var args, func, name, _i, _len, _ref, _results;
                name = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
                _ref = this.listeners[name] || [];
                _results = [];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    func = _ref[_i];
                    _results.push(func.apply(null, args));
                }
                return _results;
            };

            SanityCheck.onNextTick = function (func) {
                return setTimeout(func);
            };

            SanityCheck.onInterval = function (func, interval) {
                return setInterval(func, interval);
            };

            SanityCheck.reset = function () {
                this.listeners = {
                    success: [],
                    failure: [],
                    error: []
                };
                return this.checks = [];
            };

            SanityCheck.run = function () {
                var sc, _i, _len, _ref, _results;
                _ref = this.checks;
                _results = [];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    sc = _ref[_i];
                    _results.push(sc.run());
                }
                return _results;
            };

            function SanityCheck(atts) {
                this.name = atts.name;
                this.func = atts.func;
                this.listeners = {
                    success: [],
                    failure: [],
                    error: []
                };
            }

            SanityCheck.prototype.on = function (name, func) {
                return this.listeners[name].push(func);
            };

            SanityCheck.prototype.trigger = function () {
                var args, name,
                    _this = this;
                name = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
                return SanityCheck.onNextTick(function () {
                    var func, _i, _len, _ref, _results;
                    _ref = _this.listeners[name] || [];
                    _results = [];
                    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        func = _ref[_i];
                        _results.push(func.apply(null, args));
                    }
                    return _results;
                });
            };

            SanityCheck.prototype.run = function () {
                var e;
                try {
                    return this.func(this);
                } catch (_error) {
                    e = _error;
                    return this.trigger("error", e);
                }
            };

            SanityCheck.prototype.watch = function (selector, interval, cb) {
                var els, finder,
                    _this = this;
                if (!cb) {
                    cb = interval;
                    interval = SanityCheck.defaultInterval;
                }
                els = [];
                finder = function () {
                    var allEls, e, newEls;
                    try {
                        allEls = $(selector);
                        newEls = allEls.not(els);
                        els = allEls;
                        return newEls.each(function (i, e) {
                            var err;
                            try {
                                return cb($(e));
                            } catch (_error) {
                                err = _error;
                                return _this.trigger("error", err);
                            }
                        });
                    } catch (_error) {
                        e = _error;
                        return _this.trigger("error", e);
                    }
                };
                return SanityCheck.onInterval(finder, interval);
            };

            SanityCheck.prototype.success = function (data) {
                return this.trigger("success", data);
            };

            SanityCheck.prototype.fail = function (data) {
                return this.trigger("failure", data);
            };

            return SanityCheck;

        })();

    }).call(this);
    // Generated by CoffeeScript 1.4.0
    (function () {

        this.Portal = function (target) {
            var WaitForWindowLoad, addListener, listeners, onPostMessage, pastEvents, pluginQueue, portal;
            listeners = {};
            pastEvents = {};
            addListener = function (name, func) {
                if (target.attachEvent != null) {
                    return target.attachEvent("on" + name, func);
                } else if (target.addEventListener != null) {
                    return target.addEventListener(name, func, false);
                }
            };
            WaitForWindowLoad = function () {
                return function (beagle) {
                    var onLoad, ready;
                    ready = document.readyState === "complete";
                    if (!ready) {
                        onLoad = function () {
                            ready = true;
                            return beagle.flush();
                        };
                        addListener("load", onLoad);
                    }
                    return beagle.on("add", function () {
                        if (ready) {
                            return beagle.flush();
                        }
                    });
                };
            };
            pluginQueue = new Beagle();
            pluginQueue.use(WaitForWindowLoad());
            pluginQueue.on("flush", function (msgs) {
                var msg, _i, _len, _results;
                _results = [];
                for (_i = 0, _len = msgs.length; _i < _len; _i++) {
                    msg = msgs[_i];
                    try {
                        _results.push(target.postMessage(JSON.stringify(msg.data), "*"));
                    } catch (e) {

                    }
                }
                return _results;
            });
            onPostMessage = function (event) {
                var channel, data, eventData, eventName, func, _base, _base1, _i, _j, _len, _len1, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _results;
                try {
                    eventData = JSON.parse(event.data);
                } catch (err) {
                    return;
                }
                channel = eventData.channel;
                eventName = eventData.name;
                data = eventData.data;
                if ((_ref = listeners[channel]) == null) {
                    listeners[channel] = {};
                }
                if ((_ref1 = pastEvents[channel]) == null) {
                    pastEvents[channel] = {};
                }
                if ((_ref2 = (_base = pastEvents[channel])["*"]) == null) {
                    _base["*"] = [];
                }
                if ((_ref3 = (_base1 = pastEvents[channel])[eventName]) == null) {
                    _base1[eventName] = [];
                }
                pastEvents[channel]["*"].push(eventData);
                pastEvents[channel][eventName].push(eventData);
                _ref4 = listeners[channel]["*"] || [];
                for (_i = 0, _len = _ref4.length; _i < _len; _i++) {
                    func = _ref4[_i];
                    func(eventName, data);
                }
                _ref5 = listeners[channel][eventName] || [];
                _results = [];
                for (_j = 0, _len1 = _ref5.length; _j < _len1; _j++) {
                    func = _ref5[_j];
                    _results.push(func(data));
                }
                return _results;
            };
            addListener("message", onPostMessage, false);
            portal = function (channel) {
                return {
                    add: function (eventName, data) {
                        if (data == null) {
                            data = {};
                        }
                        return pluginQueue.add("msg", {
                            channel: channel,
                            name: eventName,
                            data: data
                        });
                    },
                    bind: function (eventName, func) {
                        var _base, _ref, _ref1;
                        if ((_ref = listeners[channel]) == null) {
                            listeners[channel] = {};
                        }
                        if ((_ref1 = (_base = listeners[channel])[eventName]) == null) {
                            _base[eventName] = [];
                        }
                        return listeners[channel][eventName].push(func);
                    },
                    on: function (eventName, func) {
                        return this.bind(eventName, func);
                    },
                    replayAndBind: function (eventName, func) {
                        var pastEvent, _i, _len, _ref, _ref1;
                        if ((_ref = pastEvents[channel]) == null) {
                            pastEvents[channel] = {};
                        }
                        _ref1 = pastEvents[channel][eventName] || [];
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            pastEvent = _ref1[_i];
                            if (eventName === "*") {
                                func(pastEvent.name, pastEvent.data);
                            } else {
                                func(pastEvent.data);
                            }
                        }
                        return this.bind(eventName, func);
                    }
                };
            };
            return portal;
        };

    }).call(this);
    // Generated by CoffeeScript 1.9.3
    (function () {
        var InteractionGoals;

        InteractionGoals = (function () {
            InteractionGoals.prototype._listeners = {
                "*": [],
                "error": []
            };

            function InteractionGoals(trackingHub, warehouse) {
                this._trackingHub = trackingHub;
                this._warehouse = warehouse;
            }

            InteractionGoals.prototype.on = function (name, fn) {
                var base;
                if ((base = this._listeners)[name] == null) {
                    base[name] = [];
                }
                return this._listeners[name].push(fn);
            };

            InteractionGoals.prototype.profileEdit = function (data) {
                return this._interactionGoal(data, "profile-edit", {
                    fields: ["changed", "action"],
                    optionalFields: ["permalink"]
                });
            };

            InteractionGoals.prototype.subscription = function (data) {
                return this._interactionGoal(data, "subscription", {
                    fields: ["division", "country", "channel", "consumerId"]
                });
            };

            InteractionGoals.prototype.login = function (data) {
                return this._interactionGoal(data, "login", {
                    fields: []
                });
            };

            InteractionGoals.prototype.signup = function (data) {
                return this._interactionGoal(data, "signup", {
                    fields: []
                });
            };

            InteractionGoals.prototype.purchase = function (data) {
                return this._purchaseForType(data, 'purchase');
            };

            InteractionGoals.prototype.purchaseTest = function (data) {
                return this._purchaseForType(data, 'purchase-test');
            };

            InteractionGoals.prototype._purchaseForType = function (data, type) {
                var fields, optionalFields;
                fields = ["value", "division", "country", "channel", "activation", "quantity", "orderId"];
                optionalFields = ["permalink", "pledgeId", "parentOrderId", "orderUuid", "parentOrderUuid", "dealUuid"];
                return this._interactionGoal(data, type, {
                    fields: fields,
                    optionalFields: optionalFields,
                    validate: (function (_this) {
                        return function (data, event) {
                            var ONE_YEAR, id, isValid, orderIds, timestamp;
                            if (_this._warehouse == null) {
                                return true;
                            }
                            isValid = false;
                            orderIds = _this._warehouse.get('orderIds') || {};
                            for (id in orderIds) {
                                timestamp = orderIds[id];
                                ONE_YEAR = 1000 * 60 * 60 * 24 * 365;
                                if (new Date() - timestamp > ONE_YEAR) {
                                    delete orderIds[id];
                                }
                            }
                            if (orderIds[data.orderId] != null) {
                                _this.error({
                                    message: "The interaction-goal-purchase message was called with a duplicate order ID: " + data.orderId
                                });
                                isValid = false;
                            } else {
                                orderIds[data.orderId] = new Date().getTime();
                                isValid = true;
                            }
                            _this._warehouse.set('orderIds', orderIds);
                            return isValid;
                        };
                    })(this)
                });
            };

            InteractionGoals.prototype.error = function (data) {
                return this._interactionGoal(data, "error", {
                    fields: ["message"]
                });
            };

            InteractionGoals.prototype._emit = function (name, data) {
                var i, j, len, len1, listener, ref, ref1, results;
                ref = this._listeners["*"];
                for (i = 0, len = ref.length; i < len; i++) {
                    listener = ref[i];
                    listener(name, data);
                }
                ref1 = this._listeners[name] || [];
                results = [];
                for (j = 0, len1 = ref1.length; j < len1; j++) {
                    listener = ref1[j];
                    results.push(listener(data));
                }
                return results;
            };

            InteractionGoals.prototype._interactionGoal = function (_data, type, config) {
                var data, field, i, j, len, len1, ref, ref1;
                data = {};
                ref = config.fields;
                for (i = 0, len = ref.length; i < len; i++) {
                    field = ref[i];
                    data[field] = _data[field];
                    if (data[field] == null) {
                        this.error({
                            message: "Event 'interaction-goal-" + type + "' was emitted with bad data. Field '" + field + "' was null."
                        });
                    }
                }
                if (config.optionalFields) {
                    ref1 = config.optionalFields;
                    for (j = 0, len1 = ref1.length; j < len1; j++) {
                        field = ref1[j];
                        data[field] = _data[field];
                    }
                }
                data.type = type;
                if ((config.validate == null) || config.validate(data, type)) {
                    this._emit(type, data);
                    return this._trackingHub.add("interaction-goal-" + type, data);
                }
            };

            return InteractionGoals;

        })();

        if (typeof window !== "undefined" && window !== null) {
            window.InteractionGoals = InteractionGoals;
        }

        if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
            module.exports = InteractionGoals;
        }

    }).call(this);
    // Generated by CoffeeScript 1.11.1
    (function () {
        var OptimizeSuite, addCustomAnalyticsDimension, addCustomAnalyticsDimensions, addServerDimensions, addTrackingHubListeners, advancedAnalyticsLoaded, bloodhoundPaused, clearLastEventId, cookieDomainFromHost, deepMerge, dimensionsToSend, domReady, ensureBrowserId, ensureSessionId, expPrefix, gaSendPurchase, gaSendSubscription, getAdditionalGAData, getCookie, getLastEventId, getLastPageId, getRandomUUID, getViewportWidth, initAdvancedAnalytics, initBloodhound, initDefaultAnalyticsDimensions, initErrorCatcher, initFinch, initGoogleAnalytics, initInspectors, initInteractionGoals, initReferral, initSanityCheck, initTrackingHub, isIterableObject, ref, ref1, ref2, runGoogleAnalyticsSnippet, secureStorageConfig, secureStorageNeeded, sendAdvancedAnalyticsEvent, setCookie, setLastEventId, setLastPageId, suppressErrors, translateToGADimensions, unsetCookie, useParentTracking, withConfigDefaults,
            slice = [].slice;

        OptimizeSuite = window.OptimizeSuite = {};

        OptimizeSuite.Evented = window.Evented;

        window.Evented = null;

        OptimizeSuite.Warehouse = window.Warehouse;

        window.Warehouse = null;

        OptimizeSuite.TrackingHub = window.TrackingHub;

        OptimizeSuite.BrowserDetect = (ref = OptimizeSuite.TrackingHub) != null ? ref.BrowserDetect : void 0;

        OptimizeSuite.Warehouse = (ref1 = OptimizeSuite.TrackingHub) != null ? ref1.Warehouse : void 0;

        window.Beagle = (ref2 = OptimizeSuite.TrackingHub) != null ? ref2.Beagle : void 0;

        if (window.Portal) {
            OptimizeSuite.Portal = window.Portal(window);
            window.Portal = null;
        }

        OptimizeSuite.SanityCheck = window.SanityCheck;

        window.SanityCheck = null;

        OptimizeSuite.Bloodhound = window.Bloodhound;

        suppressErrors = null;

        domReady = null;

        bloodhoundPaused = false;

        expPrefix = "experiment-";

        dimensionsToSend = {};

        advancedAnalyticsLoaded = false;

        OptimizeSuite.init = function (config) {
            var ref3, sessionId;
            OptimizeSuite.BrowserDetect.init();
            config = this.config = withConfigDefaults(config);
            sessionId = config.session.id;
            suppressErrors = config.suppressErrors;
            domReady = $ || domready;
            if (config.errorCatcher) {
                initErrorCatcher(config.page);
            }
            if (config.trackingHub) {
                initTrackingHub(config, sessionId);
                addTrackingHubListeners();
            }
            if (config.finch) {
                initFinch(config.finch);
            }
            if (config.sanityCheck) {
                initSanityCheck();
            }
            if (config.devMode) {
                initInspectors();
            }
            if (window.InteractionGoals && OptimizeSuite.Warehouse) {
                initInteractionGoals(OptimizeSuite.TrackingHub, OptimizeSuite.Warehouse, window.InteractionGoals);
                window.InteractionGoals = null;
            }
            if (config.googleAnalyticsTrackingId) {
                initGoogleAnalytics(config.googleAnalyticsTrackingId);
            }
            if ((ref3 = config.advancedAnalytics) != null ? ref3.enabled : void 0) {
                initAdvancedAnalytics();
            }
            OptimizeSuite.initBloodhound = function () {
                return initBloodhound(config, sessionId);
            };
            OptimizeSuite.treatAsNewPage = function (url, newConfig) {
                var bhReset, expiration, reinit, seed;
                if (newConfig == null) {
                    newConfig = {};
                }
                bhReset = function () {
                    var ref4;
                    return (ref4 = OptimizeSuite.bloodhound) != null ? ref4.reset() : void 0;
                };
                if (useParentTracking()) {
                    if (typeof parent !== "undefined" && parent !== null) {
                        parent.OptimizeSuite.treatAsNewPage(url, newConfig);
                    }
                    reinit = function () {
                        return bhReset();
                    };
                } else {
                    config = deepMerge(config, newConfig);
                    if (seed = getCookie(config.session.cookieKey)) {
                        expiration = config.session.expiry;
                        setCookie(config.session.cookieKey, seed, expiration, config.cookieDomain);
                    }
                    reinit = function () {
                        config.page.parentEventId = getLastEventId();
                        config.page.parentPageId = getLastPageId();
                        config.page.url = encodeURIComponent(url);
                        initTrackingHub(config, sessionId);
                        return bhReset();
                    };
                }
                return setTimeout(reinit, 0);
            };
            if (!OptimizeSuite.BrowserDetect.browser.match(/Safari/)) {
                OptimizeSuite.TrackingHub.flush();
            }
            return OptimizeSuite.InteractionGoals.on("error", function (error) {
                if (!config.devMode) {
                    return;
                }
                throw new Error(error.message);
            });
        };

        OptimizeSuite.getQueryString = function () {
            return window.location.search;
        };

        OptimizeSuite.getReferrer = function () {
            return window.document.referrer;
        };

        useParentTracking = function () {
            var notEqual, ref3, ref4, ref5;
            notEqual = function (a, b) {
                return a != b;
            };
            return notEqual(window.parent, window) && ((typeof window !== "undefined" && window !== null ? (ref3 = window.parent) != null ? (ref4 = ref3.OptimizeSuite) != null ? (ref5 = ref4.TrackingHub) != null ? ref5.page : void 0 : void 0 : void 0 : void 0) != null);
        };

        setCookie = function () {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            if (!useParentTracking()) {
                return Cookie.set.apply(Cookie, args);
            }
        };

        unsetCookie = function () {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            if (!useParentTracking()) {
                return Cookie.unset.apply(Cookie, args);
            }
        };

        getCookie = function () {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return Cookie.get.apply(Cookie, args);
        };

        OptimizeSuite.getLastEventId = getLastEventId = function () {
            return getCookie("bh-last-event-id");
        };

        clearLastEventId = function () {
            return unsetCookie("bh-last-event-id");
        };

        setLastEventId = function (id) {
            return setCookie("bh-last-event-id", id, 15);
        };

        getLastPageId = function () {
            return getCookie("bh-last-page-id");
        };

        setLastPageId = function (id) {
            return setCookie("bh-last-page-id", id, 1800);
        };

        getViewportWidth = function () {
            var width;
            width = $(window).width();
            if (width <= 600) {
                return 'S';
            } else if (width <= 720) {
                return 'M';
            } else if (width <= 1080) {
                return 'L';
            } else {
                return 'XL';
            }
        };

        isIterableObject = function (val) {
            return _.isObject(val) && !_.isArray(val) && !_.isFunction(val);
        };

        deepMerge = function (obj1, obj2) {
            var key, res, val;
            res = {};
            for (key in obj1) {
                val = obj1[key];
                if (isIterableObject(val) && (obj2[key] != null) && isIterableObject(obj2[key])) {
                    res[key] = deepMerge(val, obj2[key]);
                } else if (obj2[key] != null) {
                    res[key] = obj2[key];
                } else {
                    res[key] = val;
                }
            }
            if (isIterableObject(obj2)) {
                for (key in obj2) {
                    val = obj2[key];
                    if (res[key] == null) {
                        res[key] = val;
                    }
                }
            }
            return res;
        };

        cookieDomainFromHost = function (host) {
            return "." + host.split(".").slice(1).join(".");
        };

        withConfigDefaults = function (config) {
            var message, out, ref3, uuid;
            out = {
                advancedAnalytics: {
                    enabled: false,
                    serverDimensions: {}
                },
                sanityCheck: true,
                errorCatcher: true,
                trackingHub: true,
                devMode: false,
                suppressErrors: !config.devMode,
                cookieDomain: cookieDomainFromHost(window.location.host),
                tracking: {
                    interval: 3000,
                    endpoint: "/tracky",
                    secureStorageEnabled: false,
                    secureStoragePath: 'secure_storage'
                },
                referralMap: {
                    utm_source: "source",
                    utm_campaign: "campaign",
                    utm_medium: "medium",
                    utm_content: "content",
                    utm_term: "term",
                    a: "a",
                    cid: "cid"
                },
                session: {
                    cookieKey: 's',
                    expiry: 30 * 60
                },
                page: {
                    parentEventId: getLastEventId(),
                    parentPageId: getLastPageId(),
                    url: encodeURIComponent(window.location.href)
                },
                user: {
                    userAgent: window.navigator.userAgent,
                    browser: OptimizeSuite.BrowserDetect.browser || "unknown",
                    browserVersion: OptimizeSuite.BrowserDetect.version || "unknown",
                    os: OptimizeSuite.BrowserDetect.OS || "unknown",
                    device: OptimizeSuite.BrowserDetect.device,
                    deviceType: OptimizeSuite.BrowserDetect.deviceType,
                    consumerId: getCookie("c"),
                    consumerIdSource: getCookie("c_s"),
                    loggedIn: !!getCookie("snickerdoodle") || !!getCookie("user_id"),
                    permalink: getCookie("l") || getCookie("user_id"),
                    browserId: getCookie("b"),
                    scid: getCookie("scid"),
                    visit: getCookie("visited"),
                    viewportWidth: getViewportWidth()
                },
                finch: {
                    trackers: null,
                    debug: false,
                    alwaysFirePixel: true,
                    config: null
                },
                bloodhound: {}
            };
            out = deepMerge(out, config);
            out.page.parentPageId = getLastPageId();
            out.page.url = encodeURIComponent(window.location.href);
            if (((ref3 = out.session) != null ? ref3.cookieDomain : void 0) != null) {
                out.cookieDomain = out.session.cookieDomain;
                delete out.session.cookieDomain;
                if (out.devMode) {
                    message = "replace config.session.cookieDomain with config.cookieDomain in OptimizeSuite.init";
                    OptimizeSuite.log.deprecation(message);
                }
            }
            out.page.suiteVersion = OptimizeSuite.version;
            uuid = ensureSessionId(out);
            ensureBrowserId(out, uuid);
            if (getCookie("optimize-inspectors")) {
                out.devMode = true;
                out.suppressErrors = false;
            }
            return out;
        };

        initSanityCheck = function () {
            return OptimizeSuite.SanityCheck.on("failure", function (sc, data) {
                OptimizeSuite.Portal("sanity-check").add(sc.name, data);
                return OptimizeSuite.TrackingHub.add("sanity-check-failure", _.extend({
                    sanityCheck: sc.name
                }, data));
            });
        };

        initFinch = function (config) {
            var finchPortal;
            Finch.debug = config.debug;
            Finch.alwaysFirePixel = config.alwaysFirePixel;
            if (config.trackers) {
                Finch.Trackers = config.trackers;
            }
            finchPortal = OptimizeSuite.Portal("finch");
            Finch.initialize(window, config.config);
            Finch.on("guarded", function (experiment, guardName) {
                return finchPortal.add("guarded", {
                    layer: experiment.layer.name,
                    experiment: experiment.name,
                    guard: guardName
                });
            });
            Finch.on("run", function (experiment) {
                var e, experimentNames, experiments;
                finchPortal.add("run", {
                    layer: experiment.layer.name,
                    experiment: experiment.name
                });
                experiments = OptimizeSuite.TrackingHub.session.get('experiments') || [];
                experimentNames = _.pluck(experiments, 'experiment');
                if (_.indexOf(experimentNames, experiment.name) === -1) {
                    experiments.push({
                        layer: experiment.layer.name,
                        experiment: experiment.name,
                        variant: experiment.variantName()
                    });
                    OptimizeSuite.addCustomAnalyticsDimension(expPrefix + experiment.name, experiment.variantName());
                    try {
                        OptimizeSuite.TrackingHub.session.set('experiments', experiments);
                    } catch (error1) {
                        e = error1;
                    }
                    return OptimizeSuite.TrackingHub.add("finch-experiment", {
                        layer: experiment.layer.name,
                        experiment: experiment.name,
                        variant: experiment.variantName(),
                        bucket: experiment.bucket()
                    });
                }
            });
            Finch.on("error", function (err, experiment) {
                OptimizeSuite.TrackingHub.add("finch-experiment", {
                    layer: experiment.layer.name,
                    experiment: experiment.name,
                    variant: experiment.variantName(),
                    error: err.message
                });
                if (!suppressErrors) {
                    throw err;
                }
            });
            finchPortal.add("loaded", config.config);
            Finch.experiment("finchExpressAA", {
                control: function () {},
                on: function () {}
            });
            Finch.runPreferredExperiments();
            return domReady(function () {
                return Finch.run();
            });
        };

        initErrorCatcher = function (pageConfig) {
            ErrorCatcher.init();
            return ErrorCatcher.on("error", function (e) {
                var errorData, ref3;
                if ((ref3 = e.originalError) != null ? ref3.doNotTrack : void 0) {
                    return;
                }
                errorData = _.clone(e);
                delete errorData.timestamp;
                delete errorData.userAgent;
                errorData.page_type = pageConfig.type;
                errorData.page_url = pageConfig.url;
                return OptimizeSuite.TrackingHub.add("uncaught-error", errorData);
            });
        };

        gaSendPurchase = function (data) {
            ga('ec:addProduct', {
                id: data.dealUuid,
                name: data.permalink,
                category: data.channel,
                price: data.value,
                quantity: data.quantity
            });
            ga('ec:setAction', 'purchase', {
                id: data.orderId,
                revenue: data.value * data.quantity
            });
            return ga('send', 'event', 'interaction-goal', 'purchase');
        };

        translateToGADimensions = function (customDimensionValues) {
            var dimension, gaDimensionMap, mappedValues, value;
            gaDimensionMap = {
                country: "dimension1",
                division: "dimension2",
                channel: "dimension3",
                app: "dimension4",
                type: "dimension5",
                platform: "dimension6",
                browserId: "dimension7",
                consumerId: "dimension8",
                dealUUID: "dimension9",
                loggedIn: "dimension10",
                gaCookie: "dimension11"
            };
            mappedValues = {};
            for (dimension in customDimensionValues) {
                value = customDimensionValues[dimension];
                mappedValues[gaDimensionMap[dimension]] = value;
            }
            return mappedValues;
        };

        gaSendSubscription = function (arg) {
            var country;
            country = arg.country;
            return ga('send', 'event', 'interaction-goal', 'subscription', translateToGADimensions({
                country: country
            }));
        };

        runGoogleAnalyticsSnippet = function () {
            return (function (i, s, o, g, r, a, m) {
                i['GoogleAnalyticsObject'] = r;
                i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments)
                }, i[r].l = 1 * new Date();
                a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m)
            })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');;
        };

        getAdditionalGAData = function () {
            var app, browserId, channel, consumerId, dealUUID, division, gaCookie, loggedIn, platform, ref3, ref4, type;
            ref3 = OptimizeSuite.TrackingHub.page.metadata, app = ref3.app, channel = ref3.channel, division = ref3.division, type = ref3.type;
            ref4 = OptimizeSuite.TrackingHub.user, browserId = ref4.browserId, consumerId = ref4.consumerId, platform = ref4.platform, loggedIn = ref4.loggedIn;
            dealUUID = OptimizeSuite.config.dealUUID;
            gaCookie = getCookie("_ga");
            return translateToGADimensions({
                app: app,
                browserId: browserId,
                channel: channel,
                consumerId: consumerId,
                dealUUID: dealUUID,
                division: division,
                type: type,
                platform: platform,
                loggedIn: loggedIn,
                gaCookie: gaCookie
            });
        };

        OptimizeSuite.advancedAnalyticsInitializer = function (win, doc, done) {
            var scrSrc, scriptElement;
            scriptElement = void 0;
            scrSrc = void 0;
            if (typeof win.ClickTaleCreateDOMElement !== 'function') {
                win.ClickTaleCreateDOMElement = function (tagName) {
                    if (doc.createElementNS) {
                        return doc.createElementNS('http://www.w3.org/1999/xhtml', tagName);
                    }
                    return doc.createElement(tagName);
                };
            }
            win.WRInitTime = (new Date).getTime();
            scriptElement = ClickTaleCreateDOMElement('script');
            doc.getElementsByTagName('body')[0].appendChild(scriptElement);
            scriptElement.type = 'text/javascript';
            scrSrc = doc.location.protocol === 'https:' ? 'https://cdnssl.clicktale.net/' : 'http://cdn.clicktale.net/';
            scrSrc += 'www29/ptc/9b07ce43-aa6e-4c4f-b93c-fd9e7362bd41.js';
            scriptElement.async = true;
            scriptElement.src = scrSrc;
            return done();
        };

        OptimizeSuite.advancedAnalyticsReady = function () {
            return advancedAnalyticsLoaded;
        };

        OptimizeSuite.onAdvancedAnalyticsLoaded = function () {
            advancedAnalyticsLoaded = true;
            initDefaultAnalyticsDimensions();
            OptimizeSuite.addCustomAnalyticsDimensions(dimensionsToSend);
            return addServerDimensions();
        };

        initAdvancedAnalytics = function () {
            window.ClickTaleOnReady = OptimizeSuite.onAdvancedAnalyticsLoaded;
            return $(window).load(function () {
                return OptimizeSuite.advancedAnalyticsInitializer(window, document, function () {});
            });
        };

        addServerDimensions = function () {
            var ref3;
            return OptimizeSuite.addCustomAnalyticsDimensions((ref3 = OptimizeSuite.config.advancedAnalytics) != null ? ref3.serverDimensions : void 0);
        };

        OptimizeSuite.addCustomAnalyticsDimension = addCustomAnalyticsDimension = function (key, value) {
            var eventName, ref3;
            if (!((ref3 = OptimizeSuite.config.advancedAnalytics) != null ? ref3.enabled : void 0)) {
                return;
            }
            if (advancedAnalyticsLoaded) {
                eventName = key + ":" + value;
                return OptimizeSuite.sendAdvancedAnalyticsEvent(eventName);
            } else {
                return dimensionsToSend[key] = value;
            }
        };

        OptimizeSuite.sendAdvancedAnalyticsEvent = sendAdvancedAnalyticsEvent = function (eventName) {
            return ClickTaleEvent(eventName);
        };

        OptimizeSuite.addCustomAnalyticsDimensions = addCustomAnalyticsDimensions = function (dimensionMap) {
            var key, results, value;
            results = [];
            for (key in dimensionMap) {
                value = dimensionMap[key];
                results.push(OptimizeSuite.addCustomAnalyticsDimension(key, value));
            }
            return results;
        };

        initDefaultAnalyticsDimensions = function () {
            return OptimizeSuite.addCustomAnalyticsDimensions({
                pageApp: TrackingHub.page.metadata.app,
                pageChannel: TrackingHub.page.metadata.channel,
                pageDivision: TrackingHub.page.metadata.division,
                pageType: TrackingHub.page.metadata.type,
                userPlatform: TrackingHub.user.platform,
                loggedIn: TrackingHub.user.loggedIn
            });
        };

        initGoogleAnalytics = function (trackingId) {
            var initializeGoogleAnalyticsBindings;
            initializeGoogleAnalyticsBindings = function () {
                OptimizeSuite.InteractionGoals.on("purchase", function (data) {
                    return gaSendPurchase(data);
                });
                return OptimizeSuite.InteractionGoals.on("subscription", function (data) {
                    return gaSendSubscription(data);
                });
            };
            return Finch.experiment("OptimizeSuiteGoogleAnalyticsPageTracking", {
                withoutGoogleAnalytics: function () {},
                withGoogleAnalytics: function () {
                    var injectSnippet;
                    injectSnippet = function () {
                        runGoogleAnalyticsSnippet();
                        ga('create', trackingId);
                        ga('require', 'ec');
                        ga('set', getAdditionalGAData());
                        ga('send', 'pageview');
                        return initializeGoogleAnalyticsBindings();
                    };
                    return $(window).on('load', injectSnippet);
                }
            });
        };

        initInteractionGoals = function (trackingHub, Warehouse, GlobalInteractionGoals) {
            OptimizeSuite.InteractionGoals = new GlobalInteractionGoals(trackingHub, new Warehouse('interaction-goals'));
            return OptimizeSuite.InteractionGoals.on("*", function (_, data) {
                data.experiments = trackingHub.session.get('experiments');
                data.clickId = trackingHub.page.data().parentEventId;
                return data.scid = trackingHub.user.scid;
            });
        };

        initReferral = function (arg) {
            var assignReferralParams, cookieDomain, domainMatches, emailPosition, getQueryValue, hasReferralParam, isReferred, querystring, referral, referralMap, referrer, referrerHost;
            referralMap = arg.referralMap, cookieDomain = arg.cookieDomain;
            referral = void 0;
            querystring = OptimizeSuite.getQueryString();
            referrer = OptimizeSuite.getReferrer();
            domainMatches = function (host) {
                var lengthDiff, thisDomain;
                thisDomain = cookieDomain.split('.');
                if (thisDomain[0] === '') {
                    thisDomain = thisDomain.slice(1);
                }
                host = host.split('.');
                if (host.length < thisDomain.length) {
                    return false;
                }
                lengthDiff = host.length - thisDomain.length;
                return _.isEqual(thisDomain, host.slice(lengthDiff));
            };
            isReferred = function (referralMap, referrerHost, currentHost) {
                if (hasReferralParam(referralMap)) {
                    return true;
                } else if (referrerHost === currentHost) {
                    return false;
                } else if (domainMatches(referrerHost)) {
                    return false;
                } else {
                    return true;
                }
            };
            getQueryValue = function (str, key) {
                var m;
                if (m = str.match(new RegExp("[\?&]" + key + "=([^&]+)", "i"))) {
                    return m[1];
                }
            };
            assignReferralParams = function (referral, referralMap) {
                var key, q, results, val;
                results = [];
                for (key in referralMap) {
                    val = referralMap[key];
                    if (q = getQueryValue(querystring, key)) {
                        results.push(referral[val] = q);
                    } else {
                        results.push(void 0);
                    }
                }
                return results;
            };
            hasReferralParam = function (referralMap) {
                var key, val;
                for (key in referralMap) {
                    val = referralMap[key];
                    if (getQueryValue(querystring, key)) {
                        return true;
                    }
                }
                return false;
            };
            if (referrer) {
                referrerHost = referrer.match(/:\/\/([^\/]+)/)[1];
                if (isReferred(referralMap, referrerHost, window.location.host)) {
                    if (referral == null) {
                        referral = {};
                    }
                    assignReferralParams(referral, referralMap);
                    if (referral.source == null) {
                        referral.source = 'general';
                    }
                    referral.url = referrer;
                }
            } else {
                if (referral == null) {
                    referral = {};
                }
                assignReferralParams(referral, referralMap);
                if (referral.source == null) {
                    referral.source = 'direct';
                }
            }
            if ((referral != null ? referral.medium : void 0) === 'email') {
                emailPosition = parseInt(getQueryValue(querystring, 'p'), 10);
                if (emailPosition) {
                    referral.emailPosition = emailPosition;
                }
            }
            return referral;
        };

        secureStorageNeeded = function () {
            return window.location.protocol === 'http:';
        };

        secureStorageConfig = function (config) {
            return {
                type: 'secure',
                url: "https://" + window.location.hostname + "/" + config.tracking.secureStoragePath
            };
        };

        initTrackingHub = function (config, sessionId) {
            var hubData;
            if (useParentTracking()) {
                OptimizeSuite.TrackingHub = parent.OptimizeSuite.TrackingHub;
                return window.TrackingHub = OptimizeSuite.TrackingHub;
            } else {
                hubData = {
                    seed: sessionId,
                    flushInterval: config.tracking.interval,
                    endpoint: config.tracking.endpoint,
                    session: config.session,
                    page: config.page,
                    user: config.user,
                    serverTrackingInitSent: config.serverTrackingInitSent
                };
                if (config.tracking.secureStorageEnabled && secureStorageNeeded()) {
                    hubData.storage = secureStorageConfig(config);
                }
                hubData.session.referral = initReferral(config);
                OptimizeSuite.TrackingHub.init(hubData);
                clearLastEventId();
                return setLastPageId(OptimizeSuite.TrackingHub.page.id);
            }
        };

        addTrackingHubListeners = function () {
            if (!useParentTracking()) {
                OptimizeSuite.TrackingHub.on("add", function (msg) {
                    return OptimizeSuite.Portal("tracking-hub").add("add", msg);
                });
                OptimizeSuite.TrackingHub.on("flush", function (messages) {
                    OptimizeSuite.TrackingHub.track(messages);
                    return OptimizeSuite.Portal("tracking-hub").add("flush", messages);
                });
                return OptimizeSuite.TrackingHub.on("error", function (error) {
                    if (!suppressErrors) {
                        throw error;
                    }
                });
            }
        };

        initBloodhound = function (config, sessionId) {
            var bloodhound;
            OptimizeSuite.Bloodhound.Helpers.seed = sessionId;
            bloodhound = OptimizeSuite.bloodhound = new OptimizeSuite.Bloodhound(config.bloodhound);
            bloodhound.on("event", function (event) {
                var d, data, i, len, ref3, ref4, w;
                data = {
                    type: "event",
                    event: {
                        id: event.id,
                        type: event.type,
                        widgets: []
                    }
                };
                if (event.meta) {
                    data.event.meta = event.meta;
                }
                ref3 = event.widgets;
                for (i = 0, len = ref3.length; i < len; i++) {
                    w = ref3[i];
                    d = w.data();
                    delete d.content;
                    data.event.widgets.push(d);
                }
                if (event.type === 'click') {
                    data.event.clickType = (ref4 = event.clickType) != null ? ref4 : null;
                    setLastEventId(event.id);
                }
                return OptimizeSuite.TrackingHub.add("bloodhound", data);
            });
            bloodhound.on("impression", function (widgets) {
                var data, i, len, w;
                data = {
                    type: "impression",
                    widgets: []
                };
                for (i = 0, len = widgets.length; i < len; i++) {
                    w = widgets[i];
                    data.widgets.push(w.data());
                }
                return OptimizeSuite.TrackingHub.add("bloodhound", data);
            });
            return bloodhound.on("error", function (e) {
                var data;
                data = {
                    type: "error",
                    error: {
                        message: e.message,
                        stack: e.stack
                    }
                };
                OptimizeSuite.TrackingHub.add("bloodhound", data);
                if (!suppressErrors) {
                    return setTimeout(function () {
                        throw new Error(e);
                    });
                }
            });
        };

        initInspectors = function () {
            var $elWarning, getInspectorsScript, getInspectorsStylesheet, inspectorsDomain, showGWallWarning;
            $elWarning = null;
            showGWallWarning = function () {
                var template;
                template = "<div>\n  <div class=\"notification warning\">\n    Optimize Inspectors must be authenticated with the GWall. Go\n    <a href=\"https://optimize-inspectors.groupondev.com/?r=" + (OptimizeSuite.getRandomHash()) + "\"\n     target=\"_blank\">here</a>, sign in, and then refresh this page.\n  </div>\n  <div class=\"notification info\">\n    requires 3rd party cookies enabled\n  </div>\n</div>";
                $elWarning = $(template).css({
                    position: "fixed",
                    "z-index": 1000,
                    border: "solid 5px #555",
                    background: "#555",
                    "max-width": "300px",
                    top: "10%",
                    left: "10%"
                });
                return domReady(function () {
                    if (!OptimizeSuite.inspectorsRunning) {
                        return $("body").append($elWarning);
                    }
                });
            };
            OptimizeSuite.removeGWallWarning = function () {
                OptimizeSuite.inspectorsRunning = true;
                return $elWarning.remove();
            };
            getInspectorsScript = function (inpectorsDomain) {
                return $.getScript(inspectorsDomain + "/optimize-inspectors-client.js");
            };
            getInspectorsStylesheet = function (inspectorsDomain) {
                return $('<link>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: inspectorsDomain + "/optimize-inspectors-client.css"
                }).appendTo('head');
            };
            showGWallWarning();
            inspectorsDomain = OptimizeSuite.config.inspectorsDomain || "https://optimize-inspectors.groupondev.com";
            getInspectorsScript(inspectorsDomain);
            return getInspectorsStylesheet(inspectorsDomain);
        };

        ensureSessionId = function (config) {
            var uuid;
            uuid = getCookie(config.session.cookieKey);
            if (!uuid) {
                uuid = getRandomUUID();
                setCookie(config.session.cookieKey, uuid, config.session.expiry, config.cookieDomain);
            }
            return config.session.id = uuid;
        };

        ensureBrowserId = function (config, uuid) {
            if (!getCookie("b")) {
                setCookie("b", uuid, 60 * 60 * 24 * 365 * 10, config.cookieDomain);
                return config.user.browserId = uuid;
            }
        };

        getRandomUUID = function () {
            var seed;
            seed = OptimizeSuite.getRandomHash();
            return (seed.slice(0, 8)) + "-" + (seed.slice(8, 12)) + "-" + (seed.slice(12, 16)) + "-" + (seed.slice(16, 20)) + "-" + (seed.slice(20));
        };

        OptimizeSuite.getRandomHash = function () {
            var $window, key;
            $window = $(window);
            key = ["", window.history.length, window.location.href, new Date().getTime(), $window.width(), $window.height(), navigator.userAgent, document.cookie, document.referrer].join("");
            return md5(key);
        };

        OptimizeSuite.log = {
            deprecation: function (message) {
                if ((typeof console !== "undefined" && console !== null ? console.warn : void 0) != null) {
                    return console.warn("Deprecation: " + message);
                }
            }
        };

        OptimizeSuite.bloodhoundWait = function () {
            return bloodhoundPaused = true;
        };

        OptimizeSuite.isBloodhoundPaused = function () {
            return bloodhoundPaused;
        };

        if (typeof module !== "undefined" && module.exports) {
            module.exports = OptimizeSuite;
        }

    }).call(this);
    /*!
     * domready (c) Dustin Diaz 2012 - License MIT
     */
    ! function (a, b) {
        typeof module != "undefined" ? module.exports = b() : typeof define == "function" && typeof define.amd == "object" ? define(b) : this[a] = b()
    }("domready", function (a) {
        function m(a) {
            l = 1;
            while (a = b.shift()) a()
        }
        var b = [],
            c, d = !1,
            e = document,
            f = e.documentElement,
            g = f.doScroll,
            h = "DOMContentLoaded",
            i = "addEventListener",
            j = "onreadystatechange",
            k = "readyState",
            l = /^loade|c/.test(e[k]);
        return e[i] && e[i](h, c = function () {
            e.removeEventListener(h, c, d), m()
        }, d), g && e.attachEvent(j, c = function () {
            /^c/.test(e[k]) && (e.detachEvent(j, c), m())
        }), a = g ? function (c) {
            self != top ? l ? c() : b.push(c) : function () {
                try {
                    f.doScroll("left")
                } catch (b) {
                    return setTimeout(function () {
                        a(c)
                    }, 50)
                }
                c()
            }()
        } : function (a) {
            l ? a() : b.push(a)
        }
    })
    OptimizeSuite.version = '1.50.0';
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],29:[function(require,module,exports){
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define === 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}.call(this));

},{}],30:[function(require,module,exports){
module.exports = function($) {
  if ($.inviewport) {
    return;
  }
  $.belowthefold = function(element, settings) {
    var fold;
    fold = $(window).height() + $(window).scrollTop();
    return fold <= $(element).offset().top - settings.threshold;
  };
  $.abovethetop = function(element, settings) {
    var top;
    top = $(window).scrollTop();
    return top >= $(element).offset().top + $(element).height() - settings.threshold;
  };
  $.rightofscreen = function(element, settings) {
    var fold;
    fold = $(window).width() + $(window).scrollLeft();
    return fold <= $(element).offset().left - settings.threshold;
  };
  $.leftofscreen = function(element, settings) {
    var left;
    left = $(window).scrollLeft();
    return left >= $(element).offset().left + $(element).width() - settings.threshold;
  };
  $.inviewport = function(element, settings) {
    return !$.rightofscreen(element, settings) && !$.leftofscreen(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
  };
  $.extend($.expr[':'], {
    "below-the-fold": function(a, i, m) {
      return $.belowthefold(a, {
        threshold: 0
      });
    },
    "above-the-top": function(a, i, m) {
      return $.abovethetop(a, {
        threshold: 0
      });
    },
    "left-of-screen": function(a, i, m) {
      return $.leftofscreen(a, {
        threshold: 0
      });
    },
    "right-of-screen": function(a, i, m) {
      return $.rightofscreen(a, {
        threshold: 0
      });
    },
    "in-viewport": function(a, i, m) {
      return $.inviewport(a, {
        threshold: 0
      });
    }
  });

  /*
   * jQuery function to retrieve all classes from a selector
   *
   * @mixin jQuery.fn.getClasses
   * @returns {Array} classlist
   *
   * @example
   * $(document.body).getClasses()
   */
  jQuery.fn.getClasses = function() {
    var ca, classlist;
    ca = this.attr('class');
    classlist = [];
    if (ca && ca.length && ca.split) {
      ca = jQuery.trim(ca);
      ca = ca.replace(/\s+/g, ' ');
      classlist = ca.split(' ');
    }
    return classlist;
  };
  return jQuery.fn.getEvents = function(n) {
    if (n == null) {
      n = 0;
    }
    return $._data($(this)[n], 'events');
  };
};



},{}],31:[function(require,module,exports){
module.exports = function($) {
  return $.fn.ready = (function(proceed) {
    return function(unsafe) {
      var safely;
      safely = function() {
        var e, err, msg;
        try {
          return unsafe.apply(this, arguments);
        } catch (error) {
          e = error;
          msg = 'Exception in a jQuery.ready callback: ';
          if (window.console && typeof console.error === 'function') {
            console.error(msg, e);
          } else {
            err = new Error(msg + e.message);
            err.original = e;
            setTimeout((function() {
              throw err;
            }), 0);
          }
        }
      };
      return proceed(safely);
    };
  })($.fn.ready);
};



},{}],32:[function(require,module,exports){
var perflibLoader;

module.exports = perflibLoader = function() {
  var externalObjectLoader, found, frame, frameId, frames, i, len, onloadScript, ref, url, w;
  onloadScript = function() {
    var defaultConfig, key, timer, w;
    w = window;
    if (w !== w.parent) {
      w = window.parent;
      window.BOOMR = w.BOOMR;
      window.Groupon = w.Groupon;
      window.OptimizeSuite = w.OptimizeSuite;
      window.applicationConfig = w.applicationConfig;
    }
    defaultConfig = {
      user_ip: BOOMR.utils.getCookie('b'),
      beacon_url: "/analytic/view.gif",
      BW: {
        enabled: false
      },
      DNS: {
        enabled: false
      },
      autorun: false
    };
    if (typeof applicationConfig !== "undefined" && applicationConfig !== null) {
      for (key in applicationConfig) {
        if (applicationConfig[key] != null) {
          defaultConfig[key] = applicationConfig[key];
        }
      }
    }
    BOOMR.init(defaultConfig);
    if (BOOMR.t_lstart != null) {
      BOOMR.addVar("t_lstart", BOOMR.t_lstart);
    }
    for (timer in BOOMR.gtimers) {
      BOOMR.addVar(timer, BOOMR.gtimers[timer]);
    }
    BOOMR.subscribe('before_beacon', function(performance) {
      var pageData, ref, ref1, ref2, ref3, ref4, ref5;
      if ((BOOMR.t_header != null) && (((ref = window.performance) != null ? (ref1 = ref.timing) != null ? ref1.requestStart : void 0 : void 0) != null)) {
        BOOMR.addVar('t_header', BOOMR.t_header - window.performance.timing.requestStart);
      }
      if (OptimizeSuite.TrackingHub.page != null) {
        pageData = OptimizeSuite.TrackingHub.page.data();
        BOOMR.addVar("page_channel", (ref2 = pageData.channel) != null ? ref2 : "");
        BOOMR.addVar("page_country", (ref3 = pageData.country) != null ? ref3 : "");
        BOOMR.addVar("page_division", (ref4 = pageData.division) != null ? ref4 : "");
        BOOMR.addVar("page_type", (ref5 = pageData.type) != null ? ref5 : "");
      }
      return OptimizeSuite.TrackingHub.add("performance", {
        performance: performance
      });
    });
    BOOMR.t_end = new Date().getTime();
    BOOMR.addVar("t_end", BOOMR.t_end);
    if (BOOMR.t_done != null) {
      BOOMR.plugins.RT.endTimer("t_done", BOOMR.t_done);
      return BOOMR.page_ready();
    }
  };
  externalObjectLoader = function(url, onloadScript, id) {
    var doc, dom, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = "javascript:false";
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; position: absolute';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      dom = document.domain;
      iframe.src = "javascript: var d = document.open();d.domain='" + dom + "';void(0);";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (dom != null) {
        this.domain = dom;
      }
      scriptInit = this.createElement("script");
      scriptInit.type = "text/javascript";
      scriptInit.text = "Groupon = window.parent.Groupon;$ = window.parent.$";
      this.body.appendChild(scriptInit);
      js = this.createElement("script");
      js.type = "text/javascript";
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  };
  w = window;
  if (w !== w.parent) {
    w = window.parent;
  }
  frames = w.frames;
  found = false;
  frameId = 'boomr-if-as';
  for (i = 0, len = frames.length; i < len; i++) {
    frame = frames[i];
    try {
      if ((frame != null ? frame.frames['boomr-if-as'] : void 0) != null) {
        found = true;
        break;
      }
    } catch (error1) {

    }
  }
  url = (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Performance) != null ? ref.boomerangUrl : void 0 : void 0) || '/layout/assets/boomerang-basic-custom-0_9_3.js';
  if (!found) {
    return externalObjectLoader(url, onloadScript, frameId);
  }
};



},{}],33:[function(require,module,exports){
var checkCurrentLocation, cllCookie, detectCurrentLocation, error, errorCallback, success, successCallback,
  slice = [].slice;

cllCookie = require('./m_location_helper').cllCookie;

successCallback = void 0;

errorCallback = void 0;


/*
 * HTML5 Geolocation API success callback
 *
 * @callback success
 * @param   {Object}   position        - Position information returned by Geolocation API
 * @returns {function} successCallBack - Callback to proceed in the search form submit
 */

success = function(position) {
  var lat, lng, ref;
  ref = position != null ? position.coords : void 0, lat = ref.latitude, lng = ref.longitude;
  Groupon.Utils.trackEvent('client-geolocate-successful', {
    lat: lat,
    lng: lng
  });
  setInterval(checkCurrentLocation, 1000 * 60 * 5);
  cllCookie.set(position);
  return typeof successCallback === "function" ? successCallback({
    lat: lat,
    lng: lng,
    current: true
  }) : void 0;
};


/*
 * HTML5 Geolocation API error callback
 *
 * @callback error
 * @param   {Object}   err           - Error object returned by Geolocation API
 * @returns {Function} errorCallback - Callback to exit search form submit
 */

error = function(err) {
  Groupon.Utils.trackEvent('client-geolocate-failed', err);
  cllCookie.remove(err);
  return typeof errorCallback === "function" ? errorCallback(err) : void 0;
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
 * @param {Function} [successCB]       - Callback for successful geolocation (Optional)
 * @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
 */

checkCurrentLocation = function(positionOptions, successCB, errorCB) {
  if (positionOptions == null) {
    positionOptions = {};
  }
  if (successCB == null) {
    successCB = cllCookie.set;
  }
  if (errorCB == null) {
    errorCB = cllCookie.remove;
  }
  if (positionOptions.maximumAge || positionOptions.timeout) {
    navigator.geolocation.getCurrentPosition(successCB, errorCB, positionOptions);
  } else {
    navigator.geolocation.getCurrentPosition(successCB, errorCB);
  }
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Function[]} arg                   - Splat of arguments containing success and error function
 * @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
 * @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
 */

detectCurrentLocation = function() {
  var arg, positionOptions, ref;
  arg = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  successCallback = arg[0], errorCallback = arg[1];
  if (!navigator.geolocation) {
    return typeof errorCallback === "function" ? errorCallback() : void 0;
  }
  positionOptions = ((ref = Groupon.LS.options) != null ? ref.geolocationOptions : void 0) || {};
  return checkCurrentLocation(positionOptions, success, error);
};

module.exports = {
  checkCurrentLocation: checkCurrentLocation,
  currentLocationSuccess: success,
  currentLocationError: error,
  detectCurrentLocation: detectCurrentLocation
};



},{"./m_location_helper":34}],34:[function(require,module,exports){
var Division, cllCookie, decodeAddress, geoStorageKey, getFullAddressFromSearchLocCookie, getGeolocationData, getInitialGeolocationAddress, getInitialLocation, getInitialLocationData, getSearchLocCookie, getTranslations, getUserSearchLocData, presentAddress, removeGeolocationData, setELLCookie, setGeolocationData, setSearchLocCookie, userFriendlyLocation,
  slice = [].slice;

getTranslations = require('./m_typeahead_helper').getTranslations;

geoStorageKey = 'LS_geolocation';

Division = (function(currentDivision) {
  return {
    get: function() {
      return currentDivision;
    },
    set: function(division) {
      return currentDivision = division;
    }
  };
})(null);


/*
 * Get decoded address
 *
 * @param   {String} [address] - Encoded address string
 * @returns {String}           - Key value or empty object
 */

decodeAddress = function(address) {
  if (address == null) {
    address = '';
  }
  return decodeURIComponent(address).replace(/\+/g, ' ');
};


/*
 * Retrieve geolocation data from localStorage
 *
 * @param   {String}        [key] - Key name (optional)
 * @returns {String|Object} data  - Geodata object or specific data
 */

getGeolocationData = function(key) {
  var data, ref;
  try {
    if ((data = (ref = window.localStorage) != null ? ref.getItem(geoStorageKey) : void 0) != null) {
      data = JSON.parse(data);
      if (typeof key === 'string') {
        data = data[key];
      }
    }
  } catch (error) {}
  return data || {};
};


/*
 * Retrieve location name from various sources
 *
 * @returns {String} location - Location name or empty string
 */

getInitialLocation = function() {
  var division, divisionData, location;
  divisionData = Division != null ? Division.get() : void 0;
  division = divisionData != null ? divisionData.id : void 0;
  if ((location = getInitialGeolocationAddress(division))) {
    return location;
  }
  if ((location = getFullAddressFromSearchLocCookie())) {
    return location;
  }
  if ((location = userFriendlyLocation(divisionData))) {
    return location;
  }
  return '';
};


/*
 * Get location data
 *
 * @returns {Object} latLong - Location object
 */

getInitialLocationData = function() {
  var geoData, grab, latLong, locationData, queryParams;
  grab = function() {
    var data, i, j, len, properties, source, sources;
    sources = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), properties = arguments[i++];
    for (j = 0, len = sources.length; j < len; j++) {
      source = sources[j];
      data = _.pick(source || {}, properties);
      if (!_.isEmpty(data)) {
        break;
      }
    }
    return data;
  };
  queryParams = Groupon.Utils.unparam();
  locationData = getUserSearchLocData();
  latLong = grab(queryParams, locationData, Division.get(), ['lat', 'lng']);
  geoData = grab(queryParams, locationData, ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  return latLong = _.extend(latLong, geoData);
};


/*
 * Get "search_loc" cookie data
 *
 * @returns {Object} - search_loc - Search_loc data
 */

getSearchLocCookie = function() {
  var e, payload, search_loc;
  search_loc = {};
  if ((payload = Cookie.get('search_loc')) != null) {
    try {
      search_loc = JSON.parse(decodeURIComponent(payload));
    } catch (error) {
      e = error;
      try {
        search_loc = decodeURIComponent(JSON.parse(payload));
      } catch (error) {}
    }
  }
  return search_loc;
};


/*
 * Retrieve address from "search_loc" cookie
 *
 * @returns {String} - Address or empty string
 */

getFullAddressFromSearchLocCookie = function() {
  var friendlyName, fullAddress, ref;
  ref = getSearchLocCookie(), fullAddress = ref.fullAddress, friendlyName = ref.friendlyName;
  return decodeAddress(fullAddress) || decodeAddress(friendlyName);
};


/*
 * Retrieve data from "search_loc" cookie
 *
 * @returns {Object} - Relevant location data
 */

getUserSearchLocData = function() {
  var search_loc;
  search_loc = getSearchLocCookie();
  return _.pick(search_loc, ['lat', 'lng', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
};


/*
 * Returns current location label if division match current location division
 *
 * @param   {String} division - Division from itier division data
 * @returns {String} label    - Current location label or undefined
 */

getInitialGeolocationAddress = function(division) {
  var label, ref;
  label = '';
  if (division && division === getGeolocationData('current_location')['closestDivision']) {
    label = (ref = getTranslations('search')) != null ? ref.nearme : void 0;
  }
  return label;
};


/*
 * Changes address to remove duplicate address sections and country "USA"
 *
 * @param   {String} address - Address returned by Google Maps
 * @returns {String}         - Formatted address
 */

presentAddress = function(address) {
  var splitAddress;
  address = address.replace(/, USA$/, '');
  splitAddress = address.split(', ');
  return _.uniq(splitAddress, true).join(', ');
};


/*
 * Removes geolocation key from localStorage / cookie
 *
 * @param {String} key - LocalStorage key name
 */

removeGeolocationData = function(key) {
  var data, ref;
  if (key != null) {
    data = getGeolocationData();
    delete data[key];
    data = JSON.stringify(data);
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, data);
      }
    } catch (error) {
      Cookie.set(geoStorageKey, encodeURIComponent(data));
    }
  }
};


/*
 * LS-2274 Set new location cookie "ell"
 *
 * @param {String} data - String contain <lat>,<lng>
 */

setELLCookie = function(data) {
  Cookie.set('ell', data);
};


/*
 * LS-2273 current location cookie "cll"
 */

cllCookie = {

  /*
   * LS-2273 Set new current location cookie "cll"
   *
   * @param {Object} location - Object containing coordinates
   */
  set: function(location) {
    var lat, lng, ref;
    if (!(location != null ? location.coords : void 0)) {
      return;
    }
    ref = location.coords, lat = ref.latitude, lng = ref.longitude;
    Cookie.set('cll', lat + ',' + lng);
  },

  /*
   * LS-2273 remove current location cookie "cll"
   */
  remove: function() {
    return Cookie.unset('cll');
  }
};


/*
 * Sets geolocation key/value pair to localStorage / cookie
 *
 * @param {String} key   - LocalStorage key name
 * @param {String} value - Value to be set
 */

setGeolocationData = function(key, value) {
  var data, ref;
  if ((key != null) && (value != null)) {
    data = getGeolocationData();
    data[key] = value;
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, JSON.stringify(data));
      }
    } catch (error) {}
  }
};


/*
 * Sets "search_loc" cookie storing various data gathered from Gmaps and API responses
 *
 * @param {Object} data - Location data object
 */

setSearchLocCookie = function(data) {
  data = _.pick(data, ['lat', 'lng', 'closestDivision', 'friendlyName', 'fullAddress', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  Cookie.set('search_loc', encodeURIComponent(JSON.stringify(data)));
};


/*
 * Returns Division Name
 *
 * @param   {Object} division - Division from itier division data
 * @returns {String} name     - Division name
 */

userFriendlyLocation = function(division) {
  var abbreviation, name, state;
  if (!(division != null ? division.name : void 0)) {
    return '';
  }
  name = division.name, state = division.state;
  if (abbreviation = state != null ? state.abbreviation : void 0) {
    name = name + ", " + abbreviation;
  }
  return name;
};

module.exports = {
  cllCookie: cllCookie,
  decodeAddress: decodeAddress,
  getDivision: Division.get,
  getGeolocationData: getGeolocationData,
  getFullAddressFromSearchLocCookie: getFullAddressFromSearchLocCookie,
  getInitialGeolocationAddress: getInitialGeolocationAddress,
  getInitialLocation: getInitialLocation,
  getInitialLocationData: getInitialLocationData,
  getSearchLocCookie: getSearchLocCookie,
  getUserSearchLocData: getUserSearchLocData,
  presentAddress: presentAddress,
  removeGeolocationData: removeGeolocationData,
  setELLCookie: setELLCookie,
  setDivision: Division.set,
  setGeolocationData: setGeolocationData,
  setSearchLocCookie: setSearchLocCookie,
  userFriendlyLocation: userFriendlyLocation
};



},{"./m_typeahead_helper":36}],35:[function(require,module,exports){
var escapeRegExp, initRegExp, normalizeQuery, regexp, replacements;

escapeRegExp = require('../../../../../core/frontend/common/underscore_mixins').escapeRegExp;

regexp = replacements = null;

initRegExp = function() {
  var char, charMap, dest, i, key, len, len1, src, val;
  charMap = window.Groupon.LS.data.charMapping || {};
  replacements = {};
  regexp = '';
  val = _.values(charMap);
  key = _.keys(charMap);
  regexp = new RegExp('[' + escapeRegExp(val.join('')) + ']', 'g');
  len = val.length;
  while (len--) {
    src = val.pop();
    dest = key.pop();
    for (i = 0, len1 = src.length; i < len1; i++) {
      char = src[i];
      replacements[char] = dest;
    }
  }
  return regexp;
};

module.exports = normalizeQuery = function(s) {
  if (typeof s !== 'string') {
    return '';
  }
  s = s.trim().replace(regexp || initRegExp(), function(c) {
    return replacements[c];
  });
  return s.toLowerCase();
};



},{"../../../../../core/frontend/common/underscore_mixins":2}],36:[function(require,module,exports){
var RecentLocations, RecentSearches, allTranslations, createBloodhoundTag, deEmphasis, getAutocompleteList, getHeadingPartial, getRecentSearches, getSubCategoryCollection, getTranslations, matchListItem, moveAutocomplete, normalizeQuery, partialAutocompleteList, partialCurrentLocation, partialLocationHelper, partialRecentSearchesList, partialSearchCategories, partialSearchCategoryList, prepareBloodhoundTag, removeRecentSearch, removeRecentSearches, saveRecentSearch, setRecentSearches, setTranslations, templateAttributesForSubcategories, toCamelCase,
  slice = [].slice;

normalizeQuery = require('./m_normalizeQuery');

toCamelCase = require('../../../../../src/helpers/camelCase').toCamelCase;


/*
 * @type {Object} allTranslations Global closure to cache translations
 */

allTranslations = {};


/*
 * @type {Array} RecentSearches Global closure to cache recent searches terms
 */

RecentSearches = [];


/*
 * @type {Array} RecentLocations Global closure to cache recent location searches
 */

RecentLocations = [];


/*
 * Injects html tags to separate the neighborhood and the city
 *
 * @param   {String} label - Location with strong tags
 * @returns {String}
 */

deEmphasis = function(label) {
  var res;
  res = label.split(/,(.+)?/);
  if (res.length < 2) {
    return label;
  }
  if (res[0].includes('</strong>') || res[1].includes('<strong>')) {
    res.splice(1, 0, '<em>');
  } else {
    res.splice(1, 0, '</strong><em><strong>');
  }
  res.splice(3, 0, '</em>');
  return res.join('');
};


/*
 * Generate basic bloodhound tag name
 *
 * @param   {String} [type]     - Name of the api / collection name
 * @param   {String} attributes
 * @returns {String} bhw        - Base bloodhound tag
 */

createBloodhoundTag = function(type) {
  var bhw;
  if (type == null) {
    type = '';
  }
  type = type.split('|').map(function(i) {
    return toCamelCase(i);
  }).join('');
  bhw = "TouchSearchCategory" + type;
  return bhw;
};


/*
 * Method to build general (deal|location) autocomplete partial
 *
 * @param   {Array}  collections           - List of items returned from autocomplete
 * @param   {String} normQuery             - Normalized term entered by user
 * @param   {Number} [indexShift]          - Shift the index e.g due to previously processed collection
 * @returns {Object} {list, index, prefix}
 */

partialAutocompleteList = function(collections, normQuery, indexShift) {
  var index, item, label, lat, len, list, lng, locationPartial, n, queryLength, template, value;
  if (indexShift == null) {
    indexShift = 0;
  }
  queryLength = normQuery.length + 2;
  len = collections.length - 1;
  index = -1;
  list = [];
  locationPartial = '';
  while (item = collections.shift()) {
    lat = item.lat, lng = item.lng, label = item.label, value = item.value;
    if (lat) {
      locationPartial = " data-lat='" + lat + "' data-lng='" + lng + "'";
      if (item.neighborhood) {
        label = deEmphasis(label);
      }
    }
    n = len - collections.length;
    if (queryLength >= value.length && normQuery === normalizeQuery(value)) {
      index = n + indexShift;
    }
    template = "<li role='listitem' class='tw-item'>\n<a class='tw-link' id='tw" + n + "' tabindex='0' data-bhc='result-" + n + ":" + value + "' data-value='" + value + "'" + locationPartial + ">" + label + "</a>\n</li>";
    list.push(template);
  }
  return {
    list: list,
    index: index,
    prefix: 'tw'
  };
};


/*
 * LS-2211 current location / geolocation
 * Adds geolocation partial and handles matching
 *
 * @param   {String} widget         - Widget name
 * @param   {String} normQuery      - Normalized term user entered
 * @param   {Number} index          - Matched item index
 * @returns {Object} {list, index}
 */

partialCurrentLocation = function(widget, normQuery, index) {
  var list, normLabel, template, translations;
  translations = getTranslations();
  normLabel = normalizeQuery(translations.search.currentlocation);
  template = "<li role='listitem'>\n<a class='current-location icon-compass-needle tw-link' tabindex='0' data-value='" + translations.search.currentlocation + "' data-bhw='" + widget + "'>" + translations.search.currentlocation + "</a>\n</li>";
  list = [template];
  if (index > -1) {
    index = index + 1;
  }
  if (normQuery === normLabel) {
    index = index + 1;
  }
  return {
    list: list,
    index: index
  };
};


/*
 * LS-2685 Location Helper message
 * Adds message to help users when searching locations
 *
 * @returns {Array}
 */

partialLocationHelper = function() {
  var template, text, translations;
  translations = getTranslations();
  text = translations.search.helpermsg;
  template = "<li role='listitem'>\n<span class='tw-msg ls-location-helper'><span class=\"new-badge\">NEW</span>" + text + "</span>\n</li>";
  return [template];
};


/*
 * Adds recent searches partial
 *
 * @param   {String} widget         - Widget name
 * @param   {Array}  collection     - List of items to build recent searches widget
 * @param   {Object} [config]       - Configuration containing experiments settings, etc. (Optional)
 * @returns {Object} {list, prefix}
 */

partialRecentSearchesList = function(widget, collection, config) {
  var address, bhc, clearingHeadingPartial, clearingPartial, ctx, division, hasClearingExperiment, item, lat, list, lng, n, ref, template, text, translations;
  if (config == null) {
    config = {};
  }
  translations = getTranslations();
  list = [];
  text = '';
  n = 0;
  clearingPartial = '';
  clearingHeadingPartial = '';
  if ((hasClearingExperiment = (ref = config.experiments) != null ? ref['LS-1744-clear-recent-searches'] : void 0) && (hasClearingExperiment != null ? hasClearingExperiment.setClearX : void 0)) {
    clearingPartial = "<span class='tw-clear icon-x' tabindex='0' aria-label='" + translations.ax.remove + "'></span>";
  }
  switch (widget) {
    case 'recentSearches':
      text = translations.search.recentdeals;
      ctx = 'deal';
      while (item = collection.shift()) {
        bhc = prepareBloodhoundTag(item);
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-value='" + item + "'>" + item + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
      break;
    case 'recentLocations':
      text = translations.search.recentlocations;
      ctx = 'location';
      while (item = collection.shift()) {
        lat = item.lat, lng = item.lng, address = item.address, division = item.division;
        bhc = prepareBloodhoundTag(address);
        division = division ? "data-division='" + division + "'" : '';
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-lat='" + lat + "' data-lng='" + lng + "' data-value='" + address + "' " + division + ">" + address + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
  }
  if (list.length) {
    if (hasClearingExperiment && (hasClearingExperiment != null ? hasClearingExperiment.setClearAll : void 0)) {
      clearingHeadingPartial = "<span class='tw-clear' ctx='" + ctx + "'>" + translations.search.clearall + "</span>";
    }
    list.unshift("<li class='tw-heading tw-recent'>" + text + clearingHeadingPartial + "</li>");
  }
  return {
    list: list,
    prefix: 'twr'
  };
};


/*
 * Build L1 Category header partial
 *
 * @param   {String}  type           - category type
 * @returns {String}  partial        - HTML partial containing L0 category heading
 */

getHeadingPartial = function(type) {
  var partial, translations, txt;
  translations = getTranslations();
  partial = '';
  txt = translations != null ? translations.categories[type] : void 0;
  return partial = txt ? "<div class='tw-heading tw-" + type + "'>" + txt + "</div>" : '';
};

templateAttributesForSubcategories = function() {
  var args, ariaAttributes, ariaListAttributes, bhw, catInfo, htmlCloseTag, htmlOpenTag, id, menuID, prefix, sectionID;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  id = args[0], sectionID = args[1], prefix = args[2], bhw = args[3];
  htmlOpenTag = 'span class="icon-plus tw-caption"';
  htmlCloseTag = 'span';
  menuID = prefix + "tw-" + id + "-menu";
  ariaAttributes = " role='link' aria-controls='" + menuID + "' aria-owns='" + menuID + "' aria-haspopup='true' ";
  catInfo = " cat='" + id + "' cat-path='" + sectionID + "|" + id + "'";
  ariaListAttributes = ' aria-live="polite"';
  return [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo];
};


/*
 * Build Category partial
 *
 * @param   {Array}   collection - List of items
 * @param   {String}  sectionID  - category section name
 * @param   {Number}  [level]    - Optional parameter representing the taxonomy
 * @param   {Number}  [prefix]   - Optional prefix for id generation
 * @returns {String}             - HTML String
 */

partialSearchCategoryList = function(collection, sectionID, level, prefix) {
  var ariaAttributes, ariaListAttributes, attributes, baseBHW, baseObject, baseUrl, bhw, catInfo, count, countString, friendlyName, htmlCloseTag, htmlOpenTag, id, item, list, menuID, newBadge, newBadgeTag, newBadgeTxt, subcategories, template, url;
  if (level == null) {
    level = 1;
  }
  if (prefix == null) {
    prefix = '';
  }
  if (!(collection != null ? collection.length : void 0)) {
    return '';
  }
  list = [];
  url = '';
  baseBHW = createBloodhoundTag(sectionID);
  baseObject = collection.shift();
  baseUrl = baseObject.baseUrl;
  if (!baseUrl) {
    baseUrl = false;
    collection.unshift(baseObject);
  }
  while (item = collection.shift()) {

    /*
     * item can be either of type "Array" or "Object"
     * API facets are normally mapped as arrays
     * while config or constructed entries (all deals) ar
     * mapped as object.
     */
    if (Array.isArray(item)) {
      if (!baseUrl) {
        continue;
      }
      id = item[0], friendlyName = item[1], count = item[2], subcategories = item[3];
      url = baseUrl + id;
    } else {
      id = item.i, friendlyName = item.n, count = item.c, subcategories = item.s, url = item.u, newBadge = item.newBadge;
    }
    ariaAttributes = ariaListAttributes = catInfo = newBadgeTag = '';
    countString = count ? " <span class='tw-count'>(" + count + ")</span>" : '';
    bhw = id ? baseBHW + toCamelCase(id) : baseBHW + 'AllDeal';
    if (newBadge && (newBadgeTxt = allTranslations.general.newbadge)) {
      newBadgeTag = "<span class='new-badge'>" + newBadgeTxt + "</span>";
    }
    if (subcategories != null ? subcategories.length : void 0) {
      attributes = templateAttributesForSubcategories(id, sectionID, prefix, bhw);
      htmlOpenTag = attributes[0], htmlCloseTag = attributes[1], ariaAttributes = attributes[2], ariaListAttributes = attributes[3], catInfo = attributes[4];
    } else {
      url = url ? "href='" + url + "' " : '';
      htmlOpenTag = "a " + url + "class='tw-link'";
      htmlCloseTag = 'a';
    }
    template = "<li class='tw-item tw-cat-item tw-cat-L" + level + "'" + ariaListAttributes + ">\n<" + htmlOpenTag + " data-bhw='" + bhw + "' " + catInfo + " " + ariaAttributes + ">" + newBadgeTag + friendlyName + countString + "</" + htmlCloseTag + ">\n</li>";
    list.push(template);
  }
  if (list.length) {
    menuID = sectionID.split('|').pop();
    list.unshift("<ul id='" + prefix + "tw-" + menuID + "-menu' class='tw-cat-menu tw-cat-menu-L" + level + "'>");
    list.push("</ul>");
  }
  return list.join('');
};


/*
 * Build Category lists and wrap them
 *
 * @param   {Array}   collections    - List of items
 * @param   {Array}   [prefix]       - Prefix for id generation (Optional)
 * @param   {Boolean} [m2016]        - Mobile2016 flag (Optional)
 * @returns {Object}  {list[]}       - List of categories
 */

partialSearchCategories = function(collections, prefix, m2016) {
  var collection, heading, item, listItems, type;
  if (prefix == null) {
    prefix = '';
  }
  if (m2016 == null) {
    m2016 = true;
  }
  item = collections[0];
  listItems = [];
  for (type in item) {
    collection = item[type];
    if (collection != null ? collection.length : void 0) {
      heading = getHeadingPartial(type);
      listItems.push("<li id='" + prefix + "tw-" + type + "' class='tw-category'>" + heading);
      listItems.push(partialSearchCategoryList(collection.slice(0), type, 1, prefix, m2016));
      listItems.push("</li>");
    }
  }
  return {
    list: listItems
  };
};


/*
 * Global method to generate the autocomplete list
 *
 * @param   {Array}  collections               - List of collections to process
 * @param   {String} query                     - Term entered by user
 * @param   {Object} [config]                  - Config object
 * @returns {Object} {list, index, bh, prefix}
 */

getAutocompleteList = function(collections, query, config) {
  var bh, data, finalList, index, indexShift, j, len1, list, normQuery, prefix, ref, ref1, ref2, ref3, ref4, ref5, tempList, widget;
  if (config == null) {
    config = {};
  }
  tempList = [];
  index = -1;
  indexShift = 0;
  prefix = '';
  normQuery = normalizeQuery(query);
  for (j = 0, len1 = collections.length; j < len1; j++) {
    ref = collections[j], data = ref.collection, widget = ref.widget;
    switch (widget) {
      case 'autocomplete':
        if (query) {
          ref1 = partialAutocompleteList(data, normQuery, indexShift), list = ref1.list, index = ref1.index, prefix = ref1.prefix;
        }
        break;
      case 'helperMessage':
        list = partialLocationHelper();
        break;
      case 'geolocation':
        ref2 = partialCurrentLocation(widget, normQuery, index), list = ref2.list, index = ref2.index;
        indexShift += list.length;
        break;
      case 'recentLocations':
        ref3 = partialRecentSearchesList(widget, data, config), list = ref3.list, prefix = ref3.prefix;
        break;
      case 'recentSearches':
        ref4 = partialRecentSearchesList(widget, data, config), list = ref4.list, prefix = ref4.prefix;
        break;
      case 'searchCategories':
        list = partialSearchCategories(data).list;
    }
    tempList.push.apply(tempList, list);
  }
  bh = widget === 'autocomplete' ? {
    type: 'bhc',
    val: "UserTyped:" + query
  } : {
    type: 'bhw',
    val: toCamelCase(widget)
  };
  ref5 = matchListItem(tempList, index), finalList = ref5.list, index = ref5.index;
  return {
    list: finalList,
    index: index,
    bh: bh,
    prefix: prefix
  };
};


/*
 * Get translations
 *
 * @param   {String} [key]
 * @returns {Object} translations - All translations or partial
 */

getTranslations = function(key) {
  var ref, translations;
  if (!Object.keys(allTranslations).length) {
    setTranslations((ref = Groupon.LS) != null ? ref.translations : void 0);
  }
  translations = typeof key === 'string' ? allTranslations[key] : allTranslations;
  return translations || {};
};


/*
 * Returns list of recent searches queries retrieved from localStorage
 *
 * param    {String} - Input type
 * @returns {Array}  - list
 */

getRecentSearches = function(type) {
  var list, ref, ref1;
  if (type == null) {
    type = 'deal';
  }
  list = [];
  try {
    switch (type) {
      case 'deal':
        list = JSON.parse(((ref = window.localStorage) != null ? ref.getItem('LS_recentSearches') : void 0) || '[]');
        break;
      case 'location':
        list = JSON.parse(((ref1 = window.localStorage) != null ? ref1.getItem('LS_recentLocations') : void 0) || '[]');
    }
  } catch (error) {}
  return list;
};


/*
 * Sets matching classes to list item when match indicated
 *
 * @param   {Array}  list          - List of items
 * @param   {Number} index         - Index of the item in the list that matched query
 * @returns {Object} {list, index}
 */

matchListItem = function(list, index) {
  var partial;
  if (index > -1) {
    partial = "<a class='typeahead-match typeahead-match-highlight";
    if (list[index].match(/<a class='/)) {
      list[index] = list[index].replace(/<a class='/, partial + " ");
    } else {
      list[index] = list[index].replace(/<a/, partial + "'");
    }
  }
  return {
    list: list,
    index: index
  };
};


/*
 * Move typeahead container into its context.
 * This is only needed for desktop
 *
 * @param {Object} $container - Selector for typeahead wrapper
 * @param {String} ctx        - Typeahead context
 * @param {String} env        - Environment
 */

moveAutocomplete = function($container, ctx, env) {
  var selector;
  if (env === 'desktop') {
    switch (ctx) {
      case 'search':
        selector = '.deal-search';
        break;
      case 'location':
        selector = '.location-search';
    }
    $(selector).append($container);
  }
};


/*
 * Returns Bloodhound tag name
 *
 * @param   {String|Object} value
 * @returns {String}        tag
 */

prepareBloodhoundTag = function(value) {
  var address, division, tag;
  tag = '';
  if (!value) {
    return tag;
  }
  if (typeof value === 'string') {
    tag = value;
  }
  if (typeof value === 'object') {
    division = value.division, address = value.address;
    tag = address || division;
  }
  if (typeof tag === 'string') {
    tag = tag.toLowerCase().replace(/[^\w\d]+/g, '_');
  }
  return tag;
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term   - Deal query entered by user
 * @param {String} [type] - input type (Optional)
 */

removeRecentSearch = function(term, type) {
  var index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  keywords = getRecentSearches(type) || [];
  term = _.escape(term).trim().toLowerCase();
  switch (type) {
    case 'deal':
      index = keywords.findIndex(function(n) {
        return n.toLowerCase() === term;
      });
      break;
    case 'location':
      index = keywords.findIndex(function(n) {
        var ref;
        return ((ref = n.address) != null ? ref.toLowerCase() : void 0) === term;
      });
  }
  if (index > -1) {
    keywords.splice(index, 1);
  }
  setRecentSearches(keywords, type);
};


/*
 * Helper function to remove stored searches
 *
 * @param {String} type - Input type
 */

removeRecentSearches = function(type) {
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  switch (type) {
    case 'deal':
      window.localStorage.removeItem('LS_recentSearches');
      RecentSearches = [];
      break;
    case 'location':
      window.localStorage.removeItem('LS_recentLocations');
      RecentLocations = [];
  }
};


/*
 * Saves recent searches array as string in localStorage
 *
 * @param {Array}  keywords - List of keywords searched by user
 * @param {String} type     - input type
 */

setRecentSearches = function(keywords, type) {
  var key, ref;
  switch (type) {
    case 'deal':
      key = 'LS_recentSearches';
      break;
    case 'location':
      key = 'LS_recentLocations';
  }
  try {
    return (ref = window.localStorage) != null ? ref.setItem(key, JSON.stringify(keywords)) : void 0;
  } catch (error) {}
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term - Deal query entered by user
 * @param {String} type - input type (Optional)
 * @param {String} env  - Environment. Controls amount of items (Optional)
 */

saveRecentSearch = function(term, type, env) {
  var amount, index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (env == null) {
    env = 'desktop';
  }
  amount = type === 'deal' && env === 'mobile' ? 5 : 10;
  keywords = getRecentSearches(type) || [];
  switch (typeof term) {
    case 'string':
      term = _.escape(term).trim().toLowerCase();
      if (term === '') {
        return;
      }
      index = keywords.findIndex(function(n) {
        return n === term;
      });
      break;
    case 'object':
      index = keywords.findIndex(function(n) {
        return n.address === term.address;
      });
  }
  if (index > -1) {
    keywords.move(index, 0);
  } else {
    keywords.unshift(term);
  }
  setRecentSearches(keywords.slice(0, amount), type);
};


/*
 * Cache translations globally and make immutable
 *
 * @param   {Object} [translations]
 * @returns {Object} allTranslations
 */

setTranslations = function(translations) {
  if (translations == null) {
    translations = typeof Groupon !== "undefined" && Groupon !== null ? Groupon.LS.translations : void 0;
  }
  return allTranslations = Object.seal(translations);
};


/*
 * Get subcategory collection and its taxonomy level
 *
 * @param   {Array}                            collections
 * @param   {Array}                            path
 * @param   {Number}                           [level] - Taxonomy level
 * @returns {{collection.Array, level.Number}}
 */

getSubCategoryCollection = function(collections, path, level) {
  var collection, findSubCategory, id, temp;
  if (level == null) {
    level = 1;
  }
  collection = collections;
  id = void 0;

  /*
   * Condition to find matching item with categories
   * Checks if ID (i) matches and if subcategories (s) exists
   *
   * @param   {Object} item  - Array item
   * @returns {Boolean}      - Condition being passed to Array.prototype.find() to return object
   */
  findSubCategory = function(item) {
    var ref;
    return item[0] === id && ((ref = item[3]) != null ? ref.length : void 0);
  };

  /*
   * NOTE: This might be more efficient with Array::reduce
  
    findSubCategory = (item) ->
      if item[0] is id and item[3]?.length
        return item[3]
    level++ if (collection = collection.reduce(findSubCategory))
   */
  while (id = path.shift()) {
    if (temp = collection.find(findSubCategory)) {
      collection = temp[3].slice(0);
      level++;
    }
  }
  return {
    collection: collection,
    level: level
  };
};

module.exports = {
  createBloodhoundTag: createBloodhoundTag,
  getAutocompleteList: getAutocompleteList,
  getHeadingPartial: getHeadingPartial,
  getRecentSearches: getRecentSearches,
  getSubCategoryCollection: getSubCategoryCollection,
  getTranslations: getTranslations,
  deEmphasis: deEmphasis,
  matchListItem: matchListItem,
  moveAutocomplete: moveAutocomplete,
  partialAutocompleteList: partialAutocompleteList,
  partialCurrentLocation: partialCurrentLocation,
  partialLocationHelper: partialLocationHelper,
  partialRecentSearchesList: partialRecentSearchesList,
  partialSearchCategories: partialSearchCategories,
  partialSearchCategoryList: partialSearchCategoryList,
  prepareBloodhoundTag: prepareBloodhoundTag,
  removeRecentSearch: removeRecentSearch,
  removeRecentSearches: removeRecentSearches,
  saveRecentSearch: saveRecentSearch,
  setRecentSearches: setRecentSearches,
  setTranslations: setTranslations,
  templateAttributesForSubcategories: templateAttributesForSubcategories
};



},{"../../../../../src/helpers/camelCase":40,"./m_normalizeQuery":35}],37:[function(require,module,exports){
module.exports = Cookie = {
  build: function() {
    var parts = Array.prototype.slice.apply(arguments);
    for(var i = 0; i < parts.length; i++) {
      if(!parts[i])
        parts.splice(i, 1);
    }
    return parts.join("; ");
  },
  secondsFromNow: function(seconds) {
    var d = new Date();
    d.setTime(d.getTime() + (seconds * 1000));
    return d.toGMTString();
  },

  // This weird encoding/decoding of cookie values is due to the way
  // Rack::Utils#escape handles cookie serialization. In order to
  // stay consistent with how rack will serialize cookies, we
  // are performing it on the client side.
  //
  set: function(name,value,seconds, domain){
    var cookieExpiry = this._getExpiry(seconds),
        cookieDomain = this._getDomain(domain);

    if (typeof value === "string") {
      value = value.replace(/\s/g, '+');
    }
    document.cookie = Cookie.build(name + "=" + encodeURIComponent(value), cookieExpiry, "path=/", cookieDomain);
  },
  get: function(name){
    var valueMatch = new RegExp("(?:^|;(?:\\s*))" + name + "=([^;]+)").exec(document.cookie);
    var value = valueMatch ? valueMatch[1] : null;
    return value !== null ? decodeURIComponent(value).replace(/\+/g, ' ') : null;
  },

  unset: function(name, domain){
    Cookie.set(name, '', -1, domain);
  },

  _getExpiry: function(seconds, domain) {
    return seconds ? 'expires=' + Cookie.secondsFromNow(seconds) : null;
  },
  _getDomain: function(domain) {
    return domain ? 'domain=' + domain : null;
  }
};

},{}],38:[function(require,module,exports){
/*
 eventPause.js v 1.0.1
 Author: sudhanshu yadav
 https://github.com/s-yadav/eventPause.js
 Copyright (c) 2013 - 2015 Sudhanshu Yadav.
 Dual licensed under the MIT and GPL licenses
 */
;
(function ($, window, document, undefined) {
  $.fn.eventPause = function (method, events) {
    initialize();
    //check if method is defined
    if (!methods[method] && (events == null)) {
      events = method;
    }
    events = structureEvent(events);
    if (methods[method]) {
      return methods[method].call(this, events);
    } else {
      return methods.pause.call(this, events);
    }
  };

  var methods = {
    pause: function (events) {
      return this.each(function () {
        if (!$(this).data('iw-disable')) {
          $(this).data('iw-eventactive', false);
          $._iwEventPause['assigned'].push(this);
          pauseEvent(this, events);
        }
      });
    },
    active: function (events) {
      return this.each(function () {
        if (!$(this).data('iw-disable')) {
          $(this).data('iw-eventactive', true);
          $._iwEventPause['assigned'].splice(this);
          activeEvent(this, events);
        }
      });
    },
    pauseChild: function (events) {
      return methods['pause'].call(this.add(this.find('*')), events);
    },
    activeChild: function (events) {
      return methods['active'].call(this.add(this.find('*')), events);
    },
    enable: function () {
      //to enable pausing and unpausing temperorly
      this.data('iw-disable', false);
    },
    disable: function () {
      //to disable pausing and unpausing temperorly
      this.data('iw-disable', true);
    },
    toggle: function (events) {
      var status = this.data('iw-eventactive');
      if (status) {
        return methods['active'].call(this, events);
      }
      else {
        return methods['pause'].call(this, events);
      }
    },
    state: function () {
      var disable = this.data('iw-disable') ? 'disabled' : 'enabled',
          active = this.data('iw-eventactive') == false ? 'paused' : 'active';
      return active + '-' + disable;
    }
  }

  //globalMethod
  $.eventPause = {
    activeAll: function () {
      loop('active');
    },
    //this will enable disable all pause events
    enableAll: function () {
      loop('enable');
    },
    disableAll: function () {
      loop('disable');
    }
  }

  //	internal method
  //function to run for all element in array in global methods
  function loop(type) {
    if ($._iwEventPause) {
      var asgnd = $._iwEventPause['assigned'];
      for (var i = 0; i < asgnd.length; i++) {
        return methods[type].call($(asgnd[i]));
      }
    }

  }

  //function to initialize
  function initialize() {
    if (!$._iwEventPause) {
      $._iwEventPause = {};
      $._iwEventPause['assigned'] = [];
    }
  }

  //null function
  var nullFun = function () {
  }


  //function to restructure event
  function structureEvent(events) {
    var eventJson = [];
    if (!events) {
      events = ''
    }
    ;
    if ((typeof(events) == 'string') && (events != '')) {
      events = events.split(' ');
      for (var i = 0; i < events.length; i++) {
        if (events[i] == 'hover') {
          eventJson.push('hover');
          eventJson.push('mouseover');
          eventJson.push('mouseout');
        }
        else if (events[i] == 'mouseenter') {
          eventJson.push('mouseover');
        }
        else if (events[i] == 'mouseleave') {
          eventJson.push('mouseout');
        }
        else {
          eventJson.push(events[i]);
        }
      }
      events = eventJson;
    }
    return events;
  }

  function getIndex(array, value) {
    for (var i = 0; i < array.length; i++) {
      var ev = array[i],
          n = ev.indexOf('.');
      if ((ev === value) || (n > 0 ? ev.slice(0, n) === value : false)) {
        return i;
      }
    }
    return -1;
  }

  //function to pasue event
  function pauseEvent(elm, eventAry) {
    var events = $._data(elm, "events");
    if (events) {
      $.each(events, function (type, definition) {
        if ((getIndex(eventAry, type) != -1) || (eventAry == '')) {
          $.each(definition, function (index, event) {
            if (event.handler.toString() != nullFun.toString()) {
              $._iwEventPause["iw-event" + event.guid] = event.handler;
              event.handler = nullFun;
            }
          })
        }
      })
    }
  }

  //function to unpasue event
  function activeEvent(elm, eventAry) {
    var events = $._data(elm, "events");
    if (events) {
      $.each(events, function (type, definition) {
        if ((getIndex(eventAry, type) != -1) || (eventAry == '')) {
          $.each(definition, function (index, event) {
            if (event.handler.toString() == nullFun.toString()) {
              event.handler = $._iwEventPause["iw-event" + event.guid];
            }
          })
        }
      })
    }

  }


})(jQuery, window, document);

},{}],39:[function(require,module,exports){
/*!
 * Joseph Myer's md5() algorithm wrapped in a self-invoked function to prevent
 * global namespace polution, modified to hash unicode characters as UTF-8.
 *
 * Copyright 1999-2010, Joseph Myers, Paul Johnston, Greg Holt, Will Bond <will@wbond.net>
 * http://www.myersdaily.org/joseph/javascript/md5-text.html
 * http://pajhome.org.uk/crypt/md5
 *
 * Released under the BSD license
 * http://www.opensource.org/licenses/bsd-license
 */
(function() {

  function md5cycle(x, k) {
    var a = x[0], b = x[1], c = x[2], d = x[3];

    a = ff(a, b, c, d, k[0], 7, -680876936);
    d = ff(d, a, b, c, k[1], 12, -389564586);
    c = ff(c, d, a, b, k[2], 17, 606105819);
    b = ff(b, c, d, a, k[3], 22, -1044525330);
    a = ff(a, b, c, d, k[4], 7, -176418897);
    d = ff(d, a, b, c, k[5], 12, 1200080426);
    c = ff(c, d, a, b, k[6], 17, -1473231341);
    b = ff(b, c, d, a, k[7], 22, -45705983);
    a = ff(a, b, c, d, k[8], 7, 1770035416);
    d = ff(d, a, b, c, k[9], 12, -1958414417);
    c = ff(c, d, a, b, k[10], 17, -42063);
    b = ff(b, c, d, a, k[11], 22, -1990404162);
    a = ff(a, b, c, d, k[12], 7, 1804603682);
    d = ff(d, a, b, c, k[13], 12, -40341101);
    c = ff(c, d, a, b, k[14], 17, -1502002290);
    b = ff(b, c, d, a, k[15], 22, 1236535329);

    a = gg(a, b, c, d, k[1], 5, -165796510);
    d = gg(d, a, b, c, k[6], 9, -1069501632);
    c = gg(c, d, a, b, k[11], 14, 643717713);
    b = gg(b, c, d, a, k[0], 20, -373897302);
    a = gg(a, b, c, d, k[5], 5, -701558691);
    d = gg(d, a, b, c, k[10], 9, 38016083);
    c = gg(c, d, a, b, k[15], 14, -660478335);
    b = gg(b, c, d, a, k[4], 20, -405537848);
    a = gg(a, b, c, d, k[9], 5, 568446438);
    d = gg(d, a, b, c, k[14], 9, -1019803690);
    c = gg(c, d, a, b, k[3], 14, -187363961);
    b = gg(b, c, d, a, k[8], 20, 1163531501);
    a = gg(a, b, c, d, k[13], 5, -1444681467);
    d = gg(d, a, b, c, k[2], 9, -51403784);
    c = gg(c, d, a, b, k[7], 14, 1735328473);
    b = gg(b, c, d, a, k[12], 20, -1926607734);

    a = hh(a, b, c, d, k[5], 4, -378558);
    d = hh(d, a, b, c, k[8], 11, -2022574463);
    c = hh(c, d, a, b, k[11], 16, 1839030562);
    b = hh(b, c, d, a, k[14], 23, -35309556);
    a = hh(a, b, c, d, k[1], 4, -1530992060);
    d = hh(d, a, b, c, k[4], 11, 1272893353);
    c = hh(c, d, a, b, k[7], 16, -155497632);
    b = hh(b, c, d, a, k[10], 23, -1094730640);
    a = hh(a, b, c, d, k[13], 4, 681279174);
    d = hh(d, a, b, c, k[0], 11, -358537222);
    c = hh(c, d, a, b, k[3], 16, -722521979);
    b = hh(b, c, d, a, k[6], 23, 76029189);
    a = hh(a, b, c, d, k[9], 4, -640364487);
    d = hh(d, a, b, c, k[12], 11, -421815835);
    c = hh(c, d, a, b, k[15], 16, 530742520);
    b = hh(b, c, d, a, k[2], 23, -995338651);

    a = ii(a, b, c, d, k[0], 6, -198630844);
    d = ii(d, a, b, c, k[7], 10, 1126891415);
    c = ii(c, d, a, b, k[14], 15, -1416354905);
    b = ii(b, c, d, a, k[5], 21, -57434055);
    a = ii(a, b, c, d, k[12], 6, 1700485571);
    d = ii(d, a, b, c, k[3], 10, -1894986606);
    c = ii(c, d, a, b, k[10], 15, -1051523);
    b = ii(b, c, d, a, k[1], 21, -2054922799);
    a = ii(a, b, c, d, k[8], 6, 1873313359);
    d = ii(d, a, b, c, k[15], 10, -30611744);
    c = ii(c, d, a, b, k[6], 15, -1560198380);
    b = ii(b, c, d, a, k[13], 21, 1309151649);
    a = ii(a, b, c, d, k[4], 6, -145523070);
    d = ii(d, a, b, c, k[11], 10, -1120210379);
    c = ii(c, d, a, b, k[2], 15, 718787259);
    b = ii(b, c, d, a, k[9], 21, -343485551);

    x[0] = add32(a, x[0]);
    x[1] = add32(b, x[1]);
    x[2] = add32(c, x[2]);
    x[3] = add32(d, x[3]);
  }

  function cmn(q, a, b, x, s, t) {
    a = add32(add32(a, q), add32(x, t));
    return add32((a << s) | (a >>> (32 - s)), b);
  }

  function ff(a, b, c, d, x, s, t) {
    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
  }

  function gg(a, b, c, d, x, s, t) {
    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
  }

  function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
  }

  function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | (~d)), a, b, x, s, t);
  }

  function md51(s) {
    // Converts the string to UTF-8 "bytes" when necessary
    if (/[\x80-\xFF]/.test(s)) {
      s = unescape(encodeURI(s));
    }
    var n = s.length, state = [1732584193, -271733879, -1732584194, 271733878], i;
    for (i = 64; i <= s.length; i += 64) {
      md5cycle(state, md5blk(s.substring(i - 64, i)));
    }
    s = s.substring(i - 64);
    var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (i = 0; i < s.length; i++)
    tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
    tail[i >> 2] |= 0x80 << ((i % 4) << 3);
    if (i > 55) {
      md5cycle(state, tail);
      for (i = 0; i < 16; i++) tail[i] = 0;
    }
    tail[14] = n * 8;
    md5cycle(state, tail);
    return state;
  }

  function md5blk(s) { /* I figured global was faster.   */
    var md5blks = [], i; /* Andy King said do it this way. */
    for (i = 0; i < 64; i += 4) {
      md5blks[i >> 2] = s.charCodeAt(i) +
                        (s.charCodeAt(i + 1) << 8) +
                        (s.charCodeAt(i + 2) << 16) +
                        (s.charCodeAt(i + 3) << 24);
    }
    return md5blks;
  }

  var hex_chr = '0123456789abcdef'.split('');

  function rhex(n) {
    var s = '', j = 0;
    for (; j < 4; j++)
    s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] +
         hex_chr[(n >> (j * 8)) & 0x0F];
    return s;
  }

  function hex(x) {
    for (var i = 0; i < x.length; i++)
    x[i] = rhex(x[i]);
    return x.join('');
  }

  function md5(s) {
    return hex(md51(s));
  }

  /* this function is much faster, so if possible we use it. Some IEs are the
  only ones I know of that need the idiotic second function, generated by an
  if clause.  */
  function add32(a, b) {
    return (a + b) & 0xFFFFFFFF;
  }

  if (md5('hello') != '5d41402abc4b2a76b9719d911017c592') {
    function add32(x, y) {
      var lsw = (x & 0xFFFF) + (y & 0xFFFF),
          msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return (msw << 16) | (lsw & 0xFFFF);
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = md5;
  } else {
    window.md5 = md5;
  }
})();

},{}],40:[function(require,module,exports){
var toCamelCase;

toCamelCase = function(s) {
  var Word;
  if (!s) {
    throw new Error('String not defined');
  }
  Word = function(w) {
    return w.charAt().toUpperCase() + w.slice(1);
  };
  return s.split(/[-\s_.,&]+/g).map(Word).join('');
};

module.exports = {
  toCamelCase: toCamelCase
};



},{}]},{},[14])

